var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

window.whenStylesheetsLoaded = function () {
  const links = document.querySelectorAll('link[rel="stylesheet"]');
  return Promise.all(Array.from(links).map(function (link) {
    if (link.sheet) return Promise.resolve();
    return new Promise(function (resolve) {
      link.addEventListener('load', resolve, { once: true });
      link.addEventListener('error', resolve, { once: true });
    });
  }));
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    // An unhandled placeholder would otherwise render as a bare currency
    // suffix (" kr"), silently blanking prices.
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class IOSScrollLock {
  static _preventScroll = null;
  static _preventGesture = null;
  static _lockCount = 0;

  static lock() {
    if (this._lockCount === 0) {
      this._preventScroll = (e) => {
        if (e.target.closest('.Drawer--wrapper') || e.target.closest('[data-scrollable]')) return;
        e.preventDefault();
      };
      document.addEventListener('touchmove', this._preventScroll, { passive: false, capture: true });

      this._preventGesture = (e) => e.preventDefault();
      document.addEventListener('gesturestart', this._preventGesture);
    }
    this._lockCount++;
  }

  static unlock() {
    if (this._lockCount < 0) return;
    this._lockCount--;


    if (this._lockCount === 0) {
      if (this._preventScroll) {
        document.removeEventListener('touchmove', this._preventScroll, { passive: false, capture: true });
        this._preventScroll = null;
      }

      if (this._preventGesture) {
        document.removeEventListener('gesturestart', this._preventGesture);
        this._preventGesture = null;
      }
    }
  }
}

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this._ticking = false;
    this.boundRunCallbacks = () => {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this.runCallbacks();
        this._ticking = false;
      });
    };
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(true, true);

//use this for all popups
class Popup {
  constructor() {
    // Use a delegate for event handling on document.body.
    this.delegateBody = new Delegate(document.body);
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on(
      'click',
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );

    // Listen for the custom "drawer:close-other" event to close all open popups.
    this.delegateBody.on(
      'drawer:close-other',
      this.handleDrawerCloseOther.bind(this)
    );

    this.delegateBody.on(
      'edit-img:open-popup',
      this.handleOpenOptions.bind(this)
    );

    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    dynamicVars.syncHeight();
    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay of the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    if (event.key === 'Escape' && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup.querySelector('[data-action="toggle-popup"]')) {
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }

    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {
    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';

    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-hidden') === 'false') {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false) {
    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;

    // Ensure the popup is visible before starting any animations.
    popupElement.style.display = '';

    // If this is a parent popup, close any other open popups.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    popupElement.style.display = '';

    requestAnimationFrame(() => {
      popupElement.setAttribute('aria-hidden', 'false');
    });
    popupElement.removeAttribute('inert');
    requestAnimationFrame(() => {
      popupElement.setAttribute('aria-expanded', 'true');
      if (typeof this.onPopupOpen === 'function') {
        this.onPopupOpen(popupElement);
      }
    });

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');

    if (focus) {
      popupElement._scrollableElement = focus;
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    trapFocus(popupElement);
    // If the popup specifies an overlay, find it, display it, and attach a click listener.
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add('is-visible');
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      // Store the handler so it can be removed later.
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    // Push this popup onto the active stack.
    this.activePopups.push(popupElement);
  }

  // Close the popup element.
  closePopup(popupElement) {
    const index = this.activePopups.indexOf(popupElement);
    if (index !== -1) {
      // Save the scrollable element from the popup being closed.
      const closedScrollEl = popupElement._scrollableElement;
      this._closePopup(popupElement);
      this.activePopups.splice(index, 1);

      // If there is a new top popup, check for its scrollable element.
      if (this.activePopups.length > 0) {
        const topPopup = this.activePopups[this.activePopups.length - 1];
        if (topPopup._scrollableElement) {
          // Reapply the scroll lock to the new top popup's scrollable element.
          bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
        }
      } else {
        // No active popups remain; remove the scroll lock from the closed element.
        if (closedScrollEl) {
          bodyScrollLock.enableBodyScroll(closedScrollEl);
        }
      }
    }
  }


  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    popupElement.setAttribute('aria-expanded', 'false');

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.remove('is-visible');
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    popupElement.setAttribute('aria-hidden', 'true');

    removeTrapFocus(popupElement);

    const transitionEndHandler = () => {
      popupElement.style.display = 'none';
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      // Trigger the close callback after the transition ends.
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
    };

    setTimeout(() => {
      popupElement.style.display = 'none';
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
    }, 500);

    popupElement.addEventListener('transitionend', transitionEndHandler);
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup();


class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();

class CustomImageZoom {
  constructor(element, mediaSlides) {
    this.element = element;
    this.mediaSlides = Array.from(mediaSlides || []).filter((slide) => slide?.dataset?.zoomMediaId).filter((slide) => slide?.dataset?.mediaType === "image");
    this.zoomMediaElements = [];
    this.thumbnailButtons = [];
    this.thumbnailsByMediaKey = new Map();
    this.handleWrapperScroll = this.handleWrapperScroll.bind(this);
    this.scrollTicking = false;
    this.delegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.bindEvents();
    this.initImageZoom();
  }

  bindEvents() {
    this.delegate.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.toggleImageZoom.bind(this)
    );
    this.delegate.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.toggleImageZoom.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-product-zoom"]',
      this.closeImageZoom.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="zoom-to-image"]',
      this.scrollToThumbnail.bind(this)
    );
    this.handleKeyDown = this.handleKeyDown.bind(this);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (event.key === "Escape" && this.wrapper?.getAttribute("aria-hidden") === "false") {
      bodyScrollLock.clearAllBodyScrollLocks(this.wrapper);
      this.wrapper.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        this.wrapper.style.display = "none";
      }, 300);
    }
  }

  destroy() {
    if (this.delegate) {
      this.delegate.off();
    }
    if (this.delegateBody) {
      this.delegateBody.off();
    }
    document.removeEventListener("keydown", this.handleKeyDown);
    if (this.wrapper) {
      this.wrapper.removeEventListener("scroll", this.handleWrapperScroll);
      this.wrapper.remove();
    }
    this.zoomMediaElements = [];
    this.thumbnailButtons = [];
    this.thumbnailsByMediaKey.clear();
  }

  initImageZoom() {
    const existingWrapper = document.body.querySelector(".image-zoom__main");
    if (existingWrapper) {
      existingWrapper.remove();
    }

    this.wrapper = document.createElement("div");
    this.wrapper.style.display = "none";
    this.wrapper.classList.add("image-zoom__main");
    this.wrapper.setAttribute("aria-hidden", "true");

    this.thumbnailRail = document.createElement("div");
    this.thumbnailRail.classList.add("image-zoom__thumbs");

    this.feed = document.createElement("div");
    this.feed.classList.add("image-zoom__feed");

    const button = document.createElement("button");
    button.classList.add("image-zoom__close");
    button.setAttribute("data-action", "close-product-zoom");
    button.setAttribute("type", "button");
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M13.0605 12L18 7.0605L16.9395 6L12 10.9395L7.0605 6L6 7.0605L10.9395 12L6 16.9395L7.0605 18L12 13.0605L16.9395 18L18 16.9395L13.0605 12Z" fill="black"/>
      </svg>`;

    this.wrapper.appendChild(button);

    this.mediaSlides.forEach((slide, index) => {
      const mediaKey = this.getMediaKey(slide, index);
      const mediaType = slide.dataset.mediaType || "image";
      const zoomMedia = this.createZoomMediaNode(slide, mediaType);
      if (!zoomMedia) return;

      zoomMedia.dataset.zoomMediaKey = mediaKey;
      this.feed.appendChild(zoomMedia);
      this.zoomMediaElements.push(zoomMedia);

      const previewImage = this.getPreviewImageFromSlide(slide);
      if (!previewImage) return;

      const thumbButton = document.createElement("button");
      thumbButton.setAttribute("type", "button");
      thumbButton.setAttribute("data-action", "zoom-to-image");
      thumbButton.setAttribute("data-zoom-media-key", mediaKey);
      thumbButton.classList.add("image-zoom__thumb");
      thumbButton.setAttribute("aria-label", `Open media ${index + 1}`);

      const thumbImage = previewImage.cloneNode();
      thumbImage.classList.add("image-zoom__thumb-image");
      thumbImage.classList.remove("VisuallyHidden");
      thumbImage.removeAttribute("id");
      thumbButton.appendChild(thumbImage);

      this.thumbnailRail.appendChild(thumbButton);
      this.thumbnailButtons.push(thumbButton);
      this.thumbnailsByMediaKey.set(mediaKey, thumbButton);
    });

    this.wrapper.appendChild(this.thumbnailRail);
    this.wrapper.appendChild(this.feed);
    this.wrapper.addEventListener("scroll", this.handleWrapperScroll, { passive: true });

    const primaryText = getComputedStyle(this.element).getPropertyValue('--primary_text').trim();
    if (primaryText) {
      this.wrapper.style.setProperty('--primary_text', primaryText);
    }

    document.body.appendChild(this.wrapper);
  }

  toggleImageZoom(event, target) {
    if (!this.wrapper || !this.zoomMediaElements.length) return;

    const clickedTarget = target || event?.target;
    const clickedSlide = clickedTarget?.closest?.(".ProductSliderCell--Zoom");
    const mediaKey = clickedSlide?.dataset?.zoomMediaId;
    const hidden = this.wrapper.getAttribute("aria-hidden") === "true";

    if (hidden) {
      bodyScrollLock.disableBodyScroll(this.wrapper);
      this.wrapper.style.display = "flex";
      window.requestAnimationFrame(() => {
        this.wrapper.setAttribute("aria-hidden", "false");
      });
      this.scrollToTarget(mediaKey);
      return;
    }

    bodyScrollLock.clearAllBodyScrollLocks();
    this.wrapper.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      this.wrapper.style.display = "none";
    }, 300);
  }

  closeImageZoom(event) {
    const openedWrapper = event?.target?.closest?.('.image-zoom__main[aria-hidden="false"]');
    if (!openedWrapper) return;

    bodyScrollLock.clearAllBodyScrollLocks(openedWrapper);
    openedWrapper.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      openedWrapper.style.display = "none";
    }, 300);
  }

  scrollToThumbnail(event, target) {
    const thumbTarget = target?.closest?.('[data-action="zoom-to-image"]');
    const mediaKey = thumbTarget?.dataset?.zoomMediaKey;
    if (!mediaKey) return;
    this.scrollToMedia(mediaKey, "smooth");
  }

  scrollToTarget(mediaKey) {
    if (!mediaKey || !this.wrapper) return;
    this.scrollToMedia(mediaKey, "auto");
  }

  scrollToMedia(mediaKey, behavior) {
    const zoomMedia = this.zoomMediaElements.find(
      (item) => item.dataset.zoomMediaKey === mediaKey
    );
    if (!zoomMedia) return;

    zoomMedia.scrollIntoView({
      behavior,
      block: "start"
    });
    this.syncActiveThumbnail(mediaKey);
  }

  syncActiveThumbnail(mediaKey) {
    if (!this.thumbnailButtons.length) return;

    this.thumbnailButtons.forEach((thumbButton) => {
      thumbButton.classList.remove("image-zoom__thumb--active");
    });

    const activeThumb = this.thumbnailsByMediaKey.get(mediaKey);
    if (activeThumb) {
      activeThumb.classList.add("image-zoom__thumb--active");
    }
  }

  handleWrapperScroll() {
    if (!window.matchMedia("(min-width: 1025px)").matches) return;
    if (this.scrollTicking) return;

    this.scrollTicking = true;
    window.requestAnimationFrame(() => {
      const scrollTop = this.wrapper.scrollTop;
      let closestMedia = null;
      let smallestDistance = Number.POSITIVE_INFINITY;

      this.zoomMediaElements.forEach((zoomMedia) => {
        const distance = Math.abs(zoomMedia.offsetTop - scrollTop);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestMedia = zoomMedia;
        }
      });

      if (closestMedia?.dataset?.zoomMediaKey) {
        this.syncActiveThumbnail(closestMedia.dataset.zoomMediaKey);
      }

      this.scrollTicking = false;
    });
  }

  getMediaKey(slide, fallbackIndex) {
    return String(slide?.dataset?.zoomMediaId || `media-${fallbackIndex}`);
  }

  getPreviewImageFromSlide(slide) {
    return slide?.querySelector('.ProductSlider--ZoomThumbSource[data-original-src], img[data-original-src]');
  }

  createZoomMediaNode(slide, mediaType) {
    const previewImage = this.getPreviewImageFromSlide(slide);
    if (!previewImage) return null;

    if (mediaType === "image") {
      return this.createImageNode(previewImage);
    }

    const mediaContainer = this.getMediaContainer(slide, mediaType);
    if (!mediaContainer) {
      return this.createImageNode(previewImage);
    }

    const mediaWrapper = document.createElement("div");
    mediaWrapper.classList.add("image-zoom__media", `image-zoom__media--${mediaType}`);
    if (mediaType === "video" || mediaType === "external_video") {
      mediaWrapper.classList.add("video-container");
    }
    const clonedMedia = mediaContainer.cloneNode(true);
    this.stripIds(clonedMedia);
    mediaWrapper.appendChild(clonedMedia);
    return mediaWrapper;
  }

  createImageNode(image) {
    const zoomImage = image.cloneNode();
    zoomImage.classList.add("image-zoom__image");
    zoomImage.classList.remove("VisuallyHidden");
    zoomImage.removeAttribute("id");
    return zoomImage;
  }

  getMediaContainer(slide, mediaType) {
    if (mediaType === "video" || mediaType === "external_video") {
      return slide.querySelector(".VideoRatio") || slide.querySelector("video-component");
    }

    if (mediaType === "model") {
      return slide.querySelector(".ProductSlider-3D") || slide.querySelector("model-handler");
    }

    return null;
  }

  stripIds(node) {
    if (!node) return;

    if (node.hasAttribute && node.hasAttribute("id")) {
      node.removeAttribute("id");
    }

    if (node.querySelectorAll) {
      node.querySelectorAll("[id]").forEach((childNode) => {
        childNode.removeAttribute("id");
      });
    }
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide].querySelector('.ProductSlider--Element').getAttribute(
        'data-image-position'
      )
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }



    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (responsive.matchesBreakpoint('pocket')) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (item.classList.contains('ProductSliderCell--Zoom') && item.querySelector('img')) {
        images.push(item.querySelector('img'));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(target.querySelector('.ProductSlider--Element').getAttribute('data-image-position'));

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = responsive.matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }

    // Some selectbox variants can render without full inner markup.
    // Avoid runtime crashes and skip JS enhancement for those instances.
    if (!this.mainDropdown || !this.mainButton) {
      return;
    }

    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains('dropdownSelector')) {
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      event.target.setAttribute('disabled', 'true');
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      (!withinBoundaries) || event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown?.querySelector('[selected="selected"]');
    const titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && titleElement) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }



    if (typeof trapFocus === "function") {
      trapFocus(this.element);
    }
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();


    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(target.parentElement.parentElement.children)
      .filter((item) => item.classList.contains('RevolutionSelectbox'));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
      item.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', true);
      item.querySelector('.RevolutionSelectbox--Content').style.display = 'none';
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      const focus = this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add('scrollLock');
      trapFocus(this.mainDropdown);
      if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
        document.querySelector('.Drawer--Wrapper').style.overflow = 'visible';
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector('.RevolutionSelectbox--Content');
    target.setAttribute('aria-expanded', 'true');
    contentElement.style.display = 'block';
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute('aria-hidden', 'false');
      }, 20);
    } else {
      contentElement.setAttribute('aria-hidden', 'false');
    }


    this.isOpen = true;
    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector('#Drawer');
      if (menuDrawer.getAttribute('aria-expanded') == "true") {
        document.querySelector('.Drawer--Wrapper').style.overflow = "auto";
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }


    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}
class FormValidator {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      showErrorsOnSubmitOnly: false,
      ...options
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();

    if (this.options.buttonSelector) {
      if (this.options.showErrorsOnSubmitOnly) {
        this.enableButton();
      } else {
        this.updateButtonState();
      }
    }
  }

  enableButton() {
    if (!this.options.buttonSelector) return;

    const button = this.form.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    button.setAttribute('aria-disabled', 'false');
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;

    const button = this.form.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.addEventListener('click', (e) => {
      this.hasSubmittedOnce = true;
      const isValid = this.showAllErrors();

      if (button.type === 'submit' && !isValid) {
        e.preventDefault();
        this.updateButtonState();
      }
    });
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    const container = typeof this.options.errorOutputSelector === 'string'
      ? document.querySelector(this.options.errorOutputSelector)
      : this.options.errorOutputSelector;
    if (!container) return;

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  setupEventListeners() {
    const inputs = this.form.querySelectorAll('input, textarea, select');

    inputs.forEach(input => {
      input.addEventListener('input', () => this.handleInputForErrorClearing(input));
      if (this.options.validateOnBlur) {
        input.addEventListener('blur', () => this.handleFieldBlur(input));
      }
      input.addEventListener('change', () => this.handleInputChange(input));
    });
  }

  handleInputChange(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Always clear errors for empty fields
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else if (this.options.validateOnInput) {
      this.validateField(input, false);
    } else {
      this.handleInputForErrorClearing(input);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  updateErrorOutput() {
    if (!this.options.errorOutputSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const errors = this.getAllErrors();
    this.outputErrors(errors);
  }

  // Updated to not include errors for empty fields
  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach(field => {
      // Skip empty fields - don't show errors for them
      if (!field.value.trim()) {
        return;
      }

      if (!this.isFieldValid(field)) {
        if (this.customValidators.has(field.id)) {
          const { validatorFn } = this.customValidators.get(field.id);
          const result = validatorFn(field.value, field);
          if (typeof result === 'string') {
            errors.push(result);
          }
        } else if (field.validationMessage) {
          errors.push(field.validationMessage);
        } else {
          // Only show validation errors for non-empty fields
          if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
            errors.push(`Please enter a valid email address`);
          }
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const fieldContainer = input.closest(this.options.fieldSelector);
    if (!fieldContainer) return;

    // Clear error if field is empty or valid
    if (!input.value.trim() || this.isFieldValid(input)) {
      fieldContainer.classList.remove(this.options.errorClass);
      this.updateErrorOutput();
    }

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  handleFieldBlur(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    // Only validate non-empty fields on blur
    if (input.value.trim()) {
      this.validateField(input, false);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  // New helper method to clear field errors
  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    // Don't show errors for empty fields (but they may still be invalid for form submission)
    if (!field.value.trim()) {
      fieldContainer.classList.remove(this.options.errorClass);
      return this.isFieldValid(field); // Return actual validity for button state
    }

    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    if (shouldShowErrors) {
      if (isValid) {
        fieldContainer.classList.remove(this.options.errorClass);
      } else {
        fieldContainer.classList.add(this.options.errorClass);
      }
    } else if (isValid) {
      fieldContainer.classList.remove(this.options.errorClass);
    }

    return isValid;
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  isFieldValid(field) {
    // Check required fields
    if (field.hasAttribute('required') && !field.value.trim()) {
      return false;
    }

    // Check email format (only if field has value)
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
      return false;
    }

    // Check custom validators
    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') {
        return false;
      }
      return !!result;
    }

    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select');
    let isFormValid = true;

    allFields.forEach(field => {
      const isFieldValid = this.validateField(field, silent);
      if (!isFieldValid) {
        isFormValid = false;
      }
    });

    if (!silent) {
      this.updateErrorOutput();
    }

    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector) return;

    const button = this.form.querySelector(this.options.buttonSelector);
    if (!button) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      return;
    }

    const isValid = this.validateForm(true);

    if (isValid) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'true');
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach(field => {
      field.classList.remove(this.options.errorClass);
    });

    if (this.options.errorOutputSelector) {
      this.outputErrors([]);
    }
  }

  showAllErrors() {
    return this.validateForm(false);
  }


  getFormData() {
    const formData = new FormData(this.form);
    return Object.fromEntries(formData.entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    const selectedDate = new Date(dateString);
    const now = new Date();
    return selectedDate > now;
  }
}
class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

/**
 * One cart mutation per variant at a time. Concurrent clicks coalesce.
 * If the variant already has line(s), merge them and bump quantity via
 * /cart/update.js — never create another line for the same variant.
 */
const CartAddGuard = {
  _inflight: new Map(),
  _cooldownUntil: new Map(),
  _cooldownMs: 800,

  async addOrIncrement(variantId, quantity = 1, extra = {}) {
    const id = Number(variantId);
    if (!id) throw new Error('Missing variant id');

    const qty = Number(quantity) || 1;
    const key = String(id);

    const existingRun = this._inflight.get(key);
    if (existingRun) {
      try {
        const shared = await existingRun;
        return { ok: shared.ok, skipped: true, response: shared.response };
      } catch (error) {
        return { ok: false, skipped: true, response: null, error };
      }
    }

    const coolUntil = this._cooldownUntil.get(key) || 0;
    if (Date.now() < coolUntil) {
      return { ok: true, skipped: true, response: null };
    }

    // Reserve the slot synchronously before any await can yield.
    let resolveGate;
    let rejectGate;
    const gate = new Promise((resolve, reject) => {
      resolveGate = resolve;
      rejectGate = reject;
    });
    this._inflight.set(key, gate);

    (async () => {
      try {
        const localeRoot = window.routes?.localeRootUrl || '';
        const headers = {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        };

        const cartResponse = await fetch(`${localeRoot}/cart.js`, {
          credentials: 'same-origin',
          method: 'GET',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!cartResponse.ok) {
          throw new Error(`Cart fetch failed: ${cartResponse.status}`);
        }

        const cart = await cartResponse.json();
        const matches = (cart.items || []).filter((item) => {
          if (String(item.variant_id || item.id) !== key) return false;
          const props = item.properties || {};
          // Keep gift-wrapped lines separate from plain lines.
          if (props._gift_wrap === 'Yes') return false;
          return true;
        });

        let response;
        if (matches.length > 0) {
          // Bump an existing line in place. Do NOT zero sibling lines — Shopify
          // automatic discounts often split the same variant into discounted +
          // full-price rows; collapsing them drops the discount from other items.
          const target =
            matches.find(
              (item) => !(item.line_level_discount_allocations || []).length,
            ) || matches[0];
          response = await fetch(`${localeRoot}/cart/update.js`, {
            credentials: 'same-origin',
            method: 'POST',
            headers,
            body: JSON.stringify({
              updates: {
                [target.key]: (Number(target.quantity) || 0) + qty,
              },
            }),
          });
        } else {
          const line = { id, quantity: qty };
          if (extra && typeof extra === 'object') {
            if (extra.properties) line.properties = extra.properties;
            if (extra.selling_plan) line.selling_plan = extra.selling_plan;
          }
          response = await fetch(`${localeRoot}/cart/add.js`, {
            credentials: 'same-origin',
            method: 'POST',
            headers,
            body: JSON.stringify({ items: [line] }),
          });
        }

        const ok = Boolean(response && response.ok);
        if (ok) {
          this._cooldownUntil.set(key, Date.now() + this._cooldownMs);
        }

        const result = { ok, skipped: false, response };
        resolveGate(result);
      } catch (error) {
        rejectGate(error);
      } finally {
        if (this._inflight.get(key) === gate) {
          this._inflight.delete(key);
        }
      }
    })();

    return gate;
  },
};

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.isSubmitting = false;
    this.boundAddToCart = this.addToCart.bind(this);
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.off("click", "[data-action=add-to-cart]", this.boundAddToCart);
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.boundAddToCart
    );
  }

  destroy() {
    if (this.delegateElement) {
      this.delegateElement.off("click", "[data-action=add-to-cart]", this.boundAddToCart);
      this.delegateElement.off();
    }
    this.isSubmitting = false;
  }

  addToCart(event) {
    var _this = this;
    if (!event) return;
    event.preventDefault();
    if (typeof event.stopPropagation === "function") event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    var addToCartButton = event.target.closest("[data-action=add-to-cart]");
    if (!addToCartButton) return;
    if (
      this.isSubmitting ||
      addToCartButton.getAttribute("aria-disabled") === "true" ||
      addToCartButton.hasAttribute("disabled") ||
      addToCartButton.dataset.submitting === "true"
    ) {
      return;
    }

    this.isSubmitting = true;
    addToCartButton.dataset.submitting = "true";
    const isPdpMainButton = addToCartButton.classList.contains("pm__atc-button--main");
    if (this.pageLoader) this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    addToCartButton.setAttribute("aria-disabled", "true");
    if (isPdpMainButton) {
      addToCartButton.dataset.atcState = "adding";
    }
    var formElement = event.target.closest("form");
    var serialized;
    if (formElement) {
      formElement.querySelector('[name="id"]')?.removeAttribute("disabled");
      var formHelper = new Form();
      serialized = formHelper.serialize(formElement);
    } else {
      serialized = { id: addToCartButton.dataset.variantId, quantity: 1 };
    }

    const variantId = serialized.id || serialized.items?.[0]?.id;
    const quantity = serialized.quantity || serialized.items?.[0]?.quantity || 1;

    const releaseLock = function (restoreEnabled) {
      _this.isSubmitting = false;
      addToCartButton.dataset.submitting = "false";
      if (restoreEnabled) {
        addToCartButton.removeAttribute("disabled");
      }
      // aria-disabled only marks the in-flight lock, so it always clears here.
      // `disabled` alone reflects the variant state (toggleAddButton() sets it
      // when restoreEnabled is false) — toggleAddButton() never touches
      // aria-disabled, so leaving it set would block every later click.
      addToCartButton.removeAttribute("aria-disabled");
    };

    CartAddGuard.addOrIncrement(variantId, quantity)
      .then(function (result) {
      if (result.skipped) {
        releaseLock(true);
        if (isPdpMainButton) {
          addToCartButton.dataset.atcState = "default";
        }
        return;
      }
      const response = result.response;
      if (result.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        if (isPdpMainButton) {
          addToCartButton.dataset.atcState = "added";
          setTimeout(function () {
            const variantSelects = formElement
              ? formElement
                .closest("product-component")
                ?.querySelector("variant-selects")
              : null;
            if (variantSelects && typeof variantSelects.toggleAddButton === "function") {
              variantSelects.toggleAddButton();
              releaseLock(false);
            } else {
              addToCartButton.dataset.atcState = "default";
              releaseLock(true);
            }
          }, 3000);
        } else {
          releaseLock(true);
        }
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: quantity,
            },
          })
        );
      } else if (response) {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            if (_this.pageLoader) {
              _this.pageLoader.style.left = "unset";
              _this.pageLoader.style.right = 0 + "px";
              _this.pageLoader.style.width = 0 + "%";
              setTimeout(() => {
                _this.pageLoader.style.left = 0 + "px";
                _this.pageLoader.style.right = "unset";
              }, 550);
            }
            if (isPdpMainButton) {
              addToCartButton.dataset.atcState = "default";
            }
            releaseLock(true);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            if (isPdpMainButton) {
              addToCartButton.dataset.atcState = "default";
            }
            releaseLock(true);
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            if (_this.pageLoader) {
              _this.pageLoader.style.left = "unset";
              _this.pageLoader.style.right = 0 + "px";
              _this.pageLoader.style.width = 0 + "%";
              setTimeout(() => {
                _this.pageLoader.style.left = 0 + "px";
                _this.pageLoader.style.right = "unset";
              }, 550);
            }
          }
        }).catch(function () {
          if (isPdpMainButton) {
            addToCartButton.dataset.atcState = "default";
          }
          releaseLock(true);
        });
      } else {
        if (isPdpMainButton) {
          addToCartButton.dataset.atcState = "default";
        }
        releaseLock(true);
      }
    }).catch(function () {
      if (isPdpMainButton) {
        addToCartButton.dataset.atcState = "default";
      }
      releaseLock(true);
    });
  }
}


/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.key === "Tab") {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];
  const preferredFocus =
    elementToFocus && elements.includes(elementToFocus)
      ? elementToFocus
      : first;

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (preferredFocus) {
    preferredFocus.focus({ preventScroll: true });
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle - ALWAYS bind this regardless of breakpoint
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    // ADDITIONAL: Bind specifically for info__dropdown-button class used in PDP
    this.domDelegate.on(
      "click",
      ".info__dropdown-button[data-action='toggle-dropdown']",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    if (elem.classList.contains('Dropdown--Animate')) {
      DropdownContent.addEventListener("transitionend", transitionEndHandler);
    }

    DropdownButton.setAttribute("aria-expanded", "true");
    if (elem.classList.contains('Dropdown--Animate')) {
      new RevolutionAnimation(DropdownContent, "true").slideDown();
    } else {
      this.lock = false;
      DropdownContent.setAttribute("aria-hidden", false);
    }
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    if (elem.classList.contains('Dropdown--Animate')) {
      DropdownContent.addEventListener("transitionend", transitionEndHandler);
      new RevolutionAnimation(DropdownContent, "true").slideUp();
    } else {
      this.lock = false;
      DropdownContent.setAttribute("aria-hidden", true);
    }

    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("close:filters", { bubbles: true })
          );
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("open:filters", { bubbles: true })
          );
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.update();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });


  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.initialFocusElement = options["initialFocusElement"] || null;
    this.isOpen = false;
    this.element._drawerInstance = this;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);
  }

  maxHeight() {
    if (
      (this.element.classList.contains("Drawer--Left") ||
        this.element.classList.contains("Drawer--Right")) &&
      this.element.id !== "mobile-menu-drawer"
    ) {
      this.element.style.height = window.innerHeight + "px";
    }
    if (this.element.getAttribute("id") == "cart") {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var headerEl = this.element.querySelector(".CartHeader");
      if (headerEl) {
        var header = headerEl.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    const keepCartDrawerOpen = this.element.getAttribute('id') === 'quick-add-drawer'
      && this.element.dataset.keepCartDrawerOpen === 'true';
    const isSizeDrawerOpening = this.element.tagName === 'SIZE-DRAWER';

    // Single-drawer behavior: close any other open drawers first.
    document.querySelectorAll('.Drawer--wrapper[aria-expanded="true"]').forEach((openEl) => {
      if (openEl === this.element) return;
      if (
        keepCartDrawerOpen
        && (openEl.getAttribute('id') === 'cart-drawer' || openEl.getAttribute('id') === 'cart')
      ) {
        return;
      }
      if (isSizeDrawerOpening && openEl.getAttribute('id') === 'quick-add-drawer') {
        return;
      }
      const openInstance = openEl._drawerInstance;
      if (openInstance && typeof openInstance.closeDrawer === 'function') {
        openInstance.closeDrawer();
      }
    });

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (this.element.getAttribute("id") === "cart" || this.element.getAttribute("id") === "cart-drawer") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

    }
    if (this.isOpen) {
      return;
    }

    const drawerId = this.element.getAttribute('id');
    if (drawerId === 'search-drawer' || drawerId === 'cart-drawer' || drawerId === 'cart') {
      this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));
    }

    this.maxHeight();
    this.element.style.display = "";

    requestAnimationFrame(() => {
      this.element.setAttribute("aria-expanded", "true");
    });

    // Generic event so other components (e.g. added-to-cart-notification) can react to any drawer opening.
    this.element.dispatchEvent(
      new CustomEvent("drawer:opened", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "Drawer") {
      document.querySelector(".Drawer--Close").style.display = "block";
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    }

    this.pageOverlayElement.classList.add("is-visible");
    if (Drawer.activeOverlayCloseListener) {
      this.pageOverlayElement.removeEventListener("click", Drawer.activeOverlayCloseListener);
    }
    this.pageOverlayElement.addEventListener("click", this._closeListener);
    Drawer.activeOverlayCloseListener = this._closeListener;
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;

    IOSScrollLock.lock();

    setTimeout(() => {
      const preferredFocus =
        typeof this.initialFocusElement === "function"
          ? this.initialFocusElement()
          : this.initialFocusElement;
      trapFocus(this.element, preferredFocus || this.element);
    }, this.element.classList.contains('Drawer--animate') ? 0 : 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "Drawer") {
    }
    document.body.classList.remove("scrollLock");

    const quickAddEl = document.getElementById("quick-add-drawer");
    const quickAddOpen =
      quickAddEl &&
      quickAddEl !== this.element &&
      quickAddEl.getAttribute("aria-expanded") === "true";
    const shouldReleaseScrollLocks = !quickAddOpen;

    if (shouldReleaseScrollLocks) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
    }
    this.element.setAttribute("aria-expanded", "false");

    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    if (Drawer.activeOverlayCloseListener === this._closeListener) {
      Drawer.activeOverlayCloseListener = null;
    }

    const stillOpenDrawer = Array.from(
      document.querySelectorAll('.Drawer--wrapper[aria-expanded="true"]')
    ).find((openEl) => openEl !== this.element);

    if (stillOpenDrawer) {
      const stillOpenInstance = stillOpenDrawer._drawerInstance;
      if (stillOpenInstance?._closeListener) {
        this.pageOverlayElement.addEventListener("click", stillOpenInstance._closeListener);
        Drawer.activeOverlayCloseListener = stillOpenInstance._closeListener;
      }
      this.pageOverlayElement.classList.add("is-visible");
    } else {
      this.pageOverlayElement.classList.remove("is-visible");
    }
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();

    const transitionEndHandler = (e) => {
      if (e.propertyName === 'opacity') {
        if (this.element.getAttribute("aria-expanded") === "false") this.element.style.display = "none";
        this.element.removeEventListener("transitionend", transitionEndHandler);
      }
    };

    if (this.element.classList.contains('Drawer--animate')) {
      this.element.addEventListener("transitionend", transitionEndHandler);
    } else {
      this.element.style.display = "none";
    }

    if (shouldReleaseScrollLocks) {
      IOSScrollLock.unlock();
    }
  }

  destroy() {
    if (this.isOpen) this.closeDrawer();
    this.delegateBody?.off();
    this.delegateElement?.off();
    this.pageOverlayElement?.removeEventListener("click", this._closeListener);
    responsive.removeResizeListener(this, this.calculateMaxHeightListener);
  }

}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches("[data-animation]")) {
                this.animateElement(node, this.integer);
                this.integer = this.integer + 1;
              }

              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = _this.element.scrollHeight + "px";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      element.setAttribute("data-loaded", true);
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      setTimeout(() => {
        element.animate(keyframes, {
          duration: animationDuration,
          fill: "forwards",
        });
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration * 2,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Simple fade-in animation without scaling
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { opacity: "0" },
          { opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const elements = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elements.push(result.target);
            this.intersectionObserver[index].unobserve(result.target);
          }
        });
        if (elements.length === 0) {
          return;
        }
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementFadeIn: 'elementFadeIn'
        };
        const method = animations[options.type];
        if (method) {
          this[method](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

Drawer.activeOverlayCloseListener = null;

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == "true") {
      this.toggleAddButton();
    }
  }


  toggleAddButton() {
    const addButton = document.querySelector(".ProductPage--ATC");
    if (!addButton) return;
    const productElement = addButton.closest("product-component");
    const defaultLabel = addButton.querySelector('[data-atc-text-state="default"]');
    const addToBagLabel =
      productElement?.dataset.addToBagLabel ||
      window.variantStrings?.addToBag;

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    addButton.dataset.atcState = "default";
    if (defaultLabel) defaultLabel.textContent = addToBagLabel;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);


// --- CartDrawer constants ---
const CART_FETCH_HEADERS = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};

const CART_TIMINGS = {
  REMOVE_ANIMATION_MS: 350,
  SCROLL_LOCK_DELAY_MS: 500,
  LAYOUT_RECALC_DELAY_MS: 100,
  CONTENT_SETTLE_DELAY_MS: 200,
  LOADER_ANIMATION_MS: 550,
};

// --- CartBase: shared logic for CartDrawer and MainCart ---
class CartBase extends HTMLElement {
  constructor() {
    super();
    this.isUpdating = false;
  }

  bindGiftWrappingNoteEvents() {
    const sync = (input) => {
      const wrapper = input.closest('[data-gift-wrapping-recipient]');
      if (!wrapper) return;

      const limit = parseInt(input.getAttribute('data-maxlength'), 10) || 0;
      const valueLen = (input.value || '').length;
      const isInvalid = limit ? valueLen > limit : false;

      wrapper.classList.toggle('is-invalid', isInvalid);
      wrapper.classList.toggle('has-value', valueLen > 0);
      wrapper.classList.toggle('is-filled', valueLen > 0 && !isInvalid);
      input.setAttribute('aria-invalid', isInvalid ? 'true' : 'false');
    };

    this.delegateElement.on(
      'input',
      '.cart-item__gift-wrapping-recipient-input',
      (e) => {
        const input = e.target;
        sync(input);
        const giftWrapElement = input.closest('[data-gift-wrapping-item]');
        this.scheduleGiftRecipientSave(giftWrapElement);
      },
    );

    this.delegateElement.on(
      'click',
      '[data-action="gift-wrapping-clear"]',
      (e) => {
        const btn = e.target.closest('[data-action="gift-wrapping-clear"]');
        if (!btn) return;
        const wrapper = btn.closest('[data-gift-wrapping-recipient]');
        const input = wrapper?.querySelector('.cart-item__gift-wrapping-recipient-input');
        if (!wrapper || !input) return;

        input.value = '';
        wrapper.classList.remove('is-invalid', 'has-value', 'is-filled');
        input.setAttribute('aria-invalid', 'false');
        const giftWrapElement = input.closest('[data-gift-wrapping-item]');
        this.flushGiftRecipientSave(giftWrapElement);
        input.focus();
      },
    );

    this.querySelectorAll('.cart-item__gift-wrapping-recipient-input').forEach(
      (input) => sync(input),
    );
  }

  scheduleGiftRecipientSave(giftWrapElement) {
    if (!giftWrapElement) return;
    if (!this._giftNoteTimers) this._giftNoteTimers = new WeakMap();

    const existing = this._giftNoteTimers.get(giftWrapElement);
    if (existing) clearTimeout(existing);

    const timer = setTimeout(() => {
      this._giftNoteTimers.delete(giftWrapElement);
      this.flushGiftRecipientSave(giftWrapElement);
    }, 600);

    this._giftNoteTimers.set(giftWrapElement, timer);
  }

  async flushGiftRecipientSave(giftWrapElement) {
    if (!giftWrapElement || !document.contains(giftWrapElement)) return;
    if (!this._giftNoteTimers) this._giftNoteTimers = new WeakMap();
    if (!this._giftNoteInFlight) this._giftNoteInFlight = new WeakSet();

    const existing = this._giftNoteTimers.get(giftWrapElement);
    if (existing) {
      clearTimeout(existing);
      this._giftNoteTimers.delete(giftWrapElement);
    }

    if (this._giftNoteInFlight.has(giftWrapElement) || this.isUpdating) {
      this.scheduleGiftRecipientSave(giftWrapElement);
      return;
    }

    const recipientInput = giftWrapElement.querySelector('.cart-item__gift-wrapping-recipient-input');
    if (recipientInput) {
      const limit = parseInt(recipientInput.getAttribute('data-maxlength'), 10) || 0;
      if (limit && (recipientInput.value || '').length > limit) return;
    }

    this._giftNoteInFlight.add(giftWrapElement);
    try {
      await this.persistGiftWrapping(giftWrapElement, { skipRender: true });
    } finally {
      this._giftNoteInFlight.delete(giftWrapElement);
    }
  }

  getGiftWrappingBaseProperties(giftWrapElement) {
    const rawProperties = giftWrapElement?.getAttribute('data-line-properties') || '{}';
    let properties = {};

    try {
      const parsed = JSON.parse(rawProperties);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        properties = { ...parsed };
      }
    } catch (error) {
      properties = {};
    }

    delete properties._gift_wrap;
    delete properties._gift_recipient;

    return properties;
  }

  async persistGiftWrapping(giftWrapElement, options = {}) {
    if (!giftWrapElement) return;
    const { skipRender = false } = options;
    if (!skipRender && this.isUpdating) return;

    const lineId = giftWrapElement.getAttribute('data-line-id');
    const checkbox = giftWrapElement.querySelector('.cart-item__gift-wrapping-input');
    const recipientInput = giftWrapElement.querySelector('.cart-item__gift-wrapping-recipient-input');
    const cartItem = giftWrapElement.closest('.cart-item');
    const itemLoader = cartItem?.querySelector('.itemLoader');
    if (!lineId || !checkbox) return;

    const quantity = parseInt(cartItem?.getAttribute('data-current-quantity'), 10) || 1;
    const properties = this.getGiftWrappingBaseProperties(giftWrapElement);
    const recipientValue = (recipientInput?.value || '').trim();

    if (checkbox.checked) {
      properties._gift_wrap = 'Yes';
      properties._gift_recipient = recipientValue || '';
    } else {
      properties._gift_wrap = '';
      properties._gift_recipient = '';
    }

    if (!skipRender) {
      if (itemLoader) itemLoader.classList.add('is-visible');
      this.isUpdating = true;
    }

    try {
      const response = await this.postCart('/cart/change.js', {
        id: lineId,
        quantity,
        properties,
      });

      if (!response.ok) {
        throw new Error('Failed to update gift wrapping');
      }

      giftWrapElement.setAttribute('data-line-properties', JSON.stringify(properties));

      if (skipRender) {
        try {
          const cart = await response.clone().json();
          const variantId = parseInt((lineId || '').split(':')[0], 10);
          if (Number.isFinite(variantId) && Array.isArray(cart?.items)) {
            const match = cart.items.find((item) => {
              if (item.variant_id !== variantId) return false;
              const props = item.properties || {};
              return (
                (props._gift_wrap || '') === (properties._gift_wrap || '') &&
                (props._gift_recipient || '') === (properties._gift_recipient || '')
              );
            });
            if (match?.key) {
              giftWrapElement.setAttribute('data-line-id', match.key);
            }
          }
        } catch (e) {
          // non-fatal — next user action will trigger a full re-render and re-sync
        }
      }

      if (!skipRender) {
        if (typeof this.renderCart === 'function') {
          await this.renderCart();
        } else if (typeof this.refreshCart === 'function') {
          await this.refreshCart();
        }
      }
    } catch (error) {
      console.error('Failed to persist gift wrapping:', error);
    } finally {
      if (!skipRender) {
        this.isUpdating = false;
        if (itemLoader && document.body.contains(itemLoader)) {
          itemLoader.classList.remove('is-visible');
        }
      }
    }
  }

  bindGiftWrappingPropertyEvents() {
    this.delegateElement.on(
      'change',
      '.cart-item__gift-wrapping-input',
      async (e) => {
        const input = e.target.closest('.cart-item__gift-wrapping-input');
        const giftWrapElement = input?.closest('[data-gift-wrapping-item]');
        await this.persistGiftWrapping(giftWrapElement);
      },
    );

    this.delegateElement.on(
      'change',
      '.cart-item__gift-wrapping-recipient-input',
      (e) => {
        const input = e.target.closest('.cart-item__gift-wrapping-recipient-input');
        const giftWrapElement = input?.closest('[data-gift-wrapping-item]');
        this.flushGiftRecipientSave(giftWrapElement);
      },
    );
  }

  bindCartVariantSwapEvents() {
    this.delegateElement.on(
      'change',
      'select[data-action="cart-swap-variant"]',
      async (e) => {
        const select = e.target;
        const lineId = select.getAttribute('data-line-id');
        const quantity = parseInt(select.getAttribute('data-quantity'), 10) || 1;
        const newVariantId = parseInt(select.value, 10);
        if (!lineId || !newVariantId) return;
        if (this.isUpdating) return;

        this.isUpdating = true;
        try {
          await this.postCart('/cart/change.js', { id: lineId, quantity: 0 });
          await CartAddGuard.addOrIncrement(newVariantId, quantity);
        } catch (err) {
          console.error('Failed to swap cart variant:', err);
        } finally {
          this.isUpdating = false;
        }

        if (typeof this.renderCart === 'function') {
          await this.renderCart();
        } else if (typeof this.refreshCart === 'function') {
          await this.refreshCart();
        }
      },
    );
  }

  bindCartSizeDropdownEvents() {
    if (this._onCartSizeDropdownDocClick) {
      document.removeEventListener('click', this._onCartSizeDropdownDocClick, true);
    }

    this._onCartSizeDropdownDocClick = (e) => {
      if (!this.element?.contains(e.target)) return;
      if (e.target.closest('.Dropdown.cart-item__size-dropdown')) return;

      this.element
        .querySelectorAll('.Dropdown.cart-item__size-dropdown .cart-item__size-dropdown-button[aria-expanded="true"]')
        .forEach((btn) => {
          const dropdown = btn.closest('.Dropdown.cart-item__size-dropdown');
          if (!dropdown) return;
          allDropdowns.closeDropdown(dropdown, true);
          btn.setAttribute('aria-expanded', 'false');
        });
    };

    document.addEventListener('click', this._onCartSizeDropdownDocClick, true);

    this.delegateElement.on(
      'click',
      '[data-action="toggle-dropdown"].cart-item__size-dropdown-button',
      (e) => {
        const btn = e.target.closest('[data-action="toggle-dropdown"].cart-item__size-dropdown-button');
        if (!btn) return;
        const dropdown = btn.closest('.Dropdown.cart-item__size-dropdown');
        const list = dropdown?.querySelector('.cart-item__size-dropdown-list');
        const selected = dropdown?.querySelector('.cart-item__size-dropdown-item.is-selected');
        if (!list || !selected) return;
        setTimeout(() => {
          const listRect = list.getBoundingClientRect();
          const selRect = selected.getBoundingClientRect();
          const overTop = selRect.top - listRect.top;
          const overBottom = selRect.bottom - listRect.bottom;
          if (overTop < 0) list.scrollTop += overTop;
          else if (overBottom > 0) list.scrollTop += overBottom;
        }, 0);
      },
    );

    this.delegateElement.on(
      'click',
      '[data-action="cart-size-select"]',
      async (e) => {
        const btn = e.target.closest('[data-action="cart-size-select"]');
        if (!btn) return;
        if (this.isUpdating) return;

        const dropdown = btn.closest('.Dropdown.cart-item__size-dropdown');
        const cartItem = btn.closest('.cart-item');
        const itemLoader = cartItem?.querySelector('.itemLoader');
        const variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        const lineId = btn.getAttribute('data-line-id');
        const quantity = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
        if (!variantId || !lineId) return;

        const label = btn.textContent?.trim() || '';
        const labelEl = dropdown?.querySelector('.cart-item__size-dropdown-button-text');
        if (labelEl && label && labelEl.textContent?.trim() !== label) {
          clearTimeout(labelEl._sizeChangeTimer);
          labelEl.classList.add('is-changing');
          labelEl._sizeChangeTimer = window.setTimeout(() => {
            labelEl.textContent = label;
            labelEl.classList.remove('is-changing');
          }, 180);
        } else if (labelEl && label) {
          labelEl.textContent = label;
        }

        dropdown?.querySelectorAll('.cart-item__size-dropdown-item.is-selected').forEach((el) => {
          el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        const toggleBtn = dropdown?.querySelector('.cart-item__size-dropdown-button.Dropdown--Button');
        if (toggleBtn) {
          allDropdowns.closeDropdown(dropdown, true);
          toggleBtn.setAttribute('aria-expanded', 'false');
        }

        if (itemLoader) itemLoader.classList.add('is-visible');

        this.isUpdating = true;
        try {
          await this.postCart('/cart/change.js', { id: lineId, quantity: 0 });
          await CartAddGuard.addOrIncrement(variantId, quantity);
        } catch (err) {
          console.error('Failed to swap cart variant:', err);
        } finally {
          this.isUpdating = false;
        }

        if (typeof this.renderCart === 'function') {
          await this.renderCart();
        } else if (typeof this.refreshCart === 'function') {
          await this.refreshCart();
        }

        if (itemLoader && document.body.contains(itemLoader)) {
          itemLoader.classList.remove('is-visible');
        }
      },
    );
  }

  bindCartFaqOpenEvents() {
    // Close all but the first FAQ card that is open on initial render.
    // This prevents multiple `open_by_default` cart-faq-open blocks from starting expanded.
    const syncInitialState = () => {
      const faqCards = Array.from(this.element?.querySelectorAll('.cart-faq-open') || []);
      if (!faqCards.length) return;

      const openCards = faqCards.filter((card) => {
        const btn = card.querySelector('.Dropdown--Button');
        return btn?.getAttribute('aria-expanded') === 'true';
      });

      if (openCards.length <= 1) return;

      openCards.slice(1).forEach((card) => {
        const btn = card.querySelector('.Dropdown--Button');
        const content = card.querySelector('.Dropdown--Content');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (content) content.setAttribute('aria-hidden', 'true');
      });
    };

    syncInitialState();

    if (this._onCartFaqOpenDocClickCapture) {
      document.removeEventListener('click', this._onCartFaqOpenDocClickCapture, true);
    }

    this._onCartFaqOpenDocClickCapture = (e) => {
      const btn = e.target.closest('.cart-faq-open .Dropdown--Button[data-action="toggle-dropdown"]');
      if (!btn) return;

      const clickedCard = btn.closest('.cart-faq-open');
      if (!clickedCard) return;
      if (!this.element?.contains(clickedCard)) return;

      // Before the dropdown system toggles, close every other cart-faq-open.
      // This guarantees only one stays expanded at a time.
      const openOthers = Array.from(this.element.querySelectorAll('.cart-faq-open'))
        .filter((card) => card !== clickedCard);

      openOthers.forEach((card) => {
        const otherBtn = card.querySelector('.Dropdown--Button');
        const otherContent = card.querySelector('.Dropdown--Content');
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        if (otherContent) otherContent.setAttribute('aria-hidden', 'true');
      });
    };

    document.addEventListener('click', this._onCartFaqOpenDocClickCapture, true);
  }

  fetchCart() {
    return fetch(`${window.routes.localeRootUrl}/cart.js`, {
      credentials: 'same-origin',
      headers: CART_FETCH_HEADERS,
    });
  }

  postCart(endpoint, body) {
    return fetch(`${window.routes.localeRootUrl}${endpoint}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: CART_FETCH_HEADERS,
      body: JSON.stringify(body),
    });
  }

  bindQuantityEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      this.updateItemQuantity.bind(this),
    );
    this.delegateElement.on(
      'change',
      '[data-action="update-change-quantity"]',
      this.updateItemQuantity.bind(this),
    );
    this.delegateElement.on(
      'quantity:changed',
      '.cart-item__quantity',
      this.updateItemQuantity.bind(this),
    );
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    if (this.isUpdating) return { success: false };

    const cartItem = target.closest('.cart-item');
    const itemLoader = cartItem?.querySelector('.itemLoader');
    if (!cartItem || !document.body.contains(cartItem)) return { success: false };

    if (itemLoader) itemLoader.classList.add('is-visible');

    const quantity = target.tagName === 'INPUT'
      ? Math.max(parseInt(target.value, 10) || 0, 0)
      : parseInt(target.getAttribute('data-quantity'), 10);

    const lineId = target.getAttribute('data-line-id');
    if (!lineId) {
      console.error('No line ID found for cart item');
      if (itemLoader) itemLoader.classList.remove('is-visible');
      return { success: false };
    }

    this.isUpdating = true;
    try {
      // Update only this line key so automatic-discount splits stay as
      // separate rows (each with its own qty / price).
      const response = await this.postCart('/cart/change.js', {
        id: lineId,
        quantity,
      });
      if (!response.ok) {
        if (itemLoader) itemLoader.classList.remove('is-visible');
        return { success: false };
      }
      const data = await response.json();
      return { success: true, data, quantity, cartItem, itemLoader };
    } catch (err) {
      console.error('Failed to update item quantity:', err);
      if (itemLoader) itemLoader.classList.remove('is-visible');
      return { success: false };
    } finally {
      this.isUpdating = false;
    }
  }

  openFirstRecommendationsDropdown() {
    allDropdowns.updateAllDropdowns();
    const firstCartItem = this.querySelector('.cart-item');
    if (
      firstCartItem &&
      firstCartItem.querySelector('.cart-item-out-of-stock__dropdown')
    ) {
      return;
    }
    const firstRec = this.querySelector('cart-recommendations');
    if (!firstRec) return;
    const dropdown = firstRec.querySelector('.Dropdown');
    const dropdownBtn = firstRec.querySelector('.Dropdown--Button');
    if (!dropdown || !dropdownBtn) return;
    if (dropdownBtn.getAttribute('aria-expanded') === 'true') return;

    allDropdowns.openDropdown(dropdown, dropdownBtn);
    this.hasBeenOpened = true;
  }
}

class CartDrawer extends CartBase {
  static _boundInstances = new WeakSet();

  constructor() {
    super();
    this._hideDrawerTimer = null;
    this._onDrawerHideTransitionEnd = null;
    this._onDrawerHideAnimationEnd = null;
    this._recommendationsListenerController = new AbortController();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.hasBeenOpened = false;
    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.alreadyEntered = false;
        this.hideDrawerAfterMotion();
      },
      onOpen: () => {
        this.showDrawerElement();
        this.isOpen = true;

        if (this._pendingRecommendationsOpen) {
          this._pendingRecommendationsOpen = false;
          this.openFirstRecommendationsDropdown();
        } else if (!this.hasBeenOpened) {
          const firstRec = this.element.querySelector('cart-recommendations');
          if (firstRec && firstRec.isLoaded) {
            this.openFirstRecommendationsDropdown();
          }
        }

        if (this.alreadyEntered === false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });

    this.loader = this.element.querySelector('.itemLoader');

    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    this.announcer = this.element.querySelector('.cart-drawer__announcer');
    this.a11yMessages = {
      updated: this.element.dataset.announceUpdated || 'Cart updated',
      added: this.element.dataset.announceAdded || 'Item added to cart',
      removed: this.element.dataset.announceRemoved || 'Item removed from cart',
      quantity: this.element.dataset.announceQuantity || 'Cart quantity updated',
      error: this.element.dataset.announceError || 'Failed to update cart. Please try again.',
    };
    this._announceTimer = null;
    this.pageLoader = document.body.querySelector('.pageLoader');
    this.isOpen = false;

    this.alreadyEntered = false;
    this.isUpdating = false;
    new AddToCart(this.element);

    this.bindEvents();
    if (this.element.getAttribute('aria-expanded') !== 'true') {
      this.element.style.display = 'none';
    }
  }

  disconnectedCallback() {
    this._recommendationsListenerController.abort();
    this._recommendationsListenerController = new AbortController();
    if (this._announceTimer) {
      clearTimeout(this._announceTimer);
      this._announceTimer = null;
    }
    this.cleanupHideDrawerListeners();
    if (this._onProductAddedBound) {
      document.removeEventListener('product:added', this._onProductAddedBound);
    }
    if (this._onOpenBound) {
      document.removeEventListener('cart-drawer:open', this._onOpenBound);
    }
    this.delegateElement.off();
    this.delegateBody.off();
    CartDrawer._boundInstances.delete(this);
  }

  bindEvents() {
    if (CartDrawer._boundInstances.has(this)) return;

    this._onOpenBound = this.onOpen.bind(this);
    this._onProductAddedBound = this.onProductAdded.bind(this);

    document.addEventListener('cart-drawer:open', this._onOpenBound);
    document.addEventListener('product:added', this._onProductAddedBound);

    this.bindQuantityEvents();
    this.bindGiftWrappingNoteEvents();
    this.bindGiftWrappingPropertyEvents();
    this.bindCartVariantSwapEvents();
    this.bindCartSizeDropdownEvents();
    this.bindCartFaqOpenEvents();
    this.bindUpsellQuickAddToggleEvents();
    this.bindDesktopMenuHoverCloseEvents();

    CartDrawer._boundInstances.add(this);
  }

  bindDesktopMenuHoverCloseEvents() {
    this.delegateBody.on(
      'mouseover',
      '.header-link-list.header-main-menu-items.set-left .header-link-desk',
      (event) => {
        if (!responsive.matchesBreakpoint('lap_and_up')) return;
        if (!this.isOpen || !this.drawer) return;

        // Ignore repeated mouseover events within the same menu item.
        const menuItem = event.target.closest('.header-link-desk');
        if (!menuItem) return;
        if (menuItem.contains(event.relatedTarget)) return;

        this.drawer.closeDrawer();
      },
    );
  }

  announceToScreenReader(message) {
    if (!this.announcer || !message) return;
    if (this._announceTimer) {
      clearTimeout(this._announceTimer);
      this._announceTimer = null;
    }

    // Clear first so repeated messages are announced reliably.
    this.announcer.textContent = '';
    requestAnimationFrame(() => {
      this.announcer.textContent = message;
      this._announceTimer = setTimeout(() => {
        this.announcer.textContent = '';
      }, 1000);
    });
  }

  showDrawerElement() {
    this.cleanupHideDrawerListeners();
    this.element.style.display = 'block';
  }

  cleanupHideDrawerListeners() {
    if (this._onDrawerHideTransitionEnd) {
      this.element.removeEventListener(
        'transitionend',
        this._onDrawerHideTransitionEnd,
      );
      this._onDrawerHideTransitionEnd = null;
    }
    if (this._onDrawerHideAnimationEnd) {
      this.element.removeEventListener('animationend', this._onDrawerHideAnimationEnd);
      this._onDrawerHideAnimationEnd = null;
    }
    if (this._hideDrawerTimer) {
      clearTimeout(this._hideDrawerTimer);
      this._hideDrawerTimer = null;
    }
  }

  hideDrawerAfterMotion() {
    this.cleanupHideDrawerListeners();

    const hideElement = () => {
      if (this.element.getAttribute('aria-expanded') === 'true') return;
      this.cleanupHideDrawerListeners();
      this.element.style.display = 'none';
    };

    this._onDrawerHideTransitionEnd = (event) => {
      if (event.target === this.element) {
        hideElement();
      }
    };
    this._onDrawerHideAnimationEnd = (event) => {
      if (event.target === this.element) {
        hideElement();
      }
    };

    this.element.addEventListener('transitionend', this._onDrawerHideTransitionEnd);
    this.element.addEventListener('animationend', this._onDrawerHideAnimationEnd);

    // Fallback in case no transition/animation event fires.
    this._hideDrawerTimer = setTimeout(hideElement, 500);
  }

  bindUpsellQuickAddToggleEvents() {
    this.delegateElement.on(
      'click',
      '.cart-upsell--empty__container .pc__wrapper-link, .cart-upsell--full__container .pc__wrapper-link',
      async (event) => {
        const link = event.target.closest('.pc__wrapper-link');
        if (!link) return;

        const productUrlRaw = link.getAttribute('href');
        if (!productUrlRaw) return;

        const productUrl = productUrlRaw.split('#')[0].split('?')[0];
        if (!productUrl) return;

        const quickAddDrawer = document.getElementById('quick-add-drawer');
        if (!quickAddDrawer) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        if (typeof quickAddDrawer.openDrawerWithProduct === 'function') {
          await quickAddDrawer.openDrawerWithProduct(productUrl);
        }
        if (quickAddDrawer.drawer?.openDrawer) {
          quickAddDrawer.dataset.keepCartDrawerOpen = 'true';
          try {
            quickAddDrawer.drawer.openDrawer();
          } finally {
            delete quickAddDrawer.dataset.keepCartDrawerOpen;
          }
        }
      },
    );
  }

  updateLayoutVariables(container = this.element) {
    const header = container.querySelector('.cart-drawer__header');
    const footer = container.querySelector('.cart-drawer__footer');
    const shipping = container.querySelector('.cart-drawer__shipping');

    // Batch reads first to avoid layout thrashing.
    const headerHeight = header ? header.offsetHeight : 0;
    const footerHeight = footer ? footer.offsetHeight : 0;
    const shippingHeight = shipping ? shipping.offsetHeight : 0;

    // Then batch writes.
    const rootStyle = document.documentElement.style;
    rootStyle.setProperty('--cart-drawer__header-height', `${headerHeight}px`);
    rootStyle.setProperty('--cart-drawer__footer-height', `${footerHeight}px`);
    rootStyle.setProperty('--cart-drawer__shipping-height', `${shippingHeight}px`);
  }

  onOpen() {
    this.showDrawerElement();
    if (this.element.getAttribute('aria-expanded') === 'false') {
      setTimeout(() => {
        if (this.element.hasAttribute('data-open-drawer')) {
          this.focusElement = this.element.querySelector('[data-scrollable]');
          bodyScrollLock.disableBodyScroll(
            this.focusElement,
            bodyScrollLockOptions,
          );
        }
      }, CART_TIMINGS.SCROLL_LOCK_DELAY_MS);
    }

    this.updateLayoutVariables();
    this.checkTitleOverflow();
  }

  async updateItemQuantity(event, target) {
    const result = await super.updateItemQuantity(event, target);
    if (!result.success) {
      this.renderCart();
      return;
    }

    const { data, quantity, cartItem, itemLoader } = result;

    // Handle UI updates
    if (
      window.theme.cartMode === 'page' &&
      window.location.pathname === window.routes.cart_page_url
    ) {
      window.location.reload();
      return;
    }

    if (data.item_count === 0) {
      this.loader.classList.add('is-visible');
      this.renderCart();
      this.announceToScreenReader(this.a11yMessages.removed);
    } else if (quantity === 0) {
      const nextItem = cartItem.nextElementSibling;
      cartItem.classList.add('removing');
      setTimeout(() => {
        cartItem.remove();
        if (nextItem) {
          nextItem.classList.add('repo--top');
          setTimeout(
            () => nextItem.classList.remove('repo--top'),
            CART_TIMINGS.REMOVE_ANIMATION_MS,
          );
        }
      }, CART_TIMINGS.REMOVE_ANIMATION_MS);
      this.renderCart();
      this.announceToScreenReader(this.a11yMessages.removed);
    } else {
      this.renderCart();
      this.announceToScreenReader(this.a11yMessages.quantity);
    }

    if (itemLoader) itemLoader.classList.remove('is-visible');
  }

  async onProductAdded(event) {
    if (
      window.theme.cartMode === 'page' ||
      window.location.pathname === window.routes.cart_page_url
    ) {
      return;
    }

    const details = event.detail || false;

    if (window.theme.cartCount === 0 && this.isOpen === true) {
      this.loader.classList.add('is-visible');
    }

    // Update cart in background
    await this.renderCart();
    this.announceToScreenReader(this.a11yMessages.added);

    // Respect theme setting: only auto-open when data-open-drawer is present
    if (!this.element.hasAttribute('data-open-drawer')) return;

    // If drawer is already open, cart is re-rendering — nothing else needed
    if (this.isOpen) return;

    this.showDrawerElement();
    this.drawer.openDrawer();
  }

  async renderCart() {
    if (
      window.theme.cartMode === 'page' &&
      window.location.pathname === window.routes.cart_page_url
    ) {
      window.location.reload();
      return;
    }

    this.pageLoader.style.width = '90%';

    try {
      const content = await fetch(
        window.routes.localeRootUrl + '/?section_id=main-cart_drawer',
        {
          credentials: 'same-origin',
          method: 'GET',
        },
      );
      if (!content.ok) {
        throw new Error(`HTTP error: ${content.status}`);
      }
      const html = await content.text();
      this.replaceContent(html);

      // Open the first recommendations dropdown once its data is loaded.
      // If the drawer isn't visible yet, defer to when it opens.
      const firstRec = this.element.querySelector('cart-recommendations');
      if (firstRec) {
        this._recommendationsListenerController.abort();
        this._recommendationsListenerController = new AbortController();
        firstRec.addEventListener('recommendations:loaded', () => {
          if (this.isOpen) {
            this.openFirstRecommendationsDropdown();
          } else {
            this._pendingRecommendationsOpen = true;
          }
        }, {
          once: true,
          signal: this._recommendationsListenerController.signal,
        });
      }
    } catch (error) {
      console.error('Failed to render cart:', error);
      this.pageLoader.style.width = '0%';
      this.loader?.classList.remove('is-visible');
      this.announceToScreenReader(this.a11yMessages.error);
    }
  }

  replaceContent(html) {
    // Prepare the page loader animation
    this.pageLoader.style.width = '100%';
    setTimeout(() => {
      this.pageLoader.style.left = 'unset';
      this.pageLoader.style.right = '0px';
      this.pageLoader.style.width = '0%';

      setTimeout(() => {
        this.pageLoader.style.left = '0px';
        this.pageLoader.style.right = 'unset';
      }, CART_TIMINGS.LOADER_ANIMATION_MS);
    }, CART_TIMINGS.LAYOUT_RECALC_DELAY_MS);

    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector('#cart-drawer').getAttribute('data-settings'),
    );
    this.options = newOptions;

    const itemCount = newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);
    this.element.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { item_count: parseInt(itemCount, 10) },
      }),
    );

    const drawerCountEl = document.querySelector('.cart-drawer__count');
    if (drawerCountEl) drawerCountEl.innerHTML = `${itemCount}`;

    const nextShippingPercent = this.getShippingProgressPercent(
      tempElement.querySelector('.cart-drawer__shipping-progress-bar'),
    );
    const previousShippingPercent = this.getRenderedShippingProgressPercent(
      this.element.querySelector('.cart-drawer__shipping-progress-bar'),
    );

    const incomingShippingBar = tempElement.querySelector('.cart-drawer__shipping-progress-bar');
    if (incomingShippingBar && Number.isFinite(previousShippingPercent)) {
      const safePreviousPercent = Math.max(0, Math.min(previousShippingPercent, 100));
      incomingShippingBar.dataset.percent = safePreviousPercent;
      incomingShippingBar.style.transition = 'none';
      incomingShippingBar.style.width = `${safePreviousPercent}%`;
      incomingShippingBar.style.setProperty('--progress-width', `${safePreviousPercent}%`);
    }

    this.replaceCartContent(tempElement);
    this.updateCartFooter(tempElement, nextShippingPercent);
    this.animateShippingProgressBar(previousShippingPercent, nextShippingPercent);
    this.fixIOSScroll();

    this.element.dispatchEvent(
      new CustomEvent('cart:render', { bubbles: true }),
    );

    // Additional actions after a brief delay
    setTimeout(() => {
      this.checkTitleOverflow();

      if (this.isOpen && this.drawer) {
        const currentLockTarget = this.drawer._scrollLockElement;
        if (currentLockTarget && !Array.isArray(currentLockTarget)) {
          bodyScrollLock.enableBodyScroll(currentLockTarget);
        }

        const nextLockTarget = this.element.querySelector('[data-scrollable]');
        if (nextLockTarget) {
          this.drawer._scrollLockElement = nextLockTarget;
          bodyScrollLock.disableBodyScroll(
            nextLockTarget,
            bodyScrollLockOptions,
          );
        }
      }

      this.fixIOSScroll();
    }, CART_TIMINGS.CONTENT_SETTLE_DELAY_MS);
  }

  updateCartFooter(tempElement, nextShippingPercent = null) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {
      const footerParent = document.querySelector('.cart-drawer__footer');

      const newFooterTotals = tempElement.querySelector(
        '.cart_drawer__footer-totals',
      );
      const oldFooterTotals = document.querySelector(
        '.cart_drawer__footer-totals',
      );

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {
        footerParent.replaceChild(newFooterTotals, oldFooterTotals);
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const currentShippingBar = document.querySelector(
        '.cart-drawer__shipping-progress-bar',
      );
      if (currentShippingBar && Number.isFinite(nextShippingPercent)) {
        const percent = nextShippingPercent;
        currentShippingBar.dataset.percent = percent;
        if (Math.round(percent) >= 100) {
          currentShippingBar.classList.add('done');
          currentShippingBar.classList.remove('active');
        } else {
          currentShippingBar.classList.remove('done');
          currentShippingBar.classList.add('active');
        }
      }
    } else {
      this.clearCartFooter(tempElement);
    }

    this.updateLayoutVariables();
  }

  getShippingProgressPercent(shippingBar) {
    if (!shippingBar) return null;
    const rawPercent = parseFloat(shippingBar.dataset.percent);
    if (Number.isNaN(rawPercent)) return null;
    return Math.max(0, Math.min(rawPercent, 100));
  }

  getRenderedShippingProgressPercent(shippingBar) {
    if (!shippingBar) return null;
    const progressTrack = shippingBar.parentElement;
    if (!progressTrack) return this.getShippingProgressPercent(shippingBar);

    const trackWidth = progressTrack.getBoundingClientRect().width;
    const barWidth = shippingBar.getBoundingClientRect().width;
    if (trackWidth > 0) {
      return Math.max(0, Math.min((barWidth / trackWidth) * 100, 100));
    }

    return this.getShippingProgressPercent(shippingBar);
  }

  animateShippingProgressBar(previousPercent, nextPercent) {
    if (!Number.isFinite(nextPercent)) return;

    const shippingBar = this.element.querySelector('.cart-drawer__shipping-progress-bar');
    if (!shippingBar) return;

    if (this._shippingProgressRaf1) cancelAnimationFrame(this._shippingProgressRaf1);
    if (this._shippingProgressRaf2) cancelAnimationFrame(this._shippingProgressRaf2);

    // Start value is already applied to incoming markup before mount.
    this._shippingProgressRaf1 = requestAnimationFrame(() => {
      this._shippingProgressRaf2 = requestAnimationFrame(() => {
        shippingBar.style.transition = 'width 420ms ease';
        shippingBar.style.width = `${nextPercent}%`;
        shippingBar.style.setProperty('--progress-width', `${nextPercent}%`);
        this._shippingProgressRaf1 = null;
        this._shippingProgressRaf2 = null;
      });
    });
  }

  fixIOSScroll() {
    // Force iOS to recalculate scroll after DOM changes
    const scrollContainer = this.element.querySelector('[data-scrollable]');
    if (scrollContainer) {
      const currentScroll = scrollContainer.scrollTop;
      scrollContainer.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        scrollContainer.style.overflow = '';
        scrollContainer.style.webkitOverflowScrolling = 'auto';
        requestAnimationFrame(() => {
          scrollContainer.style.webkitOverflowScrolling = 'touch';
        });
        scrollContainer.scrollTop = currentScroll;
      });
    }
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector('.cart-drawer__wrapper')) return;
    if (document.querySelector('.cart-drawer__footer')) {
      document.querySelector('.cart-drawer__footer').classList.add('removing');
    }

    const wrapperParent = this.element.querySelector('.cart-drawer__wrapper');
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        '.cart-drawer__wrapper',
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {
    const currentWrapper = this.element.querySelector('.cart-drawer__wrapper');
    const cartWrapperParent = currentWrapper.parentNode;
    const currentScrollable = currentWrapper.querySelector('[data-scrollable]');
    const currentScrollPosition = currentScrollable ? currentScrollable.scrollTop : 0;

    cartWrapperParent.replaceChild(
      tempElement.querySelector('.cart-drawer__wrapper'),
      currentWrapper,
    );

    setTimeout(() => {
      this.loader.classList.remove('is-visible');
    }, CART_TIMINGS.CONTENT_SETTLE_DELAY_MS);
    const nextScrollable = this.element.querySelector(
      '.cart-drawer__wrapper [data-scrollable]',
    );
    if (nextScrollable) {
      nextScrollable.scrollTop = currentScrollPosition;
    }

    setTimeout(() => {
      this.updateLayoutVariables();
    }, CART_TIMINGS.LAYOUT_RECALC_DELAY_MS);
  }

  checkTitleOverflow() {
    this.element.querySelectorAll('.cart-item__title').forEach((el) => {
      const outerEl = el.closest('.cart-drawer__block');
      el.classList.toggle(
        'cart-item__title--fade',
        el.scrollWidth > outerEl.offsetWidth,
      );
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class MainCart extends CartBase {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sectionId = this.element.getAttribute('data-section-id');
  }

  connectedCallback() {
    this.bindEvents();
    new AddToCart(this.element);
    if (this.element.hasAttribute('data-open-recommendations-after-load')) {
      this.openFirstRecommendationsDropdownWhenReady();
    }
    this.checkTitleOverflow();
  }

  openFirstRecommendationsDropdownWhenReady() {
    const firstRec = this.element.querySelector('cart-recommendations');
    if (!firstRec) return;

    if (firstRec.isLoaded) {
      this.openFirstRecommendationsDropdown();
      return;
    }

    if (firstRec._openWhenLoadedBound) return;

    const onLoaded = () => {
      firstRec._openWhenLoadedBound = null;
      this.openFirstRecommendationsDropdown();
    };

    firstRec._openWhenLoadedBound = onLoaded;
    firstRec.addEventListener('recommendations:loaded', onLoaded, { once: true });
  }

  disconnectedCallback() {
    document.removeEventListener('product:added', this.onProductAddedListener);
  }

  bindEvents() {
    if (this.onProductAddedListener) {
      document.removeEventListener('product:added', this.onProductAddedListener);
    }

    this.onProductAddedListener = this.onProductAdded.bind(this);
    document.addEventListener('product:added', this.onProductAddedListener);

    this.delegateElement.off();
    this.delegateElement = new Delegate(this.element);
    this.bindQuantityEvents();
    this.bindGiftWrappingNoteEvents();
    this.bindGiftWrappingPropertyEvents();
    this.bindCartVariantSwapEvents();
    this.bindCartSizeDropdownEvents();
    this.bindCartFaqOpenEvents();
  }

  async updateItemQuantity(event, target) {
    const result = await super.updateItemQuantity(event, target);
    if (result.success) {
      await this.refreshCart();
    }
    if (result.itemLoader) {
      result.itemLoader.classList.remove('is-visible');
    }
  }

  async refreshCart() {
    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}?section_id=${this.sectionId}`,
        {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        },
      );

      if (!response.ok) {
        console.error('Failed to fetch cart section');
        return;
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newContent = doc.querySelector('main-cart');
      if (newContent && this.element) {
        this.element.innerHTML = newContent.innerHTML;
        this.bindEvents();
        this.checkTitleOverflow();
      }

      const cartResponse = await this.fetchCart();
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        window.theme.cartCount = cart.item_count;

        this.element.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { item_count: cart.item_count },
          }),
        );
      }

      if (this.element.hasAttribute('data-open-recommendations-after-load')) {
        this.openFirstRecommendationsDropdownWhenReady();
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }

  async onProductAdded() {
    await this.refreshCart();
  }

  checkTitleOverflow() {
    this.element.querySelectorAll('.cart-item__title').forEach((el) => {
      const outerEl = el.closest('.cart-drawer__block');
      if (!outerEl) return;
      el.classList.toggle(
        'cart-item__title--fade',
        el.scrollWidth > outerEl.offsetWidth,
      );
    });
  }
}

customElements.define('main-cart', MainCart);


class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.isLoaded = false;
    this.isLoading = false;
  }

  connectedCallback() {
    this.wrapper = this.querySelector('.cart-item-recommendations__wrapper');
    this.toggleBtn = this.querySelector(
      '.cart-item-recommendations__dropdown-button',
    );

    // If your Dropdown system toggles via data-action="toggle-dropdown",
    // we just piggyback on the same click.
    this.delegateElement.on(
      'click',
      '.cart-item-recommendations__dropdown-button[aria-expanded=false]',
      this.onToggleClick.bind(this),
    );

    this.loadRecommendations();
  }

  disconnectedCallback() {
    this.delegateElement?.off?.();
  }

  async onToggleClick(e) {
    const btn = e.target.closest('.cart-item-recommendations__dropdown-button');
    if (!btn) return;

    const isCurrentlyExpanded = btn.getAttribute('aria-expanded') === 'true';
    const isOpening = !isCurrentlyExpanded;
    if (!isOpening) return;

    this.scrollIntoViewAfterOpen();

    if (this.isLoaded || this.isLoading) return;
  }

  scrollIntoViewAfterOpen() {
    const content = this.querySelector('.Dropdown--Content');
    const scrollContainer = this.closest('.cart-drawer__content');
    if (!content || !scrollContainer) return;

    const handler = (e) => {
      if (e.target !== content || e.propertyName !== 'height') return;
      content.removeEventListener('transitionend', handler);

      const containerRect = scrollContainer.getBoundingClientRect();
      const elRect = this.closest('.cart-item').getBoundingClientRect();
      const overflow = elRect.bottom - containerRect.bottom;
      if (overflow > 0) {
        scrollContainer.scrollTop += overflow + 16;
      }
    };
    content.addEventListener('transitionend', handler);
  }

  async loadRecommendations() {
    if (!this.wrapper) return;

    const url = this.element.dataset.url;
    if (!url) {
      console.warn('CartRecommendations: Missing data-url.');
      return;
    }

    this.isLoading = true;

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

      const text = await res.text();
      const temp = document.createElement('div');
      temp.innerHTML = text;

      // Since the fetched section outputs ONLY the carousel markup,
      // we can grab it directly.
      const content =
        temp.querySelector('.cart-item-recommendations__carousels') ||
        temp.firstElementChild;

      if (!content.querySelector('.cart-item-recommendations__swiper-slide')) {
        this.element.remove();
        return;
      }

      if (!content || !content.innerHTML.trim()) {
        // No recommendations returned
        this.isLoaded = true;
        this.wrapper.innerHTML = '';
        return;
      }

      // Remove products already in cart
      const form = this.element.closest('form');
      if (form) {
        const cartProductIds = new Set(
          [...form.querySelectorAll('.cart-item[data-id]')].map(
            (el) => el.dataset.id,
          ),
        );
        content
          .querySelectorAll('.cart-item-recommendations__swiper-slide')
          .forEach((slide) => {
            const productId =
              slide.querySelector('[data-product-id]')?.dataset.productId;
            if (productId && cartProductIds.has(productId)) {
              slide.remove();
            }
          });
      }

      // If all recommendations were filtered out, show nothing
      if (!content.querySelector('.cart-item-recommendations__swiper-slide')) {
        this.isLoaded = true;
        this.wrapper.innerHTML = '';
        return;
      }

      this.wrapper.innerHTML = content.outerHTML;

      // Re-init Swiper — patch config for main-cart before initializing
      const swiperEl = this.wrapper.querySelector('swiper-init');
      if (swiperEl) {
        const mainCart = this.element.closest('main-cart');
        if (mainCart) {
          const styles = getComputedStyle(mainCart);
          const pxD = styles.getPropertyValue('--px-d').trim().replace('px', '');
          const pxM = styles.getPropertyValue('--px-m').trim().replace('px', '');

          const config = JSON.parse(swiperEl.getAttribute('data-swiper-settings'));
          config.slidesPerView = 1.31;
          config.slidesOffsetBefore = pxM;
          config.slidesOffsetAfter = pxM;
          if (config.breakpoints?.['1025']) {
            config.breakpoints['1025'].slidesPerView = 1.68;
            config.breakpoints['1025'].slidesOffsetBefore = pxD;
            config.breakpoints['1025'].slidesOffsetAfter = pxD;
          }
          swiperEl.setAttribute('data-swiper-settings', JSON.stringify(config));
        }

        if (typeof swiperEl.reinitialize === 'function') {
          swiperEl.reinitialize();
        }
      }

      // Initialize ATC logic for injected cards
      new AddToCart(this.element);

      this.isLoaded = true;
      this.element.dispatchEvent(
        new CustomEvent('recommendations:loaded', { bubbles: true }),
      );
    } catch (err) {
      console.error('CartRecommendations: Error loading recommendations', err);
    } finally {
      this.isLoading = false;
    }
  }
}

customElements.define('cart-recommendations', CartRecommendations);

class CartUpsellFull extends HTMLElement {
  connectedCallback() {
    this.element = this;
    this.url = this.element.dataset.url;
    this.recommendationsUrl = this.element.dataset.recommendationsUrl || '';
    this.sectionId = this.element.dataset.sectionId || 'cart-upsell_full';
    this.intent = this.element.dataset.intent || '';
    this.limit = parseInt(this.element.dataset.limit, 10) || 6;
    this.productIds = this.getProductIds();
    this.swiperEl = this.element.querySelector('swiper-init');
    this.wrapper = this.element.querySelector('.swiper-wrapper');
    this.hoverInfoEl = this.element.querySelector('.cart-upsell--hover-info');
    this.titleEl = this.element.querySelector('.cart-upsell--title');
    if (!this.url || !this.swiperEl || !this.wrapper) return;
    this._abortController = new AbortController();
    this.prepareForLoading();
    this.load();
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  prepareForLoading() {
    this.element.style.opacity = '0';
    this.element.style.visibility = 'hidden';
    this.element.style.pointerEvents = 'none';
  }

  revealAfterLoad() {
    this.element.style.visibility = 'visible';
    this.element.style.pointerEvents = '';
    this.element.removeAttribute('data-loaded');

    if (window.theme?.enableAnimations) {
      new RevolutionAnimation(this.element, "true").elementFadeIn([this.element]);
      return;
    }

    this.element.style.opacity = '1';
  }

  bindDesktopHoverInfo() {
    if (!this.hoverInfoEl || !this.titleEl) return;

    const isDesktop = responsive.matchesBreakpoint('lap_and_up');
    if (!isDesktop) {
      this.clearDesktopHoverInfo();
      return;
    }

    if (this._onUpsellWrapperOverBound) {
      this.wrapper.removeEventListener('mouseover', this._onUpsellWrapperOverBound);
    }
    if (this._onUpsellWrapperLeaveBound) {
      this.wrapper.removeEventListener('mouseleave', this._onUpsellWrapperLeaveBound);
    }

    this._onUpsellWrapperOverBound = (event) => {
      const card = event.target.closest('product-card');
      if (!card || !this.wrapper.contains(card)) return;
      this.renderDesktopHoverInfo(card);
    };

    this._onUpsellWrapperLeaveBound = () => {
      this.clearDesktopHoverInfo();
    };

    this.wrapper.addEventListener('mouseover', this._onUpsellWrapperOverBound);
    this.wrapper.addEventListener('mouseleave', this._onUpsellWrapperLeaveBound);

  }

  renderDesktopHoverInfo(card) {
    if (!this.hoverInfoEl || !this.titleEl || !card) return;
    const slide = card.closest('.swiper-slide[data-hover-price]');

    const title = slide?.dataset.hoverTitle
      || card.dataset.hoverTitle
      || card.querySelector('.pc__information__title--default')?.textContent?.trim()
      || '';
    const compare = slide?.dataset.hoverCompare
      || card.dataset.hoverCompare
      || '';
    const price = slide?.dataset.hoverPrice
      || card.dataset.hoverPrice
      || card.querySelector('.price-item--regular')?.textContent?.trim()
      || '';
    if (!title && !price) {
      this.clearDesktopHoverInfo();
      return;
    }

    const compareMarkup = compare ? `<s class="cart-upsell--hover-info__compare u-p2">${compare}</s>` : '';
    const priceMarkup = price ? `<span class="cart-upsell--hover-info__price u-s2">${price}</span>` : '';

    this.hoverInfoEl.innerHTML = `
      <span class="cart-upsell--hover-info__title u-h2">${title}</span>
      <span class="cart-upsell--hover-info__prices">
        ${compareMarkup}
        ${priceMarkup}
      </span>
    `;

    this.element.classList.add('is-hovering-slide');
    this.titleEl.setAttribute('aria-hidden', 'true');
    this.hoverInfoEl.setAttribute('aria-hidden', 'false');
  }

  clearDesktopHoverInfo() {
    if (!this.hoverInfoEl || !this.titleEl) return;
    this.element.classList.remove('is-hovering-slide');
    this.titleEl.setAttribute('aria-hidden', 'false');
    this.hoverInfoEl.setAttribute('aria-hidden', 'true');
    this.hoverInfoEl.innerHTML = '';
  }

  getProductIds() {
    try {
      const parsed = JSON.parse(this.element.dataset.productIds || '[]');
      if (!Array.isArray(parsed)) return [];
      return [...new Set(parsed.map((id) => parseInt(id, 10)).filter((id) => Number.isInteger(id) && id > 0))];
    } catch (e) {
      return [];
    }
  }

  buildRecommendationsUrl(productId) {
    if (!this.recommendationsUrl || !productId) return '';
    const params = new URLSearchParams({
      section_id: this.sectionId,
      product_id: String(productId),
      limit: String(this.limit),
    });
    if (this.intent) {
      params.set('intent', this.intent);
    }
    return `${this.recommendationsUrl}?${params.toString()}`;
  }

  async fetchSlides(url) {
    if (!url) return null;
    const signal = this._abortController?.signal;
    const res = await fetch(url, { credentials: 'same-origin', signal });
    if (!res.ok) return null;
    const html = await res.text();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const slides = temp.querySelector('.cart-upsell--full__slides');
    if (!slides || !slides.querySelector('.swiper-slide')) return null;
    return slides;
  }

  async load() {
    try {
      let slides = await this.fetchSlides(this.url);
      if (!slides && this.productIds.length > 1) {
        for (let i = 1; i < this.productIds.length; i += 1) {
          const fallbackUrl = this.buildRecommendationsUrl(this.productIds[i]);
          slides = await this.fetchSlides(fallbackUrl);
          if (slides) break;
        }
      }
      if (!slides || !slides.querySelector('.swiper-slide')) {
        this.element.remove();
        return;
      }

      this.wrapper.innerHTML = slides.innerHTML;
      this.bindDesktopHoverInfo();

      if (typeof this.swiperEl.reinitialize === 'function') {
        this.swiperEl.reinitialize();
      }

      requestAnimationFrame(() => {
        this.revealAfterLoad();
      });
    } catch (e) {
      if (e?.name === 'AbortError') return;
      this.element.remove();
    }
  }
}

customElements.define('cart-upsell-full', CartUpsellFull);

class AddedToCartNotification extends HTMLElement {
  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.breakpoint = responsive.getCurrentBreakpoint();

    this.durationMs = parseInt(this.element.dataset.durationMs, 10);
    if (!this.durationMs || Number.isNaN(this.durationMs)) this.durationMs = 3000;

    this.titleEl = this.element.querySelector('.atc-note__title');
    this.mediaEl = this.element.querySelector('.atc-note__media');
    this.vendorEl = this.element.querySelector('.atc-note__vendor');
    this.productEl = this.element.querySelector('.atc-note__product');
    this.priceEl = this.element.querySelector('.atc-note__price');
    this.variantEl = this.element.querySelector('.atc-note__variant');

    this._hideTimer = null;
    this._isVisible = false;
    const initiallyHidden = this.element.getAttribute('aria-hidden') === 'true';
    this.element.style.display = initiallyHidden ? 'none' : '';
    this._isVisible = !initiallyHidden;

    this.onProductAddedListener = this.onProductAdded.bind(this);
    document.addEventListener('product:added', this.onProductAddedListener);
    this.onCartDrawerOpenListener = this.hide.bind(this);
    document.addEventListener('cart-drawer:open', this.onCartDrawerOpenListener);
    // Also hide when any other drawer opens or when a desktop menu opens (hover/focus).
    this.onAnyDrawerOrMenuOpenListener = this.hide.bind(this);
    document.addEventListener('sidebar-drawer:open', this.onAnyDrawerOrMenuOpenListener);
    document.body.addEventListener('drawer:opened', this.onAnyDrawerOrMenuOpenListener, true);
    document.addEventListener('menu:open', this.onAnyDrawerOrMenuOpenListener);

    this.delegateElement.on('click', '[data-action="atc-note-view-bag"]', () => {
      this.hide();
      const cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer?.drawer?.openDrawer) {
        cartDrawer.drawer.openDrawer();
        return;
      }
      const toggleBtn = document.querySelector('[data-action="toggle-drawer"][data-toggle-id="cart-drawer"]');
      if (toggleBtn) toggleBtn.click();
    });

    this.bindSwipeToClose();
  }

  disconnectedCallback() {
    if (this.onProductAddedListener) {
      document.removeEventListener('product:added', this.onProductAddedListener);
    }
    if (this.onCartDrawerOpenListener) {
      document.removeEventListener('cart-drawer:open', this.onCartDrawerOpenListener);
    }
    if (this.onAnyDrawerOrMenuOpenListener) {
      document.removeEventListener('sidebar-drawer:open', this.onAnyDrawerOrMenuOpenListener);
      document.body.removeEventListener('drawer:opened', this.onAnyDrawerOrMenuOpenListener, true);
      document.removeEventListener('menu:open', this.onAnyDrawerOrMenuOpenListener);
    }
    if (this._hideTimer) window.clearTimeout(this._hideTimer);
    this.delegateElement?.off();
    this.unbindSwipeToClose?.();
  }

  bindSwipeToClose() {
    const isMobile = this.breakpoint === 'pocket';
    if (!isMobile) return;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    const onStart = (e) => {
      if (!this._isVisible) return;
      const touch = e.touches?.[0];
      if (!touch) return;
      isDragging = true;
      startX = touch.clientX;
      currentX = startX;
      this.element.style.transition = 'none';
    };

    const onMove = (e) => {
      if (!isDragging) return;
      const touch = e.touches?.[0];
      if (!touch) return;
      currentX = touch.clientX;
      const dx = currentX - startX;
      this.element.style.transform = `translateX(${dx}px)`;
    };

    const onEnd = () => {
      if (!isDragging) return;
      isDragging = false;
      const dx = currentX - startX;
      this.element.style.transition = '';
      this.element.style.transform = '';
      if (Math.abs(dx) > 60) {
        this.hide();
      }
    };

    this._swipeHandlers = { onStart, onMove, onEnd };
    this.element.addEventListener('touchstart', onStart, { passive: true });
    this.element.addEventListener('touchmove', onMove, { passive: true });
    this.element.addEventListener('touchend', onEnd);
    this.element.addEventListener('touchcancel', onEnd);

    this.unbindSwipeToClose = () => {
      if (!this._swipeHandlers) return;
      this.element.removeEventListener('touchstart', onStart);
      this.element.removeEventListener('touchmove', onMove);
      this.element.removeEventListener('touchend', onEnd);
      this.element.removeEventListener('touchcancel', onEnd);
      this._swipeHandlers = null;
    };
  }

  async onProductAdded(event) {
    // Do not show the notification when the cart drawer is open
    // or when the add-to-cart action originates from inside it.
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      const drawerOpen = cartDrawer.getAttribute('aria-expanded') === 'true';
      const fromInsideDrawer = event?.target && cartDrawer.contains(event.target);
      if (drawerOpen || fromInsideDrawer) return;
    }

    // For all other cases, immediately show the notification.
    // Data population happens best-effort and should never block visibility.
    this.show();

    let variantId = event?.detail?.variant;

    try {
      const cartRes = await fetch(`${window.routes.localeRootUrl}/cart.js`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!cartRes.ok) return;

      const cart = await cartRes.json();
      if (!cart?.items || !cart.items.length) return;

      if (!variantId) {
        // Fallback: if no variant detail was provided, use the last cart item.
        variantId = cart.items[cart.items.length - 1].id;
      }

      const item = cart.items.find((i) => String(i.id) === String(variantId))
        || cart.items[cart.items.length - 1];
      if (!item) return;

      const imgUrl = item.featured_image?.url || item.image;
      const vendor = item.vendor || '';
      const product = item.product_title || item.title || '';
      const price = typeof item.final_price === 'number' ? item.final_price : item.price;
      const options = (item.variant_options || []).filter((v) => v && v !== 'Default Title').join(', ');

      if (this.mediaEl) {
        this.mediaEl.innerHTML = imgUrl ? `<img src="${imgUrl}" alt="">` : '';
      }
      if (this.vendorEl) this.vendorEl.textContent = vendor;
      if (this.productEl) this.productEl.textContent = product;
      if (this.priceEl) this.priceEl.textContent = item.final_price ? Shopify.formatMoney(item.final_price) : Shopify.formatMoney(item.price);
      if (this.variantEl) this.variantEl.textContent = options;
    } catch (e) {
      // fail silently – notification is already visible
    }
  }

  show() {
    if (this._hideTimer) window.clearTimeout(this._hideTimer);
    this._isVisible = true;
    this.element.style.display = '';
    this.element.setAttribute('aria-hidden', 'false');

    if (this.durationMs > 0) {
      this._hideTimer = window.setTimeout(() => this.hide(), this.durationMs);
    } else {
      this._hideTimer = null;
    }
  }

  hide() {
    if (this._hideTimer) window.clearTimeout(this._hideTimer);
    this._hideTimer = null;
    this._isVisible = false;
    this.element.setAttribute('aria-hidden', 'true');
    this.element.style.display = 'none';
  }
}

customElements.define('added-to-cart-notification', AddedToCartNotification);

class CarouselTest extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {

  }


}
customElements.define("carousel-test", CarouselTest);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.handleMediaAreaClick = this.handleMediaAreaClick.bind(this);
  }

  connectedCallback() {
    this.element.addEventListener("click", this.handleMediaAreaClick);
    this.swapMediaPlaceholderToCollectionImage();
  }

  disconnectedCallback() {
    this.element.removeEventListener("click", this.handleMediaAreaClick);

    if (this.delegateElement && typeof this.delegateElement.destroy === "function") {
      this.delegateElement.destroy();
    }

    this.element = null;
  }

  handleMediaAreaClick(event) {
    const target = event?.target;
    if (!target) return;

    const mediaContainer = target.closest(".collection-showcase__image-container");
    if (!mediaContainer) return;

    // Preserve dedicated controls and CTA links.
    if (
      target.closest(
        ".collection-showcase__button-wrapper a, .collection-showcase__button-wrapper button, .collection-showcase__content-wrapper a, .collection-showcase__content-wrapper button, .collection-showcase__item-link, .video-controls, .vjs-control-bar, .vjs-control, .vjs-menu, .vjs-big-play-button"
      )
    ) {
      return;
    }

    const wrapper = mediaContainer.closest(".collection-showcase__image-wrapper");
    const collectionLink = wrapper?.querySelector(".collection-showcase__item-link[href]");
    if (!collectionLink) return;

    // Respect modifier-click behavior for opening in a new tab.
    if (event.metaKey || event.ctrlKey) {
      window.open(collectionLink.href, "_blank");
      return;
    }

    window.location.href = collectionLink.href;
  }

  swapMediaPlaceholderToCollectionImage() {
    const containers = this.element?.querySelectorAll?.('.collection-showcase__image-container[data-collection-image-url]');
    if (!containers || containers.length === 0) return;

    containers.forEach((container) => {
      const imgUrl = (container.getAttribute('data-collection-image-url') || '').trim();
      if (!imgUrl) return;

      const placeholderSvg = container.querySelector('svg.image__placeholder');
      if (!placeholderSvg) return;

      const alt = (container.getAttribute('data-collection-image-alt') || '').trim();
      const img = document.createElement('img');
      img.className = 'image__element collection-showcase__image';
      img.loading = 'lazy';
      img.alt = alt;
      img.src = imgUrl;

      placeholderSvg.replaceWith(img);
    });
  }
}

customElements.define("collection-showcase", CollectionShowcase);

class Header extends HTMLElement {
  static HEADER_TRANSITION_DURATION = 550;
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    this.reducedMotionQuery = null;
    this.handleReducedMotionChange = this.applyReducedMotionToAutoplayVideos.bind(this);
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    requestAnimationFrame(() => requestAnimationFrame(() => this.element.classList.add("header--ready")));

    this.updateVisibleHeight();
    window.addEventListener('load', () => requestAnimationFrame(() => this.updateVisibleHeight()));
    this.bindEvents();
    this.menuOverlapHandler();
    this.initializeDesktopMegaMenus();
    this.applyReducedMotionToAutoplayVideos();
    if (window.matchMedia) {
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (typeof this.reducedMotionQuery.addEventListener === 'function') {
        this.reducedMotionQuery.addEventListener('change', this.handleReducedMotionChange);
      } else if (typeof this.reducedMotionQuery.addListener === 'function') {
        this.reducedMotionQuery.addListener(this.handleReducedMotionChange);
      }
    }

    this.headerCartButton = this.element.querySelector('.header-cart-btn');
    this.headerCartCount = this.element.querySelector('.header__item-count--cart');
    this.syncHeaderCartCount(window.theme?.cartCount);
  }



  menuOverlapHandler() {
    const currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    const menuItems = this.element.querySelector(".header-menu-items");
    let overlapping = false;
    const menuWrapper = this.element.querySelector(".header__wrapper");
    const allHeights = [];
    const _this = this;
    if (menuItems) {
      const desiredHeight = _this.element.querySelectorAll(".header-main-links");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      const maxHeight = Math.max.apply(null, allHeights);
      const minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".header-main-menu-items").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  bindEvents() {
    this._boundSectionLoad = () => {
      this.menuOverlapHandlerListener();
      this.initializeDesktopMegaMenus();
      this.applyReducedMotionToAutoplayVideos();
    };
    document.addEventListener("shopify:section:load", this._boundSectionLoad);
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    if (this.options.transparent || this.options.sticky) {
      this._scrollListenerSubscription = scrollListener.addScrollListener(this, this.toggleColorListener);
    } else {
      window.addEventListener("scroll", this.toggleColorListener);
    }


    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .header-main-links",
      this.closeMenu.bind(this),
      true
    );

    this._boundUpdateVisibleHeight = this.updateVisibleHeight.bind(this);
    window.addEventListener("scroll", this._boundUpdateVisibleHeight);
    window.addEventListener("resize", this._boundUpdateVisibleHeight);

    this._boundCartUpdated = this.handleCartUpdated.bind(this);
    document.addEventListener('cart:updated', this._boundCartUpdated);
  }

  disconnectedCallback() {
    if (this.reducedMotionQuery) {
      if (typeof this.reducedMotionQuery.removeEventListener === 'function') {
        this.reducedMotionQuery.removeEventListener('change', this.handleReducedMotionChange);
      } else if (typeof this.reducedMotionQuery.removeListener === 'function') {
        this.reducedMotionQuery.removeListener(this.handleReducedMotionChange);
      }
    }
    document.removeEventListener("shopify:section:load", this._boundSectionLoad);
    window.removeEventListener("resize", this.menuOverlapHandlerListener);
    window.removeEventListener("scroll", this._boundUpdateVisibleHeight);
    window.removeEventListener("resize", this._boundUpdateVisibleHeight);
    document.removeEventListener('cart:updated', this._boundCartUpdated);
    if (this._scrollListenerSubscription && typeof this._scrollListenerSubscription.removeScrollListener === 'function') {
      this._scrollListenerSubscription.removeScrollListener();
    } else {
      window.removeEventListener("scroll", this.toggleColorListener);
    }
    if (this.delegateElement && typeof this.delegateElement.destroy === 'function') {
      this.delegateElement.destroy();
    }
    if (this.delegateBody && typeof this.delegateBody.destroy === 'function') {
      this.delegateBody.destroy();
    }
  }

  initializeDesktopMegaMenus() {
    const dropdowns = this.element.querySelectorAll("[data-desktop-dropdown]");
    dropdowns.forEach((dropdown) => this.setupDesktopMegaMenu(dropdown));
  }

  setupDesktopMegaMenu(dropdown) {
    if (!dropdown || dropdown.dataset.desktopMegaMenuReady === "true") {
      return;
    }

    dropdown.dataset.desktopMegaMenuReady = "true";

    const handleHover = (event) => {
      if (event.type === "focusin") return;
      const secondTrigger = event.target.closest("[data-second-key]");
      if (secondTrigger) {
        this.activateDesktopSecondLevel(dropdown, secondTrigger.getAttribute("data-second-key"));
        return;
      }
      const secondClearTrigger = event.target.closest("[data-second-clear]");
      if (secondClearTrigger) {
        this.clearDesktopSecondLevel(dropdown);
        return;
      }
      const thirdTrigger = event.target.closest("[data-third-key]");
      if (thirdTrigger) {
        this.activateDesktopThirdLevel(dropdown, thirdTrigger.getAttribute("data-third-key"));
        return;
      }
      const thirdClearTrigger = event.target.closest("[data-third-clear]");
      if (thirdClearTrigger) {
        const secondPanel = thirdClearTrigger.closest("[data-second-panel]");
        const overflowPanel = thirdClearTrigger.closest("[data-second-overflow-panel]");
        const secondKey =
          (secondPanel && secondPanel.getAttribute("data-second-panel")) ||
          (overflowPanel && overflowPanel.getAttribute("data-second-overflow-panel"));
        if (secondKey) {
          this.activateDesktopSecondLevel(dropdown, secondKey);
          return;
        }
        this.clearDesktopThirdLevel(dropdown);
      }
    };

    dropdown.addEventListener("mouseover", handleHover, true);
    dropdown.addEventListener("focusin", handleHover, true);
    dropdown.addEventListener("keydown", (event) => this.handleDesktopMenuKeydown(event, dropdown));

    this.clearDesktopMegaMenu(dropdown);
  }

  handleDesktopMenuKeydown(event, dropdown) {
    const { key } = event;
    const focusedEl = document.activeElement;
    if (!focusedEl || !dropdown.contains(focusedEl)) return;

    if (key === "Escape") {
      event.preventDefault();
      const menuTrigger = dropdown.closest("[aria-hasMenu='true']");
      if (menuTrigger) {
        this.closeMenu(event, dropdown.closest("[aria-submenu]"));
        menuTrigger.focus();
      }
      return;
    }

    if (key === "ArrowDown" || key === "ArrowUp") {
      event.preventDefault();
      const panel = focusedEl.closest(".desktop-menu__column, .desktop-menu__panel-list");
      if (!panel) return;
      const links = Array.from(panel.querySelectorAll('a[role="menuitem"]:not([hidden])'));
      const visibleLinks = links.filter((link) => {
        let el = link;
        while (el && el !== dropdown) {
          if (el.hidden) return false;
          el = el.parentElement;
        }
        return true;
      });
      const currentIndex = visibleLinks.indexOf(focusedEl);
      if (currentIndex === -1) return;
      const nextIndex = key === "ArrowDown"
        ? (currentIndex + 1) % visibleLinks.length
        : (currentIndex - 1 + visibleLinks.length) % visibleLinks.length;
      visibleLinks[nextIndex]?.focus();
      return;
    }

    if (key === "ArrowRight") {
      event.preventDefault();
      const secondTrigger = focusedEl.closest("[data-second-key]");
      if (secondTrigger) {
        this.activateDesktopSecondLevel(dropdown, secondTrigger.getAttribute("data-second-key"));
        return;
      }
      const thirdTrigger = focusedEl.closest("[data-third-key]");
      if (thirdTrigger) {
        this.activateDesktopThirdLevel(dropdown, thirdTrigger.getAttribute("data-third-key"));
        return;
      }
    }

    if (key === "ArrowLeft") {
      event.preventDefault();
      const thirdPanel = focusedEl.closest("[data-third-panel]:not([hidden]), [data-second-overflow-panel]:not([hidden])");
      if (thirdPanel) {
        this.clearDesktopThirdLevel(dropdown);
        const activeSecondTrigger = dropdown.querySelector("[data-second-key].is-active");
        if (activeSecondTrigger) activeSecondTrigger.focus();
        return;
      }
      const secondPanel = focusedEl.closest("[data-second-panel]:not([hidden])");
      if (secondPanel) {
        this.clearDesktopSecondLevel(dropdown);
        const secondCol = dropdown.querySelector(".desktop-menu__column--second");
        const firstLink = secondCol?.querySelector('a');
        if (firstLink) firstLink.focus();
        return;
      }
    }
  }

  activateDesktopSecondLevel(dropdown, secondKey) {
    if (!dropdown || !secondKey) return;

    const secondTriggers = dropdown.querySelectorAll("[data-second-key]");
    secondTriggers.forEach((trigger) => {
      const isActive = trigger.getAttribute("data-second-key") === secondKey;
      trigger.classList.toggle("is-active", isActive);
      trigger.setAttribute("aria-expanded", String(isActive));
    });

    const secondPanels = dropdown.querySelectorAll("[data-second-panel]");
    let activeSecondPanel = null;
    secondPanels.forEach((panel) => {
      const isActive = panel.getAttribute("data-second-panel") === secondKey;
      panel.hidden = !isActive;
      if (isActive) activeSecondPanel = panel;
    });

    const thirdColumn = dropdown.querySelector('[data-column="third"]');
    const hasThirdColumnContent = !!(
      activeSecondPanel &&
      activeSecondPanel.querySelector(".desktop-menu__link")
    );
    this.clearDesktopThirdLevel(dropdown);
    const hasSecondLevelOverflow = this.showDesktopSecondLevelOverflow(dropdown, secondKey);
    const pseudoThirdColumn = dropdown.querySelector('[data-column="pseudo-third"]');
    if (pseudoThirdColumn) {
      pseudoThirdColumn.hidden = !hasSecondLevelOverflow;
    }

    const hasSecondLevelCollection = this.showDesktopSecondLevelCollection(dropdown, secondKey);
    const collectionColumn = dropdown.querySelector('[data-column="collection"]');
    if (collectionColumn) {
      collectionColumn.hidden = !hasSecondLevelCollection;
    }

    if (thirdColumn) {
      thirdColumn.hidden = !hasThirdColumnContent && !hasSecondLevelCollection;
    }

    if (hasSecondLevelOverflow) {
      this.updateDesktopMenuCols(dropdown, 4);
      this.focusFirstLinkInPanel(dropdown, `[data-second-panel="${secondKey}"]:not([hidden])`);
      return;
    }
    this.updateDesktopMenuCols(dropdown, "split");
    this.focusFirstLinkInPanel(dropdown, `[data-second-panel="${secondKey}"]:not([hidden])`);
  }

  activateDesktopThirdLevel(dropdown, thirdKey) {
    if (!dropdown || !thirdKey) return;

    const thirdTriggers = dropdown.querySelectorAll("[data-third-key]");
    thirdTriggers.forEach((trigger) => {
      const isActive = trigger.getAttribute("data-third-key") === thirdKey;
      trigger.classList.toggle("is-active", isActive);
      trigger.setAttribute("aria-expanded", String(isActive));
    });

    const parentSecondKey = thirdKey.replace(/-t-\d+$/, "");
    const activeSecondPanel = dropdown.querySelector(`[data-second-panel="${parentSecondKey}"]`);
    const isSecondLevelSplit = !!(
      activeSecondPanel &&
      activeSecondPanel.getAttribute("data-second-split") === "true"
    );

    if (isSecondLevelSplit) {
      const hasSecondLevelOverflow = this.showDesktopSecondLevelOverflow(dropdown, parentSecondKey);
      const pseudoThirdColumn = dropdown.querySelector('[data-column="pseudo-third"]');
      if (pseudoThirdColumn) {
        pseudoThirdColumn.hidden = !hasSecondLevelOverflow;
      }

      const hasThirdSplitContent = this.showDesktopThirdSplitPanel(dropdown, thirdKey);

      if (hasThirdSplitContent) {
        this.hideDesktopCollectionPanels(dropdown);
      }

      const hasThirdLevelCollection = hasThirdSplitContent
        ? false
        : this.showDesktopThirdLevelCollection(dropdown, thirdKey);
      const isCollectionFallbackEnabled = this.isDesktopCollectionFallbackEnabled(dropdown);
      let hasSecondLevelCollection = false;
      if (!hasThirdSplitContent && !hasThirdLevelCollection && isCollectionFallbackEnabled) {
        hasSecondLevelCollection = this.showDesktopSecondLevelCollection(dropdown, parentSecondKey);
      } else if (!hasThirdSplitContent) {
        dropdown.querySelectorAll("[data-collection-second-panel]").forEach((panel) => {
          panel.hidden = true;
        });
      }

      const collectionColumn = dropdown.querySelector('[data-column="collection"]');
      const hasCollectionContent = hasThirdLevelCollection || hasSecondLevelCollection;
      if (collectionColumn) {
        collectionColumn.hidden = !hasThirdSplitContent && !hasCollectionContent;
      }
      this.updateDesktopMenuCols(dropdown, 4);
      return;
    }

    this.hideDesktopSecondLevelOverflow(dropdown);
    this.hideDesktopThirdSplitPanels(dropdown);

    const thirdPanels = dropdown.querySelectorAll("[data-third-panel]");
    let hasPseudoThirdContent = false;
    thirdPanels.forEach((panel) => {
      const isActive = panel.getAttribute("data-third-panel") === thirdKey;
      panel.hidden = !isActive;
      if (isActive && panel.children.length > 0) {
        hasPseudoThirdContent = true;
      }
    });
    const pseudoThirdColumn = dropdown.querySelector('[data-column="pseudo-third"]');
    if (pseudoThirdColumn) {
      pseudoThirdColumn.hidden = !hasPseudoThirdContent;
    }

    if (hasPseudoThirdContent) {
      this.hideDesktopCollectionPanels(dropdown);
    }

    const hasThirdLevelCollection = hasPseudoThirdContent
      ? false
      : this.showDesktopThirdLevelCollection(dropdown, thirdKey);
    const isCollectionFallbackEnabled = this.isDesktopCollectionFallbackEnabled(dropdown);
    let hasSecondLevelCollection = false;
    if (!hasPseudoThirdContent && !hasThirdLevelCollection && isCollectionFallbackEnabled) {
      hasSecondLevelCollection = this.showDesktopSecondLevelCollection(dropdown, parentSecondKey);
    } else if (!hasPseudoThirdContent) {
      dropdown.querySelectorAll("[data-collection-second-panel]").forEach((panel) => {
        panel.hidden = true;
      });
    }

    const collectionColumn = dropdown.querySelector('[data-column="collection"]');
    const hasCollectionContent = hasThirdLevelCollection || hasSecondLevelCollection;
    if (collectionColumn) {
      collectionColumn.hidden = !hasPseudoThirdContent && !hasCollectionContent;
    }
    this.updateDesktopMenuCols(dropdown, hasPseudoThirdContent ? 4 : "split");
    this.focusFirstLinkInPanel(dropdown, `[data-third-panel="${thirdKey}"]:not([hidden])`);
  }

  focusFirstLinkInPanel(dropdown, panelSelector) {
    const wrapper = dropdown.closest('[aria-submenu]');
    if (!wrapper || !wrapper.contains(document.activeElement)) return;
    const panel = dropdown.querySelector(panelSelector);
    const firstLink = panel?.querySelector('a');
    if (firstLink) requestAnimationFrame(() => firstLink.focus());
  }

  clearDesktopThirdLevel(dropdown) {
    if (!dropdown) return;

    dropdown.querySelectorAll("[data-third-key]").forEach((trigger) => {
      trigger.classList.remove("is-active");
      trigger.setAttribute("aria-expanded", "false");
    });
    dropdown.querySelectorAll("[data-third-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    this.hideDesktopThirdSplitPanels(dropdown);
    dropdown.querySelectorAll("[data-collection-third-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    const pseudoThirdColumn = dropdown.querySelector('[data-column="pseudo-third"]');
    if (pseudoThirdColumn) {
      pseudoThirdColumn.hidden = true;
    }
  }

  clearDesktopSecondLevel(dropdown) {
    if (!dropdown) return;

    dropdown.querySelectorAll("[data-second-key]").forEach((trigger) => {
      trigger.classList.remove("is-active");
      trigger.setAttribute("aria-expanded", "false");
    });
    dropdown.querySelectorAll("[data-second-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    this.hideDesktopSecondLevelOverflow(dropdown);

    const thirdColumn = dropdown.querySelector('[data-column="third"]');
    if (thirdColumn) thirdColumn.hidden = true;
    this.clearDesktopThirdLevel(dropdown);

    const collectionColumn = dropdown.querySelector('[data-column="collection"]');
    if (collectionColumn) collectionColumn.hidden = true;
    dropdown.querySelectorAll("[data-collection-second-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    dropdown.querySelectorAll("[data-collection-third-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    const rootCollectionPanel = dropdown.querySelector("[data-collection-root-panel]");
    const hasRootCollectionContent = !!(rootCollectionPanel && rootCollectionPanel.children.length > 0);
    if (rootCollectionPanel) {
      rootCollectionPanel.hidden = !hasRootCollectionContent;
    }
    if (collectionColumn && hasRootCollectionContent) {
      collectionColumn.hidden = false;
      this.updateDesktopMenuCols(dropdown, 2);
      return;
    }
    this.updateDesktopMenuCols(dropdown, 1);
  }

  clearDesktopMegaMenu(dropdown) {
    this.clearDesktopSecondLevel(dropdown);
  }

  isDesktopCollectionFallbackEnabled(dropdown) {
    if (!dropdown) return true;
    return dropdown.getAttribute("data-collection-fallback") !== "false";
  }

  showDesktopSecondLevelCollection(dropdown, secondKey) {
    if (!dropdown || !secondKey) return false;

    const isCollectionFallbackEnabled = this.isDesktopCollectionFallbackEnabled(dropdown);
    let hasCollectionContent = false;
    dropdown.querySelectorAll("[data-collection-second-panel]").forEach((panel) => {
      const isActive = panel.getAttribute("data-collection-second-panel") === secondKey;
      panel.hidden = !isActive;
      if (isActive && panel.children.length > 0) {
        hasCollectionContent = true;
      }
    });
    dropdown.querySelectorAll("[data-collection-third-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    const rootCollectionPanel = dropdown.querySelector("[data-collection-root-panel]");
    if (rootCollectionPanel) {
      const hasRootCollectionContent = rootCollectionPanel.children.length > 0;
      const shouldShowRootCollection = isCollectionFallbackEnabled && !hasCollectionContent && hasRootCollectionContent;
      rootCollectionPanel.hidden = !shouldShowRootCollection;
      if (shouldShowRootCollection) {
        hasCollectionContent = true;
      }
    }
    const collectionColumn = dropdown.querySelector('[data-column="collection"]');
    if (collectionColumn) {
      collectionColumn.hidden = !hasCollectionContent;
    }
    return hasCollectionContent;
  }

  showDesktopThirdLevelCollection(dropdown, thirdKey) {
    if (!dropdown || !thirdKey) return false;

    let hasCollectionContent = false;
    dropdown.querySelectorAll("[data-collection-third-panel]").forEach((panel) => {
      const isActive = panel.getAttribute("data-collection-third-panel") === thirdKey;
      panel.hidden = !isActive;
      if (isActive && panel.children.length > 0) {
        hasCollectionContent = true;
      }
    });
    const rootCollectionPanel = dropdown.querySelector("[data-collection-root-panel]");
    if (rootCollectionPanel) {
      rootCollectionPanel.hidden = true;
    }
    return hasCollectionContent;
  }

  showDesktopSecondLevelOverflow(dropdown, secondKey) {
    if (!dropdown || !secondKey) return false;

    let hasOverflowContent = false;
    dropdown.querySelectorAll("[data-second-overflow-panel]").forEach((panel) => {
      const isActive = panel.getAttribute("data-second-overflow-panel") === secondKey;
      panel.hidden = !isActive;
      if (isActive && panel.children.length > 0) {
        hasOverflowContent = true;
      }
    });
    return hasOverflowContent;
  }

  hideDesktopSecondLevelOverflow(dropdown) {
    if (!dropdown) return;
    dropdown.querySelectorAll("[data-second-overflow-panel]").forEach((panel) => {
      panel.hidden = true;
    });
  }

  showDesktopThirdSplitPanel(dropdown, thirdKey) {
    if (!dropdown || !thirdKey) return false;

    let hasThirdSplitContent = false;
    dropdown.querySelectorAll("[data-third-split-panel]").forEach((panel) => {
      const isActive = panel.getAttribute("data-third-split-panel") === thirdKey;
      panel.hidden = !isActive;
      if (isActive && panel.children.length > 0) {
        hasThirdSplitContent = true;
      }
    });
    return hasThirdSplitContent;
  }

  hideDesktopThirdSplitPanels(dropdown) {
    if (!dropdown) return;
    dropdown.querySelectorAll("[data-third-split-panel]").forEach((panel) => {
      panel.hidden = true;
    });
  }

  hideDesktopCollectionPanels(dropdown) {
    if (!dropdown) return;
    dropdown.querySelectorAll("[data-collection-second-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    dropdown.querySelectorAll("[data-collection-third-panel]").forEach((panel) => {
      panel.hidden = true;
    });
    const rootCollectionPanel = dropdown.querySelector("[data-collection-root-panel]");
    if (rootCollectionPanel) {
      rootCollectionPanel.hidden = true;
    }
  }

  updateDesktopMenuCols(dropdown, cols) {
    if (!dropdown) return;
    dropdown.setAttribute("data-cols", String(cols));
  }
  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const headerHeight = this.element.offsetHeight;

      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      visibleHeight = Math.max(visibleHeight, 0);

      if (
        visibleHeight === this._lastVisibleHeight &&
        headerHeight === this._lastHeaderHeight
      ) return;
      this._lastVisibleHeight = visibleHeight;
      this._lastHeaderHeight = headerHeight;

      const style = document.documentElement.style;
      style.setProperty("--header-dynamic-height", `${visibleHeight}px`);
      style.setProperty("--header-height-fixed", `${headerHeight}px`);
    }, Header.HEADER_TRANSITION_DURATION);

  }
  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",

      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  handleCartUpdated(event) {
    const itemCount = event?.detail?.item_count;
    this.syncHeaderCartCount(itemCount);
  }

  syncHeaderCartCount(itemCount) {
    if (!this.headerCartButton || !this.headerCartCount) return;

    const nextCount = Number.isFinite(Number(itemCount)) ? Math.max(0, parseInt(itemCount, 10)) : 0;
    const showCountEnabled = this.headerCartButton.dataset.showCountEnabled !== 'false';

    this.headerCartCount.textContent = String(nextCount);
    this.headerCartCount.style.display = nextCount > 0 ? '' : 'none';
    this.headerCartButton.classList.toggle('show-count', showCountEnabled && nextCount > 0);
  }

  applyReducedMotionToAutoplayVideos() {
    if (!window.matchMedia) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const videos = this.element.querySelectorAll('video[data-respect-reduced-motion="true"]');
    videos.forEach((video) => {
      if (prefersReducedMotion) {
        if (video.autoplay) video.dataset.originalAutoplay = 'true';
        if (video.loop) video.dataset.originalLoop = 'true';
        video.autoplay = false;
        video.loop = false;
        video.pause();
        return;
      }
      if (video.dataset.originalLoop === 'true') video.loop = true;
      if (video.dataset.originalAutoplay === 'true') {
        video.autoplay = true;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => { });
      }
    });
  }

  openMenu(event, target) {
    if (event.type === "focusin" && event.target?.closest?.(".desktop-menu__layout")) {
      return;
    }
    if (target.closest('.desktop-menu__layout')) {
      return;
    }
    // Dispatch a custom event to indicate that the menu is being opened.

    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition();

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    const wrapper = target.querySelector('.desktop-menu__dropdown-wrapper');
    if (wrapper) wrapper.style.display = '';

    target.setAttribute("aria-expanded", "true");
    const desktopDropdown = target.querySelector("[data-desktop-dropdown]");
    this.setupDesktopMegaMenu(desktopDropdown);
    this.clearDesktopMegaMenu(desktopDropdown);
    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => {
      const sibWrapper = item.querySelector('.desktop-menu__dropdown-wrapper');
      if (sibWrapper) sibWrapper.style.display = 'none';
      item.setAttribute("aria-expanded", "false");
    });

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }
    this.element.querySelectorAll("[data-desktop-dropdown]").forEach((d) => this.clearDesktopMegaMenu(d));

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      const wrapper = item.querySelector('.desktop-menu__dropdown-wrapper');
      if (wrapper) wrapper.style.display = 'none';
      item.setAttribute("aria-expanded", "false");
    });
    this.toggleColor();

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("Header--Scrolled");
    } else {
      this.element.classList.remove("Header--Scrolled");
    }
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);
    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");

    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    // Skip old overlay-based transition if View Transitions API is supported
    this.hasViewTransitions = CSS.supports("view-transition-name", "root");
    this.pageOverlay = document.querySelector(".pageTransition");

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.hasViewTransitions) return;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (this.hasViewTransitions) return;
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault();

    if (this.pageOverlay) {
      this.pageOverlay.animate(
        [{ opacity: 0, visibility: 'visible' }, { opacity: 1, visibility: 'visible' }],
        { duration: 250, fill: 'forwards', easing: 'linear' }
      ).onfinish = () => {
        window.location.href = target.href;
      };
    }
  }
}
new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.isTextDisabled = this.element.getAttribute("data-text-disable");
    this.sectionId = this.element.getAttribute("data-section-id");
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);
    this.videoPlayer = null; // Initialize videoPlayer property
    this.isInitialized = false; // Track if video has been initialized
    this.externalControlsStateSyncBound = false;
    this.userChangedMute = false; // Track if user manually toggled mute

    // Defer video init when a poster is present — keeps poster as LCP element
    const hasPoster = this.element.parentElement?.querySelector('.video-poster-eager')
      || this.element.querySelector('.videoHolder--Placeholder');

    if (hasPoster) {
      const initVideo = () => {
        if (!this.isInitialized) {
          this.isInitialized = true;
          this._originalInit();
        }
      };
      ['scroll', 'click', 'touchstart', 'keydown', 'mousemove', 'mouseenter', 'pointermove'].forEach(evt => {
        window.addEventListener(evt, initVideo, { once: true, passive: true });
      });
    } else {
      this._originalInit();
    }
  }

  _originalInit() {
    const isDesktop = !responsive.matchesBreakpoint("phone") || !responsive.matchesBreakpoint("pocket");
    const position = this.element.dataset.position;

    if (this.options["using_fade"] == "fade") {
      // On desktop with custom scroll, use IntersectionObserver for all videos
      if (isDesktop) {
        this.setupScrollBasedLoading();
      } else {
        this.bindEvents();

        // Only load video if it's the first slide or currently active
        if (
          position == 0 ||
          this.element
            .closest(".swiper-slide")
            ?.classList.contains("swiper-slide-active") ||
          this.element
            .closest(".swiper-slide")
            ?.classList.contains("swiper-slide-duplicate-active")
        ) {
          this.checkLoaded();
        }
      }
    } else {
      this.checkLoaded();
    }
  }

  setupScrollBasedLoading() {
    // Use IntersectionObserver to load videos when they come into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isInitialized) {
          observer.unobserve(this.element); // Stop observing once loaded
          this.checkLoaded();
        }
      });
    }, {
      threshold: 0.1, // Load when 10% visible
      rootMargin: "100px" // Start loading 100px before entering viewport
    });

    observer.observe(this.element);
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindHoverEvents() {
    if (this.options["play_in_view_mob_hover_desk"]) {
      this.onMouseEnterListener = this.onMouseEnter.bind(this);
      this.onMouseLeaveListener = this.onMouseLeave.bind(this);

      this.element.addEventListener("mouseenter", this.onMouseEnterListener);
      this.element.addEventListener("mouseleave", this.onMouseLeaveListener);
    }
  }

  onMouseEnter() {
    const isMobile = responsive.matchesBreakpoint("pocket");

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.options["muted"] && !this.userChangedMute) {
        this.videoPlayer.muted("true");
      }
      const playPromise = this.videoPlayer.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Silently catch autoplay prevention
        });
      }
    }
  }

  onMouseLeave() {
    const isMobile = responsive.matchesBreakpoint("pocket");

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.videoPlayer.el_.classList.contains("vjs-playing")) {
        this.videoPlayer.pause();
      }
    }
  }

  getOrCreateControlsContainer() {
    const outerContainer = this.element.closest(".video-container");
    let controlsContainer = outerContainer
      ? outerContainer.querySelector(".video-controls")
      : null;

    if (!controlsContainer) {
      controlsContainer = this.element.querySelector(".video-controls");
    }

    if (controlsContainer) return controlsContainer;

    controlsContainer = document.createElement("div");
    controlsContainer.className = "video-controls video-js";

    if (outerContainer) {
      outerContainer.appendChild(controlsContainer);
    } else {
      this.element.appendChild(controlsContainer);
    }

    return controlsContainer;
  }

  moveControlBarToExternalContainer() {
    if (!this.videoPlayer || !this.options["controls"]) return;

    const controlBar =
      this.videoPlayer.controlBar && this.videoPlayer.controlBar.el
        ? this.videoPlayer.controlBar.el()
        : null;
    if (!controlBar) return;

    const controlsContainer = this.getOrCreateControlsContainer();
    if (!controlsContainer || controlsContainer.contains(controlBar)) return;

    controlsContainer.classList.add("video-js");
    controlsContainer.appendChild(controlBar);
  }

  moveControlBarToPlayerContainer() {
    if (!this.videoPlayer || !this.options["controls"]) return;

    const controlBar =
      this.videoPlayer.controlBar && this.videoPlayer.controlBar.el
        ? this.videoPlayer.controlBar.el()
        : null;
    const playerEl = this.videoPlayer.el();
    if (!controlBar || !playerEl || playerEl.contains(controlBar)) return;

    playerEl.appendChild(controlBar);
  }

  isPlayerFullscreen() {
    if (!this.videoPlayer) return false;
    const playerEl = this.videoPlayer.el();
    return (
      this.videoPlayer.isFullscreen() ||
      playerEl.classList.contains("vjs-fullscreen") ||
      document.fullscreenElement === playerEl
    );
  }

  updateControlBarPlacement() {
    if (!this.videoPlayer || !this.options["controls"]) return;

    if (this.isPlayerFullscreen()) {
      this.moveControlBarToPlayerContainer();
    } else {
      this.moveControlBarToExternalContainer();
    }

    this.bindExternalControlsStateSync();
    this.syncExternalControlsState();
  }

  cleanupExternalControlsContainer() {
    const outerContainer = this.element.closest(".video-container");
    const controlsContainer = outerContainer
      ? outerContainer.querySelector(".video-controls")
      : this.element.querySelector(".video-controls");
    if (!controlsContainer) return;

    controlsContainer.innerHTML = "";
  }

  syncExternalControlsState() {
    if (!this.videoPlayer) return;
    const controlsContainer = this.getOrCreateControlsContainer();
    const playerEl = this.videoPlayer.el();
    if (!controlsContainer || !playerEl) return;

    const mirroredStateClasses = [
      "vjs-has-started",
      "vjs-user-active",
      "vjs-user-inactive",
      "vjs-playing",
      "vjs-paused",
      "vjs-ended",
      "vjs-controls-enabled",
      "vjs-controls-disabled",
      "vjs-error",
      "vjs-fullscreen"
    ];

    mirroredStateClasses.forEach((className) => {
      controlsContainer.classList.toggle(className, playerEl.classList.contains(className));
    });
  }

  bindExternalControlsStateSync() {
    if (!this.videoPlayer || this.externalControlsStateSyncBound) return;

    const syncState = this.syncExternalControlsState.bind(this);
    const handleFullscreenChange = this.updateControlBarPlacement.bind(this);
    [
      "ready",
      "play",
      "pause",
      "ended",
      "useractive",
      "userinactive",
      "loadedmetadata",
      "timeupdate"
    ].forEach((eventName) => {
      this.videoPlayer.on(eventName, syncState);
    });
    this.videoPlayer.on("fullscreenchange", handleFullscreenChange);

    this.externalControlsStateSyncBound = true;
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
      if (this.videoPlayer && !this.options.viewport) {
        this.videoPlayer.pause();
      }
      return;
    }
    if (this._videoScriptObserver) return;
    if (typeof IntersectionObserver === "undefined") {
      loadScript(window.theme.videoScript);
      setTimeout(function () { _this.checkLoaded(); }, 100);
      return;
    }
    this._videoScriptObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      _this._videoScriptObserver.disconnect();
      loadScript(window.theme.videoScript);
      var poll = function () {
        if (typeof videojs !== "undefined") {
          _this.videoPlayerInitialization();
          if (_this.videoPlayer && !_this.options.viewport) _this.videoPlayer.pause();
        } else {
          setTimeout(poll, 100);
        }
      };
      poll();
    }, { rootMargin: "200px" });
    this._videoScriptObserver.observe(this.element);
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    const isMobile = responsive.matchesBreakpoint("pocket");

    if (event.detail.currentIndex == this.elementPosition) {
      // Active slide - initialize or reinitialize video
      if (this.element.getAttribute("loaded")) {
        // Already loaded - on desktop, always reinitialize for fresh controls
        if (!isMobile && this.videoPlayer) {
          this.reinitializeVideoPlayer();
        } else if (!this.videoPlayer) {
          this.checkLoaded();
        }
      } else {
        // First time loading
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        this.checkLoaded();
      }

      // Handle autoplay if enabled
      if ((this.options["play_in_view"]) || (this.options["play_in_view_mob_hover_desk"] && isMobile)) {
        setTimeout(() => {
          if (this.videoPlayer) {
            const playPromise = this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Silently catch autoplay prevention
              });
            }
            this.createObserver();
          }
        }, 200);
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      // Not active slide - pause if playing
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      bigPlayButton: true,
      controlBar: this.options["controls"]
        ? {
          children: [
            "playToggle",
            "progressControl",
            "CustomControlSpacer",
            "MuteToggle",
            "fullscreenToggle"
          ]
        }
        : false,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";
      _this.updateControlBarPlacement();

      // Bind hover events for desktop behavior
      _this.bindHoverEvents();

      // Track when user manually toggles mute via controls
      _this.videoPlayer.on("volumechange", function () {
        _this.userChangedMute = true;
      });

      // Force controls to be interactive on desktop
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        setTimeout(() => {
          _this.ensureDesktopControls();
        }, 100);
      }

      if (_this.trueObserver == false && (_this.options["play_in_view_mob_hover_desk"] || _this.options["play_in_view"])) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        if (!_this.userChangedMute) {
          _this.videoPlayer.muted("true");
        }
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            const playPromise = _this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Silently catch autoplay prevention
              });
            }
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          const playPromise = _this.videoPlayer.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              // Autoplay was prevented, video will play when user interacts
              console.log('Video autoplay prevented:', error);
            });
          }
        } else {
          _this.videoPlayer.pause();
        }
      });
    } else {
      // Disable click interactions completely
      this.videoPlayer.off('click');
      this.videoPlayer.off('touchstart');

      // Hide controls completely
      this.videoPlayer.controls(false);

      // Keep hover/mouseover functionality for desktop autoplay but disable manual clicking
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        // Don't disable pointer events completely - we need hover to work
        // videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';

        // Add a custom click handler that does nothing to prevent any manual control
        videoEl.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);

        videoEl.addEventListener('touchstart', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);
      }
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    const element = this.element;
    observer.observe(element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    const isMobile = responsive.matchesBreakpoint("pocket");

    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer) {
          if (this.options["muted"] && !this.userChangedMute) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              const playPromise = this.videoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.catch(error => {
                  // Autoplay was prevented, video will play when user interacts
                  console.log('Video autoplay prevented:', error);
                });
              }
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && this.videoPlayer && isMobile) {
          if (this.options["muted"] && !this.userChangedMute) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              const playPromise = this.videoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.catch(error => {
                  // Autoplay was prevented, video will play when user interacts
                  console.log('Video autoplay prevented:', error);
                });
              }
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && isMobile &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }

  disposeVideoPlayer() {
    if (this.videoPlayer) {
      try {
        console.log('VideoComponent: Disposing video player');
        this.videoPlayer.dispose();
        this.videoPlayer = null;
        this.externalControlsStateSyncBound = false;
        this.cleanupExternalControlsContainer();
        console.log('VideoComponent: Video player disposed successfully');
      } catch (e) {
        console.warn('VideoComponent: Error disposing video player:', e);
        this.videoPlayer = null; // Force null even if dispose fails
        this.externalControlsStateSyncBound = false;
        this.cleanupExternalControlsContainer();
      }
    }
  }

  ensureDesktopControls() {
    if (!this.videoPlayer) return;

    // Only enable controls if they are supposed to be enabled
    if (this.options["controls"]) {
      // Force controls to be enabled
      this.videoPlayer.controls(true);

      // The main issue was CSS pointer-events, but we can still ensure controls are clickable
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        // Make sure text track display doesn't block clicks
        const textTrackDisplay = this.element.querySelector('.vjs-text-track-display');
        if (textTrackDisplay) {
          textTrackDisplay.style.pointerEvents = 'none';
        }
      }
    } else {
      // Make sure controls stay disabled
      this.videoPlayer.controls(false);

      // Ensure video is non-interactive
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';
      }
    }
  }

  reinitializeVideoPlayer() {
    this.disposeVideoPlayer();

    // Clear the loaded attribute so video can be reinitialized
    this.element.removeAttribute('loaded');
    this.element.removeAttribute('data-loaded');

    // Remove existing video holder completely
    const existingHolder = this.element.querySelector('.videoHolder');
    if (existingHolder) {
      existingHolder.remove();
    }

    // Force a fresh start
    setTimeout(() => {
      this.checkLoaded();
    }, 50);
  }
}
customElements.define("video-component", VideoComponent);




class RecentlyViewedStorage {
  static STORAGE_KEY = "recentlyViewedProductIds";
  static MAX_ITEMS = 8;

  static getIds() {
    try {
      const raw = window.localStorage.getItem(this.STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  static setIds(ids) {
    try {
      const normalized = (ids || [])
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id));

      const limited = normalized.slice(0, this.MAX_ITEMS);
      window.localStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify(limited)
      );
    } catch (e) { }
  }

  static track(currentId) {
    const idNum = Number(currentId);
    if (!idNum || !Number.isFinite(idNum)) return;

    const existing = this.getIds();
    const filtered = existing.filter((id) => id !== idNum);
    filtered.unshift(idNum);
    this.setIds(filtered);
  }
}

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.boundEventHandlers = new Map(); // Store bound event handlers for cleanup
    this.drawerInstances = new Map();
  }

  connectedCallback() {
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();
    const productId = this.dataset.productId;
    if (productId) {
      RecentlyViewedStorage.track(productId);
    }


    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".pm__main-swiper");
    this.carouselElementThumbs = this.element.querySelector(".pm__thumb-swiper");

    this.swipers = this.element.querySelectorAll('.pm__information .swiper');
    this.productForm = this.element.querySelector('[data-product-form]');
    this.options = {};
    if (this.carouselElement) {
      const sectionSettings = this.carouselElement.getAttribute("data-section-settings");
      if (sectionSettings) {
        this.options = JSON.parse(sectionSettings);
      }
    }
    this.stickyAtc = this.element.querySelector('.pm__atc-form--sticky');
    this.fixedAtc = this.element.querySelector('.pm__sticky-atc');
    this.annBar = document.querySelector('.announcement-bar--sticky');

    if (this.fixedAtc) {
      this.fixedInfo = this.fixedAtc.querySelector('.pm__sticky-product-info');
      this.fixedContainer = this.fixedAtc.querySelector('.pm__sticky-atc-container');
    }

    this.header = document.getElementById('header');
    this.footer = document.querySelector('footer-component');
    this.enableAtcMobile = this.element.dataset.enableAtcMobile === 'true';
    this.isMobileStickyAtcEnabled = !this.enableAtcMobile;
    this.hasScrolledSinceLoad = false;
    this.stickyAtcButtonObserver = null;

    document.documentElement.style.setProperty("--sticky-atc-height", `0px`);

    if (this.options.zoom && this.carouselElement) {
      const zoomSlides = this.carouselElement.querySelectorAll(".ProductSliderCell--Zoom");
      this.customImageZoom = new CustomImageZoom(this.element, zoomSlides);
    }

    this.addToCartInstance?.destroy?.();
    this.addToCartInstance = new AddToCart(this.element);

    this.initializeDrawers();
    this.initArticleNoBlocks();

    this.bindEvents()
    this.openFirstFaqDropdown();
    window.whenStylesheetsLoaded().then(() => {
      this.setPmStickyVariables();
      this.setupStickyAtcObserver();
      this.syncStickyAtcState();
      this.onScroll();
    });
  }

  disconnectedCallback() {
    this.addToCartInstance?.destroy?.();
    this.addToCartInstance = null;
    this.cleanupEvents();
  }

  // Clean up all event listeners
  cleanupEvents() {
    if (this.boundEventHandlers.has('scroll')) {
      window.removeEventListener("scroll", this.boundEventHandlers.get('scroll'), { passive: true });
    }
    if (this.boundEventHandlers.has('DOMContentLoaded')) {
      window.removeEventListener("DOMContentLoaded", this.boundEventHandlers.get('DOMContentLoaded'));
    }
    if (this.boundEventHandlers.has('popstate')) {
      window.removeEventListener("popstate", this.boundEventHandlers.get('popstate'));
    }
    if (this.boundEventHandlers.has('resizeStickyVars')) {
      window.removeEventListener("resize", this.boundEventHandlers.get('resizeStickyVars'));
    }
    if (this.boundEventHandlers.has('sizeDrawerOpen')) {
      this.element.removeEventListener("size-drawer:open", this.boundEventHandlers.get('sizeDrawerOpen'));
    }
    // Clean up delegate events
    if (this.delegateElement) {
      this.delegateElement.off('click', '[data-action="add-to-cart-sticky"]');
      this.delegateElement.off('change', '[data-action="handle-fit-change"][data-product-url]');
      this.delegateElement.off('change', '[data-action="handle-color-change"][data-product-url]');
      this.delegateElement.off('change', '[data-size-drawer-input]');
      this.delegateElement.off('click', '[data-action="open-size-guide-from-size-drawer"]');
    }
    if (this.delegateBody) {
      this.delegateBody.off("variant:changed");
    }
    if (this.addToCartInstance) {
      this.addToCartInstance.destroy();
      this.addToCartInstance = null;
    }
    if (this.customImageZoom) {
      this.customImageZoom.destroy();
      this.customImageZoom = null;
    }
    if (this.updateContentController) {
      this.updateContentController.abort();
      this.updateContentController = null;
    }

    this.destroyDrawers();
    if (this.stickyAtcButtonObserver) {
      this.stickyAtcButtonObserver.disconnect();
      this.stickyAtcButtonObserver = null;
    }
    if (this._pmStickyResizeObservers) {
      this._pmStickyResizeObservers.forEach((ro) => ro.disconnect());
      this._pmStickyResizeObservers = null;
    }

    if (this.colorTitlePreviewHandlers) {
      this.colorTitlePreviewHandlers.forEach(({ wrapper, input, onEnter, onLeave }) => {
        wrapper.removeEventListener('mouseenter', onEnter);
        wrapper.removeEventListener('mouseleave', onLeave);
        input.removeEventListener('focus', onEnter);
        input.removeEventListener('blur', onLeave);
      });
      this.colorTitlePreviewHandlers = null;
      this.colorTitlePreviewState = null;
    }

    this.boundEventHandlers.clear();
  }

  openFirstFaqDropdown() {
    if (this.element.dataset.openFirstFaq !== 'true') return;
    const dropdown = this.element.querySelector('.pm__faq-dropdown');
    if (!dropdown) return;
    const dropdownBtn = dropdown.querySelector('.Dropdown--Button');
    if (!dropdownBtn) return;
    if (dropdownBtn.getAttribute('aria-expanded') === 'true') return;
    allDropdowns.updateAllDropdowns();
    allDropdowns.openDropdown(dropdown, dropdownBtn);
  }

  initializeDrawers() {
    const drawers = this.element.querySelectorAll(".Drawer--wrapper");
    this.drawerInstances = new Map();

    drawers.forEach((item) => {
      if (!item.id) return;
      const existing = item._drawerInstance;
      this.drawerInstances.set(item.id, existing || new Drawer(item));
    });
  }

  destroyDrawers() {
    if (!this.drawerInstances || this.drawerInstances.size === 0) return;
    this.drawerInstances.clear();
  }

  waitForDrawerCloseTransition(drawerElement) {
    if (!drawerElement) return Promise.resolve();

    if (!drawerElement.classList.contains("Drawer--animate")) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      let resolved = false;
      const finalize = () => {
        if (resolved) return;
        resolved = true;
        drawerElement.removeEventListener("transitionend", onTransitionEnd);
        resolve();
      };
      const onTransitionEnd = (event) => {
        if (event.target !== drawerElement) return;
        if (event.propertyName !== "opacity") return;
        finalize();
      };

      drawerElement.addEventListener("transitionend", onTransitionEnd);
      window.setTimeout(finalize, 450);
    });
  }

  bindEvents() {
    // Store bound handlers for cleanup
    const scrollHandler = this.onScroll.bind(this);
    const stickyContentHandler = this.setStickyContent.bind(this);
    const boundSetPmStickyVars = this.setPmStickyVariables.bind(this);
    let resizeTimer;
    const stickyVarsResizeHandler = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(boundSetPmStickyVars, 150);
    };
    const reloadPageHandler = this.reloadPage.bind(this);
    const sizeDrawerOpenHandler = this.onSizeDrawerOpen.bind(this);

    this.boundEventHandlers.set('scroll', scrollHandler);
    this.boundEventHandlers.set('DOMContentLoaded', stickyContentHandler);
    this.boundEventHandlers.set('resizeStickyVars', stickyVarsResizeHandler);
    this.boundEventHandlers.set('popstate', reloadPageHandler);
    this.boundEventHandlers.set('sizeDrawerOpen', sizeDrawerOpenHandler);

    window.addEventListener("scroll", scrollHandler, { passive: true });
    window.addEventListener("resize", stickyVarsResizeHandler, { passive: true });
    if (this.stickyAtc) window.addEventListener("DOMContentLoaded", stickyContentHandler);
    this.element.addEventListener("size-drawer:open", sizeDrawerOpenHandler);

    // Sticky add-to-cart trigger
    const productForm = this.element.querySelector('[data-product-form]');
    if (productForm) {
      this.delegateElement.on('click', '[data-action="add-to-cart-sticky"]', () => {
        productForm.querySelector('.pm__atc-button--main')?.click();
      });
    }

    this.delegateBody.on("variant:changed", this.updateImage.bind(this));

    // Back/forward navigation should perform a full reload
    window.addEventListener("popstate", reloadPageHandler);
    this.delegateElement.on(
      "change",
      '[data-action="handle-fit-change"][data-product-url]',
      this.updateContentWithoutReload.bind(this)
    );
    this.delegateElement.on(
      "change",
      '[data-action="handle-color-change"][data-product-url]',
      this.updateContentWithoutReload.bind(this)
    );
    this.delegateElement.on(
      "change",
      "[data-size-drawer-input]",
      this.onSizeDrawerSelectionChange.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="open-size-guide-from-size-drawer"]',
      this.openSizeGuideFromSizeDrawer.bind(this)
    );

    this.delegateElement.on("click", '[data-action="scroll-to-reviews"', this.scrollToReviews.bind(this));
    this.syncSizeDrawerLabel();

    this.bindColorSwatchTitlePreview();
  }

  bindColorSwatchTitlePreview() {
    const desktopMQ = window.matchMedia('(min-width: 1025px)');
    if (!desktopMQ.matches) return;

    const wrappers = this.element.querySelectorAll('.pm__information .pc__color-selector');
    if (!wrappers.length) return;

    const titleEls = () => [
      this.element.querySelector('.pm__product-title'),
      this.element.querySelector('[data-sticky-title]'),
    ].filter(Boolean);

    this.colorTitlePreviewState = { originals: null };

    const apply = (newTitle) => {
      const els = titleEls();
      if (!els.length) return;
      if (!this.colorTitlePreviewState.originals) {
        this.colorTitlePreviewState.originals = els.map((el) => el.textContent);
      }
      els.forEach((el) => { el.textContent = newTitle; });
    };
    const restore = () => {
      const originals = this.colorTitlePreviewState.originals;
      if (!originals) return;
      titleEls().forEach((el, i) => {
        if (originals[i] != null) el.textContent = originals[i];
      });
    };

    this.colorTitlePreviewHandlers = [];
    wrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('.pc__color-checkbox[data-product-title]');
      if (!input) return;
      const title = input.dataset.productTitle;
      if (!title) return;
      const onEnter = () => apply(title);
      const onLeave = () => restore();
      wrapper.addEventListener('mouseenter', onEnter);
      wrapper.addEventListener('mouseleave', onLeave);
      input.addEventListener('focus', onEnter);
      input.addEventListener('blur', onLeave);
      this.colorTitlePreviewHandlers.push({ wrapper, input, onEnter, onLeave });
    });
  }

  onSizeDrawerOpen(event) {
    const drawerElement =
      event?.detail?.drawerElement
      || event?.target?.closest?.(".pm__size-drawer")
      || this.element.querySelector("#pm-size-drawer");

    this.updateSizeDrawerCssVariables(drawerElement);
  }

  updateSizeDrawerCssVariables(drawerElement) {
    if (!drawerElement) return;

    const drawerHeight = drawerElement.offsetHeight || 0;
    const headerHeight =
      drawerElement.querySelector(".Drawer--Header")?.offsetHeight || 0;
    const footerHeight =
      drawerElement.querySelector(".Drawer--Footer")?.offsetHeight || 0;

    document.documentElement.style.setProperty(
      "--size-drawer-height",
      `${drawerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--size-drawer-header-height",
      `${headerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--size-drawer-footer-height",
      `${footerHeight}px`
    );
  }

  syncSizeDrawerLabel(selectedValue) {
    const labels = this.element.querySelectorAll("[data-size-drawer-label]");
    if (!labels.length) return;

    const fallbackLabel = this.element.dataset.selectSizeShortLabel || "";
    const checkedInput = this.element.querySelector("[data-size-drawer-input]:checked");
    const checkedValue = selectedValue
      || checkedInput?.dataset.displayValue
      || checkedInput?.value
      || fallbackLabel;

    labels.forEach((label) => {
      label.textContent = checkedValue;
    });
  }

  onSizeDrawerSelectionChange(e) {
    const targetInput = e.target.closest("[data-size-drawer-input]");
    if (!targetInput) return;

    this.updateDrawerSelectedSizePricing(targetInput);

    const sizeDrawer = this.element.querySelector("#pm-size-drawer");
    if (!sizeDrawer || sizeDrawer.getAttribute("aria-expanded") !== "true") return;

    const closeButton = sizeDrawer.querySelector(
      '[data-action="toggle-drawer"][data-toggle-id="pm-size-drawer"]'
    );

    if (closeButton) {
      closeButton.click();
    }
  }

  updateDrawerSelectedSizePricing(targetInput) {
    if (!targetInput) return;

    const selectedPrice = targetInput.dataset.price;
    const selectedLowestPrice = targetInput.dataset.lowestPrice;

    if (selectedPrice) {
      const regularPriceEl = this.element.querySelector(".price-item--regular");
      if (regularPriceEl) regularPriceEl.textContent = selectedPrice;
    }

    if (selectedLowestPrice) {
      const lowestPriceValueEl = this.element.querySelector(".pm__lowest-price-value");
      if (lowestPriceValueEl) lowestPriceValueEl.textContent = selectedLowestPrice;
    }
  }

  openSizeGuideFromSizeDrawer(e) {
    e.preventDefault();

    const sizeDrawer = this.element.querySelector("#pm-size-drawer");
    const sizeGuideToggle = this.element.querySelector(
      '.pm__size-guide-drawer [data-action="toggle-drawer"][data-toggle-id]'
    );

    if (!sizeGuideToggle) return;

    if (sizeDrawer && sizeDrawer.getAttribute("aria-expanded") === "true") {
      const closeButton = sizeDrawer.querySelector(
        '[data-action="toggle-drawer"][data-toggle-id="pm-size-drawer"]'
      );
      if (closeButton) {
        closeButton.click();
      }

      window.setTimeout(() => {
        sizeGuideToggle.click();
      }, 250);
      return;
    }

    sizeGuideToggle.click();
  }

  updateImage(event) {
    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    if (!imageID || !this.carousel) return;

    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);
    if (!imageEl) return;

    const slideElement = imageEl.closest(".swiper-slide");
    if (!slideElement || !slideElement.parentNode) return;
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);
    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }
  }

  reloadPage(e) {
    window.location.reload();
  }

  getReloadUrl(e) {
    const trigger = e.target.closest('[data-product-url], a[href]');
    if (!trigger) return null;

    const rawUrl = trigger.dataset.productUrl || trigger.getAttribute('href');
    if (!rawUrl) return null;

    const parsedUrl = new URL(rawUrl, window.location.origin);
    return parsedUrl.pathname + parsedUrl.search;
  }

  async updateContentWithoutReload(e) {
    e.preventDefault();
    const triggerAction = e.target.closest('[data-action]')?.dataset.action || '';
    const sizeDrawerId = "pm-size-drawer";
    const activeSizeDrawer = this.element.querySelector(`#${sizeDrawerId}`);
    const shouldRestoreSizeDrawer =
      triggerAction === "handle-fit-change" &&
      activeSizeDrawer &&
      activeSizeDrawer.getAttribute("aria-expanded") === "true";

    if (shouldRestoreSizeDrawer) {
      const activeSizeDrawerInstance = this.drawerInstances.get(sizeDrawerId);
      if (activeSizeDrawerInstance) {
        activeSizeDrawerInstance.closeDrawer();
        await this.waitForDrawerCloseTransition(activeSizeDrawer);
      }
    }

    const previousSelections = {
      fit: this.element.querySelector('[data-action="handle-fit-change"]:checked')?.value || '',
      color: this.element.querySelector('[data-action="handle-color-change"]:checked')?.value || '',
      size: this.element.querySelector('.VariantSelect--size .inputSelectboxCheckbox:checked')?.value || ''
    };
    const url = this.getReloadUrl(e);
    if (!url) return;

    if (this.updateContentController) {
      this.updateContentController.abort();
    }
    this.updateContentController = new AbortController();

    let htmlContent = null;

    try {
      const response = await fetch(url, {
        credentials: "same-origin",
        signal: this.updateContentController.signal
      });
      if (!response.ok) {
        window.location.href = url;
        return;
      }
      const responseText = await response.text();
      htmlContent = new DOMParser()
        .parseFromString(responseText, "text/html")
        .querySelector("product-component.product-module");
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error("Error fetching product content:", error);
      window.location.href = url;
      return;
    }

    if (!htmlContent) {
      window.location.href = url;
      return;
    }

    this.cleanupEvents();

    if (htmlContent.dataset.title) {
      document.title = htmlContent.dataset.title;
    }

    this.element.setAttribute("class", htmlContent.getAttribute("class") || this.element.getAttribute("class"));
    this.element.dataset.productId = htmlContent.dataset.productId || this.element.dataset.productId || "";
    this.element.dataset.title = htmlContent.dataset.title || this.element.dataset.title || "";
    this.element.innerHTML = htmlContent.innerHTML;

    // Reinitialize the component after content update
    this.reinitializeAfterContentUpdate();

    const setChecked = (selector, value, dispatchChange = false) => {
      if (!value) return;
      const input = this.element.querySelector(`${selector}[value="${CSS.escape(value)}"]`);
      if (!input || input.disabled) return;
      input.checked = true;
      if (dispatchChange) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    if (triggerAction === 'handle-color-change') {
      setChecked('[data-action="handle-fit-change"]', previousSelections.fit);
      setChecked('.VariantSelect--size .inputSelectboxCheckbox', previousSelections.size, true);
    } else if (triggerAction === 'handle-fit-change') {
      setChecked('[data-action="handle-color-change"]', previousSelections.color);
      setChecked('[data-action="handle-fit-change"]', previousSelections.fit);
    } else {
      setChecked('[data-action="handle-fit-change"]', previousSelections.fit);
      setChecked('[data-action="handle-color-change"]', previousSelections.color);
      setChecked('.VariantSelect--size .inputSelectboxCheckbox', previousSelections.size, true);
    }

    if (shouldRestoreSizeDrawer) {
      const refreshedSizeDrawerInstance = this.drawerInstances.get(sizeDrawerId);
      if (refreshedSizeDrawerInstance) {
        refreshedSizeDrawerInstance.openDrawer();
      }
    }

    document.body.dispatchEvent(
      new CustomEvent("recommendations:reload", {
        bubbles: true,
        detail: this.element.dataset.productId
      })
    );

    history.pushState(null, null, url);
  }

  reinitializeAfterContentUpdate() {
    this.carouselElement = this.element.querySelector(".pm__main-swiper");
    this.carouselElementThumbs = this.element.querySelector(".pm__thumb-swiper");
    this.productForm = this.element.querySelector('[data-product-form]');
    this.stickyAtc = this.element.querySelector('.pm__atc-form--sticky');
    this.fixedAtc = this.element.querySelector('.pm__sticky-atc');
    this.enableAtcMobile = this.element.dataset.enableAtcMobile === 'true';
    this.isMobileStickyAtcEnabled = !this.enableAtcMobile;
    this.hasScrolledSinceLoad = false;

    if (this.fixedAtc) {
      this.fixedInfo = this.fixedAtc.querySelector('.pm__sticky-product-info');
      this.fixedContainer = this.fixedAtc.querySelector('.pm__sticky-atc-container');
    }

    if (this.carouselElement) {
      const sectionSettings = this.carouselElement.getAttribute("data-section-settings");
      this.options = sectionSettings ? JSON.parse(sectionSettings) : {};

      const existingSwiperInstance = this.carouselElement.getSwiper?.() || null;
      if (!existingSwiperInstance) {
        this.carouselElement.reinitialize?.();
      }
      this.carousel = this.carouselElement.getSwiper?.() || existingSwiperInstance || null;
    }

    if (this.options.zoom && this.carouselElement) {
      if (this.customImageZoom) {
        this.customImageZoom.destroy();
      }
      const zoomSlides = this.carouselElement.querySelectorAll(".ProductSliderCell--Zoom");
      this.customImageZoom = new CustomImageZoom(this.element, zoomSlides);
    }

    this.initializeDrawers();
    if (this.addToCartInstance) {
      this.addToCartInstance.destroy();
    }
    this.addToCartInstance = new AddToCart(this.element);
    this.bindEvents();
    window.whenStylesheetsLoaded().then(() => {
      this.setPmStickyVariables();
      this.setupStickyAtcObserver();
      this.syncStickyAtcState();
      this.onScroll();
    });
  }

  setStickyContent() {
    if (!this.stickyAtc || !this.fixedAtc) return;
    this.setStickyHeight();
    this.syncStickyAtcState();

    const selectorLabels = document.querySelectorAll('variant-selects .pm__selector-label');
    const stickyDetails = this.fixedAtc.querySelector('.pm__sticky-details');
    if (!stickyDetails) return;

    stickyDetails.querySelectorAll('.pm__selector-label').forEach((label) => label.remove());
    if (selectorLabels.length > 1) {
      selectorLabels.forEach((label) => {
        const clonedLabel = label.cloneNode(true);
        stickyDetails.appendChild(clonedLabel);
      });
      return;
    }

    const oneSizeLabel = this.element.dataset.oneSizeLabel;
    const hasVariantSelectors = this.element.querySelector("variant-selects");
    if (hasVariantSelectors || !oneSizeLabel) return;

    const oneSizeDetail = document.createElement("span");
    oneSizeDetail.className = "pm__selector-label u-p3";
    oneSizeDetail.textContent = oneSizeLabel;
    stickyDetails.appendChild(oneSizeDetail);
  }

  setupStickyAtcObserver() {
    if (this.stickyAtcButtonObserver) {
      this.stickyAtcButtonObserver.disconnect();
      this.stickyAtcButtonObserver = null;
    }

    const mainAtcButton = this.element.querySelector('.pm__atc-button--main');
    if (!mainAtcButton) return;

    this.stickyAtcButtonObserver = new MutationObserver(() => {
      this.syncStickyAtcState();
    });

    this.stickyAtcButtonObserver.observe(mainAtcButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  syncStickyAtcState() {
    const mainAtcButton = this.element.querySelector('.pm__atc-button--main');
    const stickyAtcButton = this.element.querySelector('[data-action="add-to-cart-sticky"]');
    if (!mainAtcButton || !stickyAtcButton) return;

    const nextState = mainAtcButton.dataset.atcState || "default";
    stickyAtcButton.dataset.atcState = nextState;

    if (mainAtcButton.hasAttribute("disabled")) {
      stickyAtcButton.setAttribute("disabled", "disabled");
    } else {
      stickyAtcButton.removeAttribute("disabled");
    }

    const labels = ["default", "select-size", "adding", "added"];
    labels.forEach((stateKey) => {
      const sourceLabel = mainAtcButton.querySelector(`[data-atc-text-state="${stateKey}"]`);
      const targetLabel = stickyAtcButton.querySelector(`[data-atc-text-state="${stateKey}"]`);
      if (sourceLabel && targetLabel) targetLabel.textContent = sourceLabel.textContent;
    });

    const sourceBrand = this.element.querySelector('.pm__title-meta > span');
    const sourceTitle = this.element.querySelector('.pm__product-title');
    const sourcePrice = this.element.querySelector('.ProductInfo--Prices .price-item--regular');
    const sourceCompareWrapper = this.element.querySelector('.ProductInfo--Prices .price-compare');
    const sourceCompare = sourceCompareWrapper?.querySelector('s');
    const targetBrand = this.element.querySelector('[data-sticky-brand]');
    const targetTitle = this.element.querySelector('[data-sticky-title]');
    const targetPrice = this.element.querySelector('[data-sticky-price]');
    const targetCompare = this.element.querySelector('[data-sticky-compare]');

    if (targetBrand && sourceBrand) targetBrand.textContent = sourceBrand.textContent.trim();
    if (targetTitle && sourceTitle) targetTitle.textContent = sourceTitle.textContent.trim();
    if (targetPrice && sourcePrice) targetPrice.textContent = sourcePrice.textContent.trim();
    if (targetCompare) {
      const compareVisible = sourceCompareWrapper && !sourceCompareWrapper.classList.contains("VisuallyHidden");
      const compareText = sourceCompare ? sourceCompare.textContent.trim() : "";
      const compareElement = targetCompare.querySelector("s");

      if (compareElement) {
        compareElement.textContent = compareText;
      } else {
        targetCompare.textContent = compareText;
      }
      targetCompare.classList.toggle("VisuallyHidden", !compareVisible || !compareText);
    }
  }

  setPmStickyVariables() {
    const stickyContainer = this.element.querySelector('.pm__content-inner');
    if (!stickyContainer) return;

    // Include all [data-pm-hidden] in the offset (description + USP are position:static but
    // their height must still pad --pm-sticky-hidden-height so .pm__information can travel
    // far enough for them to fully clear under the sticky ATC stack).
    const hiddenElements = Array.from(stickyContainer.querySelectorAll('[data-pm-hidden]'));
    const stickyElements = Array.from(stickyContainer.querySelectorAll('[data-pm-sticky]'))
      .filter((el) => !el.closest('.pm__upsell-sticky-parent'));

    const measureElementHeight = (element) => {
      const styles = window.getComputedStyle(element);
      const marginTop = parseFloat(styles.marginTop) || 0;
      const marginBottom = parseFloat(styles.marginBottom) || 0;
      const rectHeight = element.getBoundingClientRect().height || element.offsetHeight || 0;
      return rectHeight + marginTop + marginBottom;
    };

    const writeHiddenVar = () => {
      const total = hiddenElements.reduce((sum, el) => sum + measureElementHeight(el), 0);
      stickyContainer.style.setProperty('--pm-sticky-hidden-height', `${Math.ceil(total + 50)}px`);
    };
    const writeStickyVar = (element, index) => {
      stickyContainer.style.setProperty(`--pm-sticky-element-${index}`, `${Math.ceil(measureElementHeight(element))}px`);
    };

    const previousStickyElementsCount = Number(this.pmStickyElementsCount || 0);
    for (let index = stickyElements.length; index < previousStickyElementsCount; index += 1) {
      stickyContainer.style.removeProperty(`--pm-sticky-element-${index}`);
    }

    writeHiddenVar();
    stickyElements.forEach((element, index) => writeStickyVar(element, index));
    this.pmStickyElementsCount = stickyElements.length;

    if (this._pmStickyResizeObservers) {
      this._pmStickyResizeObservers.forEach((ro) => ro.disconnect());
    }
    this._pmStickyResizeObservers = [];

    if (typeof ResizeObserver === 'undefined') return;

    stickyElements.forEach((element, index) => {
      if (element.classList.contains('pm__faq-group')) return;
      const ro = new ResizeObserver(() => writeStickyVar(element, index));
      ro.observe(element);
      this._pmStickyResizeObservers.push(ro);
    });
    hiddenElements.forEach((element) => {
      const ro = new ResizeObserver(writeHiddenVar);
      ro.observe(element);
      this._pmStickyResizeObservers.push(ro);
    });
  }

  setStickyHeight() {
    if (!this.fixedAtc) return;

    this.fixedAtc.style.visibility = 'hidden';
    this.fixedAtc.style.pointerEvents = 'none';

    const show = this.fixedAtc.classList.contains('show');
    const originalAriaHidden = this.fixedAtc.getAttribute('aria-hidden');

    if (!show) {
      this.fixedAtc.classList.add('show');
      this.fixedAtc.setAttribute('aria-hidden', 'false'); // Show = aria-hidden false
    }

    document.documentElement.style.setProperty(
      "--sticky-atc-height",
      `${this.fixedAtc.offsetHeight}px`
    );

    if (!show) {
      this.fixedAtc.classList.remove('show');
      this.fixedAtc.setAttribute('aria-hidden', originalAriaHidden || 'true'); // Remove show = aria-hidden true
    }

    this.fixedAtc.style.visibility = '';
    this.fixedAtc.style.pointerEvents = '';
  }

  hideFixedAtc() {
    if (!this.fixedAtc) return;
    this.fixedAtc.classList.remove('show');
    this.fixedAtc.setAttribute('aria-hidden', 'true');
  }

  onScroll() {
    if (!this.fixedAtc || !this.footer) return;

    this.syncStickyAtcState();

    const isDesktop = this.responsive.matchesBreakpoint('lap_and_up');
    const isUserScrolling = window.scrollY > 8;
    if (isUserScrolling) this.hasScrolledSinceLoad = true;
    const footerHeight = this.footer.offsetHeight;
    const reachedFooter = window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight;
    const annBarHeight = this.annBar?.offsetHeight || 0;
    const headerOffset = (this.header?.offsetHeight || 0) + annBarHeight;
    const productComponentBottom = this.element.getBoundingClientRect().bottom;
    const passedProductComponent = productComponentBottom <= headerOffset;

    let shouldShow = false;
    if (isDesktop) {
      shouldShow = passedProductComponent && !reachedFooter;
    } else if (this.isMobileStickyAtcEnabled) {
      shouldShow = this.hasScrolledSinceLoad && isUserScrolling && !reachedFooter;
    }

    this.fixedAtc.classList.toggle('show', shouldShow);
    this.fixedAtc.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  }

  scrollToReviews(e) {
    e?.preventDefault();
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    const offset = headerHeight + 100;
    const triggerElement = e?.target?.closest('[data-action="scroll-to-reviews"]');
    const targetSelector = triggerElement?.dataset.scrollTarget || "#judgeme_product_reviews";

    let reviewsWidget;
    try {
      reviewsWidget = document.querySelector(targetSelector);
    } catch {
      return;
    }
    if (!reviewsWidget) return;

    const targetPosition = reviewsWidget?.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  initArticleNoBlocks() {
    const blocks = this.element.querySelectorAll('[data-pdp-article-block]');
    blocks.forEach((block) => {
      if (block.dataset.pdpArticleInit === '1') return;
      block.dataset.pdpArticleInit = '1';

      const valueEl = block.querySelector('[data-pdp-article-no-value]');
      if (!valueEl) return;

      const defaultValue = valueEl.dataset.defaultValue || '';

      const update = () => {
        const checked = this.element.querySelector(
          '.inputSelectboxCheckbox[data-article-no]:checked, .pm__size-drawer-input[data-article-no]:checked'
        );
        const articleNo = checked && checked.dataset.articleNo;
        valueEl.textContent = articleNo || defaultValue;
      };

      this.element.addEventListener('change', () => setTimeout(update, 0));
    });
  }
}
customElements.define("product-component", ProductElement);

class NotifyMeDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.onProductVariantChanged = this.handleVariantSelectionChanged.bind(this);
    this.onProductChange = this.handleProductChange.bind(this);
    this.onSendClick = this.handleSendClick.bind(this);
    this.autoCloseTimeout = null;
  }

  connectedCallback() {
    this.productElement = this.element.closest("product-component, .quick-add-product");
    this.sendButton = this.element.querySelector('[data-action="notify-me-send"]');
    this.emailInput = this.element.querySelector(".pm__notify-me-email");
    this.contentContainer = this.element.querySelector(".pm__notify-me-content");
    this.checkboxInputs = Array.from(this.element.querySelectorAll(".pm__notify-me-checkbox-input"));
    this.successContent = this.element.querySelector(".pm__notify-me-content--success");
    this.footerContainer = this.element.querySelector(".pm__notify-me-footer");
    this.drawer = new Drawer(this.element);

    if (this.sendButton) {
      this.sendButton.addEventListener("click", this.onSendClick);
    }

    if (this.productElement) {
      this.productElement.addEventListener("variant:changed", this.onProductVariantChanged);
      this.productElement.addEventListener("change", this.onProductChange);
    }

    this.syncFromProductState();
    this.resetSuccessState();
  }

  disconnectedCallback() {
    this.clearAutoCloseTimeout();

    if (this.sendButton) {
      this.sendButton.removeEventListener("click", this.onSendClick);
    }

    if (this.productElement) {
      this.productElement.removeEventListener("variant:changed", this.onProductVariantChanged);
      this.productElement.removeEventListener("change", this.onProductChange);
    }
  }

  handleVariantSelectionChanged() {
    this.syncFromProductState();
    this.resetSuccessState();
  }

  handleProductChange(event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest("[data-product-form]")) return;
    this.handleVariantSelectionChanged();
  }

  handleSendClick(event) {
    event.preventDefault();

    if (!this.validateSubmissionFields()) return;

    if (this.contentContainer) {
      this.contentContainer.style.display = "none";
    }

    if (this.successContent) {
      this.successContent.style.display = "block";
    }

    if (this.footerContainer) {
      this.footerContainer.style.display = "none";
    }

    this.scheduleAutoClose();
  }

  validateSubmissionFields() {
    const emailValue = this.emailInput?.value?.trim() || "";

    if (!emailValue || !this.emailInput?.checkValidity()) {
      this.emailInput?.reportValidity();
      return false;
    }

    const unchecked = this.checkboxInputs.filter((checkbox) => !checkbox.checked);
    if (unchecked.length > 0 || this.checkboxInputs.length < 2) {
      unchecked.forEach((checkbox) => {
        const row = checkbox.closest(".pm__notify-me-checkbox-row");
        if (row) {
          row.classList.add("pm__notify-me-checkbox-row--error");
          checkbox.addEventListener("change", () => {
            row.classList.remove("pm__notify-me-checkbox-row--error");
          }, { once: true });
        }
      });
      return false;
    }
    return true;
  }

  resetSuccessState() {
    this.clearAutoCloseTimeout();

    if (this.contentContainer) {
      this.contentContainer.style.display = "";
    }

    if (this.successContent) {
      this.successContent.style.display = "none";
    }

    if (this.footerContainer) {
      this.footerContainer.style.display = "";
    }
  }

  scheduleAutoClose() {
    this.clearAutoCloseTimeout();

    this.autoCloseTimeout = window.setTimeout(() => {
      if (this.element.getAttribute("aria-expanded") !== "true") return;

      const drawerToggle = this.element.querySelector(
        `[data-action="toggle-drawer"][data-toggle-id="${this.element.id}"]`
      );
      if (!drawerToggle) return;

      drawerToggle.click();
    }, 3000);
  }

  clearAutoCloseTimeout() {
    if (!this.autoCloseTimeout) return;

    clearTimeout(this.autoCloseTimeout);
    this.autoCloseTimeout = null;
  }

  getSelectedVariantId() {
    const variantInput = this.productElement?.querySelector('[data-product-form] input[name="id"]');
    return variantInput ? variantInput.value : "";
  }

  syncFromProductState() {
    const variantId = this.getSelectedVariantId();
    if (!variantId) return;

    const variantNode = this.element.querySelector(`[data-notify-variant-item][data-variant-id="${CSS.escape(variantId)}"]`);
    if (!variantNode) return;

    const imageUrl = variantNode.dataset.imageUrl || "";
    const imageEl = this.element.querySelector(".pm__notify-me-product-image-el");
    if (imageEl && imageUrl) {
      imageEl.setAttribute("src", imageUrl);
    }

    const sizeValue = variantNode.dataset.size || "";
    const sizeLabel = this.element.dataset.sizeLabel || "Size";
    const fitEl = this.element.querySelector("[data-notify-fit]");
    const colorEl = this.element.querySelector("[data-notify-color]");

    const sizeEl = this.element.querySelector("[data-notify-size]");

    if (sizeEl) {
      const sizeText = sizeValue ? `${sizeLabel} - ${sizeValue}` : "";
      sizeEl.textContent = sizeText;
      sizeEl.classList.toggle("VisuallyHidden", !sizeText);
    }
  }

  openDrawer() {
    this.syncFromProductState();
    this.resetSuccessState();

    if (this.element.getAttribute("aria-expanded") === "true") return;

    const drawerToggle = this.element.querySelector(
      `[data-action="toggle-drawer"][data-toggle-id="${this.element.id}"]`
    );
    if (!drawerToggle) return;

    drawerToggle.click();
  }
}
customElements.define("notify-me-drawer", NotifyMeDrawer);

class SizeDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.drawer = this.element._drawerInstance || new Drawer(this.element);
    this.element.addEventListener('change', this.onSizeSelected.bind(this));
  }

  onSizeSelected(event) {
    const input = event.target.closest('[data-size-drawer-input]');
    if (!input || !input.checked || input.disabled) return;

    this.syncTriggerLabel(input);

    if (this.element.getAttribute('aria-expanded') !== 'true') return;
    this.drawer?.closeDrawer?.();
  }

  syncTriggerLabel(input) {
    if (!this.element.id) return;
    const triggers = document.querySelectorAll(
      `[data-toggle-id="${this.element.id}"] [data-size-drawer-label]`
    );
    if (!triggers.length) return;

    const value = input.dataset.displayValue || input.value;
    triggers.forEach((label) => {
      label.textContent = value || label.dataset.defaultLabel || label.textContent;
    });
  }
}
customElements.define("size-drawer", SizeDrawer);

class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.fitTabs = [];
    this.fitPanels = [];
    this.measurementUnitButtons = [];
    this.currentMeasurementUnit = "cm";
    this.abortController = null;
  }

  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();

    this.bindFitTabs();
    this.initializePanels();
    this.bindMeasurementUnitToggles();
    this.bindSizeConversionTableHover();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;

    this.element
      .querySelectorAll("[data-size-guide-size-tab]")
      .forEach((sizeTab) => {
        delete sizeTab.dataset.sizeGuideBound;
      });

    this.fitTabs = [];
    this.fitPanels = [];
    this.measurementUnitButtons = [];
  }

  bindFitTabs() {
    this.fitTabs = Array.from(this.element.querySelectorAll("[data-size-guide-fit-tab]"));
    this.fitPanels = Array.from(this.element.querySelectorAll("[data-size-guide-fit-panel]"));
    if (!this.fitTabs.length || !this.fitPanels.length) return;

    const listenerOptions = this.abortController ? { signal: this.abortController.signal } : undefined;

    this.fitTabs.forEach((tabButton) => {
      tabButton.addEventListener("click", () => {
        const targetPanelId = tabButton.dataset.sizeGuideFitTarget;
        if (!targetPanelId) return;
        this.activateFitPanel(targetPanelId);
      }, listenerOptions);
    });
  }

  initializePanels() {
    this.fitPanels = Array.from(this.element.querySelectorAll("[data-size-guide-fit-panel]"));

    if (!this.fitPanels.length) {
      this.initializeSizeSelectors(this.element);
      return;
    }

    this.fitPanels.forEach((panel) => {
      this.initializeSizeSelectors(panel);
    });
  }

  activateFitPanel(targetPanelId) {
    this.fitPanels.forEach((panel) => {
      const isActive = panel.dataset.sizeGuideFitPanelId === targetPanelId;
      panel.classList.toggle("is-hidden", !isActive);
    });

    this.fitTabs.forEach((tabButton) => {
      const isActive = tabButton.dataset.sizeGuideFitTarget === targetPanelId;
      tabButton.classList.toggle("is-active", isActive);
      tabButton.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    const activePanel = this.fitPanels.find(
      (panel) => panel.dataset.sizeGuideFitPanelId === targetPanelId
    );
    if (activePanel) {
      this.initializeSizeSelectors(activePanel, true);
    }
  }

  initializeSizeSelectors(scopeElement, forceReset = false) {
    const sizeTabs = Array.from(scopeElement.querySelectorAll("[data-size-guide-size-tab]"));
    const sizeColumns = Array.from(scopeElement.querySelectorAll("[data-size-guide-size-column]"));
    if (!sizeTabs.length || !sizeColumns.length) return;

    const listenerOptions = this.abortController ? { signal: this.abortController.signal } : undefined;

    sizeTabs.forEach((sizeTab) => {
      if (sizeTab.dataset.sizeGuideBound === "true" && !forceReset) return;

      sizeTab.dataset.sizeGuideBound = "true";
      sizeTab.addEventListener("click", () => {
        const selectedIndex = Number(sizeTab.dataset.sizeGuideSizeIndex || 0);
        this.setActiveSize(scopeElement, selectedIndex);
      }, listenerOptions);
    });

    const defaultIndex = sizeTabs.length > 1 ? 1 : 0;
    this.setActiveSize(scopeElement, defaultIndex);
  }

  setActiveSize(scopeElement, selectedIndex) {
    const sizeTabs = Array.from(scopeElement.querySelectorAll("[data-size-guide-size-tab]"));
    const sizeColumns = Array.from(scopeElement.querySelectorAll("[data-size-guide-size-column]"));
    if (!sizeTabs.length || !sizeColumns.length) return;

    const maxIndex = sizeTabs.length - 1;
    const activeIndex = Math.max(0, Math.min(selectedIndex, maxIndex));
    const visibleIndexes = [];

    if (sizeTabs.length <= 3) {
      for (let index = 0; index <= maxIndex; index += 1) {
        visibleIndexes.push(index);
      }
    } else {
      let windowStart = activeIndex - 1;
      if (windowStart < 0) windowStart = 0;
      if (windowStart > maxIndex - 2) windowStart = maxIndex - 2;

      visibleIndexes.push(windowStart, windowStart + 1, windowStart + 2);
    }

    sizeTabs.forEach((sizeTab) => {
      const index = Number(sizeTab.dataset.sizeGuideSizeIndex || 0);
      const isActive = index === activeIndex;
      sizeTab.classList.toggle("is-active", isActive);
      sizeTab.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    sizeColumns.forEach((column) => {
      const index = Number(column.dataset.sizeGuideSizeIndex || 0);
      const isActive = index === activeIndex;
      const isVisible = visibleIndexes.includes(index);
      column.classList.toggle("is-active", isActive);
      column.classList.toggle("is-hidden", !isVisible);
    });
  }

  bindMeasurementUnitToggles() {
    this.measurementUnitButtons = Array.from(this.element.querySelectorAll("[data-action='size-guide-unit-toggle']"));
    if (!this.measurementUnitButtons.length) return;

    const listenerOptions = this.abortController ? { signal: this.abortController.signal } : undefined;

    this.cacheMeasurementValuesInCm();
    this.measurementUnitButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const nextUnit = button.dataset.sizeGuideUnit;
        if (!nextUnit) return;
        this.setMeasurementUnit(nextUnit);
      }, listenerOptions);
    });
    this.setMeasurementUnit("cm");
  }

  cacheMeasurementValuesInCm() {
    const measurementValues = Array.from(this.element.querySelectorAll("[data-size-guide-measurement-value]"));
    if (!measurementValues.length) return;

    measurementValues.forEach((valueNode) => {
      if (valueNode.dataset.sizeGuideCmValueCached === "true") return;
      valueNode.dataset.sizeGuideCmValue = (valueNode.textContent || "").trim();
      valueNode.dataset.sizeGuideCmValueCached = "true";
    });
  }

  setMeasurementUnit(nextUnit) {
    if (nextUnit !== "cm" && nextUnit !== "inch") return;

    this.cacheMeasurementValuesInCm();
    this.currentMeasurementUnit = nextUnit;

    const measurementValues = Array.from(this.element.querySelectorAll("[data-size-guide-measurement-value]"));
    measurementValues.forEach((valueNode) => {
      const cmValue = valueNode.dataset.sizeGuideCmValue || (valueNode.textContent || "").trim();
      if (nextUnit === "inch") {
        valueNode.textContent = this.convertCmTextToInchText(cmValue);
      } else {
        valueNode.textContent = cmValue;
      }
    });

    this.measurementUnitButtons.forEach((button) => {
      const isActive = button.dataset.sizeGuideUnit === nextUnit;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  convertCmTextToInchText(cmText) {
    if (!cmText) return cmText;

    const convertedNumbersText = cmText.replace(/(\d+(?:[.,]\d+)?)/g, (match) => {
      const normalizedValue = Number(match.replace(",", "."));
      if (Number.isNaN(normalizedValue)) return match;
      const inchesValue = normalizedValue * 0.3937007874;
      const roundedInchesValue = Math.round(inchesValue * 10) / 10;
      return Number.isInteger(roundedInchesValue)
        ? String(roundedInchesValue)
        : roundedInchesValue.toFixed(1).replace(/\.0$/, "");
    });

    return convertedNumbersText
      .replace(/\bcentimet(?:er|re)s?\b/gi, "in")
      .replace(/\bcms?\b/gi, "in");
  }

  bindSizeConversionTableHover() {
    const tables = Array.from(this.element.querySelectorAll("[data-size-conversion-table]"));
    if (!tables.length) return;

    const desktopQuery = window.matchMedia("(min-width: 1025px)");
    const listenerOptions = this.abortController ? { signal: this.abortController.signal } : undefined;

    tables.forEach((table) => {
      const cells = Array.from(table.querySelectorAll("[data-size-conversion-cell]"));
      if (!cells.length) return;

      const rowIndexes = Array.from(
        new Set(cells.map((cell) => Number(cell.dataset.sizeConversionRowIndex || 0)))
      ).sort((a, b) => a - b);
      const columnIndexes = Array.from(
        new Set(cells.map((cell) => Number(cell.dataset.sizeConversionColumnIndex || 0)))
      ).sort((a, b) => a - b);
      const firstRowIndex = rowIndexes[0];
      const lastRowIndex = rowIndexes[rowIndexes.length - 1];
      const firstColumnIndex = columnIndexes[0];
      const lastColumnIndex = columnIndexes[columnIndexes.length - 1];

      const resetTargetState = () => {
        cells.forEach((cell) => {
          cell.classList.remove("is-targeted-row");
          cell.classList.remove("is-targeted-column");
          cell.classList.remove("is-targeted-row-left");
          cell.classList.remove("is-targeted-row-right");
          cell.classList.remove("is-targeted-column-top");
          cell.classList.remove("is-targeted-column-bottom");
          cell.classList.remove("is-targeted-row-adjacent-top");
          cell.classList.remove("is-targeted-column-adjacent-left");
        });
      };

      const applyTargetState = (rowIndex, columnIndex) => {
        resetTargetState();
        const targetRow = Number(rowIndex);
        const targetColumn = Number(columnIndex);

        cells.forEach((tableCell) => {
          const cellRowIndex = Number(tableCell.dataset.sizeConversionRowIndex || 0);
          const cellColumnIndex = Number(tableCell.dataset.sizeConversionColumnIndex || 0);

          if (cellRowIndex === targetRow) {
            tableCell.classList.add("is-targeted-row");
            if (cellColumnIndex === firstColumnIndex) {
              tableCell.classList.add("is-targeted-row-left");
            }
            if (cellColumnIndex === lastColumnIndex) {
              tableCell.classList.add("is-targeted-row-right");
            }
          }

          if (cellRowIndex === targetRow - 1) {
            tableCell.classList.add("is-targeted-row-adjacent-top");
          }

          if (cellColumnIndex === targetColumn) {
            tableCell.classList.add("is-targeted-column");
            if (cellRowIndex === firstRowIndex) {
              tableCell.classList.add("is-targeted-column-top");
            }
            if (cellRowIndex === lastRowIndex) {
              tableCell.classList.add("is-targeted-column-bottom");
            }
          }

          if (cellColumnIndex === targetColumn - 1) {
            tableCell.classList.add("is-targeted-column-adjacent-left");
          }
        });
      };

      const handleCellInteraction = (cell) => {
        const rowIndex = cell.dataset.sizeConversionRowIndex;
        const columnIndex = cell.dataset.sizeConversionColumnIndex;
        applyTargetState(rowIndex, columnIndex);
      };

      cells.forEach((cell) => {
        cell.addEventListener("mouseenter", () => {
          if (desktopQuery.matches) handleCellInteraction(cell);
        }, listenerOptions);
        cell.addEventListener("click", () => {
          if (!desktopQuery.matches) handleCellInteraction(cell);
        }, listenerOptions);
      });

      table.addEventListener("mouseleave", () => {
        if (desktopQuery.matches) resetTargetState();
      }, listenerOptions);
    });
  }
}

customElements.define("size-guide", SizeGuide);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.isQuickAdd = this.element.dataset.quickAdd === "true";
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this._boundVariantChange = this.onVariantChange.bind(this);
    this._boundExternalChange = this.onExternalVariantInputChange.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    this._abortController = new AbortController();
    const signal = this._abortController.signal;

    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    this.element.querySelectorAll("select, input").forEach((item) => {
      item.addEventListener("change", this._boundVariantChange, { signal });
    });

    this._selectionScope = this.getSelectionScope();
    if (this._selectionScope) {
      this._selectionScope.addEventListener("change", this._boundExternalChange, { signal });
    }
  }

  disconnectedCallback() {
    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }
    this.delegateBody.off("quantity:changed");
    this._atcCache = null;
  }


  onQuantityChange() {
    if (this.isQuickAdd) return;
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.updateMedia();

    if (this.isQuickAdd) {
      this.renderQuickAddProductInfo();
      return;
    }

    this.updateMainProductPriceDisplay();
    this.updatePriceAndLowestPriceFromSelectedSizeData();
    this.toggleAddButton();
    this.updatePickupAvailability();
    this.updateURL();
    this.renderProductInfo();
  }

  onExternalVariantInputChange(event) {
    const externalSizeInput = event.target.closest("[data-size-drawer-input]");
    if (!externalSizeInput) return;
    this.onVariantChange();
  }

  getSelectionScope() {
    return this.element.closest(".quick-add-product, product-component");
  }

  updateOptions() {
    const selectionScope = this.getSelectionScope() || this.element;
    const optionCount = this.getVariantData()?.[0]?.options?.length || 0;

    this.options = Array.from(
      { length: optionCount },
      (_, optionIndex) => {
        const optionPosition = optionIndex + 1;
        const checkedInput = selectionScope.querySelector(
          `input[name="${optionPosition}"]:checked`
        );
        if (checkedInput) return checkedInput.value;

        const selectedSelect = this.element.querySelector(
          `select[name="${optionPosition}"]`
        );
        return selectedSelect ? selectedSelect.value : undefined;
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: {
          new_image: newMedia,
          variant: this.currentVariant,
        },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) return;

    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.removeAttribute("disabled");
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    if (!this.currentVariant) return;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const stockInfoSelector = ".pm__lowest-price-stock-wrapper";
        const stockInfoDestinations = document.querySelectorAll(stockInfoSelector);
        const stockInfoSource = html.querySelector(stockInfoSelector);

        if (stockInfoSource && stockInfoDestinations) {
          stockInfoDestinations.forEach((destination) => {
            destination.innerHTML = stockInfoSource.innerHTML;
          });
        }
        this.updatePriceAndLowestPriceFromSelectedSizeData();

        const quantityButton = document.querySelector('.QuantityHandler');
        if (quantityButton) {
          const source = html.querySelector('.QuantityHandler');
          if (source && quantityButton) quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }

  updateMainProductPriceDisplay() {
    if (!this.currentVariant) return;

    const productElement = this.element.closest("product-component");
    const pricesContainer = productElement
      ? productElement.querySelector(".ProductInfo--Prices")
      : document.querySelector(".ProductInfo--Prices");

    if (!pricesContainer) return;

    updatePriceDisplay(pricesContainer, this.currentVariant, window.theme.moneyFormat);
  }

  renderQuickAddProductInfo() {
    const quickAddContainer = this.element.closest('.quick-add-product');
    if (!quickAddContainer) return;

    const quickAddForm = quickAddContainer.querySelector('.quick-add-product__form');
    if (quickAddForm) {
      quickAddForm.dataset.currentVariantAvailable = this.currentVariant && this.currentVariant.available
        ? 'true'
        : 'false';
    }

    if (!this.currentVariant) {
      this.element.dispatchEvent(
        new CustomEvent('quick-add:variant-updated', { bubbles: true })
      );
      return;
    }

    this.element.dataset.sku = this.currentVariant.sku || '';

    updatePriceDisplay(quickAddContainer, this.currentVariant, window.theme.moneyFormat);

    this.element.dispatchEvent(
      new CustomEvent('quick-add:variant-updated', { bubbles: true })
    );
  }



  cacheToggleAddButtonElements() {
    const productElement = this.element.closest("product-component");
    const addButton = productElement
      ? productElement.querySelector(".ProductPage--ATC")
      : document.querySelector(".ProductPage--ATC");

    this._atcCache = {
      productElement,
      addButton,
      variantInput: productElement
        ? productElement.querySelector('[data-product-form] input[name="id"]')
        : document.querySelector('[data-product-form] input[name="id"]'),
      defaultLabel: addButton?.querySelector('[data-atc-text-state="default"]'),
      addingLabel: addButton?.querySelector('[data-atc-text-state="adding"]'),
      addedLabel: addButton?.querySelector('[data-atc-text-state="added"]'),
      selectSizeLabelElement: addButton?.querySelector('[data-atc-text-state="select-size"]'),
      addToBagLabel: productElement?.dataset.addToBagLabel || window.variantStrings?.addToBag,
      addingToBagLabel: productElement?.dataset.addingToBagLabel || window.variantStrings?.addingToBag,
      addedStateLabel: productElement?.dataset.addedLabel || window.variantStrings?.added,
      soldOutLabel: window.variantStrings?.soldOut,
      selectSizeLabel: productElement?.dataset.selectSizeLabel || window.variantStrings?.selectSize || 'Please select size',
    };
  }

  toggleAddButton() {
    if (!this._atcCache?.addButton || !this._atcCache.addButton.isConnected) {
      this.cacheToggleAddButtonElements();
    }
    const { productElement, addButton, variantInput, defaultLabel, addingLabel, addedLabel,
      selectSizeLabelElement, addToBagLabel, addingToBagLabel, addedStateLabel, soldOutLabel, selectSizeLabel } = this._atcCache;
    if (!addButton) return;

    const selectionScope = this.getSelectionScope() || this.element;
    const sizeInputs = selectionScope.querySelectorAll(
      '.VariantSelect--size .inputSelectboxCheckbox:not(:disabled), .pm__size-drawer-input:not(:disabled)'
    );
    const hasSizeInputs = sizeInputs.length > 0;
    const hasSelectedSize = hasSizeInputs
      ? Array.from(sizeInputs).some((input) => input.checked)
      : true;
    if (addingLabel) addingLabel.textContent = addingToBagLabel;
    if (addedLabel) addedLabel.textContent = addedStateLabel;

    if (!this.currentVariant || !hasSelectedSize) {
      this.toggleNotifyButton(productElement, false);
      addButton.setAttribute("disabled", "disabled");
      if (variantInput) variantInput.setAttribute("disabled", "disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      addButton.dataset.atcState = "select-size";
      if (defaultLabel) defaultLabel.textContent = addToBagLabel;
      if (selectSizeLabelElement) selectSizeLabelElement.textContent = selectSizeLabel;
      this.updateFromPriceWhenSizeUnselected(hasSizeInputs, hasSelectedSize);
      return;
    }

    if (variantInput) variantInput.removeAttribute("disabled");

    if (this.currentVariant.available == false) {
      this.toggleNotifyButton(productElement, true);
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("ProductCard--Sold__Out");
      addButton.dataset.atcState = "default";
      if (defaultLabel) defaultLabel.textContent = soldOutLabel;
    } else {
      this.toggleNotifyButton(productElement, false);
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      addButton.dataset.atcState = "default";
      if (defaultLabel) defaultLabel.textContent = addToBagLabel;
    }
  }

  toggleNotifyButton(productElement, shouldShowNotify) {
    if (!productElement) return;

    const productForm = productElement.querySelector("[data-product-form]");
    const notifyTriggerWrapper = productElement.querySelector("[data-notify-trigger-wrapper]");
    const stickyAtcBar = productElement.querySelector(".pm__sticky-atc");
    const notifyDrawer = productElement.querySelector("notify-me-drawer");

    if (productForm) {
      productForm.classList.toggle("is-hidden", shouldShowNotify);
    }

    if (notifyTriggerWrapper) {
      notifyTriggerWrapper.classList.toggle("VisuallyHidden", !shouldShowNotify);
    }

    if (stickyAtcBar) {
      stickyAtcBar.classList.toggle("pm__sticky-atc--notify-hidden", shouldShowNotify);
    }

    if (shouldShowNotify && notifyDrawer && typeof notifyDrawer.syncFromProductState === "function") {
      notifyDrawer.syncFromProductState();
    }
  }

  updateFromPriceWhenSizeUnselected(hasSizeInputs, hasSelectedSize) {
    const shouldShowFromPrice =
      hasSizeInputs &&
      !hasSelectedSize &&
      this.dataset.fromPrice;

    if (!shouldShowFromPrice) return;

    const productElement = this.element.closest("product-component");
    const pricesContainer = productElement
      ? productElement.querySelector(".ProductInfo--Prices")
      : document.querySelector(".ProductInfo--Prices");

    if (!pricesContainer) return;

    const regularPriceEl = pricesContainer.querySelector(".price-item--regular");
    const comparePriceWrapper = pricesContainer.querySelector(".price-compare");
    const comparePriceEl = comparePriceWrapper
      ? comparePriceWrapper.querySelector("s")
      : null;

    if (regularPriceEl) {
      regularPriceEl.textContent = this.dataset.fromPrice;
    }

    if (comparePriceWrapper) {
      comparePriceWrapper.classList.add("VisuallyHidden");
    }

    if (comparePriceEl) {
      comparePriceEl.textContent = "";
    }

    const lowestPriceDefaultValue = this.dataset.lowestPriceDefaultValue;
    if (lowestPriceDefaultValue) {
      const productElement = this.element.closest("product-component");
      const lowestPriceValueElements = productElement
        ? productElement.querySelectorAll(".pm__lowest-price-value")
        : document.querySelectorAll(".pm__lowest-price-value");

      lowestPriceValueElements.forEach((lowestPriceValueElement) => {
        lowestPriceValueElement.textContent = lowestPriceDefaultValue;
      });
    }
  }

  updatePriceAndLowestPriceFromSelectedSizeData() {
    const selectionScope = this.getSelectionScope() || this.element;
    const selectedSizeInput = selectionScope.querySelector(
      '.VariantSelect--size .inputSelectboxCheckbox:checked, .pm__size-drawer-input:checked'
    );

    if (!selectedSizeInput) return;

    const selectedPrice = selectedSizeInput.dataset.price;
    const selectedLowestPrice = selectedSizeInput.dataset.lowestPrice;

    const productElement = this.element.closest("product-component");
    const pricesContainer = productElement
      ? productElement.querySelector(".ProductInfo--Prices")
      : document.querySelector(".ProductInfo--Prices");

    if (pricesContainer && selectedPrice) {
      const regularPriceEl = pricesContainer.querySelector(".price-item--regular");
      if (regularPriceEl) regularPriceEl.textContent = selectedPrice;
    }

    if (selectedLowestPrice) {
      const lowestPriceValueElements = productElement
        ? productElement.querySelectorAll(".pm__lowest-price-value")
        : document.querySelectorAll(".pm__lowest-price-value");

      lowestPriceValueElements.forEach((lowestPriceValueElement) => {
        lowestPriceValueElement.textContent = selectedLowestPrice;
      });
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

/**
 * The department (men / women) the customer is shopping, shared by the search
 * drawer and the mobile menu so both open on the same one. Resolution order:
 * a department picked on this page (a mobile menu tab) → the current page's
 * department (`<body data-page-audience>`, from
 * snippets/helper-page_audience.liquid) → the customer's last choice → nothing,
 * leaving each caller to apply its own fallback.
 */
const Department = {
  STORAGE_KEY: 'search-audience',

  /**
   * Picked by hand on this page. Outranks the page's own department, otherwise
   * tapping Man in the menu on a women's collection would still open search on
   * Woman. In memory only, so it dies on navigation — a new page is the fresher
   * signal.
   */
  picked: '',

  /** Record a deliberate pick: it wins for this page and is remembered after. */
  pick(handle) {
    if (!handle) return;
    this.picked = handle;
    this.persist(handle);
  },

  page() {
    return document.body.dataset.pageAudience || '';
  },

  stored() {
    try {
      return localStorage.getItem(this.STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  },

  persist(handle) {
    if (!handle) return;
    try {
      localStorage.setItem(this.STORAGE_KEY, handle);
    } catch (error) { }
  },

  /**
   * @param {string[]} availableHandles - Departments the caller can show.
   * @returns {?string} The first preference the caller can show, or null.
   */
  resolve(availableHandles) {
    return [this.picked, this.page(), this.stored()].find((handle) => handle && availableHandles.includes(handle)) || null;
  },
};

/**
 * Arriving on a marked resource is itself the customer's latest department
 * signal, so store it: a neutral page (home, cart, about) then reuses it. This
 * covers header department navigation, the homepage showcase and deep links
 * without instrumenting any of them — all land on a marked page. Runs on every
 * page load, whether or not search is enabled.
 */
Department.persist(Department.page());

class SearchBar extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.abortController = null;
    this.isLoading = false;
    this.loaderElement = null;
    this.resizeSubscription = null;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.searchHeaderElement = this.element.querySelector('.search-drawer__header');
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector(".search__results");
    this.clearSearchButton = this.element.querySelector('.search-input--clear');
    this.searchUrl = this.element.dataset.searchUrl || routes.search_url || '/search';
    this.audienceFilterParam = this.element.dataset.audienceFilterParam || 'filter.p.m.custom.audience';
    this.audienceFilterInputs = Array.from(this.element.querySelectorAll('[data-audience-filter-input]'));
    this.audienceFilterValues = this._parseAudienceFilterValues();
    this.audienceLabels = this._parseJsonAttribute('audienceLabels');
    this.audienceEmptyLabel = this.element.dataset.audienceEmptyLabel || '';
    this.viewAllLabelTemplate = this.element.dataset.viewAllLabel || 'View all ({{ count }})';
    this.loadMoreTemplate = this.element.querySelector('[data-search-load-more-template]');
    this.showProducts = this.element.dataset.showProducts !== 'false';
    this.showQuerySuggestions = this.element.dataset.showQuerySuggestions !== 'false';
    this.showArticles = this.element.dataset.showArticles !== 'false';

    /** handle -> { label, resultsCount, hasNextPage, page } for the current query. */
    this.audienceState = new Map();
    this.activeAudience = null;
    /**
     * A tab the customer picked by hand. Outranks the page's own department
     * for the rest of this drawer session, otherwise the next keystroke would
     * re-resolve to the page and silently undo their choice. In-memory, so
     * navigating away drops it — a new page is the fresher signal.
     */
    this.audienceOverride = null;

    this.loaderElement = this.element.querySelector('.spinningLoader');

    this.formResultsContainer = this.element.querySelector('#predictive-search__form-results');
    this.noResultsTarget = this.formResultsContainer?.querySelector('[data-search-form-no-results]');
    this.recentKeywordsTarget = this.formResultsContainer?.querySelector('[data-search-form-recent-keywords]');
    this.articlesTarget = this.formResultsContainer?.querySelector('[data-search-form-articles]');
    this.viewAllTarget = this.formResultsContainer?.querySelector('[data-search-form-view-all]');
    this.viewAllLink = this.viewAllTarget?.querySelector('[data-search-view-all-link]');

    if (window.theme.showRecentSearches) this.getRecentSearches();

    this.updateSearchHeaderHeightHandler = this.updateSearchHeaderHeight.bind(this);
    this.resizeSubscription = responsive.addResizeListener(this, this.updateSearchHeaderHeightHandler);

    this.isOpen = false;
    this.drawer = new Drawer(this.element, {
      initialFocusElement: () => this.searchInputElement,
      onOpen: () => {
        const scrollEl = this.element.querySelector("[data-scrollable]");
        if (scrollEl) {
          bodyScrollLock.enableBodyScroll(scrollEl);
          bodyScrollLock.disableBodyScroll(
            scrollEl,
            Object.assign({}, bodyScrollLockOptions, {
              allowTouchMove: (el) => Boolean(el && this.element.contains(el)),
            })
          );
        }
        this.isOpen = true;
        this.updateSearchHeaderHeight();
        this.focusSearchInput();
      },
      onClose: () => {
        this.isOpen = false;
      },
    });
    this.updateSearchHeaderHeight();
    this.bindEvents();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.loadMoreController?.abort();
    this.audienceController?.abort();
    this.delegateElement?.destroy();
    this.delegateBody?.destroy();
    if (this.resizeSubscription && typeof this.resizeSubscription.removeResizeListener === "function") {
      this.resizeSubscription.removeResizeListener();
    }
    this.resizeSubscription = null;
  }


  bindEvents() {
    this._onInputListener = debounce((event) => this.onInput(event), 450);
    this.delegateElement.on(
      "input",
      ".search-input",
      this._onInputListener
    );

    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      '[data-action="search-string"]',
      (event, target) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        this.onInput({ target });
      }
    );

    this.delegateElement.on(
      "submit",
      ".search-form",
      this._onSearchFormSubmit.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="audience-tab"]',
      this._onAudienceTabClick.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="search-load-more"]',
      this._onLoadMoreClick.bind(this)
    );

    this.delegateBody.on(
      'mouseover',
      '.header-link-list.header-main-menu-items.set-left .header-link-desk',
      (event) => {
        if (!responsive.matchesBreakpoint('lap_and_up')) return;
        if (!this.isOpen || !this.drawer) return;

        const menuItem = event.target.closest('.header-link-desk');
        if (!menuItem) return;
        if (menuItem.contains(event.relatedTarget)) return;

        this.drawer.closeDrawer();
      },
    );
  }

  updateSearchHeaderHeight() {
    if (!this.searchHeaderElement) return;
    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchHeaderElement.offsetHeight}px`
    );
  }

  focusSearchInput() {
    if (!this.searchInputElement) return;

    requestAnimationFrame(() => {
      this.searchInputElement.focus({ preventScroll: true });
      this.searchInputElement.setSelectionRange(
        this.searchInputElement.value.length,
        this.searchInputElement.value.length
      );
    });
  }

  /**
   * Mirror the active audience tab into the search form's hidden filter inputs
   * so submitting the drawer (Enter, or the magnifier) lands on the results
   * page with the same audience filter applied. Man and Woman each need two
   * values — their department OR Unisex — and Shopify ORs a repeated list
   * filter param. Disabled inputs are not serialized, so the All tab and a
   * null handle cleanly drop the param.
   *
   * @param {?string} handle - An audience handle from SearchBar.AUDIENCES, or null to clear.
   */
  _syncAudienceFilterInput(handle) {
    if (!this.audienceFilterInputs.length) return;

    const values = this._audienceFilterValues(handle);

    this.audienceFilterInputs.forEach((input, index) => {
      const value = values[index];
      input.value = value || '';
      input.disabled = !value;
    });
  }

  /**
   * The filter value(s) each department tab sends, from the theme settings via
   * `data-audience-filter-values`. Normally one value per tab: either the bare
   * metafield value, or a Search & Discovery group that covers the department
   * plus Unisex. It has to be one value — this filter returns nothing at all
   * when handed two, unlike every other filter on the store.
   *
   * @returns {Object<string, string[]>} handle -> values, in SearchBar.AUDIENCES order.
   */
  _parseAudienceFilterValues() {
    const fallback = { men: ['Man', 'Unisex'], women: ['Woman', 'Unisex'], all: [] };
    const parsed = this._parseJsonAttribute('audienceFilterValues');
    if (!parsed) return fallback;

    const values = {};
    SearchBar.AUDIENCES.forEach(({ handle }) => {
      const entry = parsed[handle];
      values[handle] = Array.isArray(entry) ? entry.filter(Boolean) : [];
    });
    return values;
  }

  /**
   * @param {?string} handle - An audience handle from SearchBar.AUDIENCES.
   * @returns {string[]} The filter values for that tab. Empty for All.
   */
  _audienceFilterValues(handle) {
    return this.audienceFilterValues?.[handle] || [];
  }

  /**
   * The full results page URL for a query under one audience tab — the same
   * params the hidden inputs submit, so "View all" and Enter always agree.
   *
   * @param {string} query - The current search term.
   * @param {?string} handle - An audience handle from SearchBar.AUDIENCES.
   * @returns {URL}
   */
  _searchResultsUrl(query, handle) {
    const url = new URL(this.searchUrl, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    this._audienceFilterValues(handle).forEach((value) => {
      url.searchParams.append(this.audienceFilterParam, value);
    });
    return url;
  }

  /**
   * Enter can beat the drawer: the hidden audience inputs are only filled once
   * a query's results land (450 ms debounce plus the fetch), so a quick Enter
   * submitted none of them and landed on All. With no tab shown yet, submit
   * the department the drawer is about to open on.
   */
  _onSearchFormSubmit() {
    if (this.activeAudience) return;
    this._syncAudienceFilterInput(this._defaultAudienceHandle(SearchBar.AUDIENCES.map((item) => item.handle)));
  }

  _onAudienceTabClick(e, trigger) {
    e.preventDefault();
    if (trigger.disabled || trigger.getAttribute("aria-disabled") === "true") return;

    const audience = trigger.getAttribute("data-audience-tab");
    if (!audience || audience === this.activeAudience) return;

    this.audienceOverride = audience;
    Department.pick(audience);
    this._activateAudience(audience);
  }

  /**
   * Switch to a tab, fetching its products the first time it is opened. The
   * visual switch happens immediately so the tab feels responsive; the panel
   * fills in when its request lands. Already-loaded panels are reused.
   *
   * @param {string} handle - An audience handle from SearchBar.AUDIENCES.
   */
  async _activateAudience(handle) {
    this._setActiveAudience(handle);

    const panel = this.searchResultsElement?.querySelector(`[data-audience-panel="${handle}"]`);
    if (!panel || panel.dataset.audienceLoaded === 'true') return;

    this.audienceController?.abort();
    this.audienceController = new AbortController();
    const signal = this.audienceController.signal;
    const query = this.lastInputValue;

    this._setLoading(true);

    let result = null;
    try {
      result = await this._fetchAudience(query, handle, signal);
    } catch (error) {
      // On an abort the request that superseded this one owns the loading
      // state. On anything else clear it and leave the tab unloaded, so
      // clicking it again retries rather than showing a stuck spinner.
      if (error.name !== 'AbortError') this._setLoading(false);
      return;
    }

    // A newer keystroke or tab click superseded this one; the request that
    // replaced it owns the loading state from here.
    if (signal.aborted || query !== this.lastInputValue) return;
    this._setLoading(false);

    panel.dataset.audienceLoaded = 'true';
    panel.innerHTML = '';
    if (result) {
      panel.innerHTML = result.productsMarkup;
    } else {
      // Locale string, so set as text rather than interpolated into markup.
      const empty = document.createElement('p');
      empty.className = 'search-results-tabs__empty u-p2';
      empty.textContent = this.audienceEmptyLabel;
      panel.appendChild(empty);
    }

    if (result) {
      this.audienceState.set(handle, {
        label: result.label,
        resultsCount: result.resultsCount,
        hasNextPage: result.hasNextPage,
        page: result.page,
        isLoadingMore: false,
      });
      const tab = this.searchResultsElement.querySelector(`[data-audience-tab="${handle}"]`);
      if (tab) tab.textContent = result.label;
    } else {
      this.audienceState.delete(handle);
    }

    if (this.activeAudience === handle) {
      this._updateViewAll(handle);
      this._updateLoadMore(handle);
    }
  }

  /**
   * Activate one audience tab: its panel, the hidden form filters, the
   * "View all (N)" link and the "Load more" button all follow from it.
   *
   * @param {string} handle - An audience handle from SearchBar.AUDIENCES.
   */
  _setActiveAudience(handle) {
    if (!this.searchResultsElement) return;

    const tabsContainer = this.searchResultsElement.querySelector("[data-search-audience-tabs]");
    if (!tabsContainer) return;

    tabsContainer.querySelectorAll("[data-audience-tab]").forEach((tab) => {
      const isActive = tab.getAttribute("data-audience-tab") === handle;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    this.searchResultsElement.querySelectorAll("[data-audience-panel]").forEach((panel) => {
      const isActive = panel.getAttribute("data-audience-panel") === handle;
      panel.classList.toggle("is-active", isActive);
      panel.classList.toggle("search-results-tabs__panel--is-active", isActive);
      if (isActive) panel.removeAttribute("hidden");
      else panel.setAttribute("hidden", "true");
    });

    this.activeAudience = handle;
    this._syncAudienceFilterInput(handle);
    this._updateViewAll(handle);
    this._updateLoadMore(handle);
  }

  /**
   * Pick the tab to open on: a tab picked by hand this session, else the
   * shared Department resolution (page, then last choice), else All.
   *
   * @param {string[]} availableHandles - Handles that actually have a tab, in tab order.
   * @returns {?string}
   */
  _defaultAudienceHandle(availableHandles) {
    if (this.audienceOverride && availableHandles.includes(this.audienceOverride)) return this.audienceOverride;
    const preferred = Department.resolve(availableHandles);
    if (preferred) return preferred;
    if (availableHandles.includes('all')) return 'all';
    return availableHandles[0] || null;
  }

  /**
   * @param {?string} [initialAudience] - The audience whose panel is already
   *   filled. Omitted for the legacy predictive fallback markup, whose tabs
   *   come from the section and carry their own handles.
   */
  initAudienceTabs(initialAudience) {
    this._syncAudienceFilterInput(null);
    this.activeAudience = null;
    this.loadMoreWrapper = null;
    if (this.viewAllTarget) this.viewAllTarget.hidden = true;
    if (!this.searchResultsElement) return;

    const tabsContainer = this.searchResultsElement.querySelector("[data-search-audience-tabs]");
    if (!tabsContainer) return;

    this.loadMoreWrapper = this.searchResultsElement.querySelector("[data-search-load-more]");

    const handles = Array.from(tabsContainer.querySelectorAll("[data-audience-tab]"))
      .filter((tab) => !tab.disabled)
      .map((tab) => tab.getAttribute("data-audience-tab"));
    if (!handles.length) return;

    const handle = handles.includes(initialAudience)
      ? initialAudience
      : this._defaultAudienceHandle(handles);
    if (handle) this._setActiveAudience(handle);
  }

  /**
   * "View all (N)" above the query suggestions. N is the active tab's total
   * from search.results_count, not the length of the preview grid.
   *
   * @param {string} handle - An audience handle from SearchBar.AUDIENCES.
   */
  _updateViewAll(handle) {
    if (!this.viewAllTarget || !this.viewAllLink) return;

    const state = this.audienceState.get(handle);
    const count = state ? state.resultsCount : 0;
    if (!count || !this.lastInputValue) {
      this.viewAllTarget.hidden = true;
      return;
    }

    const label = this.viewAllLabelTemplate.replace(/\{\{\s*count\s*\}\}/g, String(count));
    const textElement = this.viewAllLink.querySelector('.button-txt');
    if (textElement) textElement.textContent = label;
    this.viewAllLink.setAttribute('aria-label', label);
    this.viewAllLink.href = this._searchResultsUrl(this.lastInputValue, handle).toString();
    this.viewAllTarget.hidden = false;
  }

  _updateLoadMore(handle) {
    if (!this.loadMoreWrapper) return;

    const state = this.audienceState.get(handle);
    this.loadMoreWrapper.hidden = !(state && state.hasNextPage);

    const button = this.loadMoreWrapper.querySelector('[data-action="search-load-more"]');
    if (button) button.disabled = false;
  }

  /**
   * Append the next page of the active tab's results to its grid. Uses its own
   * AbortController so a new keystroke — which replaces the grid outright —
   * cancels it without touching the three search requests.
   */
  async _onLoadMoreClick(event, trigger) {
    event.preventDefault();

    const handle = this.activeAudience;
    const state = handle ? this.audienceState.get(handle) : null;
    if (!state || !state.hasNextPage || state.isLoadingMore) return;

    const audience = SearchBar.AUDIENCES.find((item) => item.handle === handle);
    const panel = this.searchResultsElement?.querySelector(`[data-audience-panel="${handle}"]`);
    if (!audience || !panel) return;

    state.isLoadingMore = true;
    trigger.disabled = true;
    this.loadMoreController?.abort();
    this.loadMoreController = new AbortController();

    try {
      const nextPage = await this._fetchDrawerProductData(
        this.lastInputValue,
        audience,
        this.loadMoreController.signal,
        state.page + 1
      );

      if (nextPage) {
        panel.insertAdjacentHTML('beforeend', nextPage.productsMarkup);
        state.page = nextPage.page;
        state.hasNextPage = nextPage.hasNextPage;
      } else {
        state.hasNextPage = false;
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
    } finally {
      state.isLoadingMore = false;
      if (this.activeAudience === handle) this._updateLoadMore(handle);
    }
  }

  async onInput(event) {
    const target = event.target;

    if (event.type === "keydown" && event.key && event.key !== "Enter" && event.key !== " ") {
      return;
    }

    if (target.hasAttribute("data-value")) {
      this.lastInputValue = target.getAttribute("data-value") || "";
      const input = this.element.querySelector(".search-input");
      if (input) {
        input.setAttribute("value", this.lastInputValue);
        input.value = this.lastInputValue;
      }
    } else {
      this.lastInputValue = target.value || "";
    }

    this._setLoading(true);
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute('aria-hidden', 'false');

    if (this.lastInputValue === "") {
      this.resetSearch();
      return;
    }

    try {
      const data = await this._fetchSearchData(this.lastInputValue);
      this._updateFormColumn(data);
      this._updateResultsColumn(data);
      this.searchResultsElement.style.opacity = 1;
      if (window.theme.showRecentSearches) this.recentSearches();
    } catch (error) {
      if (error.name === 'AbortError') return;
      this._handleSearchError();
    } finally {
      this._setLoading(false);
    }
  }

  async _fetchSearchData(query) {
    this.abortController?.abort();
    this.loadMoreController?.abort();
    this.audienceController?.abort();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;
    this.audienceState.clear();

    /**
     * Only the tab that will actually be shown is fetched. The other two load
     * when their tab is clicked (`_activateAudience`) — fetching all three up
     * front cost three section renders per keystroke to display one.
     */
    const handle = this._defaultAudienceHandle(SearchBar.AUDIENCES.map((item) => item.handle));

    const [predictiveData, drawerResult] = await Promise.all([
      this._fetchPredictiveSearchData(query, signal),
      this._fetchInitialAudience(query, handle, signal),
    ]);

    /**
     * With product results switched off the drawer request still runs: "View
     * all (N)" needs its count and Enter its department. Only the grid is skipped.
     */
    return Object.assign({}, predictiveData, {
      drawerResult,
      drawerProductsMarkup: drawerResult && this.showProducts
        ? this._buildDrawerProductsMarkup([drawerResult])
        : '',
      initialAudience: drawerResult ? drawerResult.handle : null,
    });
  }

  /**
   * Fetch the tab the drawer will open on. If the department the customer is
   * marked for has nothing for this query, fall back to All rather than opening
   * on an empty grid — one extra request, and only in that case.
   *
   * @param {string} query - The current search term.
   * @param {string} handle - The audience the drawer wants to open on.
   * @param {AbortSignal} signal
   * @returns {Promise<?object>} A _fetchDrawerProductData result, or null.
   */
  async _fetchInitialAudience(query, handle, signal) {
    const result = await this._fetchAudience(query, handle, signal);
    if (result || handle === 'all') return result;
    return this._fetchAudience(query, 'all', signal);
  }

  /**
   * @param {string} query - The current search term.
   * @param {string} handle - An audience handle from SearchBar.AUDIENCES.
   * @param {AbortSignal} signal
   * @param {number} [page]
   * @returns {Promise<?object>} null on any non-abort failure, so one empty tab
   *   never takes the whole drawer down.
   */
  async _fetchAudience(query, handle, signal, page) {
    const audience = SearchBar.AUDIENCES.find((item) => item.handle === handle);
    if (!audience) return null;

    try {
      return await this._fetchDrawerProductData(query, audience, signal, page);
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      return null;
    }
  }

  async _fetchPredictiveSearchData(query, signal) {
    // Products stay in: the section's no-results state is decided by them.
    const types = ['product'];
    if (this.showArticles) types.push('article');
    if (this.showQuerySuggestions) types.push('query');

    const params = new URLSearchParams({
      q: query,
      'resources[type]': types.join(','),
      'resources[limit_scope]': 'each',
      'resources[options][fields]': 'title,product_type,variants.title,tag,vendor,variants.sku',
      section_id: 'search-predictive',
    });
    const response = await fetch(
      `${routes.predictive_search_url}?${params}`,
      { signal }
    );
    if (!response.ok) throw new Error(response.status);

    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, "text/html");
    const section = doc.querySelector("#shopify-section-search-predictive");
    const resultsMarkup = section ? section.innerHTML : "";

    const tempWrapper = document.createElement("div");
    tempWrapper.innerHTML = resultsMarkup;

    const predictiveRoot = tempWrapper.querySelector(".predictive-search");

    return {
      resultsMarkup,
      predictiveRoot,
      recentKeywordsTemplate: tempWrapper.querySelector("template"),
      articlesInner: predictiveRoot?.querySelector("#predictive-search__articles")?.closest(".predictive-search__inner") ?? null,
      noResultsInner: predictiveRoot?.querySelector(".predictive-search__no-results") ?? null,
    };
  }

  /**
   * Fetch one page of the drawer product cards for a single audience.
   *
   * @param {string} query - The current search term.
   * @param {{handle: string, filterValues: string[]}} audience - Entry from SearchBar.AUDIENCES.
   * @param {AbortSignal} signal - So a newer keystroke cancels the request.
   * @param {number} [page] - 1-based results page; used by "Load more".
   * @returns {Promise<?{handle: string, label: string, productsCount: number, resultsCount: number, hasNextPage: boolean, page: number, productsMarkup: string}>}
   */
  async _fetchDrawerProductData(query, audience, signal, page) {
    const url = this._searchResultsUrl(query, audience.handle);
    url.searchParams.set('section_id', 'search-drawer-products');
    if (page > 1) url.searchParams.set('page', String(page));

    const response = await fetch(url.toString(), {
      headers: { Accept: 'text/html' },
      signal,
    });
    if (!response.ok) return null;

    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const section = doc.querySelector('#shopify-section-search-drawer-products');
    const productRoot = section?.querySelector('[data-search-drawer-products]');
    if (!productRoot) return null;

    const productsList = productRoot.querySelector(
      `[data-search-drawer-products-list][data-audience="${audience.handle}"]`
    );
    if (!productsList) return null;

    const count = parseInt(productRoot.dataset[`${audience.handle}Count`] || '0', 10) || 0;
    if (!count) return null;

    return {
      handle: audience.handle,
      label: productsList.dataset.audienceLabel || audience.handle,
      productsCount: count,
      /**
       * The request's own search.results_count: the department total for Man /
       * Woman (their value OR Unisex), every product match for All. This is
       * what "View all (N)" shows — not productsCount, which is only as long
       * as the preview grid.
       */
      resultsCount: parseInt(productRoot.dataset.resultsCount || '0', 10) || 0,
      hasNextPage: productRoot.dataset.hasNextPage === 'true',
      page: page > 1 ? page : 1,
      productsMarkup: productsList.innerHTML || '',
    };
  }

  /**
   * Build the products column: the Man / Woman / All tab strip, one panel per
   * tab, and a single "Load more" below the grids.
   *
   * All three tabs always render when there are any product results (design).
   * Only the audience that was actually fetched has a filled panel; the others
   * carry `data-audience-loaded="false"` and are populated by
   * `_activateAudience` when clicked. Tabs are never disabled up front — with
   * lazy loading we do not yet know whether they have hits.
   *
   * @param {Array<object>} audienceResults - _fetchDrawerProductData results, any order.
   * @returns {string}
   */
  _buildDrawerProductsMarkup(audienceResults) {
    const resultsByHandle = new Map(audienceResults.map((result) => [result.handle, result]));

    const predictiveRoot = document.createElement('div');
    predictiveRoot.className = 'predictive-search search-drawer__predictive';

    const productsColumn = document.createElement('div');
    productsColumn.className = 'predictive-search__column predictive-search__products search-drawer__predictive-column search-drawer__predictive-column--products';

    const inner = document.createElement('div');
    inner.className = 'predictive-search__inner';

    const tabs = document.createElement('div');
    tabs.className = 'search-results-tabs';
    tabs.setAttribute('data-search-audience-tabs', '');
    tabs.setAttribute('role', 'tablist');

    const panels = document.createElement('div');
    panels.className = 'search-results-tabs__panels';
    panels.setAttribute('data-scrollable', '');

    SearchBar.AUDIENCES.forEach((audience) => {
      const result = resultsByHandle.get(audience.handle);
      const tabId = `search-results-tab-${audience.handle}`;
      const panelId = `search-results-panel-${audience.handle}`;

      if (result) {
        this.audienceState.set(audience.handle, {
          label: result.label,
          resultsCount: result.resultsCount,
          hasNextPage: result.hasNextPage,
          page: result.page,
          isLoadingMore: false,
        });
      }

      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'search-results-tabs__trigger u-p2';
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('data-action', 'audience-tab');
      tab.setAttribute('data-audience-tab', audience.handle);
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('aria-disabled', 'false');
      tab.textContent = result ? result.label : this._audienceFallbackLabel(audience.handle);

      const panel = document.createElement('div');
      panel.id = panelId;
      panel.className = 'search-results-tabs__panel';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '0');
      panel.setAttribute('aria-labelledby', tabId);
      panel.setAttribute('data-audience-panel', audience.handle);
      panel.setAttribute('data-audience-loaded', result ? 'true' : 'false');
      panel.setAttribute('hidden', 'true');
      panel.innerHTML = result ? result.productsMarkup : '';

      tabs.appendChild(tab);
      panels.appendChild(panel);
    });

    /**
     * One shared Load more, inside the scrolling panels container so it sits
     * directly under the last row of whichever grid is visible.
     */
    const loadMoreButton = this.loadMoreTemplate?.content?.firstElementChild;
    if (loadMoreButton) {
      const loadMore = document.createElement('div');
      loadMore.className = 'search-drawer__load-more';
      loadMore.setAttribute('data-search-load-more', '');
      loadMore.hidden = true;
      loadMore.appendChild(loadMoreButton.cloneNode(true));
      panels.appendChild(loadMore);
    }

    inner.appendChild(tabs);
    inner.appendChild(panels);
    productsColumn.appendChild(inner);
    predictiveRoot.appendChild(productsColumn);

    return predictiveRoot.outerHTML;
  }

  /**
   * @param {string} key - A dataset key holding JSON.
   * @returns {?object} The parsed value, or null when absent or malformed.
   */
  _parseJsonAttribute(key) {
    const raw = this.element.dataset[key];
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  /**
   * Label for a tab with no results this query, where the section could not
   * supply a translated one.
   *
   * @param {string} handle - An audience handle from SearchBar.AUDIENCES.
   * @returns {string}
   */
  _audienceFallbackLabel(handle) {
    return this.audienceLabels?.[handle] || handle;
  }

  _updateFormColumn({ predictiveRoot, recentKeywordsTemplate, articlesInner, noResultsInner, drawerResult }) {
    if (!this.formResultsContainer) return;
    const hasDrawerProducts = Boolean(drawerResult);

    if (noResultsInner && !hasDrawerProducts) {
      if (this.noResultsTarget) { this.noResultsTarget.innerHTML = ''; this.noResultsTarget.appendChild(noResultsInner); }
      if (this.recentKeywordsTarget) this.recentKeywordsTarget.innerHTML = '';
      if (this.articlesTarget) this.articlesTarget.innerHTML = '';
      this._setVisible(this.recentKeywordsTarget, false);
      this._setVisible(this.articlesTarget, false);
    } else {
      if (this.noResultsTarget) this.noResultsTarget.innerHTML = '';

      if (this.recentKeywordsTarget) {
        this.recentKeywordsTarget.innerHTML = '';
        if (recentKeywordsTemplate) this.recentKeywordsTarget.appendChild(recentKeywordsTemplate.content.firstElementChild.cloneNode(true));
      }
      this._setVisible(this.recentKeywordsTarget, !!recentKeywordsTemplate);

      if (this.articlesTarget) {
        this.articlesTarget.innerHTML = '';
        if (articlesInner) this.articlesTarget.appendChild(articlesInner);
      }
      this._setVisible(this.articlesTarget, !!articlesInner);
    }

    this.element.classList.toggle("search-drawer--has-form-results", Boolean(predictiveRoot || hasDrawerProducts));
  }

  _updateResultsColumn({ resultsMarkup, predictiveRoot, noResultsInner, drawerResult, drawerProductsMarkup, initialAudience }) {
    if (!this.showProducts) {
      // No grid and no tabs: the drawer stays a single column. The fetched tab
      // still drives "View all (N)" and the hidden inputs Enter submits.
      this.searchResultsElement.innerHTML = "";
      this.loadMoreWrapper = null;
      if (drawerResult) {
        this.audienceState.set(drawerResult.handle, {
          label: drawerResult.label,
          resultsCount: drawerResult.resultsCount,
          hasNextPage: drawerResult.hasNextPage,
          page: drawerResult.page,
          isLoadingMore: false,
        });
      }
      this.activeAudience = initialAudience;
      this._syncAudienceFilterInput(initialAudience);
      this._updateViewAll(initialAudience);
      this.element.classList.remove("search-drawer--has-results");
      this.element.classList.toggle("search-drawer--no-results", Boolean(noResultsInner) && !drawerResult);
      return;
    }

    if (drawerProductsMarkup) {
      this.searchResultsElement.innerHTML = drawerProductsMarkup;
      this.element.classList.add("search-drawer--has-results");
      this.initAudienceTabs(initialAudience);
      this.element.classList.remove("search-drawer--no-results");
      return;
    }

    if (noResultsInner) {
      this.searchResultsElement.innerHTML = "";
      this._syncAudienceFilterInput(null);
      this.activeAudience = null;
      this.loadMoreWrapper = null;
      if (this.viewAllTarget) this.viewAllTarget.hidden = true;
      this.element.classList.remove("search-drawer--has-results");
      this.element.classList.add("search-drawer--no-results");
      return;
    }

    let productsMarkup = resultsMarkup;
    if (predictiveRoot) {
      const productsColumn = predictiveRoot.querySelector(".predictive-search__products");
      if (productsColumn) {
        const newRoot = document.createElement("div");
        newRoot.className = predictiveRoot.className;
        newRoot.appendChild(productsColumn);
        productsMarkup = newRoot.outerHTML;
      }
    }

    this.searchResultsElement.innerHTML = productsMarkup;
    this.element.classList.add("search-drawer--has-results");
    this.initAudienceTabs();
    this.element.classList.remove("search-drawer--no-results");
  }

  resetSearch() {
    this.loadMoreController?.abort();
    this.audienceController?.abort();
    this.searchResultsElement.innerHTML = '';
    this._syncAudienceFilterInput(null);
    this.audienceState.clear();
    this.activeAudience = null;
    this.audienceOverride = null;
    this.loadMoreWrapper = null;
    if (this.viewAllTarget) this.viewAllTarget.hidden = true;
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");
    this.focusSearchInput();

    if (window.theme.showRecentSearches) { this.getRecentSearches(); }
    this.element.classList.remove("search-drawer--has-results", "search-drawer--has-form-results", "search-drawer--no-results");
    this._setVisible(this.recentKeywordsTarget, true);
    this._setVisible(this.articlesTarget, true);
    this._setLoading(false);
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute('aria-hidden', 'true');
  }

  _setVisible(el, visible) {
    if (!el) return;
    el.style.display = visible ? '' : 'none';
  }

  _setLoading(isLoading) {
    this.isLoading = isLoading;

    this.element.classList.toggle("search-drawer--is-loading", Boolean(isLoading));

    if (this.searchResultsElement) {
      this.searchResultsElement.setAttribute("aria-busy", isLoading ? "true" : "false");
    }

    if (this.loaderElement) {
      this.loaderElement.classList.toggle('is-visible', Boolean(isLoading));
    }
  }

  _handleSearchError() {
    if (this.viewAllTarget) this.viewAllTarget.hidden = true;
    if (!this.searchResultsElement) return;

    const message = window.theme?.searchLoadError || "We couldn't load results. Please try again.";

    this.searchResultsElement.innerHTML = `
      <div class="predictive-search__inner">
        <div class="predictive-search__no-results">
          <div class="predictive-search__no-result-content">
            <p class="u-p2">${message}</p>
          </div>
        </div>
      </div>
    `;

    this.searchResultsElement.style.opacity = 1;
    this.element.classList.remove("search-drawer--has-results", "search-drawer--has-form-results");
    this.element.classList.add("search-drawer--no-results");
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    const elementToAdd = this.element.querySelector(".search__recent-results");
    if (!elementToAdd) return;
    if (items.length > 0) {
      elementToAdd.innerHTML = "";
      items.forEach((term) => {
        const li = document.createElement("li");
        li.setAttribute("role", "option");
        li.setAttribute("tabIndex", "0");
        li.className = "u-p2";
        li.setAttribute("data-action", "search-string");
        li.setAttribute("data-value", term);
        li.textContent = term;
        elementToAdd.appendChild(li);
      });
    } else {
      this.querySelector('#predictive-search--recent-searches')?.style.setProperty('display', 'none');
    }
  }

}
/**
 * Audiences the drawer splits results into, in tab order. The filter value each
 * one sends is merchant-configured and arrives on `data-audience-filter-values`
 * — see `_parseAudienceFilterValues`. All is always unfiltered.
 */
SearchBar.AUDIENCES = [
  { handle: 'men' },
  { handle: 'women' },
  { handle: 'all' },
];

customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.stickyLinksTopPadding = this.stickyLinksTopPadding.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) document.addEventListener("scroll", this.stickyLinksTopPadding);
  }

  stickyLinksTopPadding() {
    const linkList = this.element.querySelector(".tc-layout-wrapper__linklist");
    if (linkList) {
      const isSticky = linkList.getBoundingClientRect().top === 0;

      if (isSticky) {
        linkList.style.paddingTop = "1.5rem";
      } else {
        linkList.style.paddingTop = "0rem";
      }
    }
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);


class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this._initialized = false;
    this.delegateElement = new Delegate(this.element);
  }

  bindEvents() {
    const form = this.element.querySelector('form#contactForm');
    if (!form) return;

    const requiredMessage = this.element.dataset.errorRequired || 'This field is required';
    const invalidEmailMessage = this.element.dataset.errorEmail || 'Please enter a valid email address';

    const validator = new FormValidator(form, {
      fieldSelector: '.field, .form-checkbox',
      buttonSelector: '.Contact-Btn.validate-button',
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      showErrorsOnSubmitOnly: true
    });

    const updateFieldErrorMessage = (field) => {
      const isValid = validator.isFieldValid(field);
      const container = field.closest('.field-container') || field.closest('.form-checkbox');
      if (!container) return;

      const errorEl = container.querySelector('.field__error');
      if (!errorEl) return;

      if (isValid) {
        errorEl.textContent = '';
        errorEl.classList.remove('error-visible');
        return;
      }

      let message = '';
      if (field.type === 'checkbox') {
        message = requiredMessage;
      } else if (!field.value.trim() && field.hasAttribute('required')) {
        message = requiredMessage;
      } else if (field.type === 'email' && field.value && !validator.isValidEmail(field.value)) {
        message = invalidEmailMessage;
      } else if (field.validationMessage) {
        message = field.validationMessage;
      }

      errorEl.textContent = message;
      errorEl.classList.toggle('error-visible', Boolean(message));
    };

    // Register required checkboxes with the validator
    form.querySelectorAll('input[type="checkbox"][data-state="required"]').forEach((checkbox) => {
      const checkboxId = checkbox.id || `contact-checkbox-${Math.random().toString(36).slice(2)}`;
      checkbox.id = checkboxId;
      validator.addValidator(checkboxId, (value, field) => field.checked, null);
    });

    // focusout bubbles — covers both input blur and checkbox label blur
    this.delegateElement.on('focusout', 'input, textarea', (e) => {
      if (!form.contains(e.target)) return;
      validator.validateField(e.target, false);
      updateFieldErrorMessage(e.target);
    });

    this.delegateElement.on('focusout', '.form-checkbox__label', (e) => {
      if (!form.contains(e.target)) return;
      const container = e.target.closest('.form-checkbox');
      if (!container) return;
      const checkbox = container.querySelector('input[type="checkbox"][data-state="required"]');
      if (!checkbox) return;
      validator.validateField(checkbox, false);
      updateFieldErrorMessage(checkbox);
    });

    // Checkbox change — sync error class and re-evaluate button state
    this.delegateElement.on('change', 'input[type="checkbox"][data-state="required"]', (e) => {
      if (!form.contains(e.target)) return;
      const container = e.target.closest('.form-checkbox');
      if (!container) return;
      container.classList.toggle(validator.options.errorClass, !e.target.checked);
      updateFieldErrorMessage(e.target);
      validator.updateButtonState();
    });

    // Form submit — show loading state (only fires when validation passes)
    const sendingLabel = this.element.dataset.sending || '…';
    this.delegateElement.on('submit', 'form#contactForm', () => {
      const btn = form.querySelector('.Contact-Btn.validate-button');
      if (!btn) return;
      const btnText = btn.querySelector('.ButtonText');
      if (btnText) btnText.textContent = sendingLabel;
      btn.setAttribute('disabled', '');
      btn.setAttribute('aria-disabled', 'true');
    });

    // Move focus to server feedback message on page load
    const feedbackMessage = this.element.querySelector('.contact-section__feedback');
    if (feedbackMessage) {
      window.requestAnimationFrame(() => feedbackMessage.focus());
    }
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.bindEvents();
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
    this._initialized = false;
  }

}

customElements.define('contact-section', ContactSection);


class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector('textarea');
    this.button = this.element.querySelector('.CartNote--Submit');
    this.noteSucess = this.element.querySelector('.cartNote--Success');
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      'click',
      "[data-action='update-note']",
      this.updateNote.bind(this),
    );

    this.delegateElement.on(
      'click',
      "[data-action='edit-note']",
      this.editNote.bind(this),
    );
  }
  editNote() {
    this.textarea.removeAttribute('disabled');
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute('data-action', 'update-note');
    this.textarea.focus();
    this.noteSucess.style.visibility = 'hidden';
    this.noteSucess.style.opacity = '0';
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + '/cart/update.js', {
      body: JSON.stringify({ note: this.value }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == '') {
          return;
        }
        _this.textarea.setAttribute('disabled', 'disabled');
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute('data-action', 'edit-note');
        _this.noteSucess.style.visibility = 'visible';
        _this.noteSucess.style.opacity = '1';
      }
    });
  }
}

customElements.define('cart-note', CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this._boundNewsletterSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.bindEvents();
    this.initFormValidation();

    // If returning from Shopify after a newsletter submit, show the matching state.
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const hash = window.location.hash;
      const isPopupNewsletterReturn = hash === '#popupForm';
      const errorWrapper = this.element.querySelector('.newsletter__error-wrapper');
      const hasErrors = Boolean(errorWrapper && errorWrapper.textContent.trim().length);
      const hasPostedSuccess = Boolean(this.element.querySelector('[data-newsletter-posted-success]'));

      if (isPopupNewsletterReturn && (params.get('customer_posted') === 'true' || hasPostedSuccess)) {
        this.options.delay = 0;
        this._setStorage('popup-subscribed', 'true');
        this.openNewsletter();
        this.showSuccessState();
        return;
      }

      if (isPopupNewsletterReturn && hasErrors) {
        this.options.delay = 0;
        this.openNewsletter();
        return;
      }
    }

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.checkGeolocationPopupAndStart();
    }
  }

  bindEvents() {
    const formEl = this.element.querySelector('.newsletter__form');
    if (formEl) {
      formEl.addEventListener('submit', this._boundNewsletterSubmit);
    }

    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.clearInput.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeNewsletter
    );

    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"]',
      this.closeNewsletter
    );
  }

  initFormValidation() {
    if (typeof FormValidator === 'undefined') return;
    const form = this.element.querySelector('form');
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: 'field--error',
      fieldSelector: '.newsletter__email-input-wrapper',
      buttonSelector: '.newsletter__subscribe-button',
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: ".newsletter__error-wrapper",
      showErrorsOnSubmitOnly: false,
    });

    this.setupOptionValidation();
  }

  setupOptionValidation() {
    const wrapper = this.element.querySelector('.newsletter__wrapper');
    if (!wrapper) return;

    const optionErrorMsg = wrapper.dataset?.optionError || '';
    if (!optionErrorMsg) return;

    this.optionErrorMessage = optionErrorMsg;

    this.delegateElement.on(
      "change",
      ".newsletter__option-input",
      this.handleOptionGroupValidation.bind(this)
    );

    this.delegateElement.on(
      "focusout",
      ".newsletter__option-input",
      this.handleOptionGroupValidation.bind(this)
    );

    const originalUpdateErrorOutput = this.validator.updateErrorOutput.bind(this.validator);
    this.validator.updateErrorOutput = () => {
      originalUpdateErrorOutput();

      const container = this.element.querySelector(".newsletter__error-wrapper");
      if (!container || !container.innerHTML.includes("<br>")) return;

      const parts = container.innerHTML.split("<br>");
      const seen = new Set();
      const cleaned = parts.filter((part) => {
        const text = part.trim();
        if (!text) return false;
        if (seen.has(text)) return false;
        seen.add(text);
        return true;
      });

      container.innerHTML = cleaned.join("<br>");
    };
  }

  handleOptionGroupValidation() {
    const radios = this.element.querySelectorAll(
      '.newsletter__option-input[required]'
    );
    if (!radios.length) return true;

    const anyChecked = Array.from(radios).some((radio) => radio.checked);
    const errorEl = this.element.querySelector('.newsletter__options-error');
    if (!errorEl) return anyChecked;

    if (!anyChecked) {
      errorEl.textContent = this.optionErrorMessage || '';
    } else {
      errorEl.textContent = '';
    }

    return anyChecked;
  }

  checkGeolocationPopupAndStart() {
    this.holdCookieBannerWhileGeolocation();

    this.waitForGeolocationPopupDismissal().then(() => {
      this.releaseCookieBannerAfterGeolocation();
      this.checkCookiePopupAndStart();
    });
  }

  holdCookieBannerWhileGeolocation() {
    const root = document.documentElement;
    const gatingClass = 'geolocation-gates-cookie';
    const styleId = 'geolocation-cookie-gate-style';

    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `html.${gatingClass} #shopify-pc__banner { display: none !important; visibility: hidden !important; }`;
      document.head.appendChild(style);
    }

    root.classList.add(gatingClass);
  }

  releaseCookieBannerAfterGeolocation() {
    document.documentElement.classList.remove('geolocation-gates-cookie');
  }

  isGeolocationPopupVisible() {
    const modal = document.querySelector('#md-app-embed__modal');
    if (!modal) return false;

    const isBodyOpen = document.body.classList.contains('orbe--opened');
    const computedStyle = window.getComputedStyle(modal);
    const isVisible = computedStyle.display !== 'none' &&
      computedStyle.visibility !== 'hidden' &&
      modal.getAttribute('aria-hidden') !== 'true' &&
      !modal.hasAttribute('hidden');

    return isBodyOpen || isVisible;
  }

  waitForGeolocationPopupDismissal() {
    const OBSERVE_FOR_MS = 2500;

    return new Promise((resolve) => {
      const modalExists = !!document.querySelector('#md-app-embed__modal');
      const bodyHasOrbeClass = document.body.classList.contains('orbe--opened');
      if (!modalExists && !bodyHasOrbeClass) {
        resolve();
        return;
      }

      let hasOpened = this.isGeolocationPopupVisible();
      let settled = false;
      let openWindowTimeout = null;
      let safetyTimeout = null;
      let geolocationObserver = null;

      const teardown = () => {
        if (geolocationObserver) geolocationObserver.disconnect();
        if (openWindowTimeout) clearTimeout(openWindowTimeout);
        if (safetyTimeout) clearTimeout(safetyTimeout);
      };

      const finish = () => {
        if (settled) return;
        settled = true;
        teardown();
        resolve();
      };

      const checkState = () => {
        const isVisible = this.isGeolocationPopupVisible();

        if (isVisible) {
          hasOpened = true;
          return;
        }

        if (hasOpened) finish();
      };

      geolocationObserver = new MutationObserver(checkState);
      geolocationObserver.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
      });

      checkState();

      openWindowTimeout = setTimeout(() => {
        if (!hasOpened) finish();
      }, OBSERVE_FOR_MS);

      safetyTimeout = setTimeout(finish, 10000);
    });
  }

  checkCookiePopupAndStart() {
    const cookiePopup = document.querySelector('#shopify-pc__banner');
    if (cookiePopup) {
      const isVisible = cookiePopup.style.display !== 'none' &&
        window.getComputedStyle(cookiePopup).display !== 'none';

      if (isVisible) {
        this.waitForCookiePopupDismissal();
      } else {
        this.cookiePopupDismissed = true;
        this.handleOpenOptions();
      }
    } else {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
    }
  }

  handleCookieButtonClick() {
    if (this._boundCookieHandler) {
      this.delegateBody.off(
        'click',
        '#shopify-pc__banner__btn-decline',
        this._boundCookieHandler
      );
      this.delegateBody.off(
        'click',
        '#shopify-pc__banner__btn-accept',
        this._boundCookieHandler
      );
      this._boundCookieHandler = null;
    }
    this.cookiePopupDismissed = true;
    this.handleOpenOptions();
  }

  waitForCookiePopupDismissal() {
    this._boundCookieHandler = this.handleCookieButtonClick.bind(this);

    this.delegateBody.on(
      'click',
      '#shopify-pc__banner__btn-decline',
      this._boundCookieHandler
    );

    this.delegateBody.on(
      'click',
      '#shopify-pc__banner__btn-accept',
      this._boundCookieHandler
    );
  }

  handleOpenOptions() {
    if (!this.cookiePopupDismissed) {
      return;
    }

    const seen = this._getStorage("popup-seen") === "true";
    const subscribed = this._getStorage("popup-subscribed") === "true";

    if ((this.options.show_only_once && seen) || subscribed) {
      this.element.style.display = "none";
      return;
    }

    // Always arm delay-based open.
    this.openNewsletter();

    // Scroll trigger should also work (first trigger wins).
    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
      this.scrollListener();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter(true);
    }
  };

  openNewsletter(immediate = false) {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
      this.myScrollListener = null;
    }

    if (this._openTimeout) clearTimeout(this._openTimeout);

    const delayMs = immediate ? 0 : 1000 * this.options.delay;

    this._openTimeout = setTimeout(() => {
      this._openTimeout = null;
      this.element.style.display = "";
      this.element.setAttribute("aria-hidden", false);

      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this.closeNewsletter, {once: true});

      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");

      this._setStorage("popup-seen", "true");
    }, delayMs);
  }

  closeNewsletter = () => {
    if (this.element.getAttribute('aria-hidden') !== 'false') return;

    if (this._closeTransitionHandler) {
      this.element.removeEventListener('transitionend', this._closeTransitionHandler);
    }

    const onTransitionEnd = (e) => {
      if (!e || e.propertyName !== 'visibility') {
        this.element.style.display = "none";
        this.element.removeEventListener('transitionend', onTransitionEnd);
        this._closeTransitionHandler = null;
      }
    }

    if (this.options.enable_animation) {
      this._closeTransitionHandler = onTransitionEnd;
      this.element.addEventListener('transitionend', onTransitionEnd);
    } else {
      onTransitionEnd();
    }
    this.element.setAttribute("aria-hidden", true);

    console.log("remove is-visible");
    this.pageOverlayElement.classList.remove("is-visible");

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    bodyScrollLock.enableBodyScroll(this.element);
    document.body.classList.remove("scrollLock");

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
      this.myScrollListener = null;
    }
  };

  onSubmit(e) {
    const hasValidOptions = this.handleOptionGroupValidation();
    if (!hasValidOptions) {
      e.preventDefault();
      return;
    }

    if (this.validator && !this.validator.showAllErrors()) {
      e.preventDefault();
      return;
    }

    const form = e.target;
    const emailEl = form.querySelector('.newsletter__email-input');
    const email = emailEl ? emailEl.value.trim() : '';
    if (!email) {
      e.preventDefault();
      return;
    }

    const errorWrapper = this.element.querySelector('.newsletter__error-wrapper');
    if (errorWrapper) errorWrapper.textContent = '';
  }

  showSuccessState() {
    const popup = this.element;
    const contentWrapper = popup.querySelector('.newsletter-popup__content-wrapper');
    const success = popup.querySelector('.newsletter__success-wrapper');
    const duplicateWrapper = popup.querySelector('.newsletter__duplicate-email-wrapper');
    if (!popup || !contentWrapper || !success) return;

    if (duplicateWrapper) {
      duplicateWrapper.classList.add('is-hidden');
    }

    contentWrapper.classList.add('is-hidden');
    success.classList.remove('is-hidden');
    popup.setAttribute('aria-hidden', 'false');
  }

  showDuplicateEmailState() {
    const popup = this.element;
    const contentWrapper = popup.querySelector('.newsletter-popup__content-wrapper');
    const success = popup.querySelector('.newsletter__success-wrapper');
    const duplicateWrapper = popup.querySelector('.newsletter__duplicate-email-wrapper');

    if (!success || !duplicateWrapper || !contentWrapper) return;

    contentWrapper.classList.add('is-hidden');
    success.classList.remove('is-hidden');
    duplicateWrapper.classList.remove('is-hidden');
    popup.setAttribute('aria-hidden', 'false');
  }

  clearInput() {
    const emailInput = this.element.querySelector(".input-placeholder");
    const errorWrapper = this.element.querySelector(".newsletter__error-wrapper");
    const emailWrapper = this.element.querySelector(".newsletter__inputs");

    if (emailInput) emailInput.value = "";
    if (errorWrapper) errorWrapper.textContent = "";
    if (emailWrapper) emailWrapper.classList.remove("alert");

    if (this.validator) {
      this.validator.clearErrors();
      this.validator.updateButtonState();
    }
  }

  _getStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn('NewsletterPopup: localStorage unavailable, popup state will not persist.', e);
      return null;
    }
  }

  _setStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn('NewsletterPopup: localStorage unavailable, popup state will not persist.', e);
    }
  }

  disconnectedCallback() {
    this._initialized = false;

    const formEl = this.element.querySelector('.newsletter__form');
    if (formEl && this._boundNewsletterSubmit) {
      formEl.removeEventListener('submit', this._boundNewsletterSubmit);
    }

    this.delegateElement.off();
    this.delegateBody.off();
    if (this._openTimeout) clearTimeout(this._openTimeout);
    if (this.myScrollListener) this.myScrollListener.removeScrollListener();
    if (this._closeTransitionHandler) {
      this.element.removeEventListener('transitionend', this._closeTransitionHandler);
    }
    if (this._successTransitionHandler) {
      this.element.removeEventListener('transitionend', this._successTransitionHandler);
    }
    if (this.pageOverlayElement) {
      this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);
    }
    bodyScrollLock.enableBodyScroll(this.element);
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

class LocalizationSelectors extends HTMLElement {
  connectedCallback() {
    if (this._mounted) return;
    this._mounted = true;

    const modal = document.querySelector('#modal-country');
    if (!modal) return;

    if (!modal._localizationDrawer) {
      modal._localizationDrawer = new Drawer(modal, {});

      // Desktop: enable CSS-based fade animation for localization drawer
      if (responsive.matchesBreakpoint('lap_and_up')) {
        modal.classList.add('Drawer--animate');
      }
    }

    // Force localization drawer to size to its content instead of full viewport
    if (modal._localizationDrawer && typeof modal._localizationDrawer.maxHeight === 'function') {
      const drawerInstance = modal._localizationDrawer;
      drawerInstance.maxHeight = function () {
        this.element.style.height = 'auto';
      }.bind(drawerInstance);
      // Apply once immediately in case Drawer already ran its original maxHeight
      drawerInstance.maxHeight();

      // Desktop: ensure close uses fade-out animation before hiding
      if (!drawerInstance._localizationFadePatched && typeof drawerInstance.close === 'function') {
        drawerInstance._localizationFadePatched = true;
        const originalClose = drawerInstance.close.bind(drawerInstance);

        drawerInstance.close = (event) => {
          const isDesktop = responsive.matchesBreakpoint('lap_and_up');

          // On mobile/tablet keep default Drawer behavior
          if (!isDesktop) {
            originalClose(event);
            return;
          }

          // For desktop, let CSS handle fade-out via aria-expanded toggle,
          // then call the original close after the transition duration.
          modal.setAttribute('aria-expanded', 'false');

          window.setTimeout(() => {
            originalClose(event);
          }, 230);
        };
      }
    }

    this._onDrawerOpened = () => {
      const mobileMenu = document.querySelector('#mobile-menu-drawer');
      if (mobileMenu && mobileMenu.getAttribute('aria-expanded') === 'true') {
        modal.classList.add('localization-from-mobile-menu');
      } else {
        modal.classList.remove('localization-from-mobile-menu');
      }

      const localizationModal = modal.querySelector('localization-modal');
      if (localizationModal && typeof localizationModal.syncViewportBounds === 'function') {
        localizationModal.syncViewportBounds();
      }
    };
    this._onDrawerClosed = (e) => {
      if (e.detail && (e.detail.drawerId === 'mobile-menu-drawer' || e.detail.drawerId === 'modal-country')) {
        modal.classList.remove('localization-from-mobile-menu');
      }
      if (e.detail && e.detail.drawerId === 'mobile-menu-drawer') {
        if (modal._localizationDrawer && modal._localizationDrawer.isOpen) {
          modal._localizationDrawer.closeDrawer();
        }
      }

      const localizationModal = modal.querySelector('localization-modal');
      if (localizationModal && typeof localizationModal.syncViewportBounds === 'function') {
        localizationModal.syncViewportBounds();
      }
    };

    this._onLocalizationOutsidePointerDown = (event) => {
      const drawer = modal._localizationDrawer;
      if (!drawer) return;

      const isExpanded = modal.getAttribute('aria-expanded') === 'true';
      if (!drawer.isOpen && !isExpanded) return;

      const target = event.target;
      if (!target) return;

      // Ignore clicks on the button that opens/closes the drawer
      const toggle = target.closest && target.closest('[data-toggle-id="modal-country"]');
      if (toggle) return;

      // Ignore clicks inside the modal itself
      if (modal.contains(target)) return;

      // Close the drawer when clicking anywhere outside it
      if (typeof drawer.close === 'function') {
        drawer.close(event);
      } else if (typeof drawer.closeDrawer === 'function') {
        drawer.closeDrawer(event);
      }
    };

    this._onLocalizationOpenFromMobileMenu = (event) => {
      if (responsive.matchesBreakpoint('lap_and_up')) return;

      const target = event.target;
      if (!target || !target.closest) return;

      const trigger = target.closest('[data-toggle-id="modal-country"]');
      if (!trigger) return;

      const mobileMenu = document.querySelector('#mobile-menu-drawer');
      if (!mobileMenu || !mobileMenu.contains(trigger)) return;
      if (mobileMenu.getAttribute('aria-expanded') !== 'true') return;

      const drawer = modal._localizationDrawer;
      if (!drawer || typeof drawer.openDrawer !== 'function') return;

      // Bypass generic single-drawer auto-close only for this mobile path.
      event.preventDefault();
      event.stopPropagation();

      const previousExpanded = mobileMenu.getAttribute('aria-expanded');
      mobileMenu.setAttribute('aria-expanded', 'false');
      drawer.openDrawer();
      mobileMenu.setAttribute('aria-expanded', previousExpanded || 'true');
      modal.classList.add('localization-from-mobile-menu');
    };

    document.body.addEventListener('drawer:opened', this._onDrawerOpened, true);
    document.body.addEventListener('drawer:closed', this._onDrawerClosed, true);
    document.body.addEventListener('click', this._onLocalizationOpenFromMobileMenu, true);
    // Listen on multiple event types because some mobile browsers don't fire pointer events consistently.
    document.body.addEventListener('pointerdown', this._onLocalizationOutsidePointerDown, true);
    document.body.addEventListener('mousedown', this._onLocalizationOutsidePointerDown, true);
    document.body.addEventListener('touchstart', this._onLocalizationOutsidePointerDown, true);

  }

  disconnectedCallback() {
    if (!this._mounted) return;
    this._mounted = false;
    document.body.removeEventListener('drawer:opened', this._onDrawerOpened, true);
    document.body.removeEventListener('drawer:closed', this._onDrawerClosed, true);
    if (this._onLocalizationOutsidePointerDown) {
      document.body.removeEventListener('pointerdown', this._onLocalizationOutsidePointerDown, true);
      document.body.removeEventListener('mousedown', this._onLocalizationOutsidePointerDown, true);
      document.body.removeEventListener('touchstart', this._onLocalizationOutsidePointerDown, true);
      this._onLocalizationOutsidePointerDown = null;
    }
    if (this._onLocalizationOpenFromMobileMenu) {
      document.body.removeEventListener('click', this._onLocalizationOpenFromMobileMenu, true);
      this._onLocalizationOpenFromMobileMenu = null;
    }
    this._onDrawerOpened = null;
    this._onDrawerClosed = null;
  }
}
customElements.define('localization-selectors', LocalizationSelectors);



class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.element.querySelectorAll('.RevolutionSelectbox').forEach((box) => {
      const instance = new RevolutionSelectbox(box);
      box._revolutionSelectbox = instance;
      this._patchDropdownOpen(instance);
      this._patchDropdownClose(instance, box);
    });
    this.bindEvents();
    this.ensureLocalizationData();
    if (this.ensureLanguageSelection) this.ensureLanguageSelection();
    this.sortMarketItems();
    this._disableSingleItemSelectors();
    this.syncViewportBounds();
  }

  _getMobileMenuFooterHeight() {
    const modalRoot = this.closest && this.closest('#modal-country');
    if (!modalRoot || !modalRoot.classList.contains('localization-from-mobile-menu')) {
      return 0;
    }

    const footer = document.querySelector('#mobile-menu-drawer .Drawer--Footer');
    if (!footer) return 0;

    return footer.getBoundingClientRect().height || footer.offsetHeight || 0;
  }

  syncViewportBounds() {
    const modalRoot = this.closest && this.closest('#modal-country');
    if (!modalRoot) return 0;

    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight || 0;
    const isMobile = !responsive.matchesBreakpoint('lap_and_up');
    const maxHeight = isMobile ? Math.max(viewportHeight - 40, 0) : viewportHeight;

    modalRoot.style.bottom = '';
    modalRoot.style.maxHeight = maxHeight ? `${maxHeight}px` : '';
    this.style.maxHeight = maxHeight ? `${maxHeight}px` : '';

    return maxHeight;
  }

  _measureAndApplyHeight(contentElement) {
    if (!contentElement) return;

    const maxModalHeight = this.syncViewportBounds();
    const modalRoot = this.closest && this.closest('#modal-country');
    const scrollEl = contentElement.querySelector('.RevolutionSelectbox--Content-scroll');

    contentElement.style.maxHeight = '';
    contentElement.style.height = 'auto';
    contentElement.style.overflow = 'hidden';
    if (scrollEl) {
      scrollEl.style.maxHeight = '';
      scrollEl.style.height = 'auto';
    }

    const fullHeight = scrollEl
      ? scrollEl.scrollHeight || contentElement.scrollHeight || 0
      : contentElement.scrollHeight || 0;

    // Collapse all open dropdowns to measure everything else (header, labels, buttons, gaps, padding)
    contentElement.style.height = '0px';
    const otherPanels = modalRoot
      ? Array.from(modalRoot.querySelectorAll('.RevolutionSelectbox--Content[aria-hidden="false"]'))
        .filter((p) => p !== contentElement)
      : [];
    const savedHeights = otherPanels.map((p) => p.style.height);
    otherPanels.forEach((p) => { p.style.height = '0px'; });
    // eslint-disable-next-line no-unused-expressions
    contentElement.offsetHeight;

    const modalEl = modalRoot
      ? modalRoot.querySelector('localization-modal') || modalRoot
      : this;
    const usedHeight = modalEl.scrollHeight;

    // Restore other panels
    otherPanels.forEach((p, i) => { p.style.height = savedHeights[i]; });

    const availableHeight = Math.max(maxModalHeight - usedHeight, 100);
    const targetHeight = Math.min(fullHeight, availableHeight);

    if (responsive.matchesBreakpoint('lap_and_up')) {
      contentElement.style.transition = 'height 220ms ease';
      contentElement.style.height = '0px';
      // eslint-disable-next-line no-unused-expressions
      contentElement.offsetHeight;
      contentElement.style.height = `${targetHeight}px`;
    } else {
      contentElement.style.transition = '';
      contentElement.style.height = `${targetHeight}px`;
    }

    if (scrollEl) {
      scrollEl.style.maxHeight = `${targetHeight}px`;
      scrollEl.style.overflow = 'auto';
    }
  }

  _patchDropdownOpen(instance) {
    const originalOpen = instance.openDropdown.bind(instance);

    instance.openDropdown = (target) => {
      originalOpen(target);

      const contentElement =
        target &&
        target.parentElement &&
        target.parentElement.querySelector('.RevolutionSelectbox--Content');

      if (!contentElement || !this.element.contains(contentElement)) return;

      requestAnimationFrame(() => this._measureAndApplyHeight(contentElement));

      if (!contentElement._localizationObserver) {
        const inner = contentElement.querySelector('.RevolutionSelectbox--InnerContent') || contentElement;
        const obs = new MutationObserver(() => {
          if (contentElement.getAttribute('aria-hidden') !== 'false') return;
          this._measureAndApplyHeight(contentElement);
        });
        obs.observe(inner, { childList: true, subtree: true });
        contentElement._localizationObserver = obs;
      }
    };
  }

  _patchDropdownClose(instance, box) {
    const originalClose = instance.closeDropdown.bind(instance);

    instance.closeDropdown = (target) => {
      if (instance.popover) {
        originalClose(target);
        return;
      }

      const dropdown =
        (target && target.closest && target.closest('.RevolutionSelectbox')) ||
        box;
      const btn = dropdown.querySelector('.RevolutionSelectbox--Button');
      const panel = dropdown.querySelector('.RevolutionSelectbox--Content');

      if (!btn || !panel || !this.element.contains(panel)) {
        originalClose(target);
        return;
      }

      const currentHeight = panel.scrollHeight || panel.offsetHeight || 0;
      panel.style.transition = responsive.matchesBreakpoint('lap_and_up')
        ? 'height 220ms ease'
        : '';
      panel.style.overflow = 'hidden';
      panel.style.display = 'block';
      panel.style.height = `${currentHeight}px`;
      // eslint-disable-next-line no-unused-expressions
      panel.offsetHeight;

      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.height = '0px';

      window.setTimeout(() => {
        panel.style.display = 'none';
        instance.isOpen = false;
        removeTrapFocus(instance.mainDropdownContent);
        window.removeEventListener('click', instance.onClickOutsideListener);

        if (panel._localizationObserver) {
          panel._localizationObserver.disconnect();
          panel._localizationObserver = null;
        }
        panel.style.height = '';
        panel.style.maxHeight = '';
        panel.style.overflow = '';
        panel.style.transition = '';
        const scrollEl = panel.querySelector('.RevolutionSelectbox--Content-scroll');
        if (scrollEl) {
          scrollEl.style.maxHeight = '';
          scrollEl.style.height = '';
        }
      }, 220);
    };
  }

  _disableSingleItemSelectors() {
    this.element.querySelectorAll('.RevolutionSelectbox--Selectors').forEach((box) => {
      const btn = box.querySelector('.RevolutionSelectbox--Button');
      const panel = box.querySelector('.RevolutionSelectbox--Content');
      const count = box.querySelectorAll('.RevolutionSelectbox--Item').length;
      if (!btn || !panel) return;
      if (count <= 1) {
        btn.classList.add('rs-disabled');
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.display = 'none';
      }
    });
  }

  bindEvents() {
    this._onDropdownOpened = this.checkFadeVisibility.bind(this);
    document.addEventListener('dropdown:opened', this._onDropdownOpened);
    document.body.addEventListener('selectbox:opened', this._onDropdownOpened);

    this._onCountryChange = this.updateLanguageOptions.bind(this);
    document.addEventListener('change:countrySelector', this._onCountryChange);

    this._onResize = () => {
      this.syncViewportBounds();
      this.checkFadeVisibility();
      const openPanel = this.element.querySelector(
        '.RevolutionSelectbox--Content[aria-hidden="false"]'
      );
      if (openPanel) {
        this._measureAndApplyHeight(openPanel);
      }
    };
    window.addEventListener('resize', this._onResize);

    this.delegateElement.on(
      'click',
      '[data-action=check-location-submit]',
      this.checkLocationSubmit.bind(this)
    );
    this.delegateElement.on('click', '.RevolutionSelectbox--Item', (e, target) => {
      const box = target.closest('.RevolutionSelectbox');
      if (!box) return;
      if (target.closest('.rs-country__selectbox')) {
        this.handleRegularMarketSelection(e, target);
      } else {
        this.syncSelectboxUI(box, target);
        requestAnimationFrame(() => this.closeSelectbox(box));
      }
    });
    this.delegateElement.on('keydown', '.RevolutionSelectbox--Item', (e, target) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      target.click();
    });
    this._panelScrollHandlers = [];
    this.element.querySelectorAll('.RevolutionSelectbox--Content').forEach((panel) => {
      const scrollEl = this._getScrollEl(panel);
      const fn = this.checkFadeVisibility.bind(this);
      this._panelScrollHandlers.push({ panel: scrollEl, fn });
      scrollEl.addEventListener('scroll', fn);
    });
  }

  disconnectedCallback() {
    if (this._onDropdownOpened) {
      document.removeEventListener('dropdown:opened', this._onDropdownOpened);
      document.body.removeEventListener('selectbox:opened', this._onDropdownOpened);
    }
    if (this._onCountryChange) document.removeEventListener('change:countrySelector', this._onCountryChange);
    if (this._onResize) window.removeEventListener('resize', this._onResize);
    if (this._panelScrollHandlers) {
      this._panelScrollHandlers.forEach(({ panel, fn }) => panel.removeEventListener('scroll', fn));
    }
    this._onDropdownOpened = null;
    this._onCountryChange = null;
    this._onResize = null;
    this._panelScrollHandlers = null;

    if (this._localizationFetchController) {
      this._localizationFetchController.abort();
      this._localizationFetchController = null;
    }
  }


  sortMarketItems() {
    const inner = this.element.querySelector(
      '.rs-country__selectbox .RevolutionSelectbox--InnerContent'
    );
    if (!inner) return;

    const items = Array.from(inner.querySelectorAll('.RevolutionSelectbox--Item'));
    if (!items.length) return;

    const isGlobal = (el) =>
      (el.getAttribute('data-name') || '').trim().toLowerCase() === 'global';

    const globalItems = items.filter(isGlobal);
    const rest = items.filter((el) => !isGlobal(el));

    rest.sort((a, b) => {
      const an = (a.getAttribute('data-name') || '').trim();
      const bn = (b.getAttribute('data-name') || '').trim();
      return an.localeCompare(bn, undefined, { sensitivity: 'base' });
    });

    // Rebuild DOM in order
    inner.textContent = '';
    [...globalItems, ...rest].forEach((el) => inner.appendChild(el));
  }


  _getScrollEl(panel) {
    return panel.querySelector('.RevolutionSelectbox--Content-scroll') || panel;
  }

  closeSelectbox(box) {
    const instance = box._revolutionSelectbox;
    if (instance) {
      instance.closeDropdown(box);
    } else {
      const btn = box.querySelector('.RevolutionSelectbox--Button');
      const panel = box.querySelector('.RevolutionSelectbox--Content');
      if (btn && panel) {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.display = 'none';
      }
    }
  }

  checkFadeVisibility() {
    const panels = Array.from(this.element.querySelectorAll('.RevolutionSelectbox--Content'));
    panels.forEach((panel) => {
      const isOpen =
        panel.getAttribute('aria-hidden') === 'false' &&
        getComputedStyle(panel).display !== 'none';
      if (!isOpen) return;
      const scrollEl = this._getScrollEl(panel);
      const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight + 1;
      const distanceFromBottom =
        scrollEl.scrollHeight - (scrollEl.scrollTop + scrollEl.clientHeight);
      const isAtBottom = distanceFromBottom <= 2;
      panel.classList.toggle('fade-visible', isScrollable && !isAtBottom);
    });
  }


  syncSelectboxUI(box, item) {
    const value = (item.getAttribute('data-value') || '').trim();
    const name = (item.getAttribute('data-name') || '').trim();
    const inputId = (item.getAttribute('data-selectboxid') || '').trim();

    if (inputId && value) {
      const hidden = document.getElementById(inputId);
      if (hidden) hidden.value = value;
    }

    const titleEl = box.querySelector('.RevolutionSelectbox--Button .RevolutionSelectbox--Title');
    if (titleEl && name) titleEl.textContent = name;

    box.querySelectorAll('.RevolutionSelectbox--Item[selected="selected"]').forEach((el) => {
      if (el !== item) el.removeAttribute('selected');
    });
    item.setAttribute('selected', 'selected');

    box.querySelectorAll('.RevolutionSelectbox--Item[aria-selected="true"]').forEach((el) => {
      if (el !== item) el.setAttribute('aria-selected', 'false');
    });
    item.setAttribute('aria-selected', 'true');

  }


  async checkLocationSubmit(event) {
    event.preventDefault();
    try {
      const selectedItem =
        this.element.querySelector(
          '.RevolutionSelectbox--Item[selected="selected"]'
        ) || this.element.querySelector('.RevolutionSelectbox--Item.selected');
      if (!selectedItem) return;

      const chosenCountryCode = (
        selectedItem.getAttribute('data-value') || ''
      ).trim();
      if (!chosenCountryCode) return;

      const redirectUrl = (selectedItem.getAttribute('data-redirect-url') || '').trim();
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      const countryInput = document.querySelector(
        '#country-selector__country-code'
      );
      if (countryInput) countryInput.value = chosenCountryCode;
      if (this.ensureLanguageSelection) this.ensureLanguageSelection();
      const hiddenLang = this.element.querySelector('#selected-language');
      if (hiddenLang) {
        // If no radio selected yet, select first visible one
        if (!hiddenLang.value) {
          const firstRadio = this.element.querySelector(
            '.localization__language-radio'
          );
          if (firstRadio) {
            firstRadio.checked = true;
            hiddenLang.value = firstRadio.value;
          }
        }
      }

      const form = document.getElementById('localization-form');
      if (form) {
        form.submit();
      } else {
        console.error('[Localization] localization-form not found');
      }
    } catch (error) {
      console.error('Localization submit error:', error);
    }
  }

  handleRegularMarketSelection(e, target) {
    if (!target.closest('.rs-country__selectbox')) return;

    this.element
      .querySelectorAll(
        '.rs-country__selectbox .RevolutionSelectbox--Item[selected="selected"]'
      )
      .forEach((item) => {
        if (item !== target) item.removeAttribute('selected');
      });

    target.setAttribute('selected', 'selected');


    const countryInput = this.element.querySelector(
      '#country-selector__country-code'
    );
    const value = target.getAttribute('data-value');
    if (countryInput && value) {
      countryInput.value = value.trim();
      const languages = target.getAttribute('data-languages') || '';
      document.dispatchEvent(
        new CustomEvent('change:countrySelector', {
          detail: { country: value.trim(), languages }
        })
      );
      const box = target.closest('.RevolutionSelectbox');
      if (box) this.syncSelectboxUI(box, target);

    }

    if (this.ensureLanguageSelection) this.ensureLanguageSelection();
    const box = target.closest('.RevolutionSelectbox');
    if (box) this.closeSelectbox(box);
  }

  ensureLanguageSelection() {
    const hidden = this.element.querySelector('#selected-language');
    const radios = Array.from(
      this.element.querySelectorAll('.language-selector__radio')
    );
    if (!radios.length) return;
    let checked = radios.find((r) => r.checked);
    if (!checked && hidden && hidden.value) {
      checked = radios.find(
        (r) => r.value.toLowerCase() === hidden.value.toLowerCase()
      );
    }
    if (!checked) checked = radios[0];
    if (checked && !checked.checked) checked.checked = true;
    if (hidden && checked && hidden.value !== checked.value)
      hidden.value = checked.value;
  }

  async ensureLocalizationData() {
    if (this._localizationData) return this._localizationData;
    if (!this._localizationDataPromise) {
      const controller = new AbortController();
      this._localizationFetchController = controller;
      this._localizationDataPromise = fetch('/localization.json', {
        signal: controller.signal,
      })
        .then((r) =>
          r.ok ? r.json() : Promise.reject('Failed localization.json')
        )
        .then((data) => {
          this._localizationData = data;
          return data;
        })
        .catch(() => null);
    }
    return this._localizationDataPromise;
  }

  parseLanguages(raw) {
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((l) => ({
          iso: (l.iso || l.code || '').toLowerCase(),
          name: l.name || l.endonym_name || (l.iso || '').toUpperCase(),
        }))
        .filter((l) => l.iso);
    } catch {
      return [];
    }
  }

  async fallbackLanguagesFromJson(countryIso) {
    const data = await this.ensureLocalizationData();
    if (!data || !countryIso) return [];

    const match = (data.available_countries || []).find(
      (c) => c.iso_code?.toUpperCase() === countryIso.toUpperCase()
    );
    if (!match) return [];

    return (match.available_languages || [])
      .map((l) => ({
        iso: (l.iso_code || '').toLowerCase(),
        name: (l.endonym_name || l.name || l.iso_code || '').replace(
          /\b\w/g,
          (c) => c.toUpperCase()
        ),
      }))
      .filter((l) => l.iso);
  }

  rebuildLanguageList(langs) {
    const langBox = this.querySelector('.rs-language__selectbox');
    const hidden = this.querySelector('#language-selector__language-code');
    if (!langBox || !hidden || !langs.length) return;

    const inner = langBox.querySelector('.RevolutionSelectbox--InnerContent');
    const btnTitle = langBox.querySelector('.RevolutionSelectbox--Button .RevolutionSelectbox--Title');
    const btn = langBox.querySelector('.RevolutionSelectbox--Button');
    const panel = langBox.querySelector('.RevolutionSelectbox--Content');
    if (!inner || !btn || !panel) return;

    const current = (hidden.value || '').toLowerCase();
    const hasCurrent = langs.some((l) => l.iso === current);
    const nextIso = hasCurrent ? current : langs[0].iso;

    inner.textContent = '';

    langs.forEach((l) => {
      const item = document.createElement('div');
      item.className = 'RevolutionSelectbox--Item';
      item.tabIndex = 0;
      item.setAttribute('data-value', l.iso);
      item.setAttribute('data-name', l.name);
      item.setAttribute('data-selectboxid', 'language-selector__language-code');
      item.setAttribute('data-action', 'selectbox-change');
      if (l.iso === nextIso) item.setAttribute('selected', 'selected');

      const title = document.createElement('div');
      title.className = 'RevolutionSelectbox--Title u-p2';
      title.textContent = l.name;
      item.appendChild(title);

      inner.appendChild(item);
    });

    hidden.value = nextIso;
    const chosen = langs.find((l) => l.iso === nextIso) || langs[0];
    if (btnTitle) btnTitle.textContent = chosen.name;

    if (langs.length <= 1) {
      btn.classList.add('rs-disabled');
      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.display = 'none';
    } else {
      btn.classList.remove('rs-disabled');
    }

    // If the language dropdown is currently open, update its height after rebuild
    // so the list isn't partially cut off until the user reopens it.
    window.setTimeout(() => {
      if (panel.getAttribute('aria-hidden') !== 'false') return;
      const maxH = parseFloat(panel.style.maxHeight || '') || panel.scrollHeight || 0;
      const nextH = Math.min(panel.scrollHeight || 0, maxH || panel.scrollHeight || 0);
      panel.style.height = `${nextH}px`;
    }, 0);
  }


  async updateLanguageOptions(e) {
    const raw = e?.detail?.languages || '';
    const countryIso = (e?.detail?.country || '').trim();

    let langs = this.parseLanguages(raw);

    // fallback if data-languages empty/invalid
    if (langs.length === 0) {
      langs = await this.fallbackLanguagesFromJson(countryIso);
    }

    if (langs.length === 0) return;

    this.rebuildLanguageList(langs);
  }
}
customElements.define('localization-modal', LocalizationModal);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.element.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);


class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = null;
    this.initializationMode = this.getInitializationMode();
    this.intersectionObserver = null;
    this.isDynamic = this.element.hasAttribute('data-swiper-dynamic');
    this.isDynamicOnce = this.element.hasAttribute('data-swiper-dynamic-once');
    this.isHorizontalFadeDesktop = this.element.hasAttribute("data-swiper-fade-horizontal-desktop");
    this.isHorizontalFadeMobile = this.element.hasAttribute("data-swiper-fade-horizontal-mobile");
    this.isHorizontalFade = this.element.hasAttribute("data-swiper-fade-horizontal");
    this.hasBeenInitialized = false; // Track if dynamic-once has been initialized
    this.horizontalFadeResizeListener = null;
    this.horizontalFadeUpdate = null;
    this.horizontalFadeSwiperInstance = null;
    this.windowResizeSubscription = null;

    // Bind methods
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
  }

  getInitializationMode() {
    // Check data attributes to determine mode
    if (this.element.hasAttribute('data-swiper-mobile')) {
      return 'mobile';
    } else if (this.element.hasAttribute('data-swiper-desktop')) {
      return 'desktop';
    } else if (this.element.hasAttribute('data-swiper-tablet')) {
      return 'tablet';
    } else {
      return 'universal';
    }
  }

  connectedCallback() {
    // Listen to responsive system breakpoint changes
    document.addEventListener('breakpoint:changed', this.handleBreakpointChange);

    this.windowResizeSubscription = responsive.addResizeListener(
      this,
      this.handleWindowResize
    );

    // Set up intersection observer for dynamic swipers
    if (this.isDynamic || this.isDynamicOnce) {
      this.setupIntersectionObserver();
    } else {
      // Auto-initialize if not dynamic and not disabled
      if (!this.element.hasAttribute('data-swiper-manual')) {
        this.initSwiper();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('breakpoint:changed', this.handleBreakpointChange);
    if (this.windowResizeSubscription?.removeResizeListener) {
      this.windowResizeSubscription.removeResizeListener();
    }
    this.windowResizeSubscription = null;
    this.cleanupIntersectionObserver();
    this.destroy();
  }

  handleWindowResize() {
    this.resize();
  }

  setupIntersectionObserver() {
    // Get threshold from attribute or use default
    const threshold = parseFloat(this.element.getAttribute('data-swiper-dynamic-threshold')) || 0.1;

    // Get root margin from attribute or use default
    const rootMargin = this.element.getAttribute('data-swiper-dynamic-margin') || '50px';

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      threshold: threshold,
      rootMargin: rootMargin
    });

    this.intersectionObserver.observe(this.element);

  }

  cleanupIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.target === this.element) {
        if (entry.isIntersecting) {
          // Element is in view - initialize if should be active
          if (this.shouldInitialize() && !this.swiper) {
            this.initSwiper();
          }
        } else {
          // Element is out of view
          if (this.isDynamic && this.swiper) {
            // Dynamic mode: destroy when out of view
            this.destroy();
          }
          // Dynamic-once mode: keep swiper active once initialized
        }
      }
    });
  }

  handleBreakpointChange(event) {
    const { currentBreakpoint } = event.detail;

    // Check if we should be active on this breakpoint
    const shouldBeActive = this.shouldInitialize(currentBreakpoint);
    const currentlyActive = !!this.swiper;

    // For dynamic swipers, only initialize if also in view
    if (this.isDynamic || this.isDynamicOnce) {
      // Let the intersection observer handle initialization
      // Just destroy if shouldn't be active
      if (!shouldBeActive && currentlyActive) {
        this.destroy();
      }
    } else {
      // Normal behavior for non-dynamic swipers
      if (shouldBeActive && !currentlyActive) {
        this.initSwiper();
      } else if (!shouldBeActive && currentlyActive) {
        this.destroy();
      } else if (shouldBeActive && currentlyActive) {
        this.initSwiper();
      }
    }
  }

  initHorizontalFadeOnSwiper() {
    const swiper = this.element.getSwiper();
    const swiperInstance = swiper.swiperElement;
    if (!swiper) return;

    this.teardownHorizontalFade();

    // Add "content-fade" class here
    this.element.classList.add('content-fade');
    const fadeContainer = this.element;

    const update = () => this.updateHorizontalFadeClasses(swiperInstance, fadeContainer);
    this.horizontalFadeUpdate = update;
    this.horizontalFadeSwiperInstance = swiperInstance;

    // Initial update
    update();

    // Listen to swiper events
    swiperInstance.on('slideChange', update);
    swiperInstance.on('resize', update);
    swiperInstance.on('progress', update);
    swiperInstance.on('touchMove', update);

    this.horizontalFadeResizeListener = responsive.addResizeListener(this, update);
  }

  teardownHorizontalFade() {
    if (this.horizontalFadeSwiperInstance && this.horizontalFadeUpdate) {
      this.horizontalFadeSwiperInstance.off('slideChange', this.horizontalFadeUpdate);
      this.horizontalFadeSwiperInstance.off('resize', this.horizontalFadeUpdate);
      this.horizontalFadeSwiperInstance.off('progress', this.horizontalFadeUpdate);
      this.horizontalFadeSwiperInstance.off('touchMove', this.horizontalFadeUpdate);
    }

    if (this.horizontalFadeResizeListener?.removeResizeListener) {
      this.horizontalFadeResizeListener.removeResizeListener();
    }

    this.horizontalFadeResizeListener = null;
    this.horizontalFadeUpdate = null;
    this.horizontalFadeSwiperInstance = null;
  }

  updateHorizontalFadeClasses(swiperInstance, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both-horizontal');

    const atStart = swiperInstance.isBeginning;
    const atEnd = swiperInstance.isEnd;

    if (!atStart && !atEnd) {
      c.add('fade-both-horizontal');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  shouldInitialize(breakpoint = null) {
    const currentBreakpoint = breakpoint || responsive.getCurrentBreakpoint();

    switch (this.initializationMode) {
      case 'mobile':
        return ['phone', 'pocket'].includes(currentBreakpoint);
      case 'desktop':
        return ['desktop', 'lap_and_up', 'desktop_wide'].includes(currentBreakpoint);
      case 'tablet':
        return ['tablet', 'tablet_and_up'].includes(currentBreakpoint);
      case 'universal':
        return true;
      default:
        return true;
    }
  }

  initSwiper() {
    // Don't initialize if we shouldn't be active
    if (!this.shouldInitialize()) {
      return;
    }

    // Destroy existing swiper
    this.destroy();

    try {
      // Get thumb element if specified
      const thumbSelector = this.element.getAttribute('data-swiper-thumb');
      const thumbElement = thumbSelector ? document.querySelector(thumbSelector) : null;

      // Use existing RevolutionSwiper class as-is
      this.swiper = new RevolutionSwiper(this.element, thumbElement);

      // Mark as initialized for dynamic-once mode
      if (this.isDynamicOnce) {
        this.hasBeenInitialized = true;
      }

      if (this.isHorizontalFadeDesktop && responsive.matchesBreakpoint('lap_and_up')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      const currentBreakpoint = responsive.getCurrentBreakpoint();
      if (this.isHorizontalFadeMobile && (currentBreakpoint === 'phone' || currentBreakpoint === 'pocket')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      if (this.isHorizontalFade) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      // Dispatch initialization event
      this.element.dispatchEvent(new CustomEvent('swiper:initialized', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce,
          swiper: this.swiper
        }
      }));

    } catch (error) {
      console.error('SwiperInit: Failed to initialize swiper', error);
    }
  }

  destroy() {
    this.teardownHorizontalFade();
    if (this.swiper && this.swiper.swiperElement) {
      this.swiper.swiperElement.destroy(true, true);
      this.swiper = null;

      this.element.dispatchEvent(new CustomEvent('swiper:destroyed', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce
        }
      }));
    }
  }

  // Public API methods
  selectSlide(index) {
    if (this.swiper && this.swiper.selectCell) {
      this.swiper.selectCell(index);
    } else {
      // Wait for swiper to initialize, then select
      this.element.addEventListener('swiper:initialized', () => {
        if (this.swiper && this.swiper.selectCell) {
          this.swiper.selectCell(index);
        }
      }, { once: true });
    }
  }

  resize() {
    if (this.swiper) {
      this.swiper.resize();
    }
  }

  getSwiper() {
    return this.swiper;
  }

  getCurrentBreakpoint() {
    return responsive.getCurrentBreakpoint();
  }

  reinitialize() {
    this.initSwiper();
  }

  isDynamicSwiper() {
    return this.isDynamic || this.isDynamicOnce;
  }

  getDynamicMode() {
    if (this.isDynamic) return 'dynamic';
    if (this.isDynamicOnce) return 'dynamic-once';
    return 'static';
  }

  // Static method to initialize all swipers
  static initializeAll() {
    document.querySelectorAll('swiper-init').forEach(element => {
      element.initSwiper();
    });
  }
}
customElements.define("swiper-init", SwiperInit);


class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.updateVisibleHeightHandler = this.updateVisibleHeight.bind(this);
    this.scrollSubscription = null;
    this.resizeSubscription = null;
  }

  connectedCallback() {
    this.announcementBar = document.querySelector(".announcement-bar");
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    this.bindEvents();
    this.updateVisibleHeight();
  }

  disconnectedCallback() {
    if (this.scrollSubscription && typeof this.scrollSubscription.removeScrollListener === "function") {
      this.scrollSubscription.removeScrollListener();
    }
    if (this.resizeSubscription && typeof this.resizeSubscription.removeResizeListener === "function") {
      this.resizeSubscription.removeResizeListener();
    }

    this.scrollSubscription = null;
    this.resizeSubscription = null;

    if (this.delegateElement && typeof this.delegateElement.destroy === "function") {
      this.delegateElement.destroy();
    }

    this.announcementBar = null;
    this.element = null;
  }

  bindEvents() {
    if (this.element.dataset.main == "true") {
      this.scrollSubscription = scrollListener.addScrollListener(this, this.updateVisibleHeightHandler);
      this.resizeSubscription = responsive.addResizeListener(this, this.updateVisibleHeightHandler);
    } else {
      this.resizeSubscription = responsive.addResizeListener(this, this.updateVisibleHeightHandler);
    }
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    visibleHeight = Math.max(visibleHeight, 0);

    if (visibleHeight === this._lastVisibleHeight) return;
    this._lastVisibleHeight = visibleHeight;

    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);

function updatePriceDisplay(container, variant, moneyFormat) {
  var regularPriceEl = container.querySelector('.price-item--regular');
  if (regularPriceEl && variant) {
    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    regularPriceEl.textContent = Shopify.formatMoney(variant.price, moneyFormat);
    regularPriceEl.classList.toggle('regular-price-color', !hasCompare);
  }

  var comparePriceWrapper = container.querySelector('.price-compare');
  var comparePriceS = comparePriceWrapper ? comparePriceWrapper.querySelector('s') : null;
  if (comparePriceWrapper && comparePriceS) {
    var hasCompareAt = variant.compare_at_price && variant.compare_at_price > variant.price;
    comparePriceWrapper.classList.toggle('VisuallyHidden', !hasCompareAt);
    comparePriceS.textContent = hasCompareAt
      ? Shopify.formatMoney(variant.compare_at_price, moneyFormat)
      : '';
  }
}

class ProductCard extends HTMLElement {
  static MAX_VISIBLE_SIZES = 6;
  static _sizeAddListenerBound = false;

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.isSubmittingSize = false;

    this.productTitle = null;
    this.productBrandName = null;
    this.productPrice = null;
    this.colorRadios = null;
    this.wrapperLink = null;
    this.variantsWrapper = null;
  }

  connectedCallback() {
    this.cacheElements();
    this.bindEvents();
    ProductCard.bindGlobalSizeAddListener();
  }

  disconnectedCallback() {
    this.delegateElement?.off();
    this.eventsBound = false;
    this.isSubmittingSize = false;
  }

  /**
   * Single capture-phase listener for all size chips. Prevents stacked
   * per-card handlers (and button-inside-link quirks) from firing /cart/add
   * more than once per click.
   */
  static bindGlobalSizeAddListener() {
    if (ProductCard._sizeAddListenerBound) return;
    ProductCard._sizeAddListenerBound = true;

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest?.('[data-action="pc-add-size"]');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        if (button.disabled || button.dataset.submitting === 'true') return;

        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;

        const card = button.closest('product-card');
        ProductCard.handleSizeAdd(button, variantId, card);
      },
      true
    );
  }

  static async handleSizeAdd(button, variantId, card) {
    if (button.dataset.submitting === 'true') return;
    button.dataset.submitting = 'true';

    const previousLabel = button.textContent;
    const scope = card || button.parentElement;
    const sizeButtons = scope
      ? Array.from(scope.querySelectorAll('[data-action="pc-add-size"]'))
      : [button];
    const previousDisabledStates = sizeButtons.map((sizeButton) => ({
      button: sizeButton,
      disabled: sizeButton.disabled,
    }));

    if (card && typeof card.setLoadingState === 'function') {
      card.setLoadingState(true);
      card.setAttribute('aria-busy', 'true');
    }
    button.setAttribute('aria-busy', 'true');
    previousDisabledStates.forEach(({ button: sizeButton }) => {
      sizeButton.disabled = true;
    });

    try {
      const result = await CartAddGuard.addOrIncrement(variantId, 1);
      if (result.ok && !result.skipped) {
        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: variantId, quantity: 1 },
          })
        );
      }
    } catch (error) {
      console.error('Failed to add product to cart:', error);
    } finally {
      button.dataset.submitting = 'false';
      if (card && typeof card.setLoadingState === 'function') {
        card.setLoadingState(false);
        card.removeAttribute('aria-busy');
      }
      button.removeAttribute('aria-busy');
      previousDisabledStates.forEach(({ button: sizeButton, disabled }) => {
        sizeButton.disabled = disabled;
      });
      if (previousLabel) button.textContent = previousLabel;
    }
  }

  cacheElements() {
    this.swiperWrapper = this.element.querySelector('.swiper-wrapper');
    this.productTitle = this.element.querySelector('.pc__information__title');
    this.productBrandName = this.element.querySelector('.pc__information__brand-name');
    this.productPrice = this.element.querySelector('.pc__price-wrapper');
    this.colorRadios = this.element.querySelectorAll('.pc__color-checkbox');
    this.wrapperLink = this.element.querySelector('.pc__wrapper-link');
    this.variantsWrapper = this.element.querySelector(".pc__variants-wrapper");
    this.spinningLoader = this.element.querySelector('.spinningLoader');
    this.swiperElement = this.element.querySelector(".pc__image__swiper");
  }

  bindEvents() {
    if (this.eventsBound) return;
    this.eventsBound = true;
    this.boundHandleColorChange = this.handleColorChange.bind(this);
    this.delegateElement.on(
      'click',
      '[data-action="handle-color-change"]',
      this.boundHandleColorChange
    );
  }

  async handleColorChange(event) {
    const radio = event.target;
    const productUrl = radio.dataset.productUrl;

    if (!productUrl) {
      console.warn('No product URL found for this color option');
      return;
    }

    try {
      this.setLoadingState(true);
      const productData = await this.fetchProductData(productUrl);
      this.updateProductCard(event, productData);
    } catch (error) {
      console.error('Failed to fetch product data:', error);
    } finally {
      this.setLoadingState(false);
    }
  }

  async fetchProductData(productUrl) {
    const handle = productUrl.split('/products/')[1].split('?')[0];
    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const product = await response.json();

    const productData = {
      ...product,
      formattedPrice: Shopify.formatMoney(product.price, window.theme.moneyFormat),
      url: `/products/${product.handle}`,
      images: product.images.map(img => ({
        src: `https:${img}`,
        alt: product.title,
        srcset: `
          https:${img}?width=500 500w,
          https:${img}?width=1000 1000w,
          https:${img}?width=1500 1500w
        `
      })),
      variants: product.variants.map(v => ({
        ...v,
        formattedPrice: Shopify.formatMoney(v.price, window.theme.moneyFormat)
      }))
    };

    return productData;
  }


  updateProductCard(event, productData) {
    const target = event.target;
    const wrapper = target.closest('.pc__wrapper-link');
    const selectedBrandName = target?.dataset?.brandName ? target.dataset.brandName.trim() : '';

    // Update title
    if (this.productTitle && productData.title) {
      this.productTitle.textContent = productData.title;
    }

    // Update brand name from selected swatch data
    if (this.productBrandName) {
      this.productBrandName.textContent = selectedBrandName ? selectedBrandName.toUpperCase() : '';
    }

    const selectedVariant = productData.selected_or_first_available_variant
      ? {
        ...productData.selected_or_first_available_variant,
        formattedPrice: Shopify.formatMoney(
          productData.selected_or_first_available_variant.price,
          window.theme.moneyFormat
        )
      }
      : productData.variants.find((variant) => variant.available) || productData.variants[0];

    if (selectedVariant) {
      updatePriceDisplay(wrapper, selectedVariant, window.theme.moneyFormat);
    }

    // Update link
    if (this.wrapperLink && productData.url) {
      this.wrapperLink.href = productData.url;
    }

    this.updateVariants(productData);

    // Update buy buttons
    const buyButtons = this.element.querySelectorAll(".pc__instant-atc");
    buyButtons.forEach(btn => {
      btn.setAttribute("data-product-url", productData.url);
    });



    // Update Swiper slides
    if (this.swiperWrapper && productData.images.length > 0) {
      const oldSlides = Array.from(this.swiperWrapper.querySelectorAll('.swiper-slide'));
      const oldButtons = oldSlides[0]
        ? Array.from(oldSlides[0].querySelectorAll('.swiperButton'))
        : [];

      this.swiperWrapper.innerHTML = '';

      productData.images.forEach((image, index) => {
        const slide = document.createElement('div');
        slide.classList.add('swiper-slide', 'AspectRatio');

        const img = document.createElement('img');
        img.classList.add('product-card__image');
        img.src = image.src;
        img.alt = image.alt || productData.title;
        img.srcset = image.srcset || '';
        slide.appendChild(img);

        // Clone buttons
        oldButtons.forEach(btn => slide.appendChild(btn.cloneNode(true)));

        this.swiperWrapper.appendChild(slide);
      });

      // Reinitialize swiper
      if (wrapper) {
        const swiperElement = wrapper.querySelector('.pc__image__swiper');
        if (swiperElement) swiperElement.reinitialize();
      }
    }

  }

  setLoadingState(isLoading) {
    this.element.classList.toggle('is-loading', Boolean(isLoading));
    this.spinningLoader?.classList.toggle('is-visible', Boolean(isLoading));
  }

  updateVariants(productData) {
    if (!this.variantsWrapper || !Array.isArray(productData.variants)) return;

    const cleanUrl = (productData.url || '').split('?')[0];
    const sizeOptionIndex = Array.isArray(productData.options) && productData.options.length > 0 ? 0 : -1;
    const currentVariant = productData.variants.find((variant) => variant.available) || productData.variants[0];
    const currentVariantId = currentVariant ? currentVariant.id : null;

    const uniqueSizes = [];
    const seen = new Set();

    productData.variants.forEach((variant) => {
      const label = sizeOptionIndex > -1
        ? variant[`option${sizeOptionIndex + 1}`]
        : variant.title;
      const normalizedLabel = String(label || '').trim();

      if (!normalizedLabel) return;

      const sizeKey = normalizedLabel.toLowerCase();
      if (seen.has(sizeKey)) return;

      seen.add(sizeKey);
      uniqueSizes.push({
        label: normalizedLabel,
        id: variant.id,
        available: !!variant.available,
        isCurrent: currentVariantId === variant.id
      });
    });

    this.variantsWrapper.innerHTML = '';

    uniqueSizes.slice(0, ProductCard.MAX_VISIBLE_SIZES).forEach((size) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `pc__variant-size u-p3${size.available ? '' : ' is-unavailable'}`;
      button.setAttribute('data-action', 'pc-add-size');
      button.setAttribute('data-variant-id', size.id);
      button.setAttribute('data-product-url', cleanUrl);
      button.setAttribute('aria-label', `Add size ${size.label} to cart`);
      button.textContent = size.label;

      if (!size.available) {
        button.disabled = true;
      }

      this.variantsWrapper.appendChild(button);
    });

    const hiddenCount = uniqueSizes.length - ProductCard.MAX_VISIBLE_SIZES;
    if (hiddenCount > 0) {
      const overflowButton = document.createElement('button');
      overflowButton.type = 'button';
      overflowButton.className = 'pc__variant-size pc__variant-size--more u-p2';
      overflowButton.setAttribute('data-action', 'toggle-drawer');
      overflowButton.setAttribute('data-toggle-id', 'quick-add-drawer');
      overflowButton.setAttribute('data-product-url', cleanUrl);
      overflowButton.setAttribute('aria-label', 'Open add to cart drawer');
      overflowButton.textContent = `+${hiddenCount}`;
      this.variantsWrapper.appendChild(overflowButton);
    }
  }

}

customElements.define("product-card", ProductCard);

class QuickAddDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

  connectedCallback() {
    this.addToCartInstance?.destroy?.();
    this.addToCartInstance = new AddToCart(this.element);
    this.overlay = document.querySelector('.quick-add-drawer-overlay');
    this.drawer = new Drawer(this.element, {
      onOpen: this.onDrawerOpen.bind(this),
      onClose: this.onDrawerClose.bind(this),
    });
    this.spinningLoader = this.element.querySelector('.Drawer--Content .spinningLoader');
    this.placeholder = this.element.querySelector('.pc__information-placeholder');
    this.currentLineId = null;

    this.bindEvents();
  }

  onDrawerOpen() {
    if (!this.overlay) return;
    if (this._overlayTransitionEndHandler) {
      this.overlay.removeEventListener('transitionend', this._overlayTransitionEndHandler);
      this._overlayTransitionEndHandler = null;
    }
    this.overlay.style.display = 'block';
    requestAnimationFrame(() => {
      this.overlay.classList.add('is-visible');
    });
  }

  onDrawerClose() {
    if (!this.overlay) return;
    this.overlay.classList.remove('is-visible');
    this._overlayTransitionEndHandler = (event) => {
      if (event.target !== this.overlay || event.propertyName !== 'opacity') return;
      if (!this.overlay.classList.contains('is-visible')) {
        this.overlay.style.display = 'none';
      }
      this.overlay.removeEventListener('transitionend', this._overlayTransitionEndHandler);
      this._overlayTransitionEndHandler = null;
    };
    this.overlay.addEventListener('transitionend', this._overlayTransitionEndHandler);
  }

  bindEvents() {
    if (this.eventsBound) return;
    this.eventsBound = true;
    var triggerHandler = this.handleTriggerClick.bind(this);

    this.delegateBody.on(
      'click',
      '.pc__instant-atc, .cart-item__edit',
      triggerHandler
    );
    this.delegateBody.on(
      'click',
      '[data-action="toggle-drawer"][data-toggle-id="quick-add-drawer"][data-product-url]',
      triggerHandler
    );
    this.delegateElement.on(
      'click',
      '[data-action="handle-fit-change"][data-product-url]',
      triggerHandler
    );
    this.delegateElement.on(
      'change',
      '[data-action="handle-color-change"][data-product-url]',
      triggerHandler
    );
    this.delegateElement.on(
      'change',
      '.VariantSelect--size .inputSelectboxCheckbox',
      this.handleSizeInputChange.bind(this)
    );

    this.element.addEventListener('product:added', this.onProductAdded.bind(this));
    this.element.addEventListener('quick-add:variant-updated', this.syncQuickAddSubmitState.bind(this));
    document.addEventListener('quick-add-drawer:product-loaded', this.setupHeightVariables.bind(this));

    if (this.overlay) {
      this.closeDrawerFromOverlayBound = this.closeDrawerFromOverlayBound || (() => {
        this.drawer?.closeDrawer();
      });
      this.overlay.addEventListener('click', this.closeDrawerFromOverlayBound);
    }
  }

  disconnectedCallback() {
    this.addToCartInstance?.destroy?.();
    this.addToCartInstance = null;
    this.eventsBound = false;
    if (this.overlay && this._overlayTransitionEndHandler) {
      this.overlay.removeEventListener('transitionend', this._overlayTransitionEndHandler);
      this._overlayTransitionEndHandler = null;
    }
    if (this.overlay && this.closeDrawerFromOverlayBound) {
      this.overlay.removeEventListener('click', this.closeDrawerFromOverlayBound);
    }
    this.drawer?.destroy?.();
  }

  setupHeightVariables() {
    const footer = this.element.querySelector('.quick-add-product__footer');

    if (responsive.currentBreakpoint == 'desktop' && footer) {
      document.documentElement.style.setProperty(
        '--quick-add-drawer__footer-height',
        footer.offsetHeight + 'px'
      );
    } else {
      document.documentElement.style.removeProperty('--quick-add-drawer__footer-height');
    }
  }

  handleTriggerClick(e) {
    const trigger = e.target.closest('[data-product-url]');
    if (!trigger) return;

    const productUrl = trigger.getAttribute('data-product-url');
    if (!productUrl) return;

    this.currentLineId = trigger.getAttribute('data-line-id');
    this.openDrawerWithProduct(productUrl);
  }

  handleSizeInputChange() {
    this.syncQuickAddSubmitState();
  }

  async openDrawerWithProduct(url) {
    try {
      this.setLoadingState(true);

      const response = await fetch(url + '?view=quick-add');
      const html = await response.text();

      this.placeholder.innerHTML = html;
      this.syncQuickAddSubmitState();

      this.element.dispatchEvent(
        new CustomEvent('quick-add-drawer:product-loaded', { bubbles: true })
      );

      if (this.currentLineId) {
        localStorage.setItem('current-line-item', this.currentLineId);
        localStorage.setItem('quick-atc-drawer-mode', 'edit-cart');
        const submitButton = this.element.querySelector(
          '.quick-add-product__footer [data-action="add-to-cart"]'
        );
        if (submitButton) {
          submitButton.setAttribute('data-action', 'replace-cart-item');
        }
      } else {
        localStorage.removeItem('current-line-item');
        localStorage.removeItem('quick-atc-drawer-mode');
      }
    } catch (error) {
      console.error('Error loading product:', error);
    } finally {
      this.setLoadingState(false);
    }
  }

  syncQuickAddSubmitState() {
    const container = this.element.querySelector('.quick-add-product');
    if (!container) return;

    const form = container.querySelector('.quick-add-product__form');
    if (!form) return;
    const labels = this.getQuickAddButtonLabels(form);

    const submitButtons = form.querySelectorAll('[data-quick-add-submit]');
    if (!submitButtons.length) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    const isVariantAvailable = form.dataset.currentVariantAvailable !== 'false';

    if (!isVariantAvailable) {
      variantInput.removeAttribute('disabled');
      submitButtons.forEach((button) => {
        button.classList.add('pc__sold-out');
        button.disabled = true;
        this.setQuickAddSubmitLabel(button, labels.soldOut);
      });
      return;
    }

    const sizeInputs = container.querySelectorAll(
      '.VariantSelect--size .inputSelectboxCheckbox:not(:disabled)'
    );

    if (!sizeInputs.length) {
      variantInput.removeAttribute('disabled');
      submitButtons.forEach((button) => {
        button.classList.remove('pc__sold-out');
        button.disabled = false;
        this.setQuickAddSubmitLabel(button, labels.addToCart);
      });
      return;
    }

    const hasSelectedSize = Array.from(sizeInputs).some((input) => input.checked);

    if (!hasSelectedSize) {
      variantInput.setAttribute('disabled', 'disabled');
    } else {
      variantInput.removeAttribute('disabled');
    }

    submitButtons.forEach((button) => {
      button.classList.remove('pc__sold-out');
      button.disabled = !hasSelectedSize;
      this.setQuickAddSubmitLabel(
        button,
        hasSelectedSize ? labels.addToCart : labels.selectSize
      );
    });
  }

  getQuickAddButtonLabels(form) {
    return {
      addToCart: form.dataset.labelAddToCart || 'Add to cart',
      selectSize: form.dataset.labelSelectSize || 'Please select size',
      soldOut: form.dataset.labelSoldOut || 'Sold out'
    };
  }

  setQuickAddSubmitLabel(button, label) {
    const nestedText =
      button.querySelector('.button-txt') ||
      button.querySelector('.self-align span:last-child');

    if (nestedText) {
      nestedText.textContent = label;
      return;
    }

    button.textContent = label;
  }

  onProductAdded() {
    if (this.drawer) {
      this.drawer.closeDrawer();
    }
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.spinningLoader.classList.add('is-visible');
    } else {
      this.spinningLoader.classList.remove('is-visible');
    }
  }
}

customElements.define('quick-add-drawer', QuickAddDrawer);

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.mobileMenuDrawer = null;
    this.reducedMotionQuery = null;
    this.handleReducedMotionChange = this.applyReducedMotionToCollectionVideos.bind(this);
    this.initializeDrawer();
  }

  connectedCallback() {
    if (!this.mobileMenuDrawer) this.initializeDrawer();
    this.tabBar = this.element.querySelector('.mobile-menu__link-header');
    this.navHeader = this.element.querySelector('.mobile-menu__nav-header');
    this.navParent = this.navHeader?.querySelector('[data-nav-parent]');
    this.navChild = this.navHeader?.querySelector('[data-nav-child]');
    this.navSeparator = this.navHeader?.querySelector('.mobile-menu__nav-separator');
    this.initialize();
    this.bindEvents();
    this.applyReducedMotionToCollectionVideos();
    if (window.matchMedia) {
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (typeof this.reducedMotionQuery.addEventListener === 'function') {
        this.reducedMotionQuery.addEventListener('change', this.handleReducedMotionChange);
      } else if (typeof this.reducedMotionQuery.addListener === 'function') {
        this.reducedMotionQuery.addListener(this.handleReducedMotionChange);
      }
    }
  }

  disconnectedCallback() {
    this.delegateElement?.off();
    if (this.reducedMotionQuery) {
      if (typeof this.reducedMotionQuery.removeEventListener === 'function') {
        this.reducedMotionQuery.removeEventListener('change', this.handleReducedMotionChange);
      } else if (typeof this.reducedMotionQuery.removeListener === 'function') {
        this.reducedMotionQuery.removeListener(this.handleReducedMotionChange);
      }
    }
    this.mobileMenuDrawer?.destroy();
    this.mobileMenuDrawer = null;
    this.reducedMotionQuery = null;
    this.tabBar = null;
    this.navHeader = null;
    this.navParent = null;
    this.navChild = null;
    this.navSeparator = null;
  }

  initializeDrawer() {
    this.mobileMenuDrawer = new Drawer(this.element, {
      onOpen: this.initialize.bind(this),
      onClose: this.closeMenu.bind(this),
    });
  }

  /**
   * Open on the tab for the customer's department (see Department), else the
   * All tab like search does, else the first tab when the menu has no All tab.
   * Tabs carry `data-audience` from their title (sections/main-mobile_menu.liquid);
   * tab order is untouched.
   */
  initialize() {
    const tabButtons = Array.from(this.element.querySelectorAll('[data-action="toggle-mobile-content"]'));
    const department = Department.resolve(tabButtons.map((btn) => btn.dataset.audience).filter(Boolean));
    const targetButton = department ? tabButtons.find((btn) => btn.dataset.audience === department) : null;

    const buttonToActivate = targetButton || tabButtons.find((btn) => btn.dataset.audience === 'all') || tabButtons[0];
    const idToActivate = buttonToActivate?.getAttribute('data-id');
    const contentToActivate = idToActivate
      ? this.element.querySelector(`.mobile-menu__link-content[data-id="${idToActivate}"]`)
      : this.element.querySelector('.mobile-menu__link-content');

    if (buttonToActivate && contentToActivate) {
      contentToActivate.setAttribute('aria-hidden', 'false');
      contentToActivate.setAttribute('aria-expanded', 'true');
      buttonToActivate.setAttribute('aria-expanded', 'true');
    }
  }

  applyReducedMotionToCollectionVideos() {
    if (!window.matchMedia) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const videos = this.element.querySelectorAll('video[data-respect-reduced-motion="true"]');
    videos.forEach((video) => {
      if (prefersReducedMotion) {
        if (video.autoplay) video.dataset.originalAutoplay = 'true';
        if (video.loop) video.dataset.originalLoop = 'true';
        video.autoplay = false;
        video.loop = false;
        video.pause();
        return;
      }

      if (video.dataset.originalLoop === 'true') video.loop = true;
      if (video.dataset.originalAutoplay === 'true') {
        video.autoplay = true;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => { });
      }
    });
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-mobile-content"]', this.openMenu.bind(this));
    this.delegateElement.on('click', '[data-action="open-sublevel"]', this.openSublevel.bind(this));
    this.delegateElement.on('click', '[data-action="open-thirdlevel"]', this.openThirdLevel.bind(this));
    this.delegateElement.on('click', '[data-action="nav-back"]', this.navBack.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-dropdown"]', this.handleDropdownToggle.bind(this));
  }

  openMenu(e) {
    const targetButton = e.target.closest('[data-action="toggle-mobile-content"]');
    if (!targetButton) return;
    const targetId = targetButton.getAttribute('data-id');
    if (!targetId) return;

    const targetContent = this.element.querySelector(`.mobile-menu__link-content[data-id="${targetId}"]`);
    if (!targetContent) return;

    const currentButton = this.element.querySelector('[data-action="toggle-mobile-content"][aria-expanded="true"]');
    const currentContent = this.element.querySelector('.mobile-menu__link-content[aria-expanded="true"]');
    if (targetButton === currentButton) return;

    if (currentContent) this.resetLevels(currentContent);
    if (currentButton) currentButton.setAttribute('aria-expanded', 'false');

    targetButton.setAttribute('aria-expanded', 'true');
    this.resetLevels(targetContent);

    // A department tab tapped here is the customer's choice: search follows it.
    Department.pick(targetButton.dataset.audience);

    if (currentContent) {
      currentContent.setAttribute('aria-expanded', 'false');
      currentContent.setAttribute('aria-hidden', 'true');
    }
    targetContent.setAttribute('aria-hidden', 'false');
    targetContent.setAttribute('aria-expanded', 'true');

    this.showTabBar();
    this.scrollToTop();
  }

  openSublevel(e) {
    const button = e.target.closest('[data-action="open-sublevel"]');
    if (!button) return;
    const targetId = button.getAttribute('data-target');
    const title = button.getAttribute('data-title');
    if (!targetId) return;
    const contentWrapper = button.closest('.mobile-menu__link-content');
    if (!contentWrapper) return;

    const sublevel = contentWrapper.querySelector(`[data-sublevel-id="${targetId}"]`);
    if (!sublevel) return;

    const openSublevel = contentWrapper.querySelector('.mobile-menu__level--second[aria-hidden="false"]');
    if (openSublevel) {
      openSublevel.setAttribute('aria-hidden', 'true');
      const openSublevelTrigger = contentWrapper.querySelector(`[data-action="open-sublevel"][aria-controls="${openSublevel.id}"]`);
      if (openSublevelTrigger) openSublevelTrigger.setAttribute('aria-expanded', 'false');
    }

    contentWrapper.setAttribute('data-active-level', '2');
    sublevel.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');

    this.showNavHeader(title, null);
    this.scrollToTop();
  }

  openThirdLevel(e) {
    const button = e.target.closest('[data-action="open-thirdlevel"]');
    if (!button) return;
    const targetId = button.getAttribute('data-target');
    const childTitle = button.getAttribute('data-title');
    if (!targetId) return;
    const contentWrapper = button.closest('.mobile-menu__link-content');
    const parentSublevel = button.closest('.mobile-menu__level--second');
    if (!contentWrapper || !parentSublevel) return;

    const parentTitle = parentSublevel.getAttribute('data-sublevel-title');
    const thirdLevel = parentSublevel.querySelector(`[data-thirdlevel-id="${targetId}"]`);
    if (!thirdLevel) return;

    const openThird = contentWrapper.querySelector('.mobile-menu__level--third[aria-hidden="false"]');
    if (openThird) {
      openThird.setAttribute('aria-hidden', 'true');
      const openThirdTrigger = contentWrapper.querySelector(`[data-action="open-thirdlevel"][aria-controls="${openThird.id}"]`);
      if (openThirdTrigger) openThirdTrigger.setAttribute('aria-expanded', 'false');
    }

    contentWrapper.setAttribute('data-active-level', '3');
    thirdLevel.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');

    this.showNavHeader(parentTitle, childTitle);
    this.scrollToTop();
  }

  navBack() {
    const contentWrapper = this.element.querySelector('.mobile-menu__link-content[aria-expanded="true"]');
    if (!contentWrapper) return;

    const currentLevel = contentWrapper.getAttribute('data-active-level');

    if (currentLevel === '3') {
      const openThird = contentWrapper.querySelector('.mobile-menu__level--third[aria-hidden="false"]');
      if (openThird) {
        openThird.setAttribute('aria-hidden', 'true');
        const openThirdTrigger = contentWrapper.querySelector(`[data-action="open-thirdlevel"][aria-controls="${openThird.id}"]`);
        if (openThirdTrigger) openThirdTrigger.setAttribute('aria-expanded', 'false');
      }

      contentWrapper.setAttribute('data-active-level', '2');
      const activeSublevel = contentWrapper.querySelector('.mobile-menu__level--second[aria-hidden="false"]');
      const parentTitle = activeSublevel?.getAttribute('data-sublevel-title') || '';
      this.showNavHeader(parentTitle, null);
    } else if (currentLevel === '2') {
      const openSecond = contentWrapper.querySelector('.mobile-menu__level--second[aria-hidden="false"]');
      if (openSecond) {
        openSecond.setAttribute('aria-hidden', 'true');
        const openSublevelTrigger = contentWrapper.querySelector(`[data-action="open-sublevel"][aria-controls="${openSecond.id}"]`);
        if (openSublevelTrigger) openSublevelTrigger.setAttribute('aria-expanded', 'false');
      }

      contentWrapper.removeAttribute('data-active-level');
      this.showTabBar();
    }

    this.scrollToTop();
  }

  showNavHeader(parentTitle, childTitle) {
    if (!this.navHeader) return;
    this.tabBar?.setAttribute('aria-hidden', 'true');
    this.navHeader.setAttribute('aria-hidden', 'false');

    if (this.navParent) this.navParent.textContent = parentTitle || '';

    if (childTitle) {
      if (this.navSeparator) this.navSeparator.setAttribute('aria-hidden', 'false');
      if (this.navChild) this.navChild.textContent = childTitle;
    } else {
      if (this.navSeparator) this.navSeparator.setAttribute('aria-hidden', 'true');
      if (this.navChild) this.navChild.textContent = '';
    }
  }

  showTabBar() {
    this.tabBar?.removeAttribute('aria-hidden');
    this.navHeader?.setAttribute('aria-hidden', 'true');
  }

  resetLevels(contentWrapper) {
    contentWrapper.removeAttribute('data-active-level');
    contentWrapper.querySelectorAll('.mobile-menu__level--second[aria-hidden="false"]').forEach(el => el.setAttribute('aria-hidden', 'true'));
    contentWrapper.querySelectorAll('.mobile-menu__level--third[aria-hidden="false"]').forEach(el => el.setAttribute('aria-hidden', 'true'));
    contentWrapper.querySelectorAll('[data-action="open-sublevel"][aria-expanded="true"], [data-action="open-thirdlevel"][aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
  }

  handleDropdownToggle(e) {
    const button = e.target.closest('.mobile-menu__contact-info-button[data-action="toggle-dropdown"]');
    if (!button) return;

    window.requestAnimationFrame(() => {
      if (button.getAttribute('aria-expanded') !== 'true') return;

      const scrollable = this.element.querySelector('[data-scrollable]');
      if (!scrollable) return;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scrollable.scrollTo({ top: scrollable.scrollHeight, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
  }

  scrollToTop() {
    const scrollable = this.element.querySelector('[data-scrollable]');
    if (scrollable) scrollable.scrollTop = 0;
  }

  closeMenu() {
    // If localization drawer is open, close it too when mobile menu closes.
    // This prevents the shared overlay/scroll lock from staying in an inconsistent state.
    const modal = document.querySelector('#modal-country');
    if (
      modal &&
      modal._localizationDrawer &&
      typeof modal._localizationDrawer.closeDrawer === 'function' &&
      modal._localizationDrawer.isOpen
    ) {
      modal._localizationDrawer.closeDrawer();
    }

    const currentButton = this.element.querySelector('[data-action="toggle-mobile-content"][aria-expanded="true"]');
    const currentContent = this.element.querySelector('.mobile-menu__link-content[aria-expanded="true"]');

    if (currentButton) currentButton.setAttribute('aria-expanded', 'false');
    if (currentContent) {
      this.resetLevels(currentContent);
      currentContent.setAttribute('aria-expanded', 'false');
      currentContent.setAttribute('aria-hidden', 'true');
    }
    this.showTabBar();
  }
}

customElements.define("mobile-menu", MobileMenu);

class HeadingTextAnchor extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.initialized = true;

    this.bindEvents();
    this.setInitialActiveAnchor();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="scroll-to-anchor"]', this.handleAnchorClick.bind(this));
    this.delegateElement.on('keydown', '[data-action="scroll-to-anchor"]', this.handleAnchorKeydown.bind(this));
  }

  disconnectedCallback() {
    if (this.delegateElement && typeof this.delegateElement.destroy === 'function') {
      this.delegateElement.destroy();
    }
    this.delegateElement = null;
    this.element = null;
    this.initialized = false;
  }

  handleAnchorClick(e) {
    e.preventDefault();
    const anchorItem = e.target.closest('[data-action="scroll-to-anchor"]');
    if (!anchorItem) return;

    const anchorLabel = anchorItem.querySelector('.heading-text-anchor__anchor');
    if (!anchorLabel) return;

    const anchorText = anchorLabel.textContent.trim();
    if (!anchorText) return;

    let targetHeading = null;
    const anchorComponents = document.querySelectorAll('heading-text-anchor');

    anchorComponents.forEach((component) => {
      if (targetHeading) return;

      const contentRoot = component.querySelector('.heading-text-anchor__content');
      if (!contentRoot) return;

      const headings = contentRoot.querySelectorAll('h1, h2, h3, h4, h5, h6');
      targetHeading = Array.from(headings).find((heading) => {
        const headingText = heading.textContent.trim();
        return (
          headingText === anchorText ||
          headingText.replace(/^\d+\s*/, '') === anchorText
        );
      });
    });

    if (!targetHeading) return;

    const rect = targetHeading.getBoundingClientRect();
    const absoluteTop = rect.top + window.scrollY;
    const offset = absoluteTop - (window.innerHeight / 2) + (rect.height / 2);

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: offset,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }

  setInitialActiveAnchor() {
    const contentRoot = this.element.querySelector('.heading-text-anchor__content');
    const anchors = this.element.querySelectorAll('.heading-text-anchor__anchor');
    if (!contentRoot || !anchors.length) return;

    let headings = contentRoot.querySelectorAll('h1, h2, h3, h4, h5, h6');
    if (!headings.length) {
      headings = contentRoot.querySelectorAll('.u-h1, .u-h2, .u-h3');
    }
    if (!headings.length) return;

    const normalize = (text) => text.trim().replace(/^\d+\s*/, '');
    const sectionHeadingText = normalize(headings[0].textContent || '');

    let activeAnchor = null;

    anchors.forEach((anchor) => {
      if (activeAnchor) return;
      const anchorText = normalize(anchor.textContent || '');
      if (anchorText === sectionHeadingText) {
        activeAnchor = anchor;
      }
    });

    if (!activeAnchor) return;

    anchors.forEach((link) => link.classList.remove('heading-text-anchor__anchor--active'));
    activeAnchor.classList.add('heading-text-anchor__anchor--active');
    anchors.forEach((link) => link.removeAttribute('aria-current'));
    activeAnchor.setAttribute('aria-current', 'true');
  }

  handleAnchorKeydown(e) {
    const key = e.key;
    const anchorItem = e.target.closest('[data-action="scroll-to-anchor"]');
    if (!anchorItem) return;

    const anchors = Array.from(
      this.element.querySelectorAll('.heading-text-anchor__anchor-list-item')
    );
    const currentIndex = anchors.indexOf(anchorItem);

    if (key === 'Enter' || key === ' ') {
      e.preventDefault();
      const anchorLabel = anchorItem.querySelector('.heading-text-anchor__anchor');
      if (anchorLabel) {
        anchorLabel.click();
      }
      return;
    }

    if (key === 'ArrowDown' || key === 'ArrowUp') {
      e.preventDefault();

      let nextIndex = currentIndex;
      if (key === 'ArrowDown') {
        nextIndex = currentIndex === anchors.length - 1 ? 0 : currentIndex + 1;
      } else if (key === 'ArrowUp') {
        nextIndex = currentIndex <= 0 ? anchors.length - 1 : currentIndex - 1;
      }

      const nextItem = anchors[nextIndex];
      if (!nextItem) return;

      const nextAnchor = nextItem.querySelector('.heading-text-anchor__anchor');
      if (nextAnchor) {
        nextAnchor.focus();
      }
    }
  }
}

customElements.define('heading-text-anchor', HeadingTextAnchor);

class LookbookSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = null;
    this.initialized = false;
    this.handleHotspotClick = this.handleHotspotClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.element = this;
    if (!this.delegateElement) this.delegateElement = new Delegate(this.element);
    this.initialized = true;
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.delegateElement && typeof this.delegateElement.destroy === 'function') {
      this.delegateElement.destroy();
    }
    if (this.sliderElement && this.onSwiperSlideChanged) {
      this.sliderElement.removeEventListener('swiper:slide-changed', this.onSwiperSlideChanged);
    }
    this.delegateElement = null;
    this.element = null;
    this.sliderElement = null;
    this.hotspots = null;
    this.slides = null;
    this.indexById = null;
    this.initialized = false;
  }

  bindEvents() {
    this.sliderElement = this.element.querySelector('swiper-init[data-lookbook-slider]');
    this.sliderWrap = this.element.querySelector('[data-lookbook-slider-wrap]');
    this.navigationElement = this.element.querySelector('[data-lookbook-navigation]');
    this.hotspots = Array.from(this.element.querySelectorAll('[data-lookbook-hotspot]'));
    this.slides = Array.from(this.element.querySelectorAll('[data-lookbook-slide]'));
    this.singleProduct = this.element.querySelector('[data-lookbook-single]');

    this.indexById = {};
    this.slides.forEach((slide, index) => {
      const id = slide.dataset.lookbookId;
      if (!id) return;
      this.indexById[id] = index;
    });

    const hasSlider = !!this.sliderElement;
    this.hotspots.forEach((hotspot) => {
      const id = hotspot.dataset.lookbookId;
      const hasSlide = id && this.indexById.hasOwnProperty(id);
      if (hasSlider && !hasSlide) {
        hotspot.setAttribute('aria-disabled', 'true');
      } else {
        hotspot.removeAttribute('aria-disabled');
      }
    });

    this.delegateElement.on('click', '[data-lookbook-hotspot]', this.handleHotspotClick);

    if (this.sliderElement) {
      this.bindSwiperEvents();
    }

    this.syncSliderNavigation();
    this.applyInitialState();
  }

  handleHotspotClick(event) {
    const hotspot = event.target.closest('[data-lookbook-hotspot]');
    if (!hotspot) return;

    const id = hotspot.dataset.lookbookId;
    if (!id) return;

    const index = this.indexById[id];
    const hasSlider = !!this.sliderElement;

    if (hasSlider && index != null) {
      this.sliderElement.selectSlide(index);
      this.setActiveHotspot(id);
      return;
    }

    if (!hasSlider) {
      this.setActiveHotspot(id);
    }
  }

  bindSwiperEvents() {
    if (!this.sliderElement) return;

    if (this.onSwiperSlideChanged) {
      this.sliderElement.removeEventListener('swiper:slide-changed', this.onSwiperSlideChanged);
    }

    this.onSwiperSlideChanged = this.handleSwiperSlideChanged.bind(this);
    this.sliderElement.addEventListener('swiper:slide-changed', this.onSwiperSlideChanged);
  }

  syncSliderNavigation() {
    if (!this.navigationElement) return;

    const slideCount = this.slides.length;
    const hasMultipleSlides = slideCount > 1;

    this.navigationElement.hidden = !hasMultipleSlides;

    if (this.sliderWrap) {
      this.sliderWrap.classList.toggle('lookbook-product-slider--single-slide', !hasMultipleSlides);
    }
  }

  handleSwiperSlideChanged(event) {
    const currentIndex =
      event.detail && typeof event.detail.currentIndex === 'number'
        ? event.detail.currentIndex
        : null;
    if (currentIndex == null) return;

    const activeSlide = this.slides[currentIndex];
    if (!activeSlide) return;

    const id = activeSlide.dataset.lookbookId;
    if (!id) return;

    this.setActiveHotspot(id);
  }

  applyInitialState() {
    const imageRoot = this.element.querySelector('[data-lookbook-image]');
    const defaultId = imageRoot && imageRoot.dataset.lookbookDefaultId ? imageRoot.dataset.lookbookDefaultId : null;

    if (defaultId && this.indexById.hasOwnProperty(defaultId)) {
      if (this.sliderElement && typeof this.sliderElement.selectSlide === 'function') {
        this.sliderElement.selectSlide(this.indexById[defaultId]);
      }
      this.setActiveHotspot(defaultId);
      return;
    }

    if (!this.hotspots.length) {
      return;
    }

    if (this.sliderElement) {
      const firstHotspotWithSlide = this.hotspots.find((hotspot) => {
        const id = hotspot.dataset.lookbookId;
        return id && this.indexById.hasOwnProperty(id);
      });

      if (firstHotspotWithSlide) {
        const id = firstHotspotWithSlide.dataset.lookbookId;
        if (typeof this.sliderElement.selectSlide === 'function') {
          this.sliderElement.selectSlide(this.indexById[id]);
        }
        this.setActiveHotspot(id);
        return;
      }
    }

    const firstId = this.hotspots[0].dataset.lookbookId;
    if (firstId) {
      this.setActiveHotspot(firstId);
    }
  }

  setActiveHotspot(id) {
    if (!id) return;
    this.hotspots.forEach((hotspot) => {
      hotspot.classList.toggle('is-active', hotspot.dataset.lookbookId === id);
      hotspot.setAttribute('aria-pressed', hotspot.dataset.lookbookId === id ? 'true' : 'false');
    });
  }
}

customElements.define('section-lookbook', LookbookSection);

class DesignersDirectory extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = null;
    this.initialized = false;
    this.letterObserver = null;
    this.scrollSubscription = null;
    this.tabsSwiperInitEl = null;
    this.tabsSwiperInitializedHandler = null;
    this.tabsSwiperEdgeFixApplied = false;

    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.updateActiveLetterOnScroll = this.updateActiveLetterOnScroll.bind(this);
    this.currentLetterFilter = null;
    this.lastSearchQuery = "";
  }

  connectedCallback() {
    if (this.initialized) return;
    this.element = this;
    if (!this.delegateElement) this.delegateElement = new Delegate(this.element);
    this.initialized = true;

    this.cacheDom();
    this.bindEvents();
    this.setupLetterObserver();
    this.setupTabsSwiperEdgeFix();
    this.setActiveTab("all");
    this.applySearchAndLetterFilter("");
  }

  disconnectedCallback() {
    if (this.searchInput) {
      this.searchInput.removeEventListener("input", this.handleSearchInput);
    }

    if (this.delegateElement && typeof this.delegateElement.destroy === "function") {
      this.delegateElement.destroy();
    }
    this.delegateElement = null;

    if (this.letterObserver) {
      this.letterObserver.disconnect();
      this.letterObserver = null;
    }

    if (this.scrollSubscription && typeof this.scrollSubscription.removeScrollListener === "function") {
      this.scrollSubscription.removeScrollListener();
      this.scrollSubscription = null;
    }

    if (this.tabsSwiperInitEl && this.tabsSwiperInitializedHandler) {
      this.tabsSwiperInitEl.removeEventListener(
        "swiper:initialized",
        this.tabsSwiperInitializedHandler
      );
      this.tabsSwiperInitializedHandler = null;
    }

    this.initialized = false;
  }

  cacheDom() {
    this.searchInput = this.element.querySelector("[data-designers-search-input]");
    this.searchClear = this.element.querySelector(".designers-directory__search-icon--clear");
    this.header = document.querySelector("#header");
    this.tabs = Array.from(this.element.querySelectorAll("[data-designers-tab]"));
    this.letterSections = Array.from(
      this.element.querySelectorAll(".designers-directory__letter-group")
    );
    this.links = Array.from(this.element.querySelectorAll("[data-designer-link]"));
    this.tabsSwiperInitEl = this.element.querySelector("swiper-init");

    this.imagePanel = this.element.querySelector("[data-designers-image-panel]");
    this.imageLink = this.element.querySelector("[data-designers-image-link]");
    this.imageEl = this.element.querySelector("[data-designers-image]");
    this.listRoot = this.element.querySelector(".designers-directory__list");
    this.noResultsRoot = this.element.querySelector("[data-designers-no-results]");
    this.noResultsQueryEl = this.element.querySelector(
      ".designers-directory__no-results-query"
    );

    // Capture default image state for desktop panel
    if (this.imageEl) {
      this.defaultImageSrc = this.imageEl.getAttribute("src") || "";
      this.defaultImageAlt = this.imageEl.getAttribute("alt") || "";
      this.defaultImageSrcset = this.imageEl.getAttribute("srcset") || "";
      this.defaultImageSizes = this.imageEl.getAttribute("sizes") || "";
    }
    if (this.imageLink) {
      this.defaultImageHref = this.imageLink.getAttribute("href") || "";
    }
  }

  bindEvents() {
    if (this.searchInput) {
      this.searchInput.addEventListener("input", this.handleSearchInput);
    }

    this.delegateElement.on(
      "click",
      "[data-action='clear-search']",
      this.handleSearchClear.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-designers-tab]",
      this.handleTabClick.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      "[data-designers-tab]",
      this.handleTabKeydown.bind(this)
    );

    this.delegateElement.on(
      "mouseover",
      "[data-designer-link]",
      this.handleDesignerActivate.bind(this)
    );

    this.delegateElement.on(
      "focusin",
      "[data-designer-link]",
      this.handleDesignerActivate.bind(this)
    );
  }

  handleSearchClear(event) {
    event.preventDefault();
    if (!this.searchInput) return;
    this.searchInput.value = "";
    this.lastSearchQuery = "";
    this.applySearchAndLetterFilter("");
    this.searchInput.focus();
  }

  setupLetterObserver() {
    if (!this.letterSections.length || !this.tabs.length) return;

    const breakpoint =
      typeof responsive !== "undefined" && typeof responsive.getCurrentBreakpoint === "function"
        ? responsive.getCurrentBreakpoint()
        : null;

    // On mobile, use the shared scrollListener so the active tab changes
    // when the letter group crosses a fixed offset from the top.
    if (breakpoint === "phone" || breakpoint === "pocket") {
      if (
        typeof scrollListener !== "undefined" &&
        scrollListener &&
        typeof scrollListener.addScrollListener === "function"
      ) {
        this.scrollSubscription = scrollListener.addScrollListener(
          this,
          this.updateActiveLetterOnScroll
        );
      }
      return;
    }

    if (!("IntersectionObserver" in window)) return;

    const options = {
      root: null,
      rootMargin: "-40% 0px -60% 0px",
      threshold: 0.1,
    };

    this.letterObserver = new IntersectionObserver(this.handleIntersection, options);
    this.letterSections.forEach((section) => this.letterObserver.observe(section));
  }

  isIOS() {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    if (/(iPhone|iPad|iPod)/i.test(ua)) return true;
    // iPadOS may present as MacIntel with touch input
    return (
      (navigator.platform || "").toLowerCase() === "macintel" &&
      typeof navigator.maxTouchPoints === "number" &&
      navigator.maxTouchPoints > 1
    );
  }

  setupTabsSwiperEdgeFix() {
    if (this.tabsSwiperEdgeFixApplied) return;
    if (!this.tabsSwiperInitEl) return;
    if (!this.isIOS()) return;

    const applyFix = (revolutionSwiperOrInstance) => {
      const swiperInstance =
        revolutionSwiperOrInstance && revolutionSwiperOrInstance.swiperElement
          ? revolutionSwiperOrInstance.swiperElement
          : revolutionSwiperOrInstance;

      if (!swiperInstance || swiperInstance.__designersDirectoryTabsEdgeFixApplied) return;

      swiperInstance.__designersDirectoryTabsEdgeFixApplied = true;

      // iOS Safari can allow elastic/extra drag past the last tab.
      // High resistanceRatio prevents the wrapper from moving past the edges.
      if (swiperInstance.params) {
        swiperInstance.params.resistance = true;
        swiperInstance.params.resistanceRatio = 0;
        swiperInstance.params.watchSlidesProgress = true;
      }

      // Snap back if the wrapper drifts past bounds on touch end.
      swiperInstance.on('touchEnd', () => {
        if (swiperInstance.isBeginning || swiperInstance.isEnd) {
          if (typeof swiperInstance.slideTo === "function") {
            swiperInstance.slideTo(swiperInstance.activeIndex, 300);
          }
        }
      });

      if (typeof swiperInstance.update === "function") swiperInstance.update();

      this.tabsSwiperEdgeFixApplied = true;
    };

    // If the swiper is already initialized, apply immediately.
    if (typeof this.tabsSwiperInitEl.getSwiper === "function") {
      const revolutionSwiper = this.tabsSwiperInitEl.getSwiper();
      if (revolutionSwiper) {
        applyFix(revolutionSwiper);
        if (this.tabsSwiperEdgeFixApplied) return;
      }
    }

    this.tabsSwiperInitializedHandler = (event) => {
      applyFix(event?.detail?.swiper);
    };

    this.tabsSwiperInitEl.addEventListener(
      "swiper:initialized",
      this.tabsSwiperInitializedHandler
    );
  }

  updateActiveLetterOnScroll() {
    if (!this.letterSections.length || !this.tabs.length) return;

    // Vertical offset (in px) from the viewport top at which
    // a letter section is considered "active" on mobile.
    const offsetFromTop = 134;
    let activeLetter = null;

    for (let i = 0; i < this.letterSections.length; i++) {
      const section = this.letterSections[i];
      if (!section || section.getAttribute("aria-hidden") === "true") continue;

      const rect = section.getBoundingClientRect();
      const top = rect.top;
      const bottom = rect.bottom;

      if (top <= offsetFromTop && bottom > offsetFromTop) {
        activeLetter = section.getAttribute("data-letter");
        break;
      }
    }

    if (!activeLetter) return;

    this.setActiveTab(activeLetter);
  }

  handleIntersection(entries) {
    let activeLetter = null;

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const sectionLetter = entry.target.getAttribute("data-letter");
        if (sectionLetter) {
          activeLetter = sectionLetter;
        }
      }
    });

    if (!activeLetter) return;

    this.setActiveTab(activeLetter);
  }

  setActiveTab(letter) {
    if (!letter) return;

    this.tabs.forEach((tab) => {
      const tabLetter = tab.getAttribute("data-letter");
      const isActive = tabLetter === letter;
      tab.classList.toggle("designers-directory__tab--active", isActive);
      tab.setAttribute("role", "tab");
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
      if (isActive) {
        tab.setAttribute("aria-current", "true");
      } else {
        tab.removeAttribute("aria-current");
      }
    });
  }

  updateActiveTabToFirstVisible() {
    const firstVisibleSection = this.letterSections.find(
      (section) => section && section.getAttribute("aria-hidden") !== "true"
    );
    if (!firstVisibleSection) return;

    const letter = firstVisibleSection.getAttribute("data-letter");
    if (!letter) return;

    this.setActiveTab(letter);
  }

  scrollListIntoView() {
    if (!this.listRoot) return;

    const headerHeight = this.header ? this.header.offsetHeight : 0;
    const listTopBuffer = 56;

    const rect = this.listRoot.getBoundingClientRect();
    const absoluteTop = rect.top + window.scrollY;
    const offset = Math.max(absoluteTop - headerHeight - listTopBuffer, 0);

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: offset,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
  }

  restoreDefaultImage() {
    if (!this.imageEl || !this.imageLink) return;
    if (!this.defaultImageSrc) return;

    this.imageEl.src = this.defaultImageSrc;
    this.imageEl.alt = this.defaultImageAlt || "";
    if (this.defaultImageSrcset) {
      this.imageEl.setAttribute("srcset", this.defaultImageSrcset);
    } else {
      this.imageEl.removeAttribute("srcset");
    }
    if (this.defaultImageSizes) {
      this.imageEl.setAttribute("sizes", this.defaultImageSizes);
    } else {
      this.imageEl.removeAttribute("sizes");
    }
    if (this.defaultImageHref) {
      this.imageLink.setAttribute("href", this.defaultImageHref);
      this.imageLink.classList.remove("designers-directory__image-link--empty");
    } else {
      this.imageLink.removeAttribute("href");
      this.imageLink.classList.add("designers-directory__image-link--empty");
    }
    this.imageLink.hidden = false;

    this.links.forEach((el) => {
      el.classList.remove("designers-directory__link--active");
    });
  }

  setImageFromLink(link, { setActiveClass = true } = {}) {
    if (!this.imageEl || !this.imageLink || !link) return;

    const imageUrl = link.getAttribute("data-designer-image");
    const href = link.getAttribute("data-designer-url");

    if (imageUrl) {
      this.imageEl.src = imageUrl;
      this.imageEl.alt = (link.textContent || "").trim();
      // For designer images, rely on src only to avoid stale srcset/sizes
      this.imageEl.removeAttribute("srcset");
      this.imageEl.removeAttribute("sizes");

      if (href) {
        this.imageLink.setAttribute("href", href);
        this.imageLink.classList.remove("designers-directory__image-link--empty");
      } else {
        this.imageLink.removeAttribute("href");
        this.imageLink.classList.add("designers-directory__image-link--empty");
      }
      this.imageLink.hidden = false;
    } else if (this.defaultImageSrc) {
      // Fallback: designer has no specific image, use default panel image
      this.restoreDefaultImage();
      this.imageEl.alt = this.defaultImageAlt || (link.textContent || "").trim();
    }

    if (setActiveClass) {
      this.links.forEach((el) => {
        el.classList.toggle("designers-directory__link--active", el === link);
      });
    } else {
      // Keep image panel in sync without underlining the single result.
      this.links.forEach((el) => {
        el.classList.remove("designers-directory__link--active");
      });
    }
  }

  handleTabClick(event) {
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }
    const tab = event.target.closest("[data-designers-tab]");
    if (!tab) return;

    const letter = tab.getAttribute("data-letter");
    this.activateTab(letter);
  }

  handleTabKeydown(event) {
    const tab = event.target.closest("[data-designers-tab]");
    if (!tab) return;

    const key = event.key;

    if (key === "Enter" || key === " " || key === "Spacebar") {
      event.preventDefault();
      this.handleTabClick(event);
      return;
    }

    const currentIndex = this.tabs.indexOf(tab);
    if (currentIndex === -1) return;

    let nextIndex = null;

    if (key === "ArrowRight" || key === "ArrowDown") {
      nextIndex = (currentIndex + 1) % this.tabs.length;
    } else if (key === "ArrowLeft" || key === "ArrowUp") {
      nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    } else if (key === "Home") {
      nextIndex = 0;
    } else if (key === "End") {
      nextIndex = this.tabs.length - 1;
    }

    if (nextIndex === null) return;

    event.preventDefault();

    const nextTab = this.tabs[nextIndex];
    if (!nextTab) return;

    nextTab.focus();

    const nextLetter = nextTab.getAttribute("data-letter");
    this.activateTab(nextLetter);
  }

  activateTab(letter) {
    if (!letter) return;

    if (letter === "all") {
      this.currentLetterFilter = null;
      this.applySearchAndLetterFilter(this.lastSearchQuery);
    } else {
      this.currentLetterFilter = letter;
      this.applySearchAndLetterFilter(this.lastSearchQuery);
    }

    this.setActiveTab(letter);
    this.scrollListIntoView();
  }

  handleDesignerActivate(event) {
    const link = event.target.closest("[data-designer-link]");
    if (!link) return;

    this.setImageFromLink(link);
  }

  normalize(text) {
    if (!text) return "";
    let normalized = text.toString().toLowerCase().trim();
    if (normalized.normalize) {
      normalized = normalized
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    }
    return normalized;
  }

  handleSearchInput(event) {
    const queryRaw = event.target.value || "";
    this.lastSearchQuery = queryRaw;
    this.applySearchAndLetterFilter(queryRaw);

    if (this.searchClear) {
      const hasQuery = queryRaw.trim().length > 0;
      this.searchClear.hidden = !hasQuery;
    }
  }

  applySearchAndLetterFilter(queryRaw) {
    const rawQuery = (queryRaw || "").trim();
    const query = this.normalize(rawQuery);
    const hasQuery = rawQuery.length > 0;

    let hasAnyMatch = false;

    this.letterSections.forEach((section) => {
      const sectionLetter = section.getAttribute("data-letter");

      // If a letter filter is active, hide other sections entirely
      if (this.currentLetterFilter && sectionLetter !== this.currentLetterFilter) {
        section.style.display = "none";
        section.setAttribute("aria-hidden", "true");
        return;
      }

      const items = Array.from(
        section.querySelectorAll(".designers-directory__item")
      );
      let sectionHasMatch = false;

      items.forEach((item) => {
        const dataNode =
          item.querySelector("[data-designer-link]") ||
          item.querySelector("[data-designer-name]");
        if (!dataNode) return;

        const name = this.normalize(
          dataNode.getAttribute("data-designer-name") || dataNode.textContent || ""
        );
        const keywordsRaw = dataNode.getAttribute("data-designer-keywords") || "";
        const keywords = this.normalize(keywordsRaw.replace(/\|/g, " ")).replace(
          /[^a-z0-9 ]+/g,
          " "
        );

        const haystack = `${name} ${keywords}`.trim();
        const isMatch = !hasQuery || haystack.indexOf(query) !== -1;

        if (isMatch) {
          item.style.display = "";
          item.removeAttribute("aria-hidden");
          sectionHasMatch = true;
        } else {
          item.style.display = "none";
          item.setAttribute("aria-hidden", "true");
        }
      });

      if (sectionHasMatch) {
        section.style.display = "";
        section.removeAttribute("aria-hidden");
        hasAnyMatch = true;
      } else {
        section.style.display = "none";
        section.setAttribute("aria-hidden", "true");
      }
    });

    // Sync clear icon visibility based on final query state
    if (this.searchClear) {
      const hasQuery = rawQuery.length > 0;
      this.searchClear.hidden = !hasQuery;
    }

    if (this.noResultsRoot) {
      if (hasAnyMatch || !hasQuery) {
        this.noResultsRoot.setAttribute("aria-hidden", "true");
        if (this.noResultsQueryEl) {
          this.noResultsQueryEl.textContent = "";
        }
      } else {
        this.noResultsRoot.setAttribute("aria-hidden", "false");
        if (this.noResultsQueryEl) {
          this.noResultsQueryEl.textContent = rawQuery;
        }
      }
    }

    // Hide the list + image panel when there are no matches,
    // so only the "no results" message is visible.
    if (this.listRoot) {
      if (!hasAnyMatch && hasQuery) {
        this.listRoot.setAttribute("aria-hidden", "true");
      } else {
        this.listRoot.removeAttribute("aria-hidden");
      }
    }

    if (this.imagePanel) {
      if (!hasAnyMatch && hasQuery) {
        this.imagePanel.setAttribute("aria-hidden", "true");
      } else {
        this.imagePanel.setAttribute("aria-hidden", "false");
      }
    }

    if (this.imageEl && this.imageLink) {
      if (!hasQuery || !hasAnyMatch) {
        this.restoreDefaultImage();
      } else {
        const visibleLinks = [];

        this.letterSections.forEach((section) => {
          if (!section || section.getAttribute("aria-hidden") === "true") return;

          const items = Array.from(
            section.querySelectorAll(".designers-directory__item")
          );

          items.forEach((item) => {
            if (item.style.display === "none") return;
            const link = item.querySelector("[data-designer-link]");
            if (link) visibleLinks.push(link);
          });
        });

        if (visibleLinks.length === 1) {
          // When search narrows to a single result, don't auto-underline it.
          this.setImageFromLink(visibleLinks[0], { setActiveClass: false });
        } else {
          this.restoreDefaultImage();
        }
      }
    }

    if (!this.currentLetterFilter) {
      this.updateActiveTabToFirstVisible();
    }
  }
}

customElements.define("designers-directory", DesignersDirectory);

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: '-250px 0px 200px 0px' }
    );
  }

  connectedCallback() {
    this.intersectionObserver.observe(this);

    this.carouselElement = this.element.querySelector(".product-carousel__carousels .swiper");


    new AddToCart(this.element);
  }

  async handleIntersection(entries, observer) {
    const entry = entries?.[0];
    if (!entry?.isIntersecting) return;

    observer.unobserve(this);

    const url = this.dataset?.url;
    if (!url) {
      console.warn("ProductCarousel: Missing data-url attribute.");
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const recommendations = html.querySelector('.product-recommendation');
      if (!recommendations || !recommendations.innerHTML.trim()) {
        console.warn("ProductCarousel: No valid .product-recommendation content.");
        return;
      }

      this.innerHTML = recommendations.innerHTML;

      const swiperEl = this.querySelector('.swiper');
      if (swiperEl) new RevolutionSwiper(swiperEl);

      new RevolutionAnimation(this.element);
      new AddToCart(this.element);

      requestAnimationFrame(() => {
        this.element.querySelectorAll('.ProductCard--instantATC').forEach(el => {
          el.style.visibility = 'visible';
        });
      });
    } catch (error) {
      console.error("ProductCarousel: Error loading carousel content.", error);
    }
  }
}

customElements.define("product-carousel", ProductCarousel);

class PdpUpsell extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.abortController = null;
  }

  connectedCallback() {
    this.abortController?.abort();
    this.loadRecommendations();
  }

  disconnectedCallback() {
    this.unbindEvents?.();
    this.abortController?.abort();
    this.abortController = null;
  }

  recalcStickyHeight() {
    if (!responsive.matchesBreakpoint('lap_and_up')) return;

    const stickyParent = this.closest('.pm__upsell-sticky-parent[data-pm-sticky]');
    if (!stickyParent) return;

    const stickyContainer = stickyParent.closest('.pm__content-inner');
    if (!stickyContainer) return;

    const allSticky = Array.from(stickyContainer.querySelectorAll('[data-pm-sticky]'));
    const index = allSticky.indexOf(stickyParent);
    if (index === -1) return;

    const styles = window.getComputedStyle(stickyParent);
    const marginTop = parseFloat(styles.marginTop) || 0;
    const marginBottom = parseFloat(styles.marginBottom) || 0;
    const height = (stickyParent.getBoundingClientRect().height || 0) + marginTop + marginBottom;

    stickyContainer.style.setProperty(`--pm-sticky-element-${index}`, `${Math.ceil(height)}px`);
  }

  bindEvents() {
    const headingElement = this.element.querySelector('[data-upsell-heading]');
    const hoverMetaElement = this.element.querySelector('[data-upsell-hover-meta]');
    const hoverTitleElement = this.element.querySelector('[data-upsell-hover-title]');
    const hoverPriceElement = this.element.querySelector('[data-upsell-hover-price]');
    const hoverComparePriceElement = this.element.querySelector('[data-upsell-hover-compare-price]');

    const showDefaultHeading = () => {
      if (!headingElement || !hoverMetaElement) return;
      headingElement.hidden = false;
      hoverMetaElement.hidden = true;
      hoverMetaElement.style.display = '';
    };

    const showHoverMeta = (slide) => {
      if (!headingElement || !hoverMetaElement || !slide) return;

      const title = slide.dataset.hoverTitle || '';
      const price = slide.dataset.hoverPrice || '';
      if (!title || !price) {
        showDefaultHeading();
        return;
      }

      if (hoverTitleElement) hoverTitleElement.textContent = title;
      if (hoverPriceElement) hoverPriceElement.textContent = price;

      if (hoverComparePriceElement) {
        const comparePrice = slide.dataset.hoverComparePrice || '';
        hoverComparePriceElement.textContent = comparePrice;
        hoverComparePriceElement.hidden = !comparePrice;
      }

      headingElement.hidden = true;
      hoverMetaElement.hidden = false;
      hoverMetaElement.style.display = 'flex';
    };

    const updateFromEvent = (event) => {
      if (responsive.currentBreakpoint !== 'desktop') return;
      const slide = event.target.closest('.pm-upsell__slide');
      if (!slide || !this.element.contains(slide)) return;
      showHoverMeta(slide);
    };

    const resetOnSlideMouseOut = (event) => {
      if (responsive.currentBreakpoint !== 'desktop') return;

      const currentSlide = event.target.closest('.pm-upsell__slide');
      if (!currentSlide || !this.element.contains(currentSlide)) return;

      const nextSlide = event.relatedTarget?.closest?.('.pm-upsell__slide');
      if (nextSlide && this.element.contains(nextSlide)) {
        if (nextSlide !== currentSlide) showHoverMeta(nextSlide);
        return;
      }

      showDefaultHeading();
    };

    const resetOnMouseLeave = showDefaultHeading;

    this.element.addEventListener('mouseover', updateFromEvent);
    this.element.addEventListener('mouseout', resetOnSlideMouseOut);
    this.element.addEventListener('mouseleave', resetOnMouseLeave);

    this.unbindEvents = () => {
      this.element.removeEventListener('mouseover', updateFromEvent);
      this.element.removeEventListener('mouseout', resetOnSlideMouseOut);
      this.element.removeEventListener('mouseleave', resetOnMouseLeave);
    };

    showDefaultHeading();
  }

  async loadRecommendations() {
    const url = this.dataset?.url;
    if (!url) {
      console.warn("ProductCarousel: Missing data-url attribute.");
      return;
    }

    this.abortController?.abort();
    const controller = new AbortController();
    this.abortController = controller;

    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);
      }

      const text = await response.text();
      if (controller.signal.aborted || !this.isConnected) return;
      const html = document.createElement('div');
      html.innerHTML = text;
      const urlIntent = (() => {
        try {
          return new URL(url, window.location.origin).searchParams.get('intent');
        } catch (error) {
          return null;
        }
      })();

      const fetchResult = html.querySelector('.pdp-upsell-fetch-results');
      if (!fetchResult || !fetchResult.innerHTML.trim()) {
        console.warn("PdpUpsell: No valid .pdp-upsell-fetch-results content.");
        return;
      }

      if (controller.signal.aborted || !this.isConnected) return;
      this.unbindEvents?.();

      const swiperWrapper = this.querySelector('.swiper-wrapper');
      if (swiperWrapper) {
        swiperWrapper.innerHTML = fetchResult.innerHTML;
      }

      const nav = this.querySelector('[data-upsell-navigation]');
      const count = parseInt(fetchResult.dataset.count || '0', 10);
      if (nav) {
        nav.hidden = count <= 4;
      }

      const swiperEl = this.querySelector('swiper-init');
      if (swiperEl && typeof swiperEl.initSwiper === 'function') {
        swiperEl.initSwiper();
      }

      this.bindEvents();

      new RevolutionAnimation(this.element);
      new AddToCart(this.element);

      requestAnimationFrame(() => {
        if (controller.signal.aborted || !this.isConnected) return;
        this.element.querySelectorAll('.ProductCard--instantATC').forEach(el => {
          el.style.visibility = 'visible';
        });
        this.recalcStickyHeight();
      });
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error("ProductCarousel: Error loading carousel content.", error);
    } finally {
      if (this.abortController === controller) {
        this.abortController = null;
      }
    }
  }
}

customElements.define("pdp-upsell", PdpUpsell);


class RecentlyViewed extends HTMLElement {
  static CACHE_TTL_MS = 5 * 60 * 1000;
  static CACHE_KEY_PREFIX = "recently-viewed:html:";

  constructor() {
    super();
    this.element = this;

    // populated during init when children are guaranteed to exist
    this.wrapper = null;
    this.swiperInitEl = null;
    this.abortController = null;
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  hideSection() {
    this.hidden = true;
    this.classList.remove("recently-viewed--loading", "recently-viewed--loaded");
    this.removeAttribute("aria-busy");
    this.style.removeProperty("min-height");
  }

  showLoadingState() {
    this.hidden = false;
    this.classList.add("recently-viewed--loading");
    this.setAttribute("aria-busy", "true");

    const minHeight = window.matchMedia("(min-width: 1025px)").matches
      ? "33rem"
      : "26rem";
    this.style.setProperty("min-height", minHeight);

    const template = this.querySelector(".recently-viewed__template");
    if (template) {
      template.style.opacity = "0";
    }
  }

  showLoadedState() {
    this.classList.remove("recently-viewed--loading");
    this.removeAttribute("aria-busy");
    this.style.removeProperty("min-height");

    const template = this.querySelector(".recently-viewed__template");
    if (template) {
      template.removeAttribute("data-loaded");
      template.style.opacity = "0";
      new RevolutionAnimation(template, "true").elementFadeIn([template]);
    }
  }

  getCachedHtml(cacheKey) {
    try {
      const raw = localStorage.getItem(cacheKey);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.html !== "string" || typeof parsed.timestamp !== "number") {
        localStorage.removeItem(cacheKey);
        return null;
      }

      if (Date.now() - parsed.timestamp > RecentlyViewed.CACHE_TTL_MS) {
        localStorage.removeItem(cacheKey);
        return null;
      }

      return parsed.html;
    } catch (error) {
      return null;
    }
  }

  setCachedHtml(cacheKey, html) {
    try {
      localStorage.setItem(
        cacheKey,
        JSON.stringify({
          html,
          timestamp: Date.now(),
        })
      );
    } catch (error) {
      // Ignore storage write failures (private mode/quota/etc)
    }
  }

  waitForInjectedMedia() {
    if (!this.wrapper) return Promise.resolve();

    const images = Array.from(this.wrapper.querySelectorAll("img"));
    if (!images.length) return Promise.resolve();

    const imageLoadPromises = images.map((img) => {
      if (img.complete) return Promise.resolve();

      return new Promise((resolve) => {
        const cleanup = () => {
          img.removeEventListener("load", onDone);
          img.removeEventListener("error", onDone);
        };
        const onDone = () => {
          cleanup();
          resolve();
        };

        img.addEventListener("load", onDone, { once: true });
        img.addEventListener("error", onDone, { once: true });
      });
    });

    const timeoutPromise = new Promise((resolve) => {
      setTimeout(resolve, 1500);
    });

    return Promise.race([Promise.all(imageLoadPromises), timeoutPromise]);
  }

  reorderSlidesByRecentlyViewedIds(ids) {
    if (!this.wrapper || !Array.isArray(ids) || !ids.length) return;

    const slides = Array.from(this.wrapper.children);
    if (!slides.length) return;

    const orderMap = new Map(ids.map((id, index) => [String(id), index]));

    slides.sort((a, b) => {
      const aId = a.querySelector("[data-product-id]")?.dataset.productId;
      const bId = b.querySelector("[data-product-id]")?.dataset.productId;
      return (orderMap.get(aId) ?? Infinity) - (orderMap.get(bId) ?? Infinity);
    });

    slides.forEach((slide) => {
      this.wrapper.appendChild(slide);
    });
  }

  syncNavButtonDisabledState() {
    const navButtons = this.querySelectorAll(
      ".recently-viewed__swiper-button-previous, .recently-viewed__swiper-button-next"
    );
    navButtons.forEach((button) => {
      const isAriaDisabled = button.getAttribute("aria-disabled") === "true";
      const isClassDisabled = button.classList.contains("swiper-button-disabled");
      const isDisabled = isAriaDisabled || isClassDisabled;
      if (isDisabled) {
        if (!button.hasAttribute("disabled")) {
          button.setAttribute("disabled", "true");
        }
        if (button.getAttribute("aria-disabled") !== "true") {
          button.setAttribute("aria-disabled", "true");
        }
      } else {
        if (button.hasAttribute("disabled")) {
          button.removeAttribute("disabled");
        }
        if (button.getAttribute("aria-disabled") !== "false") {
          button.setAttribute("aria-disabled", "false");
        }
      }
    });
  }

  bindNavStateSync(swiperInstance) {
    if (!swiperInstance) return;

    this.syncNavButtonDisabledState();

    const updateHandler = () => this.syncNavButtonDisabledState();
    swiperInstance.on("afterInit", updateHandler);
    swiperInstance.on("slideChange", updateHandler);
    swiperInstance.on("reachBeginning", updateHandler);
    swiperInstance.on("reachEnd", updateHandler);
    swiperInstance.on("fromEdge", updateHandler);
  }

  connectedCallback() {
    this.init();
  }

  async init() {
    this.wrapper = this.querySelector("[data-recently-viewed-products]");
    this.swiperInitEl = this.querySelector("swiper-init");

    const currentId = Number(this.dataset.currentProductId || 0);
    let ids = RecentlyViewedStorage.getIds();

    if (currentId) {
      ids = ids.filter((id) => id !== currentId);
    }

    if (!ids.length) {
      this.hideSection();
      return;
    }

    if (!this.wrapper || !this.swiperInitEl) {
      this.hideSection();
      return;
    }

    this.showLoadingState();

    if (this.abortController) {
      this.abortController.abort();
    }
    const controller = new AbortController();
    this.abortController = controller;

    const query = ids.map((id) => `id:${id}`).join(" OR ");
    const baseUrl =
      (window.routes && window.routes.localeRootUrl) || "";

    const url =
      baseUrl +
      "/search?view=recently-viewed&type=product&q=" +
      encodeURIComponent(query);
    const cacheKey = RecentlyViewed.CACHE_KEY_PREFIX + url;

    try {
      let html = this.getCachedHtml(cacheKey);

      if (!html) {
        const response = await fetch(url, {
          credentials: "same-origin",
          signal: controller.signal,
        });
        if (!response.ok) {
          this.hideSection();
          return;
        }

        html = await response.text();
        this.setCachedHtml(cacheKey, html);
      }

      if (!this.isConnected) return;
      this.wrapper.innerHTML = html;
      this.reorderSlidesByRecentlyViewedIds(ids);

      const slidesCount = this.wrapper.children.length;
      if (slidesCount === 0) {
        this.hideSection();
        return;
      }

      await this.waitForInjectedMedia();
      if (!this.isConnected) return;

      this.showLoadedState();

      // Reinitialize swiper-init now that slides are injected
      if (typeof this.swiperInitEl.reinitialize === "function") {
        this.swiperInitEl.reinitialize();
      } else if (typeof this.swiperInitEl.initSwiper === "function") {
        this.swiperInitEl.initSwiper();
      }

      const swiperObject =
        typeof this.swiperInitEl.getSwiper === "function"
          ? this.swiperInitEl.getSwiper()
          : null;
      const swiperInstance = swiperObject && swiperObject.swiperElement;
      this.bindNavStateSync(swiperInstance);
    } catch (e) {
      if (e.name === "AbortError") {
        return;
      }
      this.hideSection();
    }
  }
}

customElements.define("recently-viewed", RecentlyViewed);

class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.tabClickResetDelay = 800;
    this.onScrollEndResetClicked = null;
    this.scrollRafId = null;
    this.scrollTicking = false;
    this.swiperInitializedHandler = null;
    this.swiperPointerHandlers = new Map();
    this.handleScrollListener = null;
    this.slideToActiveTabTimeout = null;
    this.tabClickResetTimeout = null;
    this.handleFaqDropdownToggle = this.handleFaqDropdownToggle.bind(this);
    this.updateHeaderOffset = this.updateHeaderOffset.bind(this);
    this.syncFaqTabsSwiperInteractivity = this.syncFaqTabsSwiperInteractivity.bind(this);
    this.headerResizeObserver = null;
  }

  connectedCallback() {
    this.headerEl = this.element.querySelector(".faq-section__header");
    this.searchInput = this.element.querySelector(".faq--search");
    this.searchBar = this.element.querySelector(".faq__search-bar--wrapper");
    this.noResultsElement = this.element.querySelector(".faq__results--none");
    this.noResultsTermEl = this.element.querySelector("#faq__no-results-term");

    this.firstTag =
      this.element.querySelector(".faq__tab--link") ||
      this.element.querySelector(".faq__tab");

    if (this.firstTag) this.firstTag.classList.add("is-active");

    this.updateHeaderOffset();

    if (this.headerEl && typeof ResizeObserver !== "undefined") {
      this.headerResizeObserver = new ResizeObserver(() => {
        this.updateHeaderOffset();
      });
      this.headerResizeObserver.observe(this.headerEl);
    }

    window.addEventListener("load", this.updateHeaderOffset);
    document.addEventListener("breakpoint:changed", this.updateHeaderOffset);
    window.addEventListener("resize", this.syncFaqTabsSwiperInteractivity);
    document.addEventListener("breakpoint:changed", this.syncFaqTabsSwiperInteractivity);
    document.fonts?.ready?.then?.(() => {
      if (!this.element) return;
      this.updateHeaderOffset();
      this.syncFaqTabsSwiperInteractivity();
    });

    this.bindEvents();
    this.disableUnlinkedTabs();
    this.initializeFaqDropdowns();
    this.normalizeDesktopSwiperSlideMargins();

    this.swiperInitializedHandler = (e) => {
      const swiperEl = e.target; // <swiper-init>
      if (!swiperEl || swiperEl.tagName?.toLowerCase() !== "swiper-init") return;
      if (!this.element.contains(swiperEl)) return;

      this.normalizeDesktopSwiperSlideMargins();

      if (!["phone", "pocket"].includes(responsive.getCurrentBreakpoint())) return;

      const swiperInstance = swiperEl?.swiper?.swiperElement;
      if (!swiperInstance || typeof swiperInstance.slideTo !== "function") return;
      this.syncFaqTabsSwiperInteractivity(swiperInstance);

      if (swiperEl.__faqClickBound) return;
      const pointerUpHandler = () => {
        const index = swiperInstance.clickedIndex;
        if (typeof index !== "number" || index < 0) return;
        if (!this.faqTabsSwiperSlidesOverflow(swiperInstance)) return;
        swiperInstance.slideTo(index, 300);
      };

      swiperEl.__faqClickBound = true;
      this.swiperPointerHandlers.set(swiperEl, pointerUpHandler);
      swiperEl.addEventListener("pointerup", pointerUpHandler);
    };

    document.addEventListener("swiper:initialized", this.swiperInitializedHandler);
    requestAnimationFrame(() => this.syncFaqTabsSwiperInteractivity());
  }

  disconnectedCallback() {
    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
      this.headerResizeObserver = null;
    }
    window.removeEventListener("load", this.updateHeaderOffset);
    document.removeEventListener("breakpoint:changed", this.updateHeaderOffset);
    window.removeEventListener("resize", this.syncFaqTabsSwiperInteractivity);
    document.removeEventListener("breakpoint:changed", this.syncFaqTabsSwiperInteractivity);

    if (this.swiperInitializedHandler) {
      document.removeEventListener("swiper:initialized", this.swiperInitializedHandler);
    }
    if (this.swiperPointerHandlers && this.swiperPointerHandlers.size) {
      this.swiperPointerHandlers.forEach((handler, swiperEl) => {
        swiperEl.removeEventListener("pointerup", handler);
        swiperEl.__faqClickBound = false;
      });
      this.swiperPointerHandlers.clear();
    }

    if (this.handleScrollListener) {
      scrollListener.removeScrollListener?.(this, this.handleScrollListener);
    }

    if (this.slideToActiveTabTimeout) {
      clearTimeout(this.slideToActiveTabTimeout);
    }
    if (this.tabClickResetTimeout) {
      clearTimeout(this.tabClickResetTimeout);
    }
    if (this.onScrollEndResetClicked) {
      window.removeEventListener("scrollend", this.onScrollEndResetClicked);
      this.onScrollEndResetClicked = null;
    }
    if (this.scrollRafId) {
      cancelAnimationFrame(this.scrollRafId);
      this.scrollRafId = null;
    }
    this.scrollTicking = false;

    if (this.delegateElement && typeof this.delegateElement.destroy === "function") {
      this.delegateElement.destroy();
    }

    this.searchInput = null;
    this.searchBar = null;
    this.noResultsElement = null;
    this.noResultsTermEl = null;
    this.firstTag = null;
    this.headerEl = null;
    this.handleScrollListener = null;
    this.slideToActiveTabTimeout = null;
    this.tabClickResetTimeout = null;
    this.scrollRafId = null;
    this.scrollTicking = null;
    this.swiperPointerHandlers = null;
    this.swiperInitializedHandler = null;
    this.element = null;
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.debouncedHandleClick = debounce(this.handleTabClick.bind(this), 200);

    this.delegateElement.on(
      "click",
      '[data-action="handle-tab-click"]',
      (event, target) => this.debouncedHandleClick(event, target)
    );

    this.delegateElement.on(
      "faq-tabs:change",
      () => {
        this.closeAllFaqDropdowns();
      }
    );

    this.delegateElement.on("click", '[data-action="clear-search"]', this.clearSearch.bind(this));
    this.delegateElement.on("keyup", '[data-action="search-string"]', this.onInputListener);
    this.delegateElement.on(
      "click",
      '.Dropdown--Button[data-action="toggle-dropdown"]',
      this.handleFaqDropdownToggle
    );

    this.handleScrollListener = this.handleScroll.bind(this);
    scrollListener.addScrollListener(this, this.handleScrollListener);


  }

  faqTabsSwiperSlidesOverflow(s) {
    if (!s?.wrapperEl) return false;
    const viewport =
      typeof s.size === "number" && s.size > 0 ? s.size : s.el?.clientWidth ?? 0;
    if (!viewport) return false;
    return Math.ceil(s.wrapperEl.scrollWidth) > Math.floor(viewport) + 2;
  }

  getFaqTabsSwiperInstance() {
    const swiperEl = this.element?.querySelector(".faq-tabs swiper-init");
    return swiperEl?.swiper?.swiperElement || null;
  }

  syncFaqTabsSwiperInteractivity(swiperInstance = this.getFaqTabsSwiperInstance()) {
    if (!swiperInstance?.params) return;

    const isMobile = ["phone", "pocket"].includes(responsive.getCurrentBreakpoint());
    const canOverflow = isMobile && this.faqTabsSwiperSlidesOverflow(swiperInstance);

    swiperInstance.allowTouchMove = canOverflow;
    swiperInstance.params.allowTouchMove = canOverflow;
    swiperInstance.params.simulateTouch = canOverflow;
    swiperInstance.params.followFinger = canOverflow;

    if (swiperInstance.mousewheel) {
      if (canOverflow) {
        swiperInstance.mousewheel.enable?.();
      } else {
        swiperInstance.mousewheel.disable?.();
      }
    }

    if (!canOverflow) {
      swiperInstance.setTransition?.(0);
      swiperInstance.setTranslate?.(0);
      swiperInstance.updateProgress?.(0);
      swiperInstance.updateSlidesClasses?.();
    }
  }

  centerTabInSwiper(tabEl) {
    if (!['phone', 'pocket'].includes(responsive.getCurrentBreakpoint())) return;

    const swiperEl = this.element.querySelector('.faq-tabs swiper-init');
    const s = swiperEl?.swiper?.swiperElement; // real Swiper instance
    if (!s) return;
    this.syncFaqTabsSwiperInteractivity(s);
    if (!this.faqTabsSwiperSlidesOverflow(s)) return;

    const slides = Array.from(s.slides || []);
    const slideEl = tabEl.closest('.swiper-slide');
    if (!slideEl) return;

    const index = slides.indexOf(slideEl);
    if (index < 0) return;

    const targetSlide = slides[index];

    // center math
    const slideCenter = targetSlide.offsetLeft + (targetSlide.offsetWidth / 2);
    let translate = (s.width / 2) - slideCenter;

    // clamp to swiper bounds
    const min = s.minTranslate ? s.minTranslate() : s.translate;
    const max = s.maxTranslate ? s.maxTranslate() : s.translate;
    translate = Math.max(Math.min(translate, min), max);

    s.setTransition?.(300);
    s.setTranslate?.(translate);
    s.updateProgress?.(translate);
    s.updateActiveIndex?.();
    s.updateSlidesClasses?.();
  }



  setActiveTabById(toggleId) {
    if (!toggleId) return;

    const tabs = this.element.querySelectorAll(".faq__tab");

    tabs.forEach((tab) => {
      const isMatch = tab.getAttribute("data-toggle-id") === toggleId;

      tab.setAttribute("aria-expanded", isMatch ? "true" : "false");
      tab.classList.toggle("is-active", isMatch);

      const innerLink = tab.querySelector(".faq__tab--link");
      if (innerLink) innerLink.classList.toggle("is-active", isMatch);
    });
  }

  getActiveToggleId() {
    const activeBtn = this.element.querySelector('.faq__tab[aria-expanded="true"]');
    if (activeBtn?.dataset?.toggleId) return activeBtn.dataset.toggleId;
    const activeLink = this.element.querySelector('.faq__tab--link.is-active');
    if (activeLink?.dataset?.toggleId) return activeLink.dataset.toggleId;
    const firstBtn = this.element.querySelector('.faq__tab');
    return firstBtn?.dataset?.toggleId || null;
  }

  getFaqDropdownParts(dropdown) {
    if (!dropdown) return {};

    return {
      button: dropdown.querySelector('.Dropdown--Button[data-action="toggle-dropdown"]'),
      content: dropdown.querySelector('.Dropdown--Content')
    };
  }

  clearFaqDropdownAnimation(content) {
    if (!content) return;

    if (content.__faqTransitionEndHandler) {
      content.removeEventListener("transitionend", content.__faqTransitionEndHandler);
      content.__faqTransitionEndHandler = null;
    }

    if (content.__faqTransitionTimeout) {
      clearTimeout(content.__faqTransitionTimeout);
      content.__faqTransitionTimeout = null;
    }
  }

  openFaqDropdown(dropdown) {
    const { button, content } = this.getFaqDropdownParts(dropdown);
    if (!button || !content) return;

    this.clearFaqDropdownAnimation(content);

    button.setAttribute("aria-expanded", "true");

    if (!dropdown.classList.contains("Dropdown--Animate")) {
      content.setAttribute("aria-hidden", "false");
      return;
    }

    content.style.display = "";
    content.style.overflow = "";
    content.style.height = "0px";
    content.offsetHeight;

    const targetHeight = content.scrollHeight;
    content.setAttribute("aria-hidden", "false");
    content.style.height = `${targetHeight}px`;

    const onEnd = (event) => {
      if (event && event.propertyName !== "height") return;
      content.style.height = `${content.scrollHeight}px`;
      content.style.overflow = "";
      this.clearFaqDropdownAnimation(content);
    };

    content.__faqTransitionEndHandler = onEnd;
    content.addEventListener("transitionend", onEnd);
    content.__faqTransitionTimeout = setTimeout(() => onEnd(), 400);
  }

  closeFaqDropdown(dropdown) {
    const { button, content } = this.getFaqDropdownParts(dropdown);
    if (!button || !content) return;

    this.clearFaqDropdownAnimation(content);

    button.setAttribute("aria-expanded", "false");

    if (!dropdown.classList.contains("Dropdown--Animate")) {
      content.setAttribute("aria-hidden", "true");
      return;
    }

    const startHeight = content.scrollHeight;

    if (!startHeight) {
      content.setAttribute("aria-hidden", "true");
      content.style.height = "";
      content.style.overflow = "";
      return;
    }

    content.style.overflow = "hidden";
    content.style.height = `${startHeight}px`;
    content.offsetHeight;
    content.style.height = "0px";

    const onEnd = (event) => {
      if (event && event.propertyName !== "height") return;
      content.setAttribute("aria-hidden", "true");
      content.style.height = "";
      content.style.overflow = "";
      this.clearFaqDropdownAnimation(content);
    };

    content.__faqTransitionEndHandler = onEnd;
    content.addEventListener("transitionend", onEnd);
    content.__faqTransitionTimeout = setTimeout(() => onEnd(), 400);
  }

  closeAllFaqDropdowns(scope = this.element) {
    if (!scope) return;

    scope.querySelectorAll(".Dropdown").forEach((dropdown) => {
      const { button, content } = this.getFaqDropdownParts(dropdown);
      if (!button || !content) return;

      this.clearFaqDropdownAnimation(content);
      button.setAttribute("aria-expanded", "false");
      content.setAttribute("aria-hidden", "true");
      content.style.height = "";
      content.style.overflow = "";
    });
  }

  handleFaqDropdownToggle(event, target) {
    event.preventDefault();
    event.stopPropagation();

    const button = target || event.target.closest('.Dropdown--Button[data-action="toggle-dropdown"]');
    if (!button) return;

    const dropdown = button.closest(".Dropdown");
    const group = button.closest(".dropdown-wrapper");
    if (!dropdown || !group) return;

    const isOpen = button.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeFaqDropdown(dropdown);
      return;
    }

    group.querySelectorAll(".Dropdown").forEach((item) => {
      if (item !== dropdown) {
        this.closeFaqDropdown(item);
      }
    });

    this.openFaqDropdown(dropdown);
  }

  updateHeaderOffset() {
    if (!this.element || !this.headerEl) return;

    const headerStyles = window.getComputedStyle(this.headerEl);
    const paddingTop = parseFloat(headerStyles.paddingTop) || 0;
    const paddingBottom = parseFloat(headerStyles.paddingBottom) || 0;
    const childElements = Array.from(this.headerEl.children);

    let contentHeight = 0;

    if (childElements.length) {
      const headerRect = this.headerEl.getBoundingClientRect();
      let top = Infinity;
      let bottom = -Infinity;

      childElements.forEach((child) => {
        const rect = child.getBoundingClientRect();
        if (!rect.height) return;
        top = Math.min(top, rect.top - headerRect.top);
        bottom = Math.max(bottom, rect.bottom - headerRect.top);
      });

      if (Number.isFinite(top) && Number.isFinite(bottom)) {
        contentHeight = Math.max(0, bottom - top);
      }
    }

    if (!contentHeight) {
      contentHeight = Math.max(0, this.headerEl.scrollHeight - paddingTop - paddingBottom);
    }

    const totalHeaderOffset = Math.ceil(contentHeight + paddingTop + paddingBottom);
    this.element.style.setProperty("--faq-header-height", `${totalHeaderOffset}px`);
  }

  showDropdownById(toggleId) {
    const dropdowns = this.element.querySelectorAll(".dropdown-wrapper");
    dropdowns.forEach((dd) => {
      const match = dd.id === toggleId;
      dd.setAttribute("aria-hidden", String(!match));
    });
  }

  resetFaqToInitialState() {
    const tabsWrapper = this.element.querySelector(".faq-tabs");
    const dropdownList = this.element.querySelectorAll(".dropdown-wrapper");
    const noResultsElement = this.element.querySelector(".faq__results--none");
    if (tabsWrapper) tabsWrapper.classList.remove("is-hidden");

    dropdownList.forEach((dropdown) => {
      dropdown.classList.remove("is-hidden");
      const termsBlocks = dropdown.querySelectorAll(".dropdown-tabs__wrapper");
      termsBlocks.forEach((block) => {
        block.classList.remove("is-hidden");
        const questions = block.querySelectorAll(".Dropdown");
        questions.forEach((content) => content.classList.remove("is-hidden"));
      });

    });

    const activeId = this.getActiveToggleId();
    if (activeId) this.showDropdownById(activeId);

    if (noResultsElement) noResultsElement.classList.add("is-hidden");
  }

  toggleClearButton(show) {
    const clearBtn = this.element.querySelector(".support-faq--mobile-clear-btn");
    if (clearBtn) {
      clearBtn.classList.toggle("is-hidden", !show);
    }
  }

  disableUnlinkedTabs() {
    const tabs = this.element.querySelectorAll(".faq__tab");
    tabs.forEach((tab) => {
      const toggleId = tab.getAttribute("data-toggle-id");
      const targetDropdown = this.element.querySelector(`.dropdown-wrapper[id="${toggleId}"]`);
      if (!targetDropdown) tab.style.cursor = "default";
    });
  }

  toggleNoResults(show) {
    const noResultsElement = this.element.querySelector(".faq__results--none");
    if (noResultsElement) {
      noResultsElement.classList.toggle("is-hidden", !show);
    }
  }

  contentMatches(element, searchTerm) {
    return element?.textContent.toLowerCase().includes(searchTerm) || false;
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    this.toggleClearButton(!!this.searchInput.value);

    const tabsWrapper = this.element.querySelector(".faq-tabs");
    const faqGrid = this.element.querySelector(".faq__grid");
    if (tabsWrapper) tabsWrapper.classList.remove("is-hidden");

    if (searchTerm === "") {
      if (this.noResultsTermEl) this.noResultsTermEl.textContent = "";
      this.resetFaqToInitialState();
      if (faqGrid) faqGrid.classList.remove("is-hidden");
      this.toggleNoResults(false);
      return;
    }

    let hasGlobalMatch = false;

    this.element.querySelectorAll(".dropdown-wrapper").forEach((dropdown) => {
      const termsBlocks = dropdown.querySelectorAll(".dropdown-tabs__wrapper");
      let hasTabMatch = false;

      termsBlocks.forEach((block) => {
        const questions = block.querySelectorAll(".Dropdown");
        let blockMatch = false;

        const tabTitle = dropdown.querySelector(".dropdown-tabs__text-group .u-h2");
        const titleMatch = this.contentMatches(tabTitle, searchTerm);

        if (titleMatch) {
          block.classList.remove("is-hidden");
          questions.forEach((content) => content.classList.remove("is-hidden"));
          blockMatch = true;
        } else {
          questions.forEach((questionWrapper) => {
            // old FAQ markup:
            // <span class="info__dropdown-button--text">...</span>
            // new FAQ markup:
            // <button class="Dropdown--Button"><span class="rte u-s2">Question</span>...</button>
            const questionTitle =
              questionWrapper.querySelector(".info__dropdown-button--text") ||
              questionWrapper.querySelector(".Dropdown--Button .rte");

            const answerContent = questionWrapper.querySelector(".Dropdown--Content");
            const questionMatches = this.contentMatches(questionTitle, searchTerm);
            const answerMatches = this.contentMatches(answerContent, searchTerm);

            if (questionMatches || answerMatches) {
              questionWrapper.classList.remove("is-hidden");
              blockMatch = true;
            } else {
              questionWrapper.classList.add("is-hidden");
            }
          });

          block.classList.toggle("is-hidden", !blockMatch);
        }

        if (blockMatch) hasTabMatch = true;
      });


      dropdown.classList.toggle('is-hidden', !hasTabMatch);
      if (hasTabMatch) hasGlobalMatch = true;
    });

    if (hasGlobalMatch) {
      if (faqGrid) faqGrid.classList.add("is-hidden");
      this.toggleNoResults(false);
      const firstVisibleGroup = this.element.querySelector('.dropdown-wrapper:not(.is-hidden)');
      if (firstVisibleGroup?.id) {
        const id = firstVisibleGroup.id;

        this.setActiveTabById(id);
        this.showDropdownById(id);

        const esc = window.CSS?.escape ? CSS.escape(id) : id;
        const tabEl = this.element.querySelector(`.faq__tab[data-toggle-id="${esc}"]`);
        if (tabEl) this.centerTabInSwiper(tabEl);
      }
    } else {
      if (this.noResultsTermEl) this.noResultsTermEl.textContent = this.searchInput.value.trim();
      this.resetFaqToInitialState();
      if (faqGrid) faqGrid.classList.remove("is-hidden");
      this.toggleNoResults(true);
    }

    this.element.dispatchEvent(new CustomEvent("faq-tabs:change"));
  }

  clearSearch() {
    const inputValue = this.element.querySelector(".faq--search.mobile");
    if (inputValue) {
      inputValue.value = "";
      inputValue.focus();
    }
    if (this.noResultsTermEl) this.noResultsTermEl.textContent = "";
    this.toggleClearButton(false);
    this.resetFaqToInitialState();
    const faqGrid = this.element.querySelector(".faq__grid");
    if (faqGrid) faqGrid.classList.remove("is-hidden");

    this.element.dispatchEvent(new CustomEvent("faq-tabs:change"));
  }

  initializeFaqDropdowns() {
    const tabsWrapper = this.element.querySelector(".faq-tabs");
    if (tabsWrapper) tabsWrapper.classList.remove("is-hidden");

    let activeBtn = this.element.querySelector('.faq__tab[aria-expanded="true"]');
    if (!activeBtn) {
      activeBtn = this.element.querySelector(".faq__tab");
      if (activeBtn) activeBtn.setAttribute("aria-expanded", "true");
    }

    const activeId = this.getActiveToggleId();
    if (activeId) {
      this.showDropdownById(activeId);
    } else {
      const firstDropdown = this.element.querySelector(".dropdown-wrapper");
      if (firstDropdown) {
        firstDropdown.setAttribute("aria-hidden", "false");
      }
    }
  }


  handleTabClick(event, target) {
    event.preventDefault();

    const tabEl = target || event.currentTarget;
    if (!tabEl) return;

    const targetId = tabEl.getAttribute("data-toggle-id");
    if (!targetId) return;

    this.element.dataset.clicked = "true";

    this.setActiveTabById(targetId);
    this.showDropdownById(targetId);
    this.syncFaqTabsSwiperInteractivity();
    this.centerTabInSwiper(tabEl);

    const targetDropdown = this.element.querySelector(`.dropdown-wrapper[id="${targetId}"]`);
    if (targetDropdown) {
      this.scrollToSection(targetDropdown);
      targetDropdown.setAttribute("tabindex", "-1");
      targetDropdown.focus({ preventScroll: true });
    }

    this.element.dispatchEvent(new CustomEvent("faq-tabs:change"));

    if (this.tabClickResetTimeout) {
      clearTimeout(this.tabClickResetTimeout);
      this.tabClickResetTimeout = null;
    }
    if (this.onScrollEndResetClicked) {
      window.removeEventListener("scrollend", this.onScrollEndResetClicked);
      this.onScrollEndResetClicked = null;
    }

    this.onScrollEndResetClicked = () => {
      if (!this.element) return;
      this.element.dataset.clicked = "false";
      this.onScrollEndResetClicked = null;
      if (this.tabClickResetTimeout) {
        clearTimeout(this.tabClickResetTimeout);
        this.tabClickResetTimeout = null;
      }
    };

    if ("onscrollend" in window) {
      window.addEventListener("scrollend", this.onScrollEndResetClicked, { once: true });
      // Fallback safety in case scrollend doesn't fire.
      this.tabClickResetTimeout = setTimeout(
        this.onScrollEndResetClicked,
        this.tabClickResetDelay
      );
    } else {
      this.tabClickResetTimeout = setTimeout(
        this.onScrollEndResetClicked,
        this.tabClickResetDelay
      );
    }
  }

  normalizeDesktopSwiperSlideMargins() {
    if (responsive.getCurrentBreakpoint() !== "desktop") return;
    this.element
      .querySelectorAll(".faq-tabs swiper-init.swiper .swiper-slide")
      .forEach((slide) => {
        slide.style.marginRight = "0px";
      });
  }

  scrollToSection(targetElement) {
    if (!targetElement) return;

    const rootStyles = getComputedStyle(document.documentElement);
    const annHeight =
      parseInt(rootStyles.getPropertyValue("--announcement-dynamic-height")) || 0;
    const headerHeight =
      parseInt(rootStyles.getPropertyValue("--header-dynamic-height")) || 0;

    const fixedOffset = 200;
    const offset = annHeight + headerHeight + fixedOffset;

    const rect = targetElement.getBoundingClientRect();
    const targetPosition = window.scrollY + rect.top - offset;

    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }


  slideToActiveTab(delay = 0) {
    clearTimeout(this.slideToActiveTabTimeout);
    this.slideToActiveTabTimeout = setTimeout(() => {
      const activeTab =
        this.element.querySelector('.faq__tab[aria-expanded="true"]') ||
        this.element.querySelector(".faq__tab.is-active");
      if (!activeTab) return;

      const slideElement = activeTab.closest(".swiper-slide");
      if (!slideElement) return;

      const swiperEl =
        this.element.querySelector(".faq__swiper") ||
        this.element.querySelector("swiper-init.swiper") ||
        this.element.querySelector(".swiper");

      if (!swiperEl || !swiperEl.swiper) return;

      const s = swiperEl.swiper.swiperElement;
      if (!s || typeof s.slideTo !== "function") return;
      if (!this.faqTabsSwiperSlidesOverflow(s)) return;

      const slides = Array.from(swiperEl.querySelectorAll(".swiper-slide"));
      const activeIndex = slides.indexOf(slideElement);

      if (activeIndex !== -1) {
        s.slideTo(activeIndex, 300);
      }


    }, delay);
  }


  handleScroll() {
    if (this.element.dataset.clicked === "true") return;
    if (this.scrollTicking) return;

    this.scrollTicking = true;
    this.scrollRafId = requestAnimationFrame(() => {
      this.scrollTicking = false;
      this.scrollRafId = null;
      if (!this.element || this.element.dataset.clicked === "true") return;

      const sections = Array.from(this.element.querySelectorAll(".dropdown-wrapper"));
      if (!sections.length) return;

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportCenter = viewportHeight / 2;

      let closestSection = null;
      let closestDistance = Infinity;

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const sectionCenter = rect.top + rect.height / 2;
        const distance = Math.abs(sectionCenter - viewportCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestSection = section;
        }
      });

      if (!closestSection) return;

      const activeId = closestSection.id;
      if (!activeId) return;

      this.setActiveTabById(activeId);
      this.slideToActiveTab();
    });
  }

}

customElements.define("faq-section", FAQSection);

// ---------------------------------------------------------------------------
// Main blog "Load more" (AJAX pagination) - Delegate + custom element
// ---------------------------------------------------------------------------
class MainBlogSection extends HTMLElement {
  static parser = new DOMParser();

  constructor() {
    super();
    this.element = this;
    this.delegateElement = null;
    this._initialized = false;
    this.pendingCardsByAudience = new Map();
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handleTagsToggle = this.handleTagsToggle.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.abortController = new AbortController();
    this.delegateElement = new Delegate(this.element);
    this.cacheDom();
    this.bindEvents();
    this.initTagsCollapsible();
    this.refreshTagsIfNeeded();
  }

  disconnectedCallback() {
    this.destroy();
  }

  async refreshTagsIfNeeded() {
    const url = this.dataset.mainBlogTagsRefreshUrl;
    if (!url) return;
    const currentInner = this.element.querySelector(".main-blog__tags-wrap-inner");
    if (!currentInner) return;
    try {
      const response = await fetch(url, { signal: this.abortController.signal });
      if (!response.ok) return;
      const html = await response.text();
      const doc = MainBlogSection.parser.parseFromString(html, "text/html");
      const newInner = doc.querySelector(".main-blog__tags-wrap-inner");
      if (!newInner) return;

      const liveCurrentLink = currentInner.querySelector(".main-blog__tag--current a");
      const liveCurrentHref = liveCurrentLink ? liveCurrentLink.getAttribute("href") : null;

      currentInner.innerHTML = newInner.innerHTML;

      currentInner.querySelectorAll(".main-blog__tag").forEach((slide) => {
        const link = slide.querySelector("a");
        const isCurrent = link != null && link.getAttribute("href") === liveCurrentHref;
        slide.classList.toggle("main-blog__tag--current", isCurrent);
      });

      this.updateTagsCollapsible?.();
    } catch (e) {
      if (e.name !== "AbortError") {
        console.error("MainBlogSection: tags refresh failed:", e);
      }
    }
  }

  /**
   * Teardown: abort in-flight fetch, drop Delegate listeners, allow reconnect.
   */
  destroy() {
    this.destroyTagsCollapsible();
    this.abortController?.abort();
    this.abortController = null;
    this.delegateElement?.off();
    this.delegateElement = null;
    this._initialized = false;
  }

  cacheDom() {
    this.tagsCollapsibleRoot = this.element.querySelector(
      "[data-main-blog-tags-collapsible]"
    );
    this.viewGrids = Array.from(
      this.element.querySelectorAll("[data-main-blog-view-grid]")
    );
    this.loadMoreError = this.element.querySelector("[data-main-blog-load-more-error]");
    if (!this.featuredArticleId) {
      const featuredEl = this.element.querySelector("[data-featured-article-id]");
      this.featuredArticleId = featuredEl ? featuredEl.dataset.featuredArticleId : "";
    }
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="main-blog:load-more"]',
      this.handleLoadMore
    );
    this.delegateElement.on(
      "click",
      '[data-action="main-blog:toggle-tags"]',
      this.handleTagsToggle
    );
  }

  /**
   * Desktop (≥1025px): when tag links wrap to a second row, collapse to one row
   * and show arrow-down / arrow-up toggle. Uses ResizeObserver + media query.
   */
  initTagsCollapsible() {
    if (!this.tagsCollapsibleRoot) return;

    this._onTagsCollapsibleMediaChange = () => this.updateTagsCollapsible();
    this._tagsCollapsibleMediaQuery = window.matchMedia("(min-width: 1025px)");
    this._tagsCollapsibleMediaQuery.addEventListener(
      "change",
      this._onTagsCollapsibleMediaChange
    );

    const swiperEl = this.tagsCollapsibleRoot.querySelector(
      ".main-blog__tags-swiper"
    );
    this._tagsCollapsibleResizeObserver = new ResizeObserver(() => {
      this.updateTagsCollapsible();
    });
    if (swiperEl) {
      this._tagsCollapsibleResizeObserver.observe(swiperEl);
    }

    window.addEventListener(
      "resize",
      () => this.updateTagsCollapsible(),
      { signal: this.abortController.signal }
    );

    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.updateTagsCollapsible());
    });
  }

  destroyTagsCollapsible() {
    this._tagsCollapsibleResizeObserver?.disconnect();
    this._tagsCollapsibleResizeObserver = null;
    if (this._tagsCollapsibleMediaQuery && this._onTagsCollapsibleMediaChange) {
      this._tagsCollapsibleMediaQuery.removeEventListener(
        "change",
        this._onTagsCollapsibleMediaChange
      );
    }
    this._tagsCollapsibleMediaQuery = null;
    this._onTagsCollapsibleMediaChange = null;
    this.resetTagsCollapsible();
  }

  resetTagsCollapsible() {
    const root = this.tagsCollapsibleRoot;
    if (!root) return;
    const swiperEl = root.querySelector(".main-blog__tags-swiper");
    const toggle = root.querySelector('[data-action="main-blog:toggle-tags"]');
    root.classList.remove(
      "is-expanded",
      "main-blog__tags-wrap-inner--has-overflow"
    );
    delete root.dataset.collapsedHeight;
    root.style.removeProperty("--main-blog-tags-collapsed-height");
    if (swiperEl) {
      swiperEl.style.maxHeight = "";
      swiperEl.classList.remove("main-blog__tags-swiper--collapsed");
    }
    if (toggle) {
      toggle.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      const expandLabel = toggle.dataset.expandLabel;
      if (expandLabel) toggle.setAttribute("aria-label", expandLabel);
    }
  }

  updateTagsCollapsible() {
    const root = this.tagsCollapsibleRoot;
    if (!root) return;

    if (!window.matchMedia("(min-width: 1025px)").matches) {
      this.resetTagsCollapsible();
      return;
    }

    const swiperEl = root.querySelector(".main-blog__tags-swiper");
    const wrapper = swiperEl?.querySelector(".swiper-wrapper");
    const toggle = root.querySelector('[data-action="main-blog:toggle-tags"]');
    if (!swiperEl || !wrapper || !toggle) return;

    const wasExpanded = root.classList.contains("is-expanded");

    swiperEl.style.maxHeight = "";
    swiperEl.classList.remove("main-blog__tags-swiper--collapsed");

    const slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
    if (slides.length < 2) {
      root.classList.remove(
        "main-blog__tags-wrap-inner--has-overflow",
        "is-expanded"
      );
      toggle.hidden = true;
      delete root.dataset.collapsedHeight;
      root.style.removeProperty("--main-blog-tags-collapsed-height");
      return;
    }

    const firstTop = slides[0].offsetTop;
    const secondRowSlide = slides.find((s) => s.offsetTop > firstTop + 1);
    if (!secondRowSlide) {
      root.classList.remove(
        "main-blog__tags-wrap-inner--has-overflow",
        "is-expanded"
      );
      toggle.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      delete root.dataset.collapsedHeight;
      root.style.removeProperty("--main-blog-tags-collapsed-height");
      const expandLabel = toggle.dataset.expandLabel;
      if (expandLabel) toggle.setAttribute("aria-label", expandLabel);
      return;
    }

    const rowGap = parseFloat(getComputedStyle(wrapper).rowGap) || 0;
    const collapsedHeight = Math.max(
      1,
      secondRowSlide.offsetTop - rowGap
    );

    root.dataset.collapsedHeight = String(collapsedHeight);
    root.style.setProperty(
      "--main-blog-tags-collapsed-height",
      `${collapsedHeight}px`
    );
    root.classList.add("main-blog__tags-wrap-inner--has-overflow");
    toggle.hidden = false;

    if (wasExpanded) {
      swiperEl.style.maxHeight = "";
      swiperEl.classList.remove("main-blog__tags-swiper--collapsed");
      toggle.setAttribute("aria-expanded", "true");
      const collapseLabel = toggle.dataset.collapseLabel;
      if (collapseLabel) toggle.setAttribute("aria-label", collapseLabel);
    } else {
      swiperEl.style.maxHeight = `${collapsedHeight}px`;
      swiperEl.classList.add("main-blog__tags-swiper--collapsed");
      toggle.setAttribute("aria-expanded", "false");
      const expandLabel = toggle.dataset.expandLabel;
      if (expandLabel) toggle.setAttribute("aria-label", expandLabel);
    }
  }

  handleTagsToggle(event) {
    const btn = event.target.closest('[data-action="main-blog:toggle-tags"]');
    if (!btn || btn.hidden) return;
    if (!window.matchMedia("(min-width: 1025px)").matches) return;

    event.preventDefault();
    const root = this.tagsCollapsibleRoot;
    if (!root) return;
    const swiperEl = root.querySelector(".main-blog__tags-swiper");
    if (!swiperEl) return;

    const expanded = root.classList.toggle("is-expanded");
    if (expanded) {
      swiperEl.style.maxHeight = "";
      swiperEl.classList.remove("main-blog__tags-swiper--collapsed");
      btn.setAttribute("aria-expanded", "true");
      const collapseLabel = btn.dataset.collapseLabel;
      if (collapseLabel) btn.setAttribute("aria-label", collapseLabel);
    } else {
      const h = root.dataset.collapsedHeight;
      if (h) swiperEl.style.maxHeight = `${h}px`;
      swiperEl.classList.add("main-blog__tags-swiper--collapsed");
      btn.setAttribute("aria-expanded", "false");
      const expandLabel = btn.dataset.expandLabel;
      if (expandLabel) btn.setAttribute("aria-label", expandLabel);
    }
  }

  clearLoadMoreError() {
    if (!this.loadMoreError) return;

    this.loadMoreError.hidden = true;
  }

  showLoadMoreError() {
    if (!this.loadMoreError) return;

    this.loadMoreError.hidden = false;
  }

  getPendingQueue(audience) {
    if (!this.pendingCardsByAudience.has(audience)) {
      this.pendingCardsByAudience.set(audience, []);
    }
    return this.pendingCardsByAudience.get(audience);
  }

  hasPendingCards() {
    for (const queue of this.pendingCardsByAudience.values()) {
      if (queue.length) return true;
    }
    return false;
  }

  consumePendingCards(maxCount, appendedCards) {
    let appendedCount = 0;

    this.viewGrids.forEach((grid) => {
      if (maxCount !== null && appendedCount >= maxCount) return;

      const audience = grid.dataset.audienceView || "";
      const queue = this.getPendingQueue(audience);
      while (queue.length && (maxCount === null || appendedCount < maxCount)) {
        const card = queue.shift();
        if (!card) continue;
        grid.appendChild(card);
        appendedCards.push(card);
        appendedCount += 1;
      }
    });

    return appendedCount;
  }

  async handleLoadMore(event) {
    const button = event.target.closest('[data-action="main-blog:load-more"]');
    if (!button) return;

    if (!this.viewGrids.length) return;

    const nextUrl = button.dataset.nextUrl || button.getAttribute("href") || "";

    event.preventDefault();

    if (button.dataset.loading === "true") return;
    button.dataset.loading = "true";
    this.clearLoadMoreError();

    const loader = button.querySelector(".itemLoader");
    loader?.classList.add("is-visible");
    button.setAttribute("aria-busy", "true");
    button.setAttribute("aria-disabled", "true");

    try {
      const pageSize = Number.parseInt(this.element.dataset.blogPageSize || "", 10);
      const targetBatchSize = Number.isFinite(pageSize) && pageSize > 0 ? pageSize : null;
      const hasPendingCards = this.hasPendingCards();
      if (!nextUrl && !hasPendingCards) {
        button.remove();
        return;
      }

      let urlToFetch = nextUrl;
      let latestNextUrl = null;
      /** @type {Element[]} */
      const appendedCards = [];
      let appendedArticleCount = this.consumePendingCards(targetBatchSize, appendedCards);
      /** @type {Element[]} */
      while (urlToFetch && (targetBatchSize === null || appendedArticleCount < targetBatchSize)) {
        const response = await fetch(urlToFetch, { signal: this.abortController?.signal });
        if (!response.ok) {
          throw new Error(
            `MainBlogSection: Failed to fetch next blog page: ${response.status}`
          );
        }

        const text = await response.text();
        const doc = MainBlogSection.parser.parseFromString(text, "text/html");
        const newViewGrids = Array.from(doc.querySelectorAll("[data-main-blog-view-grid]"));
        newViewGrids.forEach((newGrid) => {
          const audience = newGrid.dataset.audienceView || "";
          const currentGrid = this.viewGrids.find(
            (grid) => (grid.dataset.audienceView || "") === audience
          );

          if (!currentGrid) return;

          const newCards = newGrid.querySelectorAll(".main-blog__article-card");
          newCards.forEach((card) => {
            if (this.featuredArticleId && card.id === this.featuredArticleId) return;
            if (targetBatchSize !== null && appendedArticleCount >= targetBatchSize) {
              this.getPendingQueue(audience).push(card);
              return;
            }
            currentGrid.appendChild(card);
            appendedCards.push(card);
            appendedArticleCount += 1;
          });
        });

        const newPagination = doc.querySelector("#BlogPagination");
        const newLoadMore = newPagination
          ? newPagination.querySelector(".main-blog__load-more")
          : null;
        latestNextUrl = newLoadMore
          ? newLoadMore.dataset.nextUrl || newLoadMore.getAttribute("href")
          : null;

        if (!latestNextUrl) {
          break;
        }

        urlToFetch = latestNextUrl;
      }

      const loadMoreStatus = this.element.querySelector('[id^="blog-status-"]');
      const announcementTemplate = this.element.dataset.blogLoadMoreAnnouncement;
      if (loadMoreStatus && announcementTemplate && appendedArticleCount > 0) {
        loadMoreStatus.textContent = announcementTemplate.replace(
          /__COUNT__/g,
          String(appendedArticleCount)
        );
      }

      if (latestNextUrl) {
        button.dataset.nextUrl = latestNextUrl;
        button.setAttribute("href", latestNextUrl);
        button.style.display = "";
      } else if (this.hasPendingCards()) {
        button.dataset.nextUrl = "";
        button.removeAttribute("href");
        button.style.display = "";
      } else {
        button.remove();
      }

      this.cacheDom();

      if (window.theme && window.theme.enableAnimations) {
        new RevolutionAnimation(this.element);
      }

      if (appendedCards.length) {
        requestAnimationFrame(() => {
          for (const card of appendedCards) {
            const view = card.closest("[data-main-blog-view]");
            if (!view || view.hidden || view.classList.contains("is-hidden")) {
              continue;
            }
            card.querySelector("a")?.focus();
            break;
          }
        });
      }

      this.clearLoadMoreError();
    } catch (error) {
      console.error(error);
      this.showLoadMoreError();
    } finally {
      loader?.classList.remove("is-visible");
      button.removeAttribute("aria-busy");
      button.removeAttribute("aria-disabled");
      if (document.body.contains(button)) {
        button.dataset.loading = "false";
      }
    }
  }
}

customElements.define("main-blog-section", MainBlogSection);

class ArticleComments extends HTMLElement {
  static parser = new DOMParser();

  constructor() {
    super();
    if (this._initialized) return;
    this._initialized = true;
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.articleWrapper = null;
    this.showLessButton = null;
    this.commentForm = null;
    this.statusRegion = null;
    this._onFormSubmit = this.handleFormSubmit.bind(this);
    this._timeouts = new Set();
  }

  connectedCallback() {
    this.abortController = new AbortController();
    this._cacheElements();
    if (!this.articleWrapper) return;
    this._attachFormListener();
    this.bindEvents();
    this.toggleButton();
    this.autoHideSuccessMessage();
  }

  disconnectedCallback() {
    this.destroy();
  }

  destroy() {
    this.abortController?.abort();
    this.abortController = null;
    this.commentForm?.removeEventListener("submit", this._onFormSubmit, true);
    this.delegateElement?.off();
    this._timeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
    this._timeouts.clear();
  }

  _cacheElements() {
    this.articleWrapper = this.element.querySelector(".article-comments__main-container");
    this.showLessButton = this.element.querySelector(".article-comments__show-less-button");
    this.commentForm = this.element.querySelector("#comment_form");
    this.statusRegion = this.element.querySelector("[data-comments-status]");
    const formErrors = this.element.querySelector("#comment-form-errors");
    if (this.commentForm && formErrors) {
      this.commentForm.setAttribute("aria-describedby", "comment-form-errors");
    }
  }

  _attachFormListener() {
    if (this.commentForm) {
      this.commentForm.addEventListener("submit", this._onFormSubmit, true);
    }
  }

  _setTimeout(callback, delay) {
    const timeoutId = window.setTimeout(() => {
      this._timeouts.delete(timeoutId);
      callback();
    }, delay);
    this._timeouts.add(timeoutId);
    return timeoutId;
  }

  _announce(message) {
    if (!this.statusRegion) return;
    this.statusRegion.textContent = "";
    this._setTimeout(() => {
      this.statusRegion.textContent = message;
    }, 10);
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLess.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateElement.on(
      "input",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  handleFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.customSubmit(event);
    return false;
  }

  toggleButton() {
    const submitButton = this.element.querySelector(".article-comments__submit-button");
    if (!submitButton) return;

    const requiredFields = this.element.querySelectorAll("[data-state='required']");
    let isValid = true;

    requiredFields.forEach((field) => {
      if (field.type === "checkbox") {
        if (!field.checked) {
          isValid = false;
        }
      } else if (field.value.trim() === "") {
        isValid = false;
      }
    });

    if (isValid) {
      submitButton.removeAttribute("disabled");
    } else {
      submitButton.setAttribute("disabled", "true");
    }
  }

  //Escaping first digit for valid querySelector
  escapeSelector(id) {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
      return CSS.escape(id);
    }
    if (/^\d/.test(id)) {
      return `\\3${id[0]} ${id.slice(1)}`;
    }
    return id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, "\\$1");
  }


  async loadMore(event, target) {
    if (!this.abortController) return;
    event.preventDefault();
    const dataHref = target.dataset.nextHref;

    if (!dataHref) {
      return;
    }

    const loader = this.element.querySelector(".article-comments__load-more-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      const response = await fetch(dataHref, {
        credentials: "same-origin",
        method: "GET",
        signal: this.abortController?.signal,
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const htmlDocument = ArticleComments.parser.parseFromString(htmlData, "text/html");

      const newComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");
      let firstAppendedComment = null;

      newComments.forEach((comment) => {
        const commentId = comment.getAttribute('id');
        if (!commentId) return;

        const escapedId = this.escapeSelector(commentId);
        if (!commentsContainer.querySelector(`#${escapedId}`)) {
          commentsContainer.appendChild(comment);
          if (!firstAppendedComment) {
            firstAppendedComment = comment;
          }
        }
      });

      if (newComments.length > 0) {
        this._announce(`${newComments.length} new comments loaded`);
      }

      if (firstAppendedComment) {
        firstAppendedComment.setAttribute("tabindex", "-1");
        firstAppendedComment.focus();
      }

      new RevolutionAnimation(this.element);

      const newLoadMoreElement = htmlDocument.querySelector("[data-next-href]");
      const currentLoadMoreElement = this.element.querySelector(".article-comments__load-more-button");

      if (newLoadMoreElement) {
        const newHref = newLoadMoreElement.dataset.nextHref;
        if (currentLoadMoreElement) {
          currentLoadMoreElement.dataset.nextHref = newHref;
          commentsContainer.appendChild(currentLoadMoreElement);
          commentsContainer.appendChild(this.showLessButton);
        }
      } else {
        currentLoadMoreElement?.remove();
        commentsContainer.appendChild(this.showLessButton);
        this.showLessButton.classList.remove('hidden');
      }

    } catch (error) {
      console.error("Failed to load more comments", error);
      this.showCommentsError();
    } finally {
      loader?.classList.remove("is-visible");
    }
  }


  async customSubmit(event) {
    if (!this.abortController) return;
    const submitButton = this.commentForm.querySelector('.article-comments__submit-button');
    const loader = submitButton?.querySelector('.itemLoader');
    const messageWrapper = this.element.querySelector('.article-comments__submit-message-wrapper');


    // Show loader and disable button
    if (loader) {
      loader.classList.add('is-visible');
    }
    if (submitButton) {
      submitButton.setAttribute('disabled', 'true');
    }

    // Remove any existing messages
    messageWrapper?.querySelectorAll('.AlertSuccess, .AlertError').forEach(msg => msg.remove());

    try {
      // Collect form data
      const formData = new FormData(this.commentForm);
      const actionUrl = this.commentForm.action;

      // Execute hCaptcha if available
      if (window.hcaptcha) {
        const captchaToken = await window.hcaptcha.execute(null, { async: true });
        formData.set("h-captcha-response", captchaToken.response);
      }


      // Submit via fetch (Shopify may respond with redirects or 4xx/5xx, but we always
      // try to parse the returned HTML for success or error messages instead of
      // hard-failing on non-2xx statuses.)
      const response = await fetch(actionUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        signal: this.abortController?.signal,
      });

      const htmlData = await response.text();
      const htmlDocument = ArticleComments.parser.parseFromString(htmlData, 'text/html');

      // Check if comment was successful
      const successMessage = htmlDocument.querySelector('#comment_form .AlertSuccess');
      const errorMessage = htmlDocument.querySelector('#comment_form .AlertError');

      if (successMessage) {
        // Show success message
        messageWrapper?.appendChild(successMessage.cloneNode(true));

        // Reset form
        this.commentForm.reset();

        // Reload comments to show the new one.
        // Instead of samo dodati novi komentar na postojeći popis (što krši "Comments per page"),
        // uzmi prvu stranicu komentara iz response HTML-a i zamijeni trenutni container.
        const currentCommentsContainer = this.element.querySelector(".article-comments__main-container");
        const newCommentsContainer = htmlDocument.querySelector(".article-comments__main-container");

        if (currentCommentsContainer && newCommentsContainer) {
          currentCommentsContainer.innerHTML = newCommentsContainer.innerHTML;
          // Re-cache DOM reference za show-less / status / form itd.
          this._cacheElements();
          new RevolutionAnimation(this.element);
          this._announce("1 new comment added");
        }

        // Auto-hide success message after 5 seconds
        this._setTimeout(() => {
          messageWrapper?.querySelector('.AlertSuccess')?.remove();
        }, 5000);

      } else if (errorMessage) {
        // Show error message
        messageWrapper?.appendChild(errorMessage.cloneNode(true));
      } else {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'AlertError';
        errorDiv.setAttribute('role', 'alert');
        errorDiv.innerHTML = `<h3 class="AlertError u-p3" tabindex="-1">${this.dataset.error}</h3>`;
        messageWrapper?.appendChild(errorDiv);
      }

    } catch (error) {

      const errorDiv = document.createElement('div');
      errorDiv.className = 'AlertError';
      errorDiv.setAttribute('role', 'alert');
      errorDiv.innerHTML = `<h3 class="AlertError u-p3" tabindex="-1">${this.dataset.error}</h3>`;
      messageWrapper?.appendChild(errorDiv);

    } finally {
      // Hide loader and re-enable button
      if (loader) {
        loader.classList.remove('is-visible');
      }
      if (submitButton) {
        submitButton.removeAttribute('disabled');
      }
      this.toggleButton();
    }
  }

  async showLess(event, target) {
    if (!this.abortController) return;
    event.preventDefault();
    const firstPageUrl = target.dataset.firstPageUrl;
    const loader = this.element.querySelector(".article-comments__show-less-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      const response = await fetch(firstPageUrl, {
        credentials: "same-origin",
        method: "GET",
        signal: this.abortController?.signal,
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const htmlDocument = ArticleComments.parser.parseFromString(htmlData, "text/html");

      const firstPageComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      commentsContainer.querySelectorAll(".article-comments__comment").forEach(comment => comment.remove());
      commentsContainer.prepend(...firstPageComments);
      this._announce("Comments reset to first page");

      new RevolutionAnimation(this.element);

      this.showLessButton.classList.add('hidden');

      commentsContainer.querySelector(".article-comments__load-more-button")?.remove();

      const loadMoreButton = htmlDocument.querySelector(".article-comments__load-more-button");
      if (loadMoreButton) {
        commentsContainer.appendChild(loadMoreButton);
      }

      const containerRect = this.element.getBoundingClientRect();
      const scrollOffset = 150;

      window.scrollTo({
        top: containerRect.top + window.scrollY - scrollOffset,
        behavior: 'smooth',
      });
    } catch (error) {
      console.error("Failed to reset comments list", error);
      this.showCommentsError();
    } finally {
      loader?.classList.remove("is-visible");
    }
  }

  showCommentsError() {
    const container = this.element.querySelector(".article-comments__main-container") || this.element;
    if (!container) return;

    // Avoid stacking duplicate messages
    if (container.querySelector(".article-comments__error-message")) return;

    const errorDiv = document.createElement("div");
    errorDiv.className = "AlertError u-p3 article-comments__error-message";
    errorDiv.setAttribute("role", "alert");
    errorDiv.textContent = this.dataset.errorLoading;

    container.appendChild(errorDiv);

    this._setTimeout(() => {
      errorDiv.remove();
    }, 5000);
  }

  autoHideSuccessMessage() {
    // Check if the URL contains a comment parameter (indicating successful comment submission)
    if (window.location.search.includes('comment=')) {
      const successMessage = this.element.querySelector('.AlertSuccess');

      if (successMessage) {
        // Auto-hide after 5 seconds
        this._setTimeout(() => {
          successMessage.remove();

          // Clean up URL by removing the comment parameter
          const url = new URL(window.location);
          url.searchParams.delete('comment');
          window.history.replaceState({}, '', url);
        }, 5000);
      }
    }
  }
}

customElements.define("article-comments", ArticleComments);



class MainSearch extends HTMLElement {
  refreshDomRefs() {
    this.sectionLoader = this.element.querySelector('.spinningLoader');
    this.toggleWrapper = this.element.querySelector('.main-search__toggle-buttons');
    this.categoriesContainer = this.element.querySelector('#main-search__categories');
    this.productRoot = this.element.querySelector('#collection-product');
    this.articleRoot = this.element.querySelector('#collection-article');
    this.gridElement = this.element.querySelector('#collection__main-grid');
    this.paginationElement = this.element.querySelector('#main-collection__pagination');
    this.productsCountEl = this.element.querySelector('[data-products-count]');
    this.articlesCountEl = this.element.querySelector('[data-articles-count]');
    this.resultsCountLabelEl = this.element.querySelector('[data-results-count-label]');
    this.resultsCountValueEl = this.element.querySelector('[data-results-count]');
    this.articleGridElement = this.element.querySelector('#collection__article-grid');
    this.articlePaginationElement = this.element.querySelector('#main-collection__article-pagination');
  }

  constructor() {
    super();
    this.element = this;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // Bind tab toggle handler for Products / Blogs buttons
    this.onToggleTab = this.onToggleTab.bind(this);
    this.delegateElement.on('click', '.main-search__toggle-button', this.onToggleTab);

    // Native "Load more" click handler
    this.onNativeLoadMoreClick = this.onNativeLoadMoreClick.bind(this);
    this.delegateElement.on('click', '[data-action="load-more-search"]', this.onNativeLoadMoreClick);

    this.icons = (window.mainSearchIcons) || {};

    // Cancel in-flight tab / pagination requests to avoid race conditions.
    this._tabFetchController = null;
    this._nativeLoadMoreController = null;
    this._pendingTab = null;
    this._warmOtherTabTimer = null;

    // Track whether each tab has completed at least one type-pinned fetch.
    // Used to gate prefetch/warm so an empty article result can't loop.
    this._productsHydrated = false;
    this._articlesHydrated = false;

    // Cache key DOM elements used throughout the lifecycle
    this.refreshDomRefs();

    this.pageSize = this.gridElement ? parseInt(this.gridElement.dataset.pageSize || this.gridElement.dataset.results || '16', 10) || 16 : 16;

    const initialArticlesTotal = this.element.dataset.articlesTotal
      ? parseInt(this.element.dataset.articlesTotal || '0', 10)
      : 0;
    this.blogTotalCount = Number.isNaN(initialArticlesTotal) ? 0 : initialArticlesTotal;

    this.enableBlogPosts = this.element?.dataset?.enableBlogPosts === 'true';
    this.activeTab = 'products';
    this.blogPageSize = this.articleGridElement
      ? parseInt(this.articleGridElement.dataset.pageSize || '6', 10) || 6
      : 6;

    // If URL is type-pinned, use section-level results_count immediately so
    // counts are accurate before async tab fetch completes.
    const initialRequestType = String(this.element.dataset.requestType || '').toLowerCase();
    const initialResultsCount = parseInt(this.element.dataset.resultsCount || '0', 10) || 0;
    if ((initialRequestType === 'article' || initialRequestType === 'articles') && initialResultsCount > 0) {
      this.element.dataset.articlesTotal = String(initialResultsCount);
      this.blogTotalCount = initialResultsCount;
    } else if ((initialRequestType === 'product' || initialRequestType === 'products') && initialResultsCount > 0) {
      this.element.dataset.productsTotal = String(initialResultsCount);
    }
  }

  connectedCallback() {
    this.refreshDomRefs();
    if (this.sectionLoader) {
      this.sectionLoader.classList.remove('is-visible');
    }

    const productsCount = parseInt(this.element.dataset.productsTotal || '0', 10) || 0;
    const articlesCount = this.enableBlogPosts ? (parseInt(this.element.dataset.articlesTotal || '0', 10) || 0) : 0;
    const currentUrl = new URL(window.location.href);
    const hasQuery = !!(currentUrl.searchParams.get('q') || '').trim();
    const typeParam = (currentUrl.searchParams.get('type') || '').toLowerCase();

    if (this.enableBlogPosts) {
      if (!productsCount && articlesCount) {
        this.switchToTab('articles');
        const typeParam = (currentUrl.searchParams.get('type') || '').toLowerCase();
        if (typeParam !== 'article' && typeParam !== 'articles') {
          this._updateTypeInUrl('articles');
        }
      } else {
        this.switchToTab('products');
      }
      // Ensure the initially active tab is synced from a type-specific response
      // so total counts don't depend on entry path or stale server snapshot.
      if (hasQuery && (typeParam === 'article' || typeParam === 'articles')) {
        this.switchToTab('articles');
        this._fetchTabContent('articles');
      } else if (hasQuery && (typeParam === 'product' || typeParam === 'products')) {
        this.switchToTab('products');
        this._fetchTabContent('products');
      } else if (hasQuery) {
        // Mixed response: hydrate Products totals from a type-specific response
        // (Liquid only knows first-page counts per type).
        this._fetchTabContent('products');
        // Warm the other tab in the background so users don't see "1 blog then all blogs".
        this._scheduleWarmOtherTab('articles');
      }
      this._prefetchOtherTabIfNeeded();
      this._recoverFromEmptyPinnedType(hasQuery, typeParam, productsCount, articlesCount);
    } else {
      this.updateToggleButtons();
    }

    // Set up simple "Load more" buttons using native Shopify pagination.
    this._initNativeLoadMore();
  }

  _setRecoveryPendingState(isPending) {
    const noResults = this.element.querySelector('.main-search__no-results');
    if (!noResults) return;

    noResults.hidden = isPending;
    if (this.sectionLoader) {
      this.sectionLoader.classList.toggle('is-visible', isPending);
    }
  }

  async _recoverFromEmptyPinnedType(hasQuery, typeParam, productsCount, articlesCount) {
    if (!hasQuery || !this.enableBlogPosts) return;

    // If URL is pinned to products but only articles exist for this query,
    // auto-recover by fetching/switching to the article tab.
    if ((typeParam === 'product' || typeParam === 'products') && productsCount === 0) {
      this._setRecoveryPendingState(true);
      try {
        await this._fetchTabContent('articles');
        const recoveredArticles = parseInt(this.element.dataset.articlesTotal || '0', 10) || 0;
        if (recoveredArticles > 0) {
          this.switchToTab('articles');
          this._updateTypeInUrl('articles');
        }
      } finally {
        this._setRecoveryPendingState(false);
      }
      return;
    }

    // Symmetric recovery for article-pinned URLs.
    if ((typeParam === 'article' || typeParam === 'articles') && articlesCount === 0) {
      this._setRecoveryPendingState(true);
      try {
        await this._fetchTabContent('products');
        const recoveredProducts = parseInt(this.element.dataset.productsTotal || '0', 10) || 0;
        if (recoveredProducts > 0) {
          this.switchToTab('products');
          this._updateTypeInUrl('products');
        }
      } finally {
        this._setRecoveryPendingState(false);
      }
    }
  }

  disconnectedCallback() {
    if (this.delegateElement?.off) this.delegateElement.off();
    if (this.delegateBody?.off) this.delegateBody.off();
    this._tabFetchController?.abort();
    this._tabFetchController = null;
    this._nativeLoadMoreController?.abort();
    this._nativeLoadMoreController = null;
    if (this._warmOtherTabTimer) {
      clearTimeout(this._warmOtherTabTimer);
      this._warmOtherTabTimer = null;
    }
  }

  _scheduleWarmOtherTab(tab) {
    if (this._warmOtherTabTimer) clearTimeout(this._warmOtherTabTimer);
    this._warmOtherTabTimer = setTimeout(() => {
      this._warmOtherTabTimer = null;
      if (!this.isConnected) return;
      // Wait until no active tab fetch to avoid aborting it.
      if (this._tabFetchController) {
        this._scheduleWarmOtherTab(tab);
        return;
      }
      const isHydrated = tab === 'articles' ? this._articlesHydrated : this._productsHydrated;
      if (isHydrated) return;
      this._fetchTabContent(tab);
    }, 250);
  }

  _updateTypeInUrl(tab) {
    const url = new URL(window.location.href);
    if (tab === 'articles' || tab === 'article') {
      url.searchParams.set('type', 'article');
      // Product filters should not persist on article tab URL.
      Array.from(url.searchParams.keys()).forEach((key) => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('type', 'product');
    }
    history.pushState({}, '', url.toString());
  }

  _prefetchOtherTabIfNeeded() {
    if (!this.enableBlogPosts) return;
    // Don't prefetch while an active tab fetch is running (it would abort it).
    if (this._tabFetchController) return;
    const url = new URL(window.location.href);
    const query = (url.searchParams.get('q') || '').trim();
    if (!query) return;
    const typeParam = (url.searchParams.get('type') || '').toLowerCase();
    const otherTab = (typeParam === 'article' || typeParam === 'articles') ? 'products' : 'articles';
    const isHydrated = otherTab === 'articles' ? this._articlesHydrated : this._productsHydrated;
    if (!isHydrated) {
      this._fetchTabContent(otherTab);
    }
  }

  async _fetchTabContent(tab) {
    // Cancel any in-flight tab request so DOM updates remain ordered.
    if (this._tabFetchController) {
      this._tabFetchController.abort();
    }
    this._tabFetchController = new AbortController();
    const signal = this._tabFetchController.signal;
    this._pendingTab = tab;
    const fetchUrl = new URL(window.location.href);
    if (tab === 'articles') {
      // Articles must be independent from product filter/sort URL state.
      // Build a clean request with only q + type.
      const q = (fetchUrl.searchParams.get('q') || '').trim();
      fetchUrl.search = '';
      if (q) fetchUrl.searchParams.set('q', q);
      fetchUrl.searchParams.set('type', 'article');
    } else {
      fetchUrl.searchParams.set('type', 'product');
      fetchUrl.searchParams.delete('page');
    }

    try {
      const fetchAndParse = async (url, requestSignal) => {
        const res = await fetch(url.toString(), { headers: { Accept: 'text/html' }, signal: requestSignal });
        if (!res.ok) return null;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const remote = doc.querySelector('search-component');
        if (!remote) return null;
        return { doc, remote };
      };

      let payload = await fetchAndParse(fetchUrl, signal);
      // Ignore stale responses.
      if (this._tabFetchController?.signal !== signal) return;
      if (!payload) return;

      let { doc, remote } = payload;

      // If SSR rendered an empty-state variant without tab roots,
      // hydrate the full search-component markup in-place (no page reload).
      if ((!this.articleRoot || !this.productRoot) && remote) {
        this.element.innerHTML = remote.innerHTML;
        this.refreshDomRefs();
      }

      let fetchedProducts = parseInt(remote.dataset.productsTotal || '0', 10) || 0;
      let fetchedArticles = parseInt(remote.dataset.articlesTotal || '0', 10) || 0;
      let fetchedResultsCount = parseInt(remote.dataset.resultsCount || '0', 10) || 0;
      let fetchedRequestType = String(remote.dataset.requestType || '').toLowerCase();
      let fetchedProductsResultsCount = parseInt(doc.querySelector('#collection__main-grid')?.dataset.results || '0', 10) || 0;
      let fetchedArticlesResultsCount = parseInt(doc.querySelector('#collection__article-grid')?.dataset.results || '0', 10) || 0;

      if (tab === 'articles') {
        const accurateArticlesTotal =
          (fetchedRequestType === 'article' || fetchedRequestType === 'articles')
            ? (fetchedResultsCount || fetchedArticlesResultsCount || fetchedArticles)
            : (fetchedArticlesResultsCount || fetchedArticles);
        this.element.dataset.articlesTotal = String(accurateArticlesTotal);
        this.blogTotalCount = accurateArticlesTotal;
        const src = doc.querySelector('#collection__article-grid');
        if (this.articleGridElement && src) this.articleGridElement.innerHTML = src.innerHTML;
        // Fresh tab payload replaces page-1 content; reset native pagination state.
        this._nativeArticlesPage = 1;
        this._nativeArticlesHasMore = null;
        this._articlesHydrated = true;
      } else {
        const accurateProductsTotal =
          (fetchedRequestType === 'product' || fetchedRequestType === 'products')
            ? (fetchedResultsCount || fetchedProductsResultsCount || fetchedProducts)
            : (fetchedProductsResultsCount || fetchedProducts);
        this.element.dataset.productsTotal = String(accurateProductsTotal);
        const src = doc.querySelector('#collection__main-grid');
        if (this.gridElement && src) {
          this.gridElement.innerHTML = src.innerHTML;
          if (src.dataset.total) this.gridElement.dataset.total = src.dataset.total;
        }
        // Fresh tab payload replaces page-1 content; reset native pagination state.
        this._nativeProductsPage = 1;
        this._nativeProductsHasMore = null;
        this._productsHydrated = true;
      }

      // DOM content for grids/pagination may have changed; refresh cached references once.
      this.refreshDomRefs();

      const targetGrid = tab === 'articles' ? this.articleGridElement : this.gridElement;
      if (targetGrid) {
        targetGrid.querySelectorAll('.animatedContent').forEach((el) => {
          el.classList.remove('animatedContent');
          el.setAttribute('data-loaded', 'true');
          el.style.opacity = '1';
        });
      }

      this.updateToggleButtons();
      this._updateNativeLoadMoreButtons();
    } catch (err) {
      if (err?.name === 'AbortError') return;
      // Keep this silent like existing behavior, but don't swallow non-abort errors entirely.
      // eslint-disable-next-line no-console
      console.error('MainSearch tab fetch failed:', err);
    } finally {
      if (this._tabFetchController?.signal === signal) {
        this._tabFetchController = null;
      }
      if (this._pendingTab === tab) {
        this._pendingTab = null;
      }
      // Now safe to prefetch the other tab without aborting the active fetch.
      this._prefetchOtherTabIfNeeded();
    }
  }

  escapeHTML(str) {
    const div = document.createElement('div');
    div.textContent = String(str ?? '');
    return div.innerHTML;
  }


  _initNativeLoadMore() {
    this._nativeProductsPage = 1;
    this._nativeArticlesPage = 1;
    this._nativeProductsHasMore = null;
    this._nativeArticlesHasMore = null;

    this._updateNativeLoadMoreButtons();
  }

  _updateNativeLoadMoreButtons() {
    const productsTotal = parseInt(this.element.dataset.productsTotal || '0', 10) || 0;
    const articlesTotal = this.enableBlogPosts
      ? (parseInt(this.element.dataset.articlesTotal || '0', 10) || 0)
      : 0;

    const productsPerPage = this.pageSize || 16;
    const articlesPerPage = this.blogPageSize || 6;

    const productsTotalPages = productsPerPage > 0
      ? Math.ceil(productsTotal / productsPerPage)
      : 1;
    const articlesTotalPages = articlesPerPage > 0
      ? Math.ceil(articlesTotal / articlesPerPage)
      : 1;

    const estimatedHasMoreProducts = productsTotalPages > (this._nativeProductsPage || 1);
    const estimatedHasMoreArticles = articlesTotalPages > (this._nativeArticlesPage || 1);
    const hasMoreProducts = this._nativeProductsHasMore === null ? estimatedHasMoreProducts : this._nativeProductsHasMore;
    const hasMoreArticles = this._nativeArticlesHasMore === null ? estimatedHasMoreArticles : this._nativeArticlesHasMore;

    const themeStrings = window.theme?.strings || {};
    const paginationStrings = themeStrings.pagination || {};
    const loadMoreLabel =
      paginationStrings.load_more;

    if (this.paginationElement) {
      if (hasMoreProducts) {
        this.paginationElement.innerHTML = `
          <div class="Pagination main-search__pagination main-search__pagination--products">
            <button
              type="button"
              class="Button Button--SecondaryOnLight u-pb1"
              data-action="load-more-search"
              data-load-target="products"
            >
              <div class="itemLoader">
                ${this.icons.loader || ''}
              </div>
              <div class="ButtonTextContainer">
                <span class="ButtonText button-top-txt ">
                  <span class="button-txt u-pb1">${this.escapeHTML(loadMoreLabel)}</span>
                </span>
              </div>
            </button>
          </div>`;
      } else {
        this.paginationElement.innerHTML = '';
      }
    }

    if (this.articlePaginationElement) {
      if (this.enableBlogPosts && hasMoreArticles) {
        this.articlePaginationElement.innerHTML = `
          <div class="Pagination main-search__pagination main-search__pagination--articles">
            <button
              type="button"
              class="Button Button--PrimaryOnLight u-pb1"
              data-action="load-more-search"
              data-load-target="articles"
            >
              <div class="itemLoader">
                ${this.icons.loader || ''}
              </div>
              <div class="ButtonTextContainer">
                <span class="ButtonText button-top-txt ">
                  <span class="button-txt u-pb1">${this.escapeHTML(loadMoreLabel)}</span>
                </span>
              </div>
            </button>
          </div>`;
        this.articlePaginationElement.style.display = '';
      } else {
        this.articlePaginationElement.innerHTML = '';
        this.articlePaginationElement.style.display = 'none';
      }
    }
  }

  async onNativeLoadMoreClick(e) {
    const btn = e.target.closest('[data-action="load-more-search"]');
    if (!btn) return;

    e.preventDefault();
    const loader = btn.querySelector('.itemLoader');
    loader?.classList.add('is-visible');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    if ('disabled' in btn) btn.disabled = true;

    // Cancel any in-flight pagination request so rapid clicks can't reorder DOM.
    if (this._nativeLoadMoreController) {
      this._nativeLoadMoreController.abort();
    }
    this._nativeLoadMoreController = new AbortController();
    const signal = this._nativeLoadMoreController.signal;

    const target = btn.dataset.loadTarget === 'articles' ? 'articles' : 'products';

    const productsPerPage = this.pageSize || 16;
    const articlesPerPage = this.blogPageSize || 6;

    const productsTotal = parseInt(this.element.dataset.productsTotal || '0', 10) || 0;
    const articlesTotal = this.enableBlogPosts
      ? (parseInt(this.element.dataset.articlesTotal || '0', 10) || 0)
      : 0;

    const productsTotalPages = productsPerPage > 0
      ? Math.ceil(productsTotal / productsPerPage)
      : 1;
    const articlesTotalPages = articlesPerPage > 0
      ? Math.ceil(articlesTotal / articlesPerPage)
      : 1;

    try {
      if (target === 'products') {
        const current = this._nativeProductsPage || 1;
        if (this._nativeProductsHasMore === false || current >= productsTotalPages) {
          this._updateNativeLoadMoreButtons();
          return;
        }
        const result = await this._fetchAndAppendNativePage(current + 1, 'products', signal);
        if (this._nativeLoadMoreController?.signal !== signal) return;
        if (result.appendedCount > 0) {
          this._nativeProductsPage = current + 1;
        }
        // If the next page is empty or shorter than page size, we're at the end.
        this._nativeProductsHasMore = result.appendedCount >= productsPerPage;
      } else {
        const current = this._nativeArticlesPage || 1;
        if (this._nativeArticlesHasMore === false || current >= articlesTotalPages) {
          this._updateNativeLoadMoreButtons();
          return;
        }
        const result = await this._fetchAndAppendNativePage(current + 1, 'articles', signal);
        if (this._nativeLoadMoreController?.signal !== signal) return;
        if (result.appendedCount > 0) {
          this._nativeArticlesPage = current + 1;
        }
        // If the next page is empty or shorter than page size, we're at the end.
        this._nativeArticlesHasMore = result.appendedCount >= articlesPerPage;
      }

      this._updateNativeLoadMoreButtons();
      this.updateToggleButtons();
    } finally {
      loader?.classList.remove('is-visible');
      btn.removeAttribute('aria-busy');
      btn.setAttribute('aria-disabled', 'false');
      if ('disabled' in btn) btn.disabled = false;
      if (this._nativeLoadMoreController?.signal === signal) {
        this._nativeLoadMoreController = null;
      }
    }
  }

  async _fetchAndAppendNativePage(page, target, signal) {
    const grid =
      target === 'articles'
        ? this.articleGridElement
        : this.gridElement;

    if (!grid) return { appendedCount: 0 };

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));

      const res = await fetch(url.toString(), {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
        signal: signal,
      });
      if (!res.ok) return { appendedCount: 0 };

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const remoteGrid = doc.querySelector(
        target === 'articles'
          ? '#collection__article-grid'
          : '#collection__main-grid'
      );
      if (!remoteGrid) return { appendedCount: 0 };

      const appendedCount = remoteGrid.children.length;

      const fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(remoteGrid.children, (child) => {
        fragment.appendChild(child.cloneNode(true));
      });

      if (signal?.aborted) return { appendedCount: 0 };
      grid.appendChild(fragment);

      this._animateSearchNewContent(grid);
      return { appendedCount };
    } catch (err) {
      if (err?.name === 'AbortError') return { appendedCount: 0 };
      // eslint-disable-next-line no-console
      console.error('[MainSearch] Load more fetch failed:', err);
      return { appendedCount: 0 };
    }
  }

  _animateSearchNewContent(gridEl) {
    if (!gridEl) return;

    const elementsToReveal = gridEl.querySelectorAll('[data-animation]:not([data-loaded])');
    const animationDuration = (window.theme && window.theme.animationDuration) || 400;
    const animationDelay = (window.theme && window.theme.animationBetweenElements) || 50;

    elementsToReveal.forEach((element, index) => {
      element.setAttribute('data-loaded', 'true');
      setTimeout(() => {
        element.animate([
          { transform: 'translateY(30px)', opacity: '0' },
          { transform: 'translateY(0px)', opacity: '1' }
        ], {
          duration: animationDuration,
          fill: 'forwards'
        });
      }, animationDelay * index);
    });
  }

  // ── Blog Posts Tab ──────────────────────────────────────────────

  onToggleTab(e) {
    const btn = e.target.closest('.main-search__toggle-button');
    if (!btn) return;
    e.preventDefault();

    if (btn.getAttribute('aria-disabled') === 'true' || btn.dataset.hasResults === 'false') return;

    const targetId = btn.getAttribute('aria-controls');
    if (!targetId) return;

    const isArticles = targetId === 'collection-article';
    const newTab = isArticles ? 'articles' : 'products';
    if (newTab === this.activeTab) return;

    // Mark pending BEFORE switchToTab updates the "showing ..." label.
    this._pendingTab = newTab;
    this.switchToTab(newTab);
    if (this.enableBlogPosts) {
      this._updateTypeInUrl(newTab);
      if (isArticles) {
        this._fetchTabContent('articles');
      } else {
        const targetGrid = this.gridElement;
        if (targetGrid && !targetGrid.innerHTML.trim()) {
          this._fetchTabContent('products');
        }
      }
    }
  }

  switchToTab(tab) {
    this.activeTab = tab;
    const isArticles = tab === 'articles';

    this.element.classList.toggle('templateSearch--articles', isArticles);
    this.element.classList.toggle('templateSearch--products', !isArticles);

    this.element.querySelectorAll('.main-search__toggle-button').forEach((btn) => {
      const controls = btn.getAttribute('aria-controls');
      const isActive =
        (isArticles && controls === 'collection-article') ||
        (!isArticles && controls === 'collection-product');
      btn.setAttribute('aria-expanded', String(isActive));
    });

    const productGrid = this.productRoot;
    const articleGrid = this.articleRoot;
    if (productGrid) {
      productGrid.setAttribute('aria-hidden', String(isArticles));
    }
    if (articleGrid) {
      articleGrid.setAttribute('aria-hidden', String(!isArticles));
    }

    // Update counts and button states when switching tabs so the
    // visible result count reflects the active tab.
    this.updateToggleButtons();

    const categories = this.categoriesContainer;
    if (categories) {
      categories.hidden = isArticles;
      categories.setAttribute('aria-hidden', String(isArticles));
    }

  }

  updateToggleButtons() {
    const toggleWrapper = this.toggleWrapper;
    if (toggleWrapper) toggleWrapper.setAttribute("aria-hidden", "false");

    const productsCountEl = this.productsCountEl;
    const articlesCountEl = this.articlesCountEl;
    const productsCount = parseInt(this.element.dataset.productsTotal || '0', 10) || 0;
    const articlesCount = parseInt(this.element.dataset.articlesTotal || '0', 10) || 0;

    if (productsCountEl) productsCountEl.textContent = String(productsCount);
    if (articlesCountEl) articlesCountEl.textContent = String(articlesCount);

    const resultsCountTextEls = this.element.querySelectorAll ? this.element.querySelectorAll('[data-results-count-text]') : [];
    if (resultsCountTextEls.length) {
      const isArticlesTab = this.activeTab === 'articles';
      const activeCount = isArticlesTab ? articlesCount : productsCount;
      const template = isArticlesTab
        ? (this.element.dataset.showingBlogs || 'Showing {{ count }} blogs')
        : (this.element.dataset.showingProducts || 'Showing {{ count }} products');
      const text = template.replace(/\{\{\s*count\s*\}\}/g, String(activeCount));
      resultsCountTextEls.forEach((el) => { el.textContent = text; });
    } else {
      const resultsLabelEl = this.resultsCountLabelEl;
      const resultsValueEl = this.resultsCountValueEl;
      if (resultsLabelEl && resultsValueEl) {
        const isArticlesTab = this.activeTab === 'articles';
        const activeCount = isArticlesTab ? articlesCount : productsCount;
        const label = isArticlesTab
          ? (resultsLabelEl.dataset.resultsLabelArticles || 'Articles')
          : (resultsLabelEl.dataset.resultsLabelProducts || 'Products');
        resultsLabelEl.textContent = label;
        resultsValueEl.textContent = String(activeCount);
      }
    }

    // Expose result state on toggle buttons so CSS can style them.
    this.element.querySelectorAll('.main-search__toggle-button').forEach((btn) => {
      const controls = btn.getAttribute('aria-controls');

      if (controls === 'collection-product') {
        btn.dataset.hasResults = productsCount > 0 ? 'true' : 'false';
        btn.setAttribute('aria-disabled', productsCount > 0 ? 'false' : 'true');
      } else if (controls === 'collection-article') {
        btn.dataset.hasResults = articlesCount > 0 ? 'true' : 'false';
        btn.setAttribute('aria-disabled', articlesCount > 0 ? 'false' : 'true');
      }
    });
  }

}

customElements.define('search-component', MainSearch);

class ContactDropdowns extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    this.delegateElement.on(
      "click",
      "[data-action='toggle-contact-dropdown']",
      this.handleToggle
    );
  }

  disconnectedCallback() {
    if (this.delegateElement && this.handleToggle) {
      this.delegateElement.off(
        "click",
        "[data-action='toggle-contact-dropdown']",
        this.handleToggle
      );
    }
  }

  handleToggle(event, target) {
    event.preventDefault();

    const button = target || event.target.closest("[data-action='toggle-contact-dropdown']");
    if (!button) return;

    const dropdown = button.closest(".contact-dropdowns__dropdown");
    const content = dropdown && dropdown.querySelector(".contact-dropdowns__content");
    if (!dropdown || !content) return;

    const isOpen = button.getAttribute("aria-expanded") === "true";

    // Close any other open dropdowns within this component
    this.element.querySelectorAll(".contact-dropdowns__dropdown").forEach((item) => {
      const itemButton = item.querySelector("[data-action='toggle-contact-dropdown']");
      const itemContent = item.querySelector(".contact-dropdowns__content");
      if (!itemButton || !itemContent) return;

      if (item === dropdown && !isOpen) {
        this.openItem(itemButton, itemContent);
      } else {
        this.closeItem(itemButton, itemContent);
      }
    });
  }

  openItem(button, content) {
    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const arrow = button.querySelector(".Dropdown--Arrow");
    if (arrow) {
      arrow.style.transition = "transform 160ms ease";
      arrow.style.transform = "rotate(180deg)";
    }
    button.setAttribute("aria-expanded", "true");
    content.setAttribute("aria-hidden", "false");

    if (prefersReducedMotion) {
      content.style.display = "block";
      content.style.overflow = "";
      content.style.height = "";
      content.style.opacity = "";
      content.style.transform = "";
      content.style.transition = "";
      return;
    }

    content.style.display = "block";
    content.style.overflow = "hidden";
    content.style.height = `0px`;
    content.style.opacity = "0";
    content.style.transform = "translateY(-0.25rem)";

    content.offsetHeight;

    const targetHeight = content.scrollHeight;

    content.style.transition =
      "height 160ms ease, opacity 160ms ease, transform 160ms ease";

    requestAnimationFrame(() => {
      content.style.height = `${targetHeight}px`;
      content.style.opacity = "1";
      content.style.transform = "translateY(0)";
    });

    const onEnd = (event) => {
      if (event.propertyName !== "height") return;
      content.style.height = "";
      content.style.overflow = "";
      content.style.transition = "";
      content.removeEventListener("transitionend", onEnd);
    };

    content.addEventListener("transitionend", onEnd);
  }

  closeItem(button, content) {
    const arrow = button.querySelector(".Dropdown--Arrow");
    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion) {
      button.setAttribute("aria-expanded", "false");
      content.setAttribute("aria-hidden", "true");
      content.style.display = "none";
      content.style.overflow = "";
      content.style.height = "";
      content.style.opacity = "";
      content.style.transform = "";
      content.style.transition = "";

      if (arrow) {
        arrow.style.transition = "transform 160ms ease";
        arrow.style.transform = "rotate(0deg)";
      }
      return;
    }

    const startHeight = content.scrollHeight;

    if (!startHeight) {
      button.setAttribute("aria-expanded", "false");
      content.setAttribute("aria-hidden", "true");
      content.style.display = "none";

      if (arrow) {
        arrow.style.transition = "transform 160ms ease";
        arrow.style.transform = "rotate(0deg)";
      }
      return;
    }

    content.style.display = "block";
    content.style.overflow = "hidden";
    content.style.height = `${startHeight}px`;
    content.style.opacity = "1";
    content.style.transform = "translateY(0)";

    content.offsetHeight;

    content.style.transition =
      "height 160ms ease, opacity 160ms ease, transform 160ms ease";

    requestAnimationFrame(() => {
      button.setAttribute("aria-expanded", "false");
      content.style.height = "0px";
      content.style.opacity = "0";
      content.style.transform = "translateY(-0.25rem)";

      if (arrow) {
        arrow.style.transition = "transform 160ms ease";
        arrow.style.transform = "rotate(0deg)";
      }
    });

    const onEnd = (event) => {
      if (event.propertyName !== "height") return;

      content.setAttribute("aria-hidden", "true");
      content.style.display = "none";
      content.style.overflow = "";
      content.style.height = "";
      content.style.opacity = "";
      content.style.transform = "";
      content.style.transition = "";
      content.removeEventListener("transitionend", onEnd);
    };

    content.addEventListener("transitionend", onEnd);
  }
}

customElements.define("contact-dropdowns", ContactDropdowns);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this._initialized = false;
    this.newsletterWrapper = null;
    this.successText = null;
    this.linksGroup = null;
    this.optionErrorMessage = '';
    this.optionBlurTimeout = null;
    this._boundOnSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.newsletterWrapper = this.querySelector('.newsletter__wrapper');
    this.successText = this.querySelector('.footer__newsletter--success');
    this.linksGroup = this.querySelector('.links__links-group');

    // give this footer instance a stable unique id for scoping selectors
    if (!this.id) {
      this.id = `footer-newsletter-${Math.random().toString(36).slice(2)}`;
    }

    this.bindEvents();
    this.initFormValidation();

    const urlParams = new URLSearchParams(window.location.search);
    const isFooterNewsletterReturn = window.location.hash === '#footer-newsletter-form';
    const hasPostedSuccess = this.querySelector('[data-newsletter-posted-success]');
    const hasNewsletterErrors = this.querySelector('.newsletter__error-wrapper')?.textContent.trim().length > 0;

    if (isFooterNewsletterReturn && (hasPostedSuccess || urlParams.get('customer_posted') === 'true')) {
      this.showSuccessMessage();
    }

    if (isFooterNewsletterReturn && (hasPostedSuccess || hasNewsletterErrors || urlParams.get('customer_posted') === 'true')) {
      this.scrollToNewsletterMessage();
    }

    this.updateFooterHeight();
    window.addEventListener('load', this.updateFooterHeight);
    this.resizeListener = responsive.addResizeListener(
      this,
      this.updateFooterHeight,
    );

    // ensure initial state
    if (this.validator) this.validator.updateButtonState();

    if (this.linksGroup?.children.length % 2 === 1) {
      this.linksGroup.classList.add('is-odd');
    }
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.updateFooterHeight);
    if (this.resizeListener) this.resizeListener.removeResizeListener();
    const formEl = this.element.querySelector('.newsletter__form');
    if (formEl) formEl.removeEventListener('submit', this._boundOnSubmit, { capture: true });
    this.delegateElement.off();
    if (this.optionBlurTimeout) {
      window.clearTimeout(this.optionBlurTimeout);
      this.optionBlurTimeout = null;
    }
  }

  initFormValidation() {
    const form = this.element.querySelector('.newsletter__form');
    if (!form) return;

    const wrapper = this.element.querySelector('.newsletter__wrapper');
    const optionErrorMsg = wrapper?.dataset?.optionError || '';
    this.optionErrorMessage = optionErrorMsg;
    const errorOutput = this.element.querySelector('.newsletter__error-wrapper');

    this.validator = new FormValidator(form, {
      errorClass: 'field--error',
      fieldSelector: '.newsletter__email-input-wrapper',
      buttonSelector: '.newsletter__subscribe-button',
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: errorOutput,
      showErrorsOnSubmitOnly: false,
    });
  }

  bindEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="clear-input"]',
      this.clearInput.bind(this),
    );

    const formEl = this.element.querySelector('.newsletter__form');
    if (formEl) {
      formEl.addEventListener('submit', this._boundOnSubmit, { capture: true });
    }

    const optionInputs = this.element.querySelectorAll('.newsletter__option-input');
    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.handleOptionGroupValidation(false);
      });

      input.addEventListener('blur', () => {
        window.clearTimeout(this.optionBlurTimeout);
        this.optionBlurTimeout = window.setTimeout(() => {
          this.handleOptionGroupValidation(true);
        }, 0);
      });
    });

    const emailInput = this.element.querySelector('.newsletter__email-input');
    if (emailInput) {
      emailInput.addEventListener('blur', () => {
        if (emailInput.value.trim()) {
          this.handleOptionGroupValidation(true);
        }
      });
    }

  }

  updateFooterHeight = () => {
    const footerHeight = this.offsetHeight + 'px';
    document.documentElement.style.setProperty(
      '--footer-dynamic-height',
      footerHeight,
    );
    document.documentElement.style.setProperty('--footer-height', footerHeight);
  };

  clearInput() {
    const emailInput = this.querySelector('.input-placeholder');
    const errorWrapper = this.querySelector('.newsletter__error-wrapper');
    const emailWrapper = this.querySelector('.footer__newsletter-form-inputs');

    if (emailInput) emailInput.value = '';
    if (errorWrapper) errorWrapper.innerHTML = '';
    if (emailWrapper) emailWrapper.classList.remove('alert');

    if (this.validator) {
      this.validator.clearErrors();
      this.validator.updateButtonState();
    }
  }

  onSubmit(e) {
    if (!this.handleOptionGroupValidation(true)) {
      e.preventDefault();
      return;
    }

    if (this.validator && !this.validator.showAllErrors()) {
      e.preventDefault();
      return;
    }

    const form = e.currentTarget || this.element.querySelector('.newsletter__form');
    if (!form) return;

    const emailEl = form.querySelector('.newsletter__email-input');
    const email = emailEl ? emailEl.value.trim() : '';
    if (!email) {
      e.preventDefault();
      return;
    }

    const errorWrapper = this.element.querySelector('.newsletter__error-wrapper');
    if (errorWrapper) errorWrapper.textContent = '';
  }

  handleOptionGroupValidation(showIfInvalid = true) {
    const radios = this.element.querySelectorAll('.newsletter__option-input[required]');
    if (!radios.length) return true;

    const anyChecked = Array.from(radios).some((radio) => radio.checked);
    this.updateSubscribeButtonVisibility(anyChecked);

    const errorEl = this.element.querySelector('.newsletter__options-error');
    if (!errorEl) return anyChecked;

    if (!anyChecked && showIfInvalid) {
      errorEl.textContent = this.optionErrorMessage || 'Please select an option';
    } else {
      errorEl.textContent = '';
    }

    return anyChecked;
  }

  updateSubscribeButtonVisibility(anyChecked) {
    const subscribeButton = this.element.querySelector('.newsletter__subscribe-button');
    if (!subscribeButton) return;

    if (anyChecked) {
      subscribeButton.style.display = '';
      subscribeButton.removeAttribute('aria-hidden');
    } else {
      subscribeButton.style.display = 'none';
      subscribeButton.setAttribute('aria-hidden', 'true');
    }
  }

  showSuccessMessage() {
    if (this.newsletterWrapper) this.newsletterWrapper.style.display = 'none';
    if (this.successText) this.successText.style.display = '';
  }

  scrollToNewsletterMessage() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const target = this.successText || this.newsletterWrapper || this;
        target.scrollIntoView({ block: 'center' });
      });
    });
  }
}

customElements.define("footer-component", FooterComponent);


class ExpandableTextComponent extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
  }

  connectedCallback() {
    if (this._initialized) return;

    this.contentEl = this.querySelector('.expandable-text__content');
    if (!this.contentEl) return;

    this.animateWrapper = document.createElement('div');
    this.animateWrapper.className = 'expandable-text__animate';
    this.contentEl.parentNode.insertBefore(this.animateWrapper, this.contentEl);
    this.animateWrapper.appendChild(this.contentEl);

    if (this.dataset.continuationStyle === 'fade') {
      this.fadeOverlay = document.createElement('div');
      this.fadeOverlay.className = 'expandable-text__fade';
      this.animateWrapper.appendChild(this.fadeOverlay);
    }

    this.mobileLines = parseInt(this.dataset.mobileLines, 10) || 3;
    this.desktopLines = parseInt(this.dataset.desktopLines, 10) || 3;
    this.showMoreText = this.dataset.showMore || 'Show more';
    this.showLessText = this.dataset.showLess || 'Show less';
    this.btnFontClass = this.dataset.btnFont || 'u-p2';
    this.showMoreIconSlot = this.querySelector('[data-icon-slot="show-more"]');
    this.showLessIconSlot = this.querySelector('[data-icon-slot="show-less"]');

    this.fullHTML = this.contentEl.innerHTML;
    this.fullText = this.contentEl.textContent;

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      if (btn.dataset.action === 'show-more') this.expand();
      if (btn.dataset.action === 'show-less') this.collapse();
    });

    this._initialized = true;

    if (this.closest('[data-dynamic-content]')) {
      this.classList.add('is-ready');
      this._boundResize = this.handleResize.bind(this);
      window.addEventListener('resize', this._boundResize);
      return;
    }

    this.init();
    this.classList.add('is-ready');
    this._boundResize = this.handleResize.bind(this);
    window.addEventListener('resize', this._boundResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._boundResize);
  }

  getCollapsedHeight() {
    const cs = getComputedStyle(this.contentEl);
    const lineHeight = parseFloat(cs.lineHeight) || 16;
    const rowGap = parseFloat(cs.rowGap) || 0;
    const isDesktop = responsive.getCurrentBreakpoint() === 'desktop';
    const lines = isDesktop ? this.desktopLines : this.mobileLines;
    const btnTakesRow = this.dataset.btnTakesRow === 'true';
    const btnLines = (isDesktop && !btnTakesRow) ? 0 : 1;
    let height = lineHeight * lines;
    if (btnLines > 0) {
      const btn = this.querySelector('.expandable-text__btn-more');
      const btnHeight = btn ? btn.offsetHeight : lineHeight;
      const btnMargin = btn ? (parseFloat(getComputedStyle(btn).marginTop) || 0) : 0;
      height += rowGap + btnHeight + btnMargin;
    }
    return Math.ceil(height);
  }

  init() {
    this.contentEl.innerHTML = this.fullHTML;
    const fullHeight = this.contentEl.scrollHeight;
    const collapsedHeight = this.getCollapsedHeight();

    if (fullHeight <= collapsedHeight + 4) {
      this.needsTruncation = false;
      this.animateWrapper.style.maxHeight = '';
      this.removeAttribute('data-collapsed');
      this.removeAttribute('data-expanded');
      if (this.fadeOverlay) this.fadeOverlay.classList.remove('is-visible');
      return;
    }

    this.needsTruncation = true;
    this.truncateToFit();
  }

  getIconHTML(slot) {
    if (!slot) return '';
    const wrap = document.createElement('span');
    wrap.className = 'expandable-text__btn-icon';
    wrap.innerHTML = slot.innerHTML;
    return wrap.outerHTML;
  }

  truncateToFit() {
    const collapsedHeight = this.getCollapsedHeight();
    const useFade = this.dataset.continuationStyle === 'fade';
    const moreIconHTML = this.dataset.showMoreIcon && this.showMoreIconSlot ? this.getIconHTML(this.showMoreIconSlot) : '';
    const btnContent = this.showMoreText + ' ' + moreIconHTML;

    this._removeExternalBtn();

    if (useFade) {
      this.contentEl.innerHTML = this.fullHTML;
      const btnHTML = '<button class="expandable-text__btn-more ' + this.btnFontClass + '" data-action="show-more">' + btnContent + '</button>';
      const btnEl = document.createElement('div');
      btnEl.className = 'expandable-text__btn-external';
      btnEl.innerHTML = btnHTML;
      this.animateWrapper.after(btnEl);

      if (!this._collapseAnimating) {
        this.animateWrapper.style.height = '';
        this.animateWrapper.style.maxHeight = collapsedHeight + 'px';
      }
      this.setAttribute('data-collapsed', '');
      this.removeAttribute('data-expanded');
      this.isExpanded = false;
      if (this.fadeOverlay) this.fadeOverlay.classList.toggle('is-visible', true);
      return;
    }

    const text = this.fullText;
    const ellipsis = '&hellip; ';
    const btnHTML = ellipsis + '<button class="expandable-text__btn-more ' + this.btnFontClass + '" data-action="show-more">' + btnContent + '</button>';

    this.contentEl.innerHTML = btnHTML;
    const targetHeight = this.getCollapsedHeight();

    let low = 0;
    let high = text.length;
    let best = 0;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      this.contentEl.innerHTML = text.substring(0, mid).trimEnd() + btnHTML;

      if (this.contentEl.scrollHeight <= targetHeight + 2) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    this.contentEl.innerHTML = text.substring(0, best).trimEnd() + btnHTML;
    if (!this._collapseAnimating) {
      this.animateWrapper.style.height = '';
      this.animateWrapper.style.maxHeight = targetHeight + 'px';
    }
    this.setAttribute('data-collapsed', '');
    this.removeAttribute('data-expanded');
    this.isExpanded = false;
    if (this.fadeOverlay) {
      this.fadeOverlay.classList.toggle('is-visible', true);
    }
  }

  _removeExternalBtn() {
    const ext = this.querySelector('.expandable-text__btn-external');
    if (ext) ext.remove();
  }

  expand() {
    this._removeExternalBtn();
    const lessIconHTML = this.dataset.showLessIcon && this.showLessIconSlot ? this.getIconHTML(this.showLessIconSlot) : '';
    const btnContent = this.showLessText + ' ' + lessIconHTML;
    const btnHTML = ' <button class="expandable-text__btn-less rte ' + this.btnFontClass + '" data-action="show-less">' + btnContent + '</button>';
    this.animateWrapper.style.height = '';
    this.contentEl.innerHTML = this.fullHTML + btnHTML;
    const fullHeight = this.contentEl.scrollHeight;
    this.animateWrapper.style.maxHeight = fullHeight + 'px';
    this.setAttribute('data-expanded', '');
    this.removeAttribute('data-collapsed');
    this.isExpanded = true;
    if (this.fadeOverlay) {
      this.fadeOverlay.classList.toggle('is-visible', false);
    }
  }

  collapse() {
    this._collapseAnimating = true;
    const currentHeight = this.animateWrapper.offsetHeight;

    this.animateWrapper.style.maxHeight = 'none';
    this.animateWrapper.style.height = currentHeight + 'px';

    this.truncateToFit();
    const collapsedHeight = this.getCollapsedHeight();

    if (currentHeight <= collapsedHeight) {
      this.animateWrapper.style.height = '';
      this.animateWrapper.style.maxHeight = collapsedHeight + 'px';
      this._collapseAnimating = false;
      return;
    }

    const onTransitionEnd = (e) => {
      if (e.target !== this.animateWrapper || e.propertyName !== 'height') return;
      this.animateWrapper.removeEventListener('transitionend', onTransitionEnd);
      this.animateWrapper.style.height = '';
      this.animateWrapper.style.maxHeight = collapsedHeight + 'px';
      this._collapseAnimating = false;
    };

    this.animateWrapper.addEventListener('transitionend', onTransitionEnd);
    void this.animateWrapper.offsetHeight;
    this.animateWrapper.style.height = collapsedHeight + 'px';
  }

  handleResize() {
    if (this.isExpanded) return;
    this.init();
  }
}

customElements.define('expandable-text-component', ExpandableTextComponent);

class FavoritesStorage {
  static STORAGE_KEY = 'productFavorites';
  static MAX_FAVORITES = 50;

  static getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]')
        .filter(item => item.id !== null);
    } catch (error) {
      console.error('Error parsing favorites from storage:', error);
      return [];
    }
  }

  static saveFavorites(items) {
    try {
      const limitedItems = items.slice(0, this.MAX_FAVORITES);
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(limitedItems));
      return true;
    } catch (error) {
      console.error('Error saving favorites to storage:', error);
      return false;
    }
  }

  static removeFavorite(productId) {
    const items = this.getFavorites();
    const filteredItems = items.filter(item => item.id !== productId);
    return this.saveFavorites(filteredItems);
  }

  static updateFavoriteVariant(productId, size, variantId) {
    const items = this.getFavorites();
    const index = items.findIndex(item => item.id === productId);
    if (index === -1) return false;
    items[index] = { ...items[index], size, variantId };
    return this.saveFavorites(items);
  }
}

class FavoritesDOM {
  static updateHeartIcon(container, isActive) {
    const solidHeart = container.querySelector('.solid-favorite');
    const emptyHeart = container.querySelector('.empty-favorite');

    if (!solidHeart || !emptyHeart) return;

    if (isActive) {
      solidHeart.style.display = 'flex';
      emptyHeart.style.display = 'none';
      solidHeart.ariaHidden = 'false';
      emptyHeart.ariaHidden = 'true';
    } else {
      solidHeart.style.display = 'none';
      emptyHeart.style.display = 'flex';
      solidHeart.ariaHidden = 'true';
      emptyHeart.ariaHidden = 'false';
    }
  }

  static updateHeaderHeartIcon(container, hasFavorites) {
    const emptyHeart = container.querySelector('.header__favorites--empty');
    const filledHeart = container.querySelector('.header__favorites--filled');

    if (!emptyHeart || !filledHeart) return;

    if (hasFavorites) {
      emptyHeart.style.display = 'none';
      emptyHeart.ariaHidden = 'true';
      filledHeart.style.display = 'flex';
      filledHeart.ariaHidden = 'false';
    } else {
      emptyHeart.style.display = 'flex';
      emptyHeart.ariaHidden = 'false';
      filledHeart.style.display = 'none';
      filledHeart.ariaHidden = 'true';
    }
  }
}

class FavoritesHeader extends HTMLElement {
  static hasBound = false;

  connectedCallback() {
    this.element = this;
    this.delegateBody = new Delegate(document.body);

    this.toggleFavorites();
    this.bindEvents();
    this.updateHeaderIcons();
  }

  disconnectedCallback() {
    this.delegateBody?.destroy();
    this.delegateBody = null;
    FavoritesHeader.hasBound = false;
  }

  bindEvents() {
    // Only bind events once globally
    if (FavoritesHeader.hasBound) return;
    FavoritesHeader.hasBound = true;

    this.delegateBody.on(
      "click",
      '[data-action="toggle-favorites"]',
      this.addToFavorites.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      '[data-action="toggle-favorites"]',
      this.addToFavorites.bind(this)
    );

    this.delegateBody.on("variant:changed", (event) => {
      const productEl = event.target.closest("product-component");
      if (!productEl) return;
      const variant = event.detail?.variant;
      if (!variant) return;

      productEl.dataset.selectedVariantId = variant.id;
      const sizeOptionIndex = parseInt(productEl.dataset.sizeOptionIndex || "0", 10);
      if (sizeOptionIndex >= 1 && sizeOptionIndex <= 3) {
        productEl.dataset.selectedSize = variant[`option${sizeOptionIndex}`] || "";
      }
    });
  }

  toggleFavorites() {
    const items = this.getFavorites();
    const favorites = document.querySelectorAll(
      ".product-card__favorites-container, .pdp-favorites-button"
    );

    favorites.forEach(item => {
      const state = item.getAttribute("state");
      const myID = item.getAttribute("data-id");
      const exists = items.some(fav => fav.id === myID);

      if (state === "not-active" && exists) {
        FavoritesDOM.updateHeartIcon(item, true);
        item.setAttribute("state", "active");
        item.setAttribute("aria-pressed", "true");
      } else if (!exists) {
        FavoritesDOM.updateHeartIcon(item, false);
        item.setAttribute("state", "not-active");
        item.setAttribute("aria-pressed", "false");
      }
    });
  }

  updateHeaderIcons() {
    const favorites = this.getFavorites();
    const hasFavorites = favorites.length > 0;

    document.querySelectorAll('.fav-icon__wrapper').forEach(container => {
      FavoritesDOM.updateHeaderHeartIcon(container, hasFavorites);
    });

    document.querySelectorAll('.header__item-count--favorites').forEach(countEl => {
      countEl.textContent = favorites.length;
      countEl.style.display = hasFavorites ? '' : 'none';
    });

    document.querySelectorAll('[data-favorites-count]').forEach(countEl => {
      countEl.textContent = hasFavorites ? ` (${favorites.length})` : '';
    });
  }

  getFavorites() {
    return FavoritesStorage.getFavorites();
  }

  saveFavorites(items) {
    FavoritesStorage.saveFavorites(items);
    this.toggleFavorites();
    this.updateHeaderIcons();
  }

  removeFromFavorites(productId, size) {
    FavoritesStorage.removeFavorite(productId);
    this.updateHeaderIcons();
    this.toggleFavorites();

    document.body.dispatchEvent(new CustomEvent("favorite:remove", {
      detail: { id: productId, size: size }
    }));
  }

  addToFavorites(e) {
    if (e.key && e.key !== "Enter" && e.key !== " ") {
      return;
    }
    e.preventDefault();
    e.stopPropagation();

    const trigger = e.target.closest('[data-action="toggle-favorites"]');
    if (!trigger) return;

    let items = this.getFavorites();
    const productId = trigger.dataset.id;
    let size = trigger.dataset.size || null;
    let variantId = trigger.dataset.variantId || null;

    const pdpButton = e.target.closest(".pdp-favorites-button");
    if (pdpButton) {
      const productComponent = pdpButton.closest("product-component");
      if (productComponent) {
        // variant:changed only fires when featured_media changes, so the cached
        // dataset values stay stale for size-only variants. Read live state.
        const variantSelects = productComponent.querySelector("variant-selects");
        const currentVariant = variantSelects?.currentVariant;
        const sizeOptionIndex = parseInt(productComponent.dataset.sizeOptionIndex || "0", 10);

        if (currentVariant) {
          variantId = currentVariant.id;
          if (sizeOptionIndex >= 1 && sizeOptionIndex <= 3) {
            size = currentVariant[`option${sizeOptionIndex}`] || size;
          }
        } else {
          const variantInput = productComponent.querySelector('form[data-product-form] input[name="id"]');
          if (variantInput?.value) variantId = variantInput.value;
          else if (productComponent.dataset.selectedVariantId) variantId = productComponent.dataset.selectedVariantId;
          if (productComponent.dataset.selectedSize) size = productComponent.dataset.selectedSize;
        }
      }
    }

    if (!productId) {
      return;
    }

    const existingItemIndex = items.findIndex(item => item.id === productId);

    if (existingItemIndex === -1) {
      items.unshift({ id: productId, size: size, variantId: variantId });
    } else {
      this.removeFromFavorites(productId, size);
      return;
    }

    this.saveFavorites(items);

    const favoritesSection = document.querySelector('favorites-section');
    if (favoritesSection && !favoritesSection.contains(trigger)) {
      document.body.dispatchEvent(new CustomEvent("favorite:add-external", {
        detail: { id: productId, size: size, variantId: variantId }
      }));
    }
  }
}

customElements.define("favorites-header", FavoritesHeader);
